import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { BASE_URL } from "../../../config/axios";
// import usePermission from "../../../config/permissions";
import { ToastContainer, toast } from "react-toastify";
import { handleErrorToast, ProgressModal } from "../../CustomFunctions";
import { AddwithWhiteCircle, UpdatePencil, DeleteDustbin, DropdownArrow } from "../../AllSvg";
import { X } from "lucide-react";






const AddEmployeeInvoices = ({ p_id, invoice_id, getEmployeeInvoice, month, year, logData, setEotDetails }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        getTransportation();
        setShow(true);
    };

    const [formData, setFormData] = useState([]);

    const [employee, setEmployee] = useState([]);

    const getTransportation = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqemployeebyproject/${p_id}/`
            );

            if (Array.isArray(res.data)) {
                setEmployee(res.data);
                const initialData = res.data.map((item) => ({
                    project: p_id,
                    invoice: invoice_id,
                    employee: item.id,
                    actual_month: "",
                    month: month,
                    year: year,
                    current_invoice_amount: ""
                }));
                setFormData(initialData);
            } else {
                console.error("Error: Expected a list of transportation items");
            }
        } catch (err) {
            console.error("Error fetching transportation data", err);
        }
    };


    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        formData.forEach((entry, index) => {
            const requiredFields = [];
            requiredFields.forEach((field) => {
                if (!entry[field]) {
                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                // Submit the formData array as bulk data
                const res = await axios.post(
                    `${BASE_URL}/siteproject/invoiceemployeebulk/`,
                    formData
                );

                if (res.status === 201) {
                    await getEmployeeInvoice();
                    handleClose();

                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    console.log(formData)

    //! **************************** post API End ***********************!//

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = formData.map((entry, i) =>
            i === index ? { ...entry, [name]: value } : entry
        );
        setFormData(updatedFormData);
    };

    return (
        <>
            <button title="Add Employee Invoice" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle />
                {" "} Employee Invocie
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Employee  Invoice</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-row justify-center">
                                <table className="table-css width-10vw">
                                    <thead>
                                        <tr className="custom-table-head-tr width-10vw">
                                            <th className="align-left width-10vw">S no.</th>
                                            <th className="align-center width-10vw">Employee</th>
                                            <th className="align-center width-10vw">Actual Month</th>
                                            <th className="align-center width-10vw">Current Invoice Amount</th>
                                        </tr>
                                    </thead>

                                    <tbody>

                                        {formData.map((entry, index) => (
                                            <tr className="custom-table-head-td ">

                                                <td className="align-left width-5vw" >
                                                    {index + 1}
                                                </td>
                                                <td>
                                                    <div title="Employee" className="flex-column form-group-selectt">
                                                        <input
                                                            id={`employee_${index}`}
                                                            name="employee "
                                                            value={employee.find(t => t.id === entry.employee)?.empcode || "Loading..."}
                                                            className={`form-input-date width-10vw   ${errors[`${index}_employee`] ? "error" : ""}`}
                                                            disabled
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div title="Actual Month" className="flex-column">

                                                        <input
                                                            type="number"
                                                            id={`actual_month_${index}`}
                                                            name="actual_month"
                                                            placeholder="Actual Month"
                                                            value={entry.actual_month}
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            className={`form-input-date  width-5vw  ${errors[`${index}_actual_month`] ? "error" : ""}`}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div title="Invoice Amount" className="flex-column form-group-selectt">

                                                        <input
                                                            id={`current_invoice_amount_${index}`}
                                                            name="current_invoice_amount"
                                                            type="number"
                                                            value={entry.current_invoice_amount}
                                                            placeholder="Current Invoice Amount"
                                                            onChange={(e) => handleInputChange(e, index)}
                                                            className={`form-input-date width-5vw   ${errors[`${index}_current_invoice_amount`] ? "error" : ""}`}
                                                        />
                                                    </div>
                                                </td>

                                            </tr>
                                        ))}

                                    </tbody>

                                </table>
                            </div>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button font-weight500"
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                >
                                    Add
                                </button>
                            </div>

                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};


// const AddEmployeeInvoice = ({ invoiceData, p_id, invoice_id, getEmployeeInvoice, month, year, logData, usedfor }) => {
//     const [show, setShow] = useState(false);
//     const [employeeData, setEmployeeData] = useState([]);
//     const [logid, setLogId] = useState("null");
//     const [uploadProgress, setUploadProgress] = useState(0);
//     const [showProgressModal, setShowProgressModal] = useState(false);

//     const handleClose = () => {
//         setShow(false);
//         setModalLoading(false);
//         setEmployeeListLoaded(false);
//         setFetchProgress({ percent: 0, label: "" }); // reset for next open
//     };
//     const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
//     const [withHeldDeductionData, setWithHeldDeductionData] = useState([]);
//     const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
//     const [invoiceIds, setInvoiceIds] = useState([]);
//     const [months, setMonths] = useState([]);
//     const [years, setyears] = useState([]);
//     const [getResults, setGetResults] = useState([]);
//     const [getAllResults, setGetAllResults] = useState([]);
//     const [getSheetData, setGetSheetData] = useState([])
//     const [getTotalWithId, setGetTotalWithid] = useState([])
//     const [matchingData, setmatchingData] = useState([])
//     const [modalLoading, setModalLoading] = useState(false);
//     const handleShow = async () => {
//         setShow(true);
//         await getAttendance();
//         await getData();
//     };

//     const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
//     const [formData, setFormData] = useState([]);

//     // ****************************************BOQ Attendance Data Code **********************

//     const [BOQAttendanceList, setBOQAttendanceList] = useState([]);

//     const getAttendance = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/attendancesitefilter/${p_id}/${month}/${year}/null/null/`);
//             setBOQAttendanceList(res.data); // still set in state
//             return res.data; // RETURN the data
//         } catch (err) {
//             handleErrorToast(err);
//             return []; // fail-safe
//         }
//     };


//     // useEffect(() => {
//     //     if (show) {
//     //         getAttendance();
//     //     }
//     // }, [month, year, p_id, show]);


//     const [AttendanceformData, setAttendanceFormData] = useState([]);


//     useEffect(() => {
//         if (Array.isArray(BOQAttendanceList)) {
//             const initialData = BOQAttendanceList.map((item) => ({
//                 rate: "",
//                 is_invoice_raised: true,
//                 current_amount: "",
//                 man_months: item.man_months,
//             }));
//             setAttendanceFormData(initialData);
//         }
//     }, [BOQAttendanceList]);



//     // ****************************************End of BOQ Attendance Data Code **********************


//     // **************************************Previous data Fetch CCode*****************************************
//     const [employeeListLoaded, setEmployeeListLoaded] = useState(false);

//     const [employeeList, setEmployeeList] = useState([]);
//     // useEffect(() => {
//     //     if (show === true) {


//     //         if (!month || !year) {
//     //             console.error("Both month and year are required to fetch progress data.");
//     //             return;
//     //         }

//     //         const getEmployeeData = async () => {
//     //             try {
//     //                 let currentMonth = month - 1 === 0 ? 12 : month - 1;
//     //                 let currentYear = month - 1 === 0 ? year - 1 : year;
//     //                 let dataFound = false;


//     //                 // while (!dataFound) {
//     //                 //     const response = await axios.get(
//     //                 //         `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//     //                 //     );
//     //                 //     const response2 = await axios.get(
//     //                 //         `${BASE_URL}/siteproject/newinvoiceemployeelistcreate/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/null/null/`
//     //                 //     );

//     //                 //     const data = response.data;
//     //                 //     const data2 = response2.data;

//     //                 //     const allBoqJsonsNull = data.every(item => item.boq_json === null);

//     //                 //     const selectedData = (data.length === 0 || allBoqJsonsNull) ? data2 : data;



//     //                 //     if (selectedData.length > 0) {
//     //                 //         const updatedEmployeeData = data.map((item) => {
//     //                 //             const prevAmount = parseFloat(item.previous_invoice_total) || 0;
//     //                 //             const currentAmount = item.invoice_amount === null
//     //                 //                 ? parseFloat(item.current_invoice_amount) || 0
//     //                 //                 : parseFloat(item.invoice_amount) || 0;

//     //                 //             const newPreviousAmount = prevAmount + currentAmount;

//     //                 //             const prev = parseFloat(item.actual_month_total_previous) || 0;
//     //                 //             const current = parseFloat(item.actual_month) || 0;
//     //                 //             const newPrevious = prev + current;

//     //                 //             const prev_month_array = item.actual_month_total_previous_two?.map((i) => (i))
//     //                 //             const prev_amount_array = item.previous_invoice_total_two?.map((i) => (i))

//     //                 //             const current_amount_array = item.current_invoice_amount_two?.map((i) => (i))
//     //                 //             const current_month_array = item.actual_month_two?.map((i) => (i))

//     //                 //             const sum_previous_month = current_month_array.map((val, idx) => {
//     //                 //                 const prevVal = prev_month_array?.[idx] ?? 0; // if prev array is shorter, default 0
//     //                 //                 return (Number(val) || 0) + (Number(prevVal) || 0);
//     //                 //             });
//     //                 //             const sum_previous_amount = current_amount_array.map((val, idx) => {
//     //                 //                 const prevVal = prev_amount_array?.[idx] ?? 0; // if prev array is shorter, default 0
//     //                 //                 return (Number(val) || 0) + (Number(prevVal) || 0);
//     //                 //             });



//     //                 //             console.log("sumArray:", sum_previous_month);
//     //                 //             console.log("sum_previous_amount:", sum_previous_amount);

//     //                 //             console.log("current_amount_array", current_amount_array)
//     //                 //             console.log("current_month_array", current_month_array)
//     //                 //             console.log("prev_month_array", prev_month_array)
//     //                 //             console.log("prev_amount_array", prev_amount_array)


//     //                 //             return {
//     //                 //                 ...item,
//     //                 //                 updated_previous_invoice_total: sum_previous_amount,
//     //                 //                 updated_actual_month_total_previous: sum_previous_month,
//     //                 //             };
//     //                 //         });



//     //                 //         console.log("Updated Progress Data:", updatedEmployeeData);
//     //                 //         setEmployeeList(updatedEmployeeData);
//     //                 //         setEmployeeListLoaded(true); // ✅ Mark as loaded
//     //                 //         dataFound = true;
//     //                 //     } else {
//     //                 //         console.warn(
//     //                 //             `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
//     //                 //         );

//     //                 //         currentMonth -= 1;
//     //                 //         if (currentMonth === 0) {
//     //                 //             currentMonth = 12;
//     //                 //             currentYear -= 1;
//     //                 //         }

//     //                 //         // Stop after going back more than 1 year from selected year
//     //                 //         if (currentYear < year - 1) {
//     //                 //             console.error("No data found for the past 1 year.");
//     //                 //             break;
//     //                 //         }
//     //                 //     }
//     //                 // }


//     //                 while (!dataFound) {
//     //                     const response = await axios.get(
//     //                         `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//     //                     );

//     //                     const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//     //                     setWithHeldReleaseData(releaseResponse.data);
//     //                     const deductionResponse = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/${p_id}/null/null/`);
//     //                     setWithHeldDeductionData(deductionResponse.data);
//     //                     const monthInt = parseInt(month, 10);

//     //                     const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//     //                     const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//     //                     console.log("Month Calculation:", monthCalculation);
//     //                     console.log("calculatedYear Calculation:", calculatedYear);


//     //                     const filterReleaseData = withHeldReleaseData.filter(i => (i.month === monthCalculation && i.year === calculatedYear) && i?.deduction_data?.project === p_id);
//     //                     setfilterwithHeldReleaseData(filterReleaseData);

//     //                     const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];

//     //                     setInvoiceIds(invoiceIds);


//     //                     if (invoiceIds.length > 0) {
//     //                         const res = await axios.get(
//     //                             `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//     //                         );

//     //                         const filteredData = res.data.filter(item => invoiceIds.includes(item.id));
//     //                         if (filteredData.length > 0) {
//     //                             const months = [...new Set(filteredData.map(i => i.month))];
//     //                             const years = [...new Set(filteredData.map(i => i.year))];

//     //                             setMonths(months);
//     //                             setyears(years);

//     //                             const allResults = [];

//     //                             for (const m of months) {
//     //                                 for (const y of years) {
//     //                                     try {
//     //                                         const filterRes = await axios.get(
//     //                                             `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${m}/${y}/`
//     //                                         );
//     //                                         allResults.push(...filterRes.data);
//     //                                     } catch (err) {
//     //                                         console.error(`Failed for month: ${m}, year: ${y}`, err);
//     //                                     }
//     //                                 }
//     //                             }
//     //                             const allIds = [...new Set(allResults.map(i => i.id).filter(Boolean))];

//     //                             console.log("All IDs:", allIds);
//     //                             const secondaryResults = [];

//     //                             for (const id of allIds) {
//     //                                 try {
//     //                                     const secondRes = await axios.get(
//     //                                         `${BASE_URL}/siteproject/newinvoiceemployeefilter/${id}/`  // 👈 replace with your actual endpoint
//     //                                     );
//     //                                     secondaryResults.push(...secondRes.data);
//     //                                 } catch (err) {
//     //                                     console.error(`Failed for id: ${id}`, err);
//     //                                 }
//     //                             }

//     //                             console.log("Secondary Results:", secondaryResults);
//     //                             setGetSheetData(secondaryResults);


//     //                             const getboqIds = allResults.map(i => i?.employee_details?.id);

//     //                             setGetResults(getboqIds);
//     //                             setGetAllResults(allResults);

//     //                             console.log(allResults, "allresults"); // all fetched data combined
//     //                             console.log(getboqIds, "getboqIds"); // all fetched data combined
//     //                             // setYourState(allResults);
//     //                         }
//     //                     }









//     //                     const data = response.data;





//     //                     let selectedData = [];

//     //                     if (data.length > 0) {
//     //                         const uids = data.map(item => item.id).filter(Boolean);

//     //                         let uidResults = [];

//     //                         for (const uid of uids) {
//     //                             const res = await axios.get(
//     //                                 `${BASE_URL}/siteproject/newinvoiceemployeefilter/${uid}/`
//     //                             );


//     //                             if (!res.data || res.data.length === 0) {
//     //                                 console.error(`No data found for UID ${uid}. Breaking loop.`);
//     //                                 dataFound = false;
//     //                                 break; // stop everything
//     //                             }

//     //                             uidResults = [...uidResults, ...res.data];
//     //                         }

//     //                         if (!dataFound && uidResults.length === 0) {
//     //                             break; // if any uid fails, exit while loop
//     //                         }

//     //                         selectedData = uidResults;


//     //                     } else {
//     //                         // ❌ No data -> skip calling second API
//     //                         console.warn(
//     //                             `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
//     //                         );

//     //                         currentMonth -= 1;
//     //                         if (currentMonth === 0) {
//     //                             currentMonth = 12;
//     //                             currentYear -= 1;
//     //                         }

//     //                         if (currentYear < year - 1) {
//     //                             console.error("No data found for the past 1 year.");
//     //                             break;
//     //                         }

//     //                         continue; // retry loop with new month/year
//     //                     }

//     //                     console.log("Selected Data for month/year", selectedData);


//     //                     if (selectedData.length > 0) {

//     //                         const updatedGetAllResults = getSheetData.map((resultItem) => {

//     //                             const matchingReleases = filterwithHeldReleaseData.filter(
//     //                                 (r) => r?.deduction_data?.item_id === resultItem.id
//     //                             );

//     //                             setmatchingData(matchingReleases);



//     //                             const totalReleaseAmount = matchingReleases.reduce(
//     //                                 (sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0),
//     //                                 0
//     //                             );
//     //                             const totalDeductionAmount = matchingReleases.reduce(
//     //                                 (sum, r) => sum + (Number(r.deduction_amount) || 0),
//     //                                 0
//     //                             );

//     //                             const total = totalReleaseAmount + totalDeductionAmount;

//     //                             return {
//     //                                 id: resultItem?.employee_details?.id,  // 👈 boq id
//     //                                 total_AMOUNT: totalDeductionAmount,
//     //                             };

//     //                         });

//     //                         // ✅ Result: [{ id: 5, total: 350 }, { id: 8, total: 200 }, ...]
//     //                         console.log("Updated Results:", updatedGetAllResults);
//     //                         console.log("Updated Results:", updatedGetAllResults);
//     //                         setGetTotalWithid(updatedGetAllResults);


//     //                         const updatedEmployeeData = selectedData.map((item) => {
//     //                             const oldData = getAllResults.filter(i => i.employee_details?.id === item.employee_details?.id);
//     //                             const releAseData = filterwithHeldReleaseData.filter(i => i.deduction_data?.item_id === getAllResults.id)
//     //                             const prevAmount = parseFloat(item.previous_invoice_total) || 0;
//     //                             const currentAmount = item.invoice_amount === null
//     //                                 ? parseFloat(item.current_invoice_amount) || 0
//     //                                 : parseFloat(item.invoice_amount) || 0;

//     //                             const newPreviousAmount = prevAmount + currentAmount;

//     //                             const prev = parseFloat(item.actual_month_total_previous) || 0;
//     //                             const current = parseFloat(item.actual_month) || 0;
//     //                             const newPrevious = prev + current;

//     //                             const prev_month_array = item.actual_month_total_previous_two?.map((i) => (i));
//     //                             const prev_amount_array = item.previous_invoice_total_two?.map((i) => (i));

//     //                             const current_amount_array = item.current_invoice_amount_two?.map((i) => (i));
//     //                             const current_month_array = item.actual_month_two?.map((i) => (i));

//     //                             const sum_previous_month = current_month_array.map((val, idx) => {
//     //                                 const prevVal = prev_month_array?.[idx] ?? 0;
//     //                                 return (Number(val) || 0) + (Number(prevVal) || 0);
//     //                             });

//     //                             const sum_previous_amount = current_amount_array.map((val, idx) => {
//     //                                 const prevVal = prev_amount_array?.[idx] ?? 0;
//     //                                 return (Number(val) || 0) + (Number(prevVal) || 0);
//     //                             });

//     //                             return {
//     //                                 ...item,
//     //                                 updated_previous_invoice_total: sum_previous_amount,
//     //                                 updated_actual_month_total_previous: sum_previous_month,
//     //                             };
//     //                         });

//     //                         console.log("Updated Progress Data:", updatedEmployeeData);
//     //                         setEmployeeList(updatedEmployeeData);
//     //                         setEmployeeListLoaded(true);
//     //                         dataFound = true;


//     //                     }

//     //                 }


//     //                 // ✅ If no data was found even after the loop
//     //                 if (!dataFound) {
//     //                     setEmployeeListLoaded(true);
//     //                 }

//     //             } catch (error) {
//     //                 console.error("Error fetching progress data:", error);
//     //                 setEmployeeListLoaded(true); // ✅ Still unblock the second effect on error
//     //             }
//     //         };








//     //         getEmployeeData();
//     //     }
//     // }, [month, year, show]);
//     useEffect(() => {
//         if (show === true) {
//             if (!month || !year) {
//                 console.error("Both month and year are required to fetch progress data.");
//                 return;
//             }

//             // const getEmployeeData = async () => {
//             //     try {
//             //         let currentMonth = month - 1 === 0 ? 12 : month - 1;
//             //         let currentYear = month - 1 === 0 ? year - 1 : year;
//             //         let dataFound = false;
//             //         let currentPercent = 0;

//             //         // ✅ Helper: only moves forward, never back
//             //         const updateProgress = (percent, label) => {
//             //             currentPercent = Math.max(currentPercent, percent);
//             //             setFetchProgress({ percent: currentPercent, label });
//             //         };

//             //         updateProgress(5, "Connecting to server...");

//             //         while (!dataFound) {
//             //             updateProgress({ percent: 5, label: "Connecting to server..." });

//             //             const response = await axios.get(
//             //                 `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//             //             );
//             //             updateProgress({ percent: 20, label: "Fetching withheld release data..." });

//             //             const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//             //             // ✅ Store raw data in local variable
//             //             const releaseRawData = releaseResponse.data;
//             //             setWithHeldReleaseData(releaseRawData);
//             //             updateProgress({ percent: 30, label: "Fetching deduction data..." });

//             //             const deductionResponse = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/${p_id}/null/null/`);
//             //             setWithHeldDeductionData(deductionResponse.data);

//             //             const monthInt = parseInt(month, 10);
//             //             const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//             //             const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//             //             console.log("Month Calculation:", monthCalculation);
//             //             console.log("calculatedYear Calculation:", calculatedYear);

//             //             // ✅ Use local variable instead of state
//             //             const filterReleaseData = releaseRawData.filter(i =>
//             //                 (i.month === monthCalculation && i.year === calculatedYear) &&
//             //                 i?.deduction_data?.project === p_id
//             //             );
//             //             setfilterwithHeldReleaseData(filterReleaseData);

//             //             console.log("filterReleaseData:", filterReleaseData);

//             //             const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
//             //             setInvoiceIds(invoiceIds);

//             //             let localAllResults = [];
//             //             let localSheetData = [];

//             //             if (invoiceIds.length > 0) {
//             //                 updateProgress({ percent: 40, label: "Fetching consultant invoices..." });

//             //                 const res = await axios.get(
//             //                     `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//             //                 );

//             //                 const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

//             //                 if (filteredData.length > 0) {
//             //                     const months = [...new Set(filteredData.map(i => i.month))];
//             //                     const years = [...new Set(filteredData.map(i => i.year))];

//             //                     setMonths(months);
//             //                     setyears(years);
//             //                     const totalMonthYearCalls = months.length * years.length;
//             //                     let completedMonthYearCalls = 0;

//             //                     for (const m of months) {
//             //                         for (const y of years) {
//             //                             try {
//             //                                 const filterRes = await axios.get(
//             //                                     `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${m}/${y}/`
//             //                                 );
//             //                                 localAllResults.push(...filterRes.data);
//             //                             } catch (err) {
//             //                                 console.error(`Failed for month: ${m}, year: ${y}`, err);
//             //                             }
//             //                             completedMonthYearCalls++;
//             //                             const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
//             //                             updateProgress({ percent: 40 + monthYearPercent, label: `Fetching BOQ data for ${m}/${y}...` });
//             //                         }
//             //                     }

//             //                     console.log("All Results:", localAllResults);

//             //                     const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
//             //                     console.log("All IDs:", allIds);
//             //                     const totalIdCalls = allIds.length;
//             //                     let completedIdCalls = 0;
//             //                     for (const id of allIds) {
//             //                         try {
//             //                             const secondRes = await axios.get(
//             //                                 `${BASE_URL}/siteproject/newinvoiceemployeefilter/${id}/`
//             //                             );
//             //                             localSheetData.push(...secondRes.data);
//             //                         } catch (err) {
//             //                             console.error(`Failed for id: ${id}`, err);
//             //                         }
//             //                         completedIdCalls++;
//             //                         const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
//             //                         updateProgress({ percent: 55 + idPercent, label: `Loading employee sheet ${completedIdCalls} of ${totalIdCalls}...` });

//             //                     }

//             //                     console.log("Secondary Results:", localSheetData);
//             //                     setGetSheetData(localSheetData);

//             //                     const getboqIds = localAllResults.map(i => i?.employee_details?.id);
//             //                     setGetResults(getboqIds);
//             //                     setGetAllResults(localAllResults);

//             //                     console.log(localAllResults, "allresults");
//             //                     console.log(getboqIds, "getboqIds");
//             //                 }
//             //             }
//             //             updateProgress({ percent: 70, label: "Processing invoice records..." });


//             //             const data = response.data;
//             //             let selectedData = [];

//             //             if (data.length > 0) {
//             //                 const uids = data.map(item => item.id).filter(Boolean);
//             //                 let uidResults = [];
//             //                 const totalUids = uids.length;
//             //                 let completedUids = 0;
//             //                 for (const uid of uids) {
//             //                     const res = await axios.get(
//             //                         `${BASE_URL}/siteproject/newinvoiceemployeefilter/${uid}/`
//             //                     );

//             //                     if (!res.data || res.data.length === 0) {
//             //                         console.error(`No data found for UID ${uid}. Breaking loop.`);
//             //                         dataFound = false;
//             //                         break;
//             //                     }

//             //                     uidResults = [...uidResults, ...res.data];
//             //                     completedUids++;
//             //                     const uidPercent = Math.round((completedUids / totalUids) * 15);
//             //                     updateProgress({ percent: 70 + uidPercent, label: `Loading employee ${completedUids} of ${totalUids}...` });

//             //                 }

//             //                 if (!dataFound && uidResults.length === 0) {
//             //                     break;
//             //                 }

//             //                 selectedData = uidResults;

//             //             } else {
//             //                 console.warn(`No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`);
//             //                 updateProgress({ percent: 15, label: `No data found, checking ${currentMonth - 1}/${currentYear}...` });
//             //                 currentMonth -= 1;
//             //                 if (currentMonth === 0) {
//             //                     currentMonth = 12;
//             //                     currentYear -= 1;
//             //                 }

//             //                 if (currentYear < year - 1) {
//             //                     console.error("No data found for the past 1 year.");
//             //                     break;
//             //                 }

//             //                 continue;
//             //             }

//             //             console.log("Selected Data for month/year", selectedData);

//             //             if (selectedData.length > 0) {
//             //                 updateProgress({ percent: 90, label: "Calculating cumulative totals..." });

//             //                 // ✅ Use localSheetData instead of getSheetData state
//             //                 const updatedGetAllResults = localSheetData.map((resultItem) => {

//             //                     const matchingReleases = filterReleaseData.filter(
//             //                         (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
//             //                     );

//             //                     const totalReleaseAmount = matchingReleases.reduce(
//             //                         (sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0),
//             //                         0
//             //                     );

//             //                     const totalDeductionAmount = matchingReleases.reduce(
//             //                         (sum, r) => sum + (Number(r.deduction_amount) || 0),
//             //                         0
//             //                     );

//             //                     const totalMonthRelease = matchingReleases.reduce(
//             //                         (sum, r) => sum + (r.release_month || 0),
//             //                         0
//             //                     );

//             //                     const total = totalReleaseAmount + totalDeductionAmount;

//             //                     return {
//             //                         id: resultItem?.employee_details?.id,
//             //                         total_AMOUNT: total,
//             //                         total_month_release: totalMonthRelease,
//             //                     };
//             //                 });

//             //                 console.log("Updated Results:", updatedGetAllResults);
//             //                 setGetTotalWithid(updatedGetAllResults);
//             //                 console.log("Updated Results 2:", getTotalWithId);

//             //                 // ✅ Use localAllResults instead of getAllResults state
//             //                 const updatedEmployeeData = selectedData.map((item) => {
//             //                     const empId = item?.employee_details?.id;

//             //                     // 👉 filter all matching entries
//             //                     const matchedData = updatedGetAllResults.filter(i => i.id === empId);

//             //                     // 👉 sum all entries (IMPORTANT FIX)
//             //                     const totalReleaseAmount = matchedData.reduce(
//             //                         (sum, i) => sum + (Number(i.total_AMOUNT) || 0),
//             //                         0
//             //                     );

//             //                     const totalMonthRelease = matchedData.reduce(
//             //                         (sum, i) => sum + (Number(i.total_month_release) || 0),
//             //                         0
//             //                     );

//             //                     const prev_month_array = item.actual_month_total_previous_two?.map((i) => i);
//             //                     const prev_amount_array = item.previous_invoice_total_two?.map((i) => i);
//             //                     const current_amount_array = item.current_invoice_amount_two?.map((i) => i);
//             //                     const current_month_array = item.actual_month_two?.map((i) => i);

//             //                     const sum_previous_month = current_month_array.map((val, idx) => {
//             //                         const prevVal = prev_month_array?.[idx] ?? 0;
//             //                         return (Number(val) || 0) + (Number(prevVal) || 0) + totalMonthRelease;
//             //                     });

//             //                     const sum_previous_amount = current_amount_array.map((val, idx) => {
//             //                         const prevVal = prev_amount_array?.[idx] ?? 0;
//             //                         return (Number(val) || 0) + (Number(prevVal) || 0) + totalReleaseAmount;
//             //                     });

//             //                     return {
//             //                         ...item,
//             //                         updated_previous_invoice_total: sum_previous_amount,
//             //                         updated_actual_month_total_previous: sum_previous_month,
//             //                     };
//             //                 });
//             //                 updateProgress({ percent: 100, label: "Done!" });

//             //                 console.log("Updated Progress Data:", updatedEmployeeData);
//             //                 setEmployeeList(updatedEmployeeData);
//             //                 setEmployeeListLoaded(true);
//             //                 dataFound = true;
//             //             }
//             //         }

//             //         if (!dataFound) {
//             //             updateProgress({ percent: 100, label: "No previous data found." });

//             //             setEmployeeListLoaded(true);
//             //         }

//             //     } catch (error) {
//             //         console.error("Error fetching progress data:", error);
//             //         setFetchProgress({ percent: 100, label: "Error loading data." });

//             //         setEmployeeListLoaded(true);
//             //     }
//             // };

//             const getEmployeeData = async () => {
//                 try {
//                     let currentMonth = month - 1 === 0 ? 12 : month - 1;
//                     let currentYear = month - 1 === 0 ? year - 1 : year;
//                     let dataFound = false;
//                     let currentPercent = 0;

//                     // ✅ Helper: only moves forward, never back
//                     const updateProgress = (percent, label) => {
//                         currentPercent = Math.max(currentPercent, percent);
//                         setFetchProgress({ percent: currentPercent, label });
//                     };

//                     updateProgress(5, "Connecting to server...");

//                     while (!dataFound) {
//                         updateProgress(10, "Fetching previous invoice data...");
//                         const response = await axios.get(
//                             `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//                         );

//                         updateProgress(20, "Fetching withheld release data...");
//                         const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//                         const releaseRawData = releaseResponse.data;
//                         setWithHeldReleaseData(releaseRawData);

//                         updateProgress(30, "Fetching deduction data...");
//                         const deductionResponse = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/${p_id}/null/null/`);
//                         setWithHeldDeductionData(deductionResponse.data);

//                         const monthInt = parseInt(month, 10);
//                         const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//                         const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//                         const filterReleaseData = releaseRawData.filter(i =>
//                             (i.month === monthCalculation && i.year === calculatedYear) &&
//                             i?.deduction_data?.project === p_id
//                         );
//                         setfilterwithHeldReleaseData(filterReleaseData);

//                         const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
//                         setInvoiceIds(invoiceIds);

//                         let localAllResults = [];
//                         let localSheetData = [];

//                         if (invoiceIds.length > 0) {
//                             updateProgress(40, "Fetching consultant invoices...");
//                             const res = await axios.get(
//                                 `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//                             );

//                             const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

//                             if (filteredData.length > 0) {
//                                 const months = [...new Set(filteredData.map(i => i.month))];
//                                 const years = [...new Set(filteredData.map(i => i.year))];
//                                 setMonths(months);
//                                 setyears(years);

//                                 const totalMonthYearCalls = months.length * years.length;
//                                 let completedMonthYearCalls = 0;

//                                 for (const m of months) {
//                                     for (const y of years) {
//                                         try {
//                                             const filterRes = await axios.get(
//                                                 `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${m}/${y}/`
//                                             );
//                                             localAllResults.push(...filterRes.data);
//                                         } catch (err) {
//                                             console.error(`Failed for month: ${m}, year: ${y}`, err);
//                                         }
//                                         completedMonthYearCalls++;
//                                         const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
//                                         updateProgress(40 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
//                                     }
//                                 }

//                                 const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
//                                 const totalIdCalls = allIds.length;
//                                 let completedIdCalls = 0;

//                                 for (const id of allIds) {
//                                     try {
//                                         const secondRes = await axios.get(
//                                             `${BASE_URL}/siteproject/newinvoiceemployeefilter/${id}/`
//                                         );
//                                         localSheetData.push(...secondRes.data);
//                                     } catch (err) {
//                                         console.error(`Failed for id: ${id}`, err);
//                                     }
//                                     completedIdCalls++;
//                                     const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
//                                     updateProgress(55 + idPercent, `Loading employee sheet ${completedIdCalls} of ${totalIdCalls}...`);
//                                 }

//                                 setGetSheetData(localSheetData);
//                                 const getboqIds = localAllResults.map(i => i?.employee_details?.id);
//                                 setGetResults(getboqIds);
//                                 setGetAllResults(localAllResults);
//                             }
//                         }

//                         updateProgress(70, "Processing invoice records...");
//                         const data = response.data;
//                         let selectedData = [];

//                         if (data.length > 0) {
//                             const uids = data.map(item => item.id).filter(Boolean);
//                             let uidResults = [];
//                             const totalUids = uids.length;
//                             let completedUids = 0;

//                             for (const uid of uids) {
//                                 const res = await axios.get(
//                                     `${BASE_URL}/siteproject/newinvoiceemployeefilter/${uid}/`
//                                 );

//                                 if (!res.data || res.data.length === 0) {
//                                     console.error(`No data found for UID ${uid}. Breaking loop.`);
//                                     dataFound = false;
//                                     break;
//                                 }

//                                 uidResults = [...uidResults, ...res.data];
//                                 completedUids++;
//                                 const uidPercent = Math.round((completedUids / totalUids) * 15);
//                                 updateProgress(70 + uidPercent, `Loading employee ${completedUids} of ${totalUids}...`);
//                             }

//                             if (!dataFound && uidResults.length === 0) break;
//                             selectedData = uidResults;

//                         } else {
//                             // ✅ No data for this month — go back but DON'T reset progress
//                             // just update the label, percent stays wherever it is
//                             updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

//                             currentMonth -= 1;
//                             if (currentMonth === 0) {
//                                 currentMonth = 12;
//                                 currentYear -= 1;
//                             }
//                             if (currentYear < year - 1) {
//                                 console.error("No data found for the past 1 year.");
//                                 break;
//                             }
//                             continue;
//                         }

//                         if (selectedData.length > 0) {
//                             updateProgress(90, "Calculating cumulative totals...");

//                             const updatedGetAllResults = localSheetData.map((resultItem) => {
//                                 const matchingReleases = filterReleaseData.filter(
//                                     (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
//                                 );
//                                 const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
//                                 const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
//                                 const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
//                                 const total = totalReleaseAmount + totalDeductionAmount;
//                                 return { id: resultItem?.employee_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
//                             });

//                             setGetTotalWithid(updatedGetAllResults);

//                             const updatedEmployeeData = selectedData.map((item) => {
//                                 const empId = item?.employee_details?.id;
//                                 const matchedData = updatedGetAllResults.filter(i => i.id === empId);
//                                 const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
//                                 const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

//                                 const prev_month_array = item.actual_month_total_previous_two?.map((i) => i);
//                                 const prev_amount_array = item.previous_invoice_total_two?.map((i) => i);
//                                 const current_amount_array = item.current_invoice_amount_two?.map((i) => i);
//                                 const current_month_array = item.actual_month_two?.map((i) => i);

//                                 const sum_previous_month = current_month_array.map((val, idx) => {
//                                     const prevVal = prev_month_array?.[idx] ?? 0;
//                                     return (Number(val) || 0) + (Number(prevVal) || 0) + totalMonthRelease;
//                                 });
//                                 const sum_previous_amount = current_amount_array.map((val, idx) => {
//                                     const prevVal = prev_amount_array?.[idx] ?? 0;
//                                     return (Number(val) || 0) + (Number(prevVal) || 0) + totalReleaseAmount;
//                                 });

//                                 return {
//                                     ...item,
//                                     updated_previous_invoice_total: sum_previous_amount,
//                                     updated_actual_month_total_previous: sum_previous_month,
//                                 };
//                             });

//                             updateProgress(100, "Done!");
//                             setEmployeeList(updatedEmployeeData);
//                             setEmployeeListLoaded(true);
//                             dataFound = true;
//                         }
//                     }

//                     if (!dataFound) {
//                         updateProgress(100, "No previous data found.");
//                         setEmployeeListLoaded(true);
//                     }

//                 } catch (error) {
//                     console.error("Error fetching progress data:", error);
//                     setFetchProgress({ percent: 100, label: "Error loading data." });
//                     setEmployeeListLoaded(true);
//                 }
//             };
//             getEmployeeData();
//         }
//     }, [month, year, show]);





//     // **************************************End of Previous data Fetch Code*****************************************

//     // **************************************Revised data Fetch Code*****************************************

//     const employeeID = employeeData.map(e => e.id);
//     const empData = logData.filter(item =>
//         employeeID.includes(item.object_id)
//     );
//     const empChangeReason = employeeData[0]?.reason_of_change || "";

//     const groupedByRandomChange = Object.entries(
//         empData.reduce((acc, item) => {
//             const groupKey = item.data?.random_value_of_changes;
//             if (!acc[groupKey]) acc[groupKey] = [];
//             acc[groupKey].push(item);
//             return acc;
//         }, {})
//     ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

//     const selectedGroup = logid === "null"
//         ? employeeData
//         : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

//     // **************************************End of Revised data Fetch Code*****************************************

//     // **************************************BOQ Fetch Code*****************************************
//     const getData = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/boqemployeebyproject/${p_id}/`);
//             if (Array.isArray(res.data)) {
//                 setEmployeeData(res.data);
//             } else {
//                 console.error("Error: Expected a list of transportation items");
//             }
//         } catch (err) {
//             console.error("Error fetching transportation data", err);
//         }
//     };

//     const [finalFormData, setFinalFormData] = useState([]);

//     useEffect(() => {
//         if (!employeeListLoaded || employeeData.length === 0) return;

//         console.log("selectedGroup");
//         console.log(selectedGroup);



//         const initialData = selectedGroup
//             .sort((a, b) =>
//                 logid === "null"
//                     ? a.rank - b.rank
//                     : a.data.rank - b.data.rank
//             )
//             .flatMap((item) => {
//                 const empId = item.object_id ?? item.id;

//                 // Find matching progress entry from previousProgressData
//                 // const matchedProgress = employeeList.find((progress) => {
//                 //     console.log("Trying to match:", empId, "with progress.employee:", progress.employee);
//                 //     return String(progress.employee) === String(empId);
//                 // });
//                 const matchedProgress = employeeList.filter(
//                     (progress) => String(progress.employee) === String(empId)
//                 );

//                 const previousInvoice = employeeList.map((i) => (i))

//                 console.log("Matched All Progress for empId", empId, ":", matchedProgress);


//                 console.log("Matched Progress:", previousInvoice);


//                 if (logid === "null") {

//                     if (
//                         !item.employee_name_details ||
//                         item.employee_name_details.length === 0

//                     ) {

//                         const rate = Number(item.rate ?? 0);
//                         const cp = Number(item.MM_construction_period ?? 0);
//                         const dlp = Number(item.MM_OM_period ?? 0);
//                         const employee_names = item.employee_name_details?.map((i) => i.name);
//                         const employee_namess = item?.employee_name_details?.map((i) => ({
//                             id: i.id,
//                             name: i.name,
//                             replacement_deduction: i.replacement_deduction
//                         }));


//                         const replacementDeduction = item.employee_name_details?.map((i) => (
//                             i.replacement_deduction === "" ? 0 : i.replacement_deduction
//                         ));




//                         const employeeMonths = employee_namess.map(emp =>
//                             BOQAttendanceList.find(a => a.employee === emp.id)?.man_months || 0
//                         );

//                         const totalEmployeeMonths = employeeMonths.reduce((sum, val) => sum + Number(val || 0), 0);

//                         const calculateAmount = employee_namess.map((emp, idx) => {
//                             const manMonth = Number(employeeMonths[idx]);
//                             const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

//                             if (manMonth === 0) return 0; // ✅

//                             let amount = 0;
//                             if (replacement > 0) {
//                                 amount = replacement * manMonth;
//                             } else if (eot_details && eot_details.length > 0) {
//                                 const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
//                                 amount = manMonth * lastRate;
//                             } else {
//                                 amount = manMonth * Number(item?.rate || 0);
//                             }
//                             return Number(amount.toFixed(0));
//                         });

//                         const totalCalculateAmount = calculateAmount.reduce((sum, val) => sum + Number(val || 0), 0);




//                         const attendance = employeeMonths.map(i => ({
//                             month: i.man_months ?? 0

//                         }));









//                         const eot_details = item.eot_details?.map((item) => (
//                             item
//                         ));




//                         const previousArray = previousInvoice
//                             .filter((inv) => inv.employee_details?.id === empId)
//                             .flatMap((inv) => inv.updated_actual_month_total_previous);

//                         const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);



//                         const previousAmount = previousInvoice
//                             .filter((inv) => inv.employee_details?.id === empId)
//                             .flatMap((inv) => inv.updated_previous_invoice_total);

//                         const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);


//                         const COMULATED_MONTH = employeeMonths.map((val, idx) => {
//                             const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
//                             return (Number(val) || 0) + (Number(prevVal) || 0);
//                         });
//                         const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
//                         const COMULATED_Amount = calculateAmount.map((val, idx) => {
//                             const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
//                             return (Number(val) || 0) + (Number(prevVal) || 0);
//                         });
//                         const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

//                         let remainingamount;

//                         if (item.eot_details && item.eot_details.length > 0) {
//                             const lastEOT = item.eot_details[item.eot_details.length - 1];
//                             remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
//                         } else {
//                             const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
//                             const TOTAL = Number(monthh) * Number(item.rate);
//                             remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
//                         }
//                         let remainingmonth;

//                         if (item.eot_details && item.eot_details.length > 0) {
//                             const lastEOT = item.eot_details[item.eot_details.length - 1];
//                             remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
//                         } else {
//                             const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
//                             remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
//                         }

//                         return {
//                             project: p_id,
//                             invoice: invoice_id,
//                             employee: empId,
//                             actual_month: totalEmployeeMonths,
//                             month: month,
//                             year: year,
//                             designation_name: item.designation_name,
//                             actual_month_cumulative_total_two: COMULATED_MONTH,
//                             actual_amount_cumulative_total: COMULATED_Amount,
//                             actual_month_cumulative_total: totalCOMULATED_MONTH,
//                             actual_month_two: (employeeMonths && employeeMonths.length > 0)
//                                 ? employeeMonths
//                                 : [0],
//                             cumulative_invoice_total: totalCOMULATED_Amount,
//                             contract_amount: "",
//                             remaining_amount: remainingamount,
//                             actual_month_remaining: remainingmonth,
//                             invoice_amount: totalCalculateAmount,
//                             actual_month_total_previous_two: previousArray,
//                             previous_invoice_total_two: previousAmount,
//                             current_invoice_amount_two: calculateAmount,
//                             previous_invoice_total: previousAmountSum,
//                             actual_month_total_previous: previousSum,
//                             boq_designation: item.rank,
//                             boq_rate: rate,
//                             boq_empcode: "TBN",
//                             boq_name_employee: "TBN",
//                             boq_name_employee_two: (employee_names && employee_names.length > 0)
//                                 ? employee_names
//                                 : ["TBN"],
//                             boq_construction_period: cp,
//                             boq_OM_period: dlp,
//                             eot_details: eot_details,
//                             replacement_deduction: replacementDeduction || [0],

//                         };

//                     }
//                     // // Step 1: Flatten all employees across all items

//                     const rate = Number(item.rate ?? 0);
//                     const cp = Number(item.MM_construction_period ?? 0);
//                     const dlp = Number(item.MM_OM_period ?? 0);
//                     const employee_names = item.employee_name_details?.map((i) => i.name);
//                     const employee_namess = item?.employee_name_details?.map((i) => ({
//                         id: i.id,
//                         name: i.name,
//                         replacement_deduction: i.replacement_deduction
//                     }));


//                     const replacementDeduction = item.employee_name_details?.map((i) => (
//                         i.replacement_deduction === "" ? 0 : i.replacement_deduction
//                     ));

//                     const contractAmount = item.rate



//                     const employeeMonths = employee_namess.map(emp =>
//                         BOQAttendanceList.find(a => a.employee === emp.id)?.man_months || 0
//                     );

//                     const totalEmployeeMonths = employeeMonths.reduce((sum, val) => sum + Number(val || 0), 0);








//                     const eot_details = item.eot_details?.map((item) => (
//                         item
//                     ));

//                     const calculateAmount = employee_namess.map((emp, idx) => {
//                         const manMonth = Number(employeeMonths[idx]);
//                         const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

//                         if (manMonth === 0) return 0; // ✅

//                         let amount = 0;
//                         if (replacement > 0) {
//                             amount = replacement * manMonth;
//                         } else if (eot_details && eot_details.length > 0) {
//                             const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
//                             amount = manMonth * lastRate;
//                         } else {
//                             amount = manMonth * Number(item?.rate || 0);
//                         }
//                         return Number(amount.toFixed(0));
//                     });
//                     const totalCalculateAmount = calculateAmount.reduce((sum, val) => sum + Number(val || 0), 0);


//                     const previousArray = previousInvoice
//                         .filter((inv) => inv.employee_details?.id === empId)
//                         .flatMap((inv) => inv.updated_actual_month_total_previous);

//                     const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);



//                     const previousAmount = previousInvoice
//                         .filter((inv) => inv.employee_details?.id === empId)
//                         .flatMap((inv) => inv.updated_previous_invoice_total);

//                     const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);


//                     const COMULATED_MONTH = employeeMonths.map((val, idx) => {
//                         const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
//                         return (Number(val) || 0) + (Number(prevVal) || 0);
//                     });
//                     const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
//                     const COMULATED_Amount = calculateAmount.map((val, idx) => {
//                         const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
//                         return (Number(val) || 0) + (Number(prevVal) || 0);
//                     });
//                     const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

//                     let remainingamount;

//                     if (item.eot_details && item.eot_details.length > 0) {
//                         const lastEOT = item.eot_details[item.eot_details.length - 1];
//                         remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
//                     } else {
//                         const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
//                         const TOTAL = Number(monthh) * Number(item.rate);
//                         remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
//                     }
//                     let remainingmonth;

//                     if (item.eot_details && item.eot_details.length > 0) {
//                         const lastEOT = item.eot_details[item.eot_details.length - 1];
//                         remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
//                     } else {
//                         const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
//                         remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
//                     }

//                     return {
//                         project: p_id,
//                         invoice: invoice_id,
//                         employee: empId,
//                         actual_month: totalEmployeeMonths.toFixed(2),
//                         month: month,
//                         rank: item.rank,

//                         year: year,
//                         designation_name: item.designation_name,
//                         actual_month_cumulative_total_two: COMULATED_MONTH,
//                         actual_amount_cumulative_total: COMULATED_Amount,
//                         actual_month_cumulative_total: totalCOMULATED_MONTH,
//                         actual_month_two: employeeMonths ?? 0,
//                         cumulative_invoice_total: totalCOMULATED_Amount,
//                         contract_amount: "",
//                         remaining_amount: remainingamount,
//                         actual_month_remaining: remainingmonth,
//                         invoice_amount: totalCalculateAmount,
//                         actual_month_total_previous_two: previousArray,
//                         previous_invoice_total_two: previousAmount,
//                         current_invoice_amount_two: calculateAmount,
//                         previous_invoice_total: previousAmountSum,
//                         actual_month_total_previous: previousSum,
//                         boq_rate: rate,
//                         boq_empcode: "TBN",
//                         boq_name_employee: "TBN",
//                         boq_name_employee_two: employee_names,
//                         boq_construction_period: cp,
//                         boq_OM_period: dlp,
//                         boq_designation: item.rank,

//                         eot_details: eot_details,
//                         replacement_deduction: replacementDeduction || [0],


//                     };

//                 }
//                 else {
//                     if (item.employee_name?.length === 0) {
//                         const empCodes = item.data.empcode; // ["emp1", "emp2"]
//                         const rate = Number(item.data?.rate ?? 0);
//                         const cp = Number(item.data?.MM_construction_period ?? 0);
//                         const dlp = Number(item.data?.MM_OM_period ?? 0);
//                         const rank = item.data.rankl;



//                         const employee_names = item?.employee_name?.map((i) => i).reverse();
//                         const employee_namess = item?.data?.empcode?.map((i) => (i));
//                         const employeeMonths = employee_namess?.map(emp =>
//                             BOQAttendanceList.find(a => a.employee === emp)?.man_months || 0
//                         );

//                         const replacement = item.employee_replacement_deduction === "" ? 0 : Number(item.employee_replacement_deduction);

//                         const totalEmployeeMonths = employeeMonths?.reduce((sum, val) => sum + Number(val || 0), 0);

//                         const calculateAmount = employee_namess.map((emp, idx) => {
//                             const manMonth = Number(employeeMonths[idx]);
//                             const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

//                             if (manMonth === 0) return 0; // ✅

//                             let amount = 0;
//                             if (replacement > 0) {
//                                 amount = replacement * manMonth;
//                             } else if (eot_details && eot_details.length > 0) {
//                                 const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
//                                 amount = manMonth * lastRate;
//                             } else {
//                                 amount = manMonth * Number(item?.rate || 0);
//                             }
//                             return Number(amount.toFixed(0));
//                         });

//                         const totalCalculateAmount = calculateAmount?.reduce((sum, val) => sum + Number(val || 0), 0);













//                         const eot_details = item?.data?.eot_details?.map((item) => (
//                             item
//                         ));




//                         const previousArray = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_actual_month_total_previous);

//                         const previousSum = previousArray?.reduce((sum, val) => sum + Number(val || 0), 0);



//                         const previousAmount = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_previous_invoice_total);

//                         const previousAmountSum = previousAmount?.reduce((sum, val) => sum + Number(val || 0), 0);


//                         const COMULATED_MONTH = employeeMonths?.map((val, idx) => {
//                             const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
//                             return (Number(val) || 0) + (Number(prevVal) || 0);
//                         });
//                         const totalCOMULATED_MONTH = COMULATED_MONTH?.reduce((sum, val) => sum + val, 0);
//                         const COMULATED_Amount = calculateAmount?.map((val, idx) => {
//                             const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
//                             return (Number(val) || 0) + (Number(prevVal) || 0);
//                         });
//                         const totalCOMULATED_Amount = COMULATED_Amount?.reduce((sum, val) => sum + val, 0);

//                         let remainingamount;

//                         if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
//                             const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
//                             remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
//                         } else {
//                             const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
//                             const TOTAL = Number(monthh) * Number(item?.data?.rate);
//                             remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
//                         }
//                         let remainingmonth;

//                         if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
//                             const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
//                             remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
//                         } else {
//                             const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
//                             remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
//                         }

//                         return {
//                             project: p_id,
//                             invoice: invoice_id,
//                             employee: empId,
//                             actual_month: totalEmployeeMonths.toFixed(2),
//                             month: month,
//                             year: year,
//                             designation_name: item.designation_name,
//                             actual_month_cumulative_total_two: COMULATED_MONTH,
//                             actual_amount_cumulative_total: COMULATED_Amount,
//                             actual_month_cumulative_total: totalCOMULATED_MONTH,
//                             actual_month_two: (employeeMonths && employeeMonths.length > 0)
//                                 ? employeeMonths
//                                 : ["0"],
//                             cumulative_invoice_total: totalCOMULATED_Amount,
//                             contract_amount: "",
//                             remaining_amount: remainingamount,
//                             actual_month_remaining: remainingmonth,
//                             invoice_amount: totalCalculateAmount,
//                             actual_month_total_previous_two: previousArray,
//                             previous_invoice_total_two: previousAmount,
//                             current_invoice_amount_two: calculateAmount,
//                             previous_invoice_total: previousAmountSum,
//                             actual_month_total_previous: previousSum,
//                             rank: item.data.rank,
//                             boq_designation: item.data.rank,

//                             boq_rate: rate,
//                             boq_empcode: "TBN",
//                             boq_name_employee: "TBN",
//                             boq_name_employee_two: (employee_names && employee_names.length > 0)
//                                 ? employee_names
//                                 : ["TBN"],
//                             boq_construction_period: cp,
//                             boq_OM_period: dlp,
//                             eot_details: eot_details,


//                         };
//                     }


//                     const empCodes = item.data.empcode; // ["emp1", "emp2"]
//                     const rate = Number(item.data?.rate ?? 0);
//                     const cp = Number(item.data?.MM_construction_period ?? 0);
//                     const dlp = Number(item.data?.MM_OM_period ?? 0);



//                     const employee_names = item?.employee_name?.map((i) => i).reverse();
//                     const employee_deductions = item?.employee_replacement_deduction?.map((i) => (i));
//                     const employee_namess = item?.data?.empcode?.map((i) => (i));
//                     const employeeMonths = employee_namess?.map(emp =>
//                         BOQAttendanceList.find(a => a.employee === emp)?.man_months || 0
//                     );

//                     const totalEmployeeMonths = employeeMonths?.reduce((sum, val) => sum + Number(val || 0), 0);
//                     const replacement = item?.employee_replacement_deduction;


//                     const eot_details = item?.data?.eot_details?.map((item) => (
//                         item
//                     ));

//                     const calculateAmount = employee_namess.map((emp, idx) => {
//                         const manMonth = Number(employeeMonths[idx]);
//                         const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

//                         if (manMonth === 0) return 0; // ✅

//                         let amount = 0;
//                         if (replacement > 0) {
//                             amount = replacement * manMonth;
//                         } else if (eot_details && eot_details.length > 0) {
//                             const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
//                             amount = manMonth * lastRate;
//                         } else {
//                             amount = manMonth * Number(item?.rate || 0);
//                         }
//                         return Number(amount.toFixed(0));
//                     });

//                     const totalCalculateAmount = calculateAmount?.reduce((sum, val) => sum + Number(val || 0), 0);



//                     const previousArray = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_actual_month_total_previous);

//                     const previousSum = previousArray?.reduce((sum, val) => sum + Number(val || 0), 0);



//                     const previousAmount = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_previous_invoice_total);

//                     const previousAmountSum = previousAmount?.reduce((sum, val) => sum + Number(val || 0), 0);


//                     const COMULATED_MONTH = employeeMonths?.map((val, idx) => {
//                         const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
//                         return (Number(val) || 0) + (Number(prevVal) || 0);
//                     });
//                     const totalCOMULATED_MONTH = COMULATED_MONTH?.reduce((sum, val) => sum + val, 0);
//                     const COMULATED_Amount = calculateAmount?.map((val, idx) => {
//                         const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
//                         return (Number(val) || 0) + (Number(prevVal) || 0);
//                     });
//                     const totalCOMULATED_Amount = COMULATED_Amount?.reduce((sum, val) => sum + val, 0);

//                     let remainingamount;

//                     if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
//                         const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
//                         remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
//                     } else {
//                         const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
//                         const TOTAL = Number(monthh) * Number(item?.data?.rate);
//                         remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
//                     }
//                     let remainingmonth;

//                     if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
//                         const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
//                         remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
//                     } else {
//                         const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
//                         remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
//                     }


//                     return {
//                         project: p_id,
//                         invoice: invoice_id,
//                         employee: empId,
//                         actual_month: totalEmployeeMonths.toFixed(2),
//                         month: month,
//                         year: year,
//                         designation_name: item.designation_name,
//                         actual_month_cumulative_total_two: COMULATED_MONTH,
//                         actual_amount_cumulative_total: COMULATED_Amount,
//                         actual_month_cumulative_total: totalCOMULATED_MONTH,
//                         actual_month_two: (employeeMonths && employeeMonths.length > 0)
//                             ? employeeMonths
//                             : ["0"],
//                         cumulative_invoice_total: totalCOMULATED_Amount,
//                         contract_amount: "",
//                         remaining_amount: remainingamount,
//                         actual_month_remaining: remainingmonth,
//                         invoice_amount: totalCalculateAmount,
//                         actual_month_total_previous_two: previousArray,
//                         previous_invoice_total_two: previousAmount,
//                         current_invoice_amount_two: calculateAmount,
//                         previous_invoice_total: previousAmountSum,
//                         actual_month_total_previous: previousSum,
//                         boq_designation: item.data.rank,


//                         boq_rate: rate,
//                         boq_empcode: "TBN",
//                         boq_name_employee: "TBN",
//                         boq_name_employee_two: employee_names,
//                         boq_construction_period: cp,
//                         boq_OM_period: dlp,
//                         eot_details: eot_details,
//                         replacement_deduction: replacement || [0],


//                     };
//                 }














//             });

//         setFormData(initialData);



//         console.log(formData);





//     }, [logid, employeeData, employeeList, employeeListLoaded]);

//     console.log("formData");
//     console.log(formData);
//     console.log("selectedGroup");
//     console.log(selectedGroup);

//     useEffect(() => {
//         if (formData?.length > 0) {
//             setFinalFormData(formData);
//         }
//     }, [formData])


//     useEffect(() => {
//         if (formData.length === 0) return;

//         const empCodeCount = formData.reduce((acc, item) => {
//             const code = item.employee;
//             if (code) {
//                 acc[code] = (acc[code] || 0) + 1;
//             }
//             return acc;
//         }, {});

//         const duplicates = formData.filter(item => empCodeCount[item.employee] > 1);
//         if (duplicates.length === 0) return;

//         const rate = Number(duplicates[0]?.boq_rate || 0);
//         const cp = Number(duplicates[0]?.boq_construction_period || 0);
//         const dlp = Number(duplicates[0]?.boq_OM_period || 0);
//         const totalMonths = cp + dlp;
//         const contractAmount = rate * totalMonths;

//         const actual_monthSum = duplicates.reduce((sum, item) => sum + Number(item.actual_month || 0), 0);
//         const actual_AMOUNTsUM = duplicates.reduce((sum, item) => sum + Number(item.invoice_amount || 0), 0);


//         const previous_invoicE = Number(duplicates[0]?.prevoiusAmt || 0);
//         const PREVIOUSmonth = Number(duplicates[0]?.prevoius || 0);
//         const previous_ACTUAL = Number(duplicates[0]?.prevoiusACTUAL || 0);
//         const PREVIOUS_ActualAmt = Number(duplicates[0]?.prevoiusactuallAmt || 0);
//         const previous_invoice_total_sum = Number(duplicates[0]?.previous_invoice_total || 0);
//         const PREVIOUS_MONTH = Number(duplicates[0]?.actual_month_total_previous || 0);

//         const previous_invoice_totall = Number(previous_invoicE || 0) + Number(PREVIOUS_ActualAmt || 0);
//         const previous_month_totall = Number(PREVIOUSmonth || 0) + Number(previous_ACTUAL || 0);

//         const comulatedAmount = previous_invoice_total_sum + actual_AMOUNTsUM;
//         const comulatedMonth = PREVIOUS_MONTH + actual_monthSum;




//         const remainingMonth = totalMonths - comulatedMonth;
//         const remainingAmount = contractAmount - comulatedAmount;

//         // Build updated form data
//         const updatedFormData = formData.map(item => {
//             if (empCodeCount[item.employee] > 1) {
//                 return {
//                     ...item,
//                     actual_month_cumulative_total: comulatedMonth.toFixed(2),
//                     cumulative_invoice_total: comulatedAmount.toFixed(2),
//                     remaining_amount: remainingAmount.toFixed(2),
//                     actual_month_remaining: remainingMonth.toFixed(2),
//                     previous_invoice_total: previous_invoice_totall.toFixed(2),
//                     actual_month_total_previous: previous_month_totall.toFixed(2),
//                 };
//             }
//             return item;
//         });

//         // ✅ Prevent infinite loop by checking if data actually changed
//         const isChanged = JSON.stringify(formData) !== JSON.stringify(updatedFormData);
//         if (isChanged) {
//             setFormData(updatedFormData);
//         }

//     }, [formData]);



//     useEffect(() => {
//         if (!show) return;
//         if (employeeListLoaded) {
//             setModalLoading(false);
//         } else {
//             setModalLoading(true);
//         }
//     }, [employeeListLoaded, show]);




//     // **************************************End of BOQ Fetch Code*****************************************




//     console.log("formData Attendance:", formData);
//     console.log(formData)




//     // Validation start
//     const [errors, setErrors] = useState({});

//     const validateForm = () => {
//         const newErrors = {};

//         formData.forEach((entry, index) => {
//             const requiredFields = [];
//             requiredFields.forEach((field) => {
//                 if (!entry[field]) {
//                     newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//                 }
//             });
//         });

//         setErrors(newErrors);

//         return Object.keys(newErrors).length === 0;
//     };
//     // Validation End

//     // Post API
//     const [loading, setLoading] = useState(false);


//     console.log(formData);
//     console.log("finalFormData")
//     console.log(finalFormData)

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             setShowProgressModal(true);
//             setUploadProgress(0); // Reset progress
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             if (usedfor === "InvoiceandDeduction") {

//                 try {
//                     const res = await axios.post(
//                         `${BASE_URL}/siteproject/invoiceemployeebulk/`,
//                         formData
//                     );

//                     if (res.status === 201) {
//                         const createdData = res.data;

//                         const mappedFinalData = finalFormData.map((item, index) => ({
//                             ...item,
//                             invoiceemployee: createdData[index]?.id, // attach the id from first API
//                         }));

//                         const res2 = await axios.post(
//                             `${BASE_URL}/siteproject/newinvoiceemployeelistcreate/`, // 👈 replace with your actual endpoint
//                             mappedFinalData, {
//                             onUploadProgress: (progressEvent) => {
//                                 const percentCompleted = Math.round(
//                                     (progressEvent.loaded * 100) / progressEvent.total
//                                 );
//                                 setUploadProgress(percentCompleted);
//                             },
//                         }
//                         );

//                         if (res2.status === 201) {
//                             await getEmployeeInvoice();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("BOQ Added Successfully"); // Show success toast
//                             }, 4000);
//                         } else {
//                             alert("Second API failed");
//                         }

//                     } else {
//                         alert("First API failed");
//                     }
//                 } catch (err) {
//                     handleErrorToast(err, loadingToastId);
//                 } finally {
//                     setTimeout(() => {
//                         setShowProgressModal(false);
//                     }, 2000); // Hide after 3 seconds

//                     setTimeout(() => {
//                         setLoading(false); //loading logic
//                         toast.dismiss(loadingToastId);
//                     }, 4000)
//                 }
//             } else if (usedfor === "OnlyDeduction") {
//                 try {
//                     const createdData = invoiceData
//                     const response = await axios.get(`${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${month}/${year}/`);

//                     if (response.status === 200) {


//                         const mappedFinalData = formData.map((item, index) => ({
//                             ...item,
//                             invoiceemployee: response.data[index]?.id, // attach the id from first API
//                         }));

//                         console.log("Mapped Final Data for Deduction:", mappedFinalData);

//                         const res2 = await axios.post(
//                             `${BASE_URL}/siteproject/newinvoiceemployeelistcreate/`, // 👈 replace with your actual endpoint
//                             mappedFinalData, {
//                             onUploadProgress: (progressEvent) => {
//                                 const percentCompleted = Math.round(
//                                     (progressEvent.loaded * 100) / progressEvent.total
//                                 );
//                                 setUploadProgress(percentCompleted);
//                             },
//                         }
//                         );

//                         if (res2.status === 201) {
//                             await getEmployeeInvoice();
//                             handleClose();
//                             setTimeout(() => {
//                                 toast.dismiss(loadingToastId); // Close loading toast
//                                 toast.success("BOQ Added Successfully"); // Show success toast
//                             }, 4000);
//                         } else {
//                             alert("Second API failed");
//                         }
//                     }

//                 } catch (error) {
//                     handleErrorToast(error, loadingToastId);
//                 } finally {
//                     setTimeout(() => {
//                         setShowProgressModal(false);
//                     }, 2000); // Hide after 3 seconds

//                     setTimeout(() => {
//                         setLoading(false); //loading logic
//                         toast.dismiss(loadingToastId);
//                     }, 4000)
//                 }

//             }
//         }
//     };


//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         const updatedFormData = formData.map((entry, i) =>
//             i === index ? { ...entry, [name]: value } : entry
//         );
//         setFormData(updatedFormData);

//     };


//     // ✅ For array fields (actual_month_two, current_invoice_amount_two) with recalculation
//     // const handleArrayInputChange = (e, formIndex, arrayIndex, fieldName) => {
//     //     const { value } = e.target;

//     //     const updatedFormData = formData.map((entry, i) => {
//     //         if (i !== formIndex) return entry;

//     //         // ✅ Update the changed array field
//     //         const updatedArray = [...(entry[fieldName] || [])];
//     //         updatedArray[arrayIndex] = value;

//     //         // ✅ Get latest arrays after change
//     //         const updatedMonths = fieldName === "actual_month_two"
//     //             ? updatedArray
//     //             : [...(entry.actual_month_two || [])];

//     //         const updatedAmounts = fieldName === "current_invoice_amount_two"
//     //             ? updatedArray
//     //             : [...(entry.current_invoice_amount_two || [])];

//     //         // ✅ Recalculate totals
//     //         const totalActualMonth = updatedMonths.reduce((sum, val) => sum + (Number(val) || 0), 0);
//     //         const totalInvoiceAmount = updatedAmounts.reduce((sum, val) => sum + (Number(val) || 0), 0);

//     //         // ✅ Recalculate cumulative
//     //         const previousArray = entry.actual_month_total_previous_two || [];
//     //         const previousAmount = entry.previous_invoice_total_two || [];

//     //         const COMULATED_MONTH = updatedMonths.map((val, idx) => {
//     //             const prevVal = previousArray[idx] ?? 0;
//     //             return (Number(val) || 0) + (Number(prevVal) || 0);
//     //         });

//     //         const COMULATED_Amount = updatedAmounts.map((val, idx) => {
//     //             const prevVal = previousAmount[idx] ?? 0;
//     //             return (Number(val) || 0) + (Number(prevVal) || 0);
//     //         });

//     //         const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
//     //         const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

//     //         // ✅ Recalculate remaining
//     //         let remainingamount;
//     //         let remainingmonth;

//     //         if (entry.eot_details && entry.eot_details.length > 0) {
//     //             const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//     //             remainingamount = Number(lastEOT.total_amount || 0) - totalCOMULATED_Amount;
//     //             remainingmonth = Number(lastEOT.t_month || 0) - totalCOMULATED_MONTH;
//     //         } else {
//     //             const monthh = Number(entry.boq_construction_period || 0) + Number(entry.boq_OM_period || 0);
//     //             const TOTAL = monthh * Number(entry.boq_rate || 0);
//     //             remainingamount = TOTAL - totalCOMULATED_Amount;
//     //             remainingmonth = monthh - totalCOMULATED_MONTH;
//     //         }

//     //         return {
//     //             ...entry,
//     //             [fieldName]: updatedArray,

//     //             // ✅ Recalculated fields
//     //             actual_month: totalActualMonth,
//     //             invoice_amount: totalInvoiceAmount,
//     //             actual_month_cumulative_total_two: COMULATED_MONTH,
//     //             actual_amount_cumulative_total: COMULATED_Amount,
//     //             actual_month_cumulative_total: totalCOMULATED_MONTH,
//     //             cumulative_invoice_total: totalCOMULATED_Amount,
//     //             remaining_amount: remainingamount,
//     //             actual_month_remaining: remainingmonth,
//     //         };
//     //     });

//     //     setFormData(updatedFormData);
//     // };


//     const handleArrayInputChange = (e, formIndex, arrayIndex, fieldName) => {
//         const { value } = e.target;

//         const updatedFormData = formData.map((entry, i) => {
//             if (i !== formIndex) return entry;

//             const updatedArray = [...(entry[fieldName] || [])];
//             updatedArray[arrayIndex] = value;

//             const updatedMonths = fieldName === "actual_month_two"
//                 ? updatedArray
//                 : [...(entry.actual_month_two || [0])];

//             let updatedAmounts;
//             if (fieldName === "actual_month_two") {
//                 updatedAmounts = updatedMonths.map((month, idx) => {
//                     const eot_details = entry.eot_details;
//                     const replacement = entry.replacement_deduction?.[idx];
//                     const manMonth = Number(month) || 0;
//                     const repl = Number(replacement) || 0;

//                     let amount = 0;
//                     if (repl > 0) {
//                         amount = repl * manMonth;
//                     } else if (eot_details && eot_details.length > 0) {
//                         const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
//                         amount = manMonth * lastRate;
//                     } else {
//                         amount = manMonth * Number(entry.boq_rate || 0);
//                     }
//                     return Number(amount.toFixed(0));
//                 });
//             } else {
//                 updatedAmounts = updatedArray;
//             }

//             const totalActualMonth = updatedMonths.reduce((sum, val) => sum + (Number(val) || 0), 0);
//             const totalInvoiceAmount = updatedAmounts.reduce((sum, val) => sum + (Number(val) || 0), 0);

//             const previousArray = entry.actual_month_total_previous_two || [];
//             const previousAmount = entry.previous_invoice_total_two || [];

//             const COMULATED_MONTH = updatedMonths.map((val, idx) => {
//                 const prevVal = previousArray[idx] ?? 0;
//                 return (Number(val) || 0) + (Number(prevVal) || 0);
//             });

//             const COMULATED_Amount = updatedAmounts.map((val, idx) => {
//                 const prevVal = previousAmount[idx] ?? 0;
//                 return (Number(val) || 0) + (Number(prevVal) || 0);
//             });

//             const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
//             const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

//             let remainingamount;
//             let remainingmonth;

//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 remainingamount = Number(lastEOT.total_amount || 0) - totalCOMULATED_Amount;
//                 remainingmonth = Number(lastEOT.t_month || 0) - totalCOMULATED_MONTH;
//             } else {
//                 const monthh = Number(entry.boq_construction_period || 0) + Number(entry.boq_OM_period || 0);
//                 const TOTAL = monthh * Number(entry.boq_rate || 0);
//                 remainingamount = TOTAL - totalCOMULATED_Amount;
//                 remainingmonth = monthh - totalCOMULATED_MONTH;
//             }

//             return {
//                 ...entry,
//                 actual_month_two: updatedMonths,
//                 current_invoice_amount_two: updatedAmounts,
//                 actual_month: totalActualMonth,
//                 invoice_amount: totalInvoiceAmount,
//                 actual_month_cumulative_total_two: COMULATED_MONTH,
//                 actual_amount_cumulative_total: COMULATED_Amount,
//                 actual_month_cumulative_total: totalCOMULATED_MONTH,
//                 cumulative_invoice_total: totalCOMULATED_Amount,
//                 remaining_amount: remainingamount,
//                 actual_month_remaining: remainingmonth,
//             };
//         });

//         setFormData(updatedFormData);
//     };




//     // return (
//     //     <>
//     //         <button title="Add Employee Invoice" className="upload-svg flex-row" onClick={handleShow}>
//     //             <AddwithWhiteCircle />
//     //             {" "} Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//     //         </button>

//     //         <Modal
//     //             show={show}
//     //             onHide={handleClose}
//     //             dialogClassName="model-width90vw width-90vw"
//     //         >
//     //             <Modal.Header closeButton>
//     //                 <div className="flex-row justify-between " style={{ width: "100%" }}>
//     //                     <Modal.Title>Add Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}</Modal.Title>
//     //                     <div>
//     //                         {(employeeData.length > 0 && groupedByRandomChange.length > 0) && (
//     //                             <select
//     //                                 value={logid}
//     //                                 onChange={(e) => setLogId(e.target.value)}
//     //                                 className="ddropdown"
//     //                             >
//     //                                 <option value="null">
//     //                                     BOQ {groupedByRandomChange.length + 1} - {empChangeReason}
//     //                                 </option>
//     //                                 {groupedByRandomChange.map(([groupKey, items], index) => {
//     //                                     const reasons = [...new Set(
//     //                                         items.map(i => i.data?.reason_of_change).filter(reason =>
//     //                                             reason !== null && reason !== "null" && reason?.trim() !== ""
//     //                                         )
//     //                                     )];
//     //                                     return (
//     //                                         <option key={groupKey} value={groupKey}>
//     //                                             BOQ {groupedByRandomChange.length - index}
//     //                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//     //                                         </option>
//     //                                     );
//     //                                 })}
//     //                             </select>
//     //                         )}
//     //                     </div>
//     //                 </div>
//     //             </Modal.Header>
//     //             <Modal.Body>
//     //                 <div className="parent-div">
//     //                     <div className="bdy-div flex-column">

//     //                         <div className="flex-row justify-center">
//     //                             <table className="nested-table-lightblue width-90vw payment">

//     //                                 <thead>
//     //                                     <tr className="custom-table-head-td width-10vw">
//     //                                         <th className="align-left width-5vw" style={{ color: "black", fontWeight: "bold" }}>S no.</th>
//     //                                         <th className=" width-20vw">Employee Name</th>
//     //                                         <th className=" width-20vw">Employee Desigantion</th>

//     //                                         <th className="align-center width-10vw">Actual Month</th>
//     //                                         <th className="text-end width-10vw">Current Invoice Amount</th>
//     //                                     </tr>
//     //                                 </thead>

//     //                                 <tbody>
//     //                                     {formData.sort((a, b) => a.rank - b.rank).map((entry, index) => (
//     //                                         <tr key={index} className="custom-table-head-td ">
//     //                                             <td className="align-left width-5vw">
//     //                                                 {index + 1}.
//     //                                             </td>
//     //                                             {/* <td>
//     //                                                     <input
//     //                                                         name="emp_code"
//     //                                                         value={entry.emp_code || "N/A"}
//     //                                                         className="form-input-date width-10vw"
//     //                                                         disabled
//     //                                                     />
//     //                                                 </td> */}
//     //                                             <td className="width-15vw">
//     //                                                 <p className="" >
//     //                                                     {entry.boq_name_employee_two?.join(", ") || "TBN"}
//     //                                                 </p>
//     //                                             </td>

//     //                                             <td className="width-15vw">
//     //                                                 <p className="">{entry.designation_name}</p>
//     //                                             </td>
//     //                                             <td className="width-15vw">
//     //                                                 {entry.actual_month_two?.map((month, arrayIndex) => (
//     //                                                     <input
//     //                                                         key={arrayIndex}
//     //                                                         type="number"
//     //                                                         value={month}
//     //                                                         onChange={(e) => handleArrayInputChange(e, index, arrayIndex, "actual_month_two")}
//     //                                                         className={`form-input-date width-5vw ${errors[`${index}_no_of_vehicle`] ? "error" : ""}`}

//     //                                                         placeholder={`Month ${arrayIndex + 1}`}
//     //                                                     />
//     //                                                 ))}

//     //                                                 {/* ✅ invoice_amount - array of amounts per employee */}

//     //                                             </td>
//     //                                             <td className="width-15vw">
//     //                                                 <p className="text-end">
//     //                                                     {(entry.current_invoice_amount_two?.length > 0
//     //                                                         ? entry.current_invoice_amount_two
//     //                                                         : entry.actual_month_two?.map(() => 0) // ✅ fallback: one input per month, defaulting to 0
//     //                                                     )?.map((amount, arrayIndex) => (
//     //                                                         <input
//     //                                                             key={arrayIndex}
//     //                                                             type="number"
//     //                                                             value={amount ?? 0} // ✅ always show 0 instead of empty
//     //                                                             onChange={(e) => handleArrayInputChange(e, index, arrayIndex, "current_invoice_amount_two")}
//     //                                                             className={`form-input-date width-5vw ${errors[`${index}_no_of_vehicle`] ? "error" : ""}`}
//     //                                                             placeholder={`Amount ${arrayIndex + 1}`}
//     //                                                         />
//     //                                                     ))}
//     //                                                 </p>
//     //                                             </td>
//     //                                         </tr>
//     //                                     ))}
//     //                                 </tbody>
//     //                             </table>
//     //                         </div>
//     //                         <div className="button-models">
//     //                             <button
//     //                                 className="model-button-cancel model-button font-weight500"
//     //                                 onClick={handleClose}
//     //                             >
//     //                                 Cancel
//     //                             </button>
//     //                             <button
//     //                                 type="submit"
//     //                                 className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//     //                                 disabled={loading}
//     //                                 onClick={handleSubmit}
//     //                             >
//     //                                 Add
//     //                             </button>
//     //                         </div>

//     //                     </div>
//     //                 </div>
//     //                 <ToastContainer
//     //                     position="top-center"
//     //                     autoClose={1000}
//     //                     hideProgressBar={false}
//     //                     newestOnTop={true}
//     //                     closeOnClick
//     //                     rtl={false}
//     //                     pauseOnFocusLoss
//     //                     draggable
//     //                     pauseOnHover
//     //                 />
//     //             </Modal.Body>
//     //         </Modal >


//     //     </>
//     // );

//     return (
//         <>
//             <button title="Add Employee Invoice" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
//                 <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <circle cx="12" cy="12" r="10" />
//                     <line x1="12" y1="8" x2="12" y2="16" />
//                     <line x1="8" y1="12" x2="16" y2="12" />
//                 </svg>
//                 Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//             </button>
//             {showProgressModal ?
//                 <ProgressModal usedFor="Add" show={showProgressModal} progress={uploadProgress} /> :

//                 <Modal
//                     show={show}
//                     onHide={handleClose}
//                     dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
//                 >
//                     <Modal.Header className="eb-bulk-modal-header">
//                         <Modal.Title className="eb-bulk-modal-title">
//                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                 <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
//                                 <polyline points="14 2 14 8 20 8" />
//                                 <line x1="16" y1="13" x2="8" y2="13" />
//                                 <line x1="16" y1="17" x2="8" y2="17" />
//                                 <polyline points="10 9 9 9 8 9" />
//                             </svg>
//                             Add Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//                         </Modal.Title>

//                         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                             {(employeeData.length > 0 && groupedByRandomChange.length > 0) && (
//                                 <select
//                                     value={logid}
//                                     onChange={(e) => setLogId(e.target.value)}
//                                     style={{
//                                         fontSize: "13px",
//                                         background: "var(--surface-2, #fff)",
//                                         border: "0.5px solid var(--border-strong, #ccc)",
//                                         borderRadius: "var(--radius, 8px)",
//                                         padding: "4px 10px",
//                                         cursor: "pointer",
//                                         color: "var(--text-primary)",
//                                     }}
//                                 >
//                                     <option value="null">
//                                         BOQ {groupedByRandomChange.length + 1} - {empChangeReason}
//                                     </option>
//                                     {groupedByRandomChange.map(([groupKey, items], index) => {
//                                         const reasons = [...new Set(
//                                             items.map(i => i.data?.reason_of_change).filter(reason =>
//                                                 reason !== null && reason !== "null" && reason?.trim() !== ""
//                                             )
//                                         )];
//                                         return (
//                                             <option key={groupKey} value={groupKey}>
//                                                 BOQ {groupedByRandomChange.length - index}
//                                                 {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                             </option>
//                                         );
//                                     })}
//                                 </select>
//                             )}
//                             <button className="close-btn" onClick={handleClose}>
//                                 <X size={20} />
//                             </button>
//                         </div>
//                     </Modal.Header>

//                     <Modal.Body className="eb-bulk-modal-body">
//                         {modalLoading ? (
//                             <div style={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 minHeight: "50vh",
//                                 gap: "20px",
//                                 padding: "40px",
//                             }}>
//                                 {/* Spinner */}
//                                 <div style={{
//                                     width: "44px",
//                                     height: "44px",
//                                     border: "3px solid #e0e0e0",
//                                     borderTop: "3px solid #000",
//                                     borderRadius: "50%",
//                                     animation: "eb-spin 0.8s linear infinite",
//                                 }} />

//                                 {/* Label */}
//                                 <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
//                                     {fetchProgress.label || "Loading data..."}
//                                 </p>

//                                 {/* Progress bar track */}
//                                 <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
//                                     <div style={{
//                                         height: "100%",
//                                         width: `${fetchProgress.percent}%`,
//                                         background: "#111",
//                                         borderRadius: "999px",
//                                         transition: "width 0.3s ease",
//                                     }} />
//                                 </div>

//                                 {/* Percentage */}
//                                 <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
//                                     {fetchProgress.percent}%
//                                 </p>

//                                 <style>{`
//             @keyframes eb-spin {
//                 0% { transform: rotate(0deg); }
//                 100% { transform: rotate(360deg); }
//             }
//         `}</style>
//                             </div>
//                         ) : (
//                             <div className="eb-bulk-container">
//                                 <div className="eb-bulk-content">

//                                     <div className="eb-bulk-table-wrapper">
//                                         <div
//                                             className="eb-bulk-table-scroll table-box scroll-container-tablesss"
//                                             style={{ maxHeight: "50vh", minHeight: "50vh" }}
//                                         >
//                                             <table className="eb-bulk-table">
//                                                 <thead className="eb-bulk-table-head">
//                                                     <tr className="eb-bulk-table-header-row">
//                                                         <th className="eb-bulk-th" style={{ width: "48px" }}>
//                                                             <span className="eb-bulk-th-label">#</span>
//                                                         </th>
//                                                         <th className="eb-bulk-th">
//                                                             <span className="eb-bulk-th-label">Employee name</span>
//                                                         </th>
//                                                         <th className="eb-bulk-th">
//                                                             <span className="eb-bulk-th-label">Designation</span>
//                                                         </th>
//                                                         <th className="eb-bulk-th" style={{ textAlign: "right" }}>
//                                                             <span className="eb-bulk-th-label">Actual month</span>
//                                                         </th>
//                                                         <th className="eb-bulk-th" style={{ textAlign: "right" }}>
//                                                             <span className="eb-bulk-th-label">Invoice amount</span>
//                                                         </th>
//                                                     </tr>
//                                                 </thead>

//                                                 <tbody>
//                                                     {formData.sort((a, b) => a.rank - b.rank).map((entry, index) => {
//                                                         const months = Array.isArray(entry.actual_month_two)
//                                                             ? entry.actual_month_two
//                                                             : [];
//                                                         const amounts = entry.current_invoice_amount_two?.length > 0
//                                                             ? entry.current_invoice_amount_two
//                                                             : months.map(() => 0);
//                                                         const names = entry.boq_name_employee_two || [];

//                                                         return months.map((month, arrayIndex) => (
//                                                             <tr key={`${index}-${arrayIndex}`} className="eb-bulk-row">

//                                                                 <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px", verticalAlign: "top" }}>
//                                                                     {arrayIndex === 0 ? `${index + 1}.` : ""}
//                                                                 </td>

//                                                                 <td className="eb-bulk-td" style={{ verticalAlign: "top" }}>
//                                                                     <span style={{ fontWeight: 500 }}>
//                                                                         {names[arrayIndex] || "TBN"}
//                                                                     </span>
//                                                                 </td>

//                                                                 <td className="eb-bulk-td" style={{ color: "var(--text-secondary)", verticalAlign: "top" }}>
//                                                                     {arrayIndex === 0 ? entry.designation_name : ""}
//                                                                 </td>

//                                                                 <td className="eb-bulk-td" style={{ textAlign: "right" }}>
//                                                                     <input
//                                                                         type="number"
//                                                                         step="0.01"
//                                                                         value={
//                                                                             month !== "" && month !== null && month !== undefined
//                                                                                 ? Number(month).toFixed(2)
//                                                                                 : ""
//                                                                         } onChange={(e) =>
//                                                                             handleArrayInputChange(
//                                                                                 e,
//                                                                                 index,
//                                                                                 arrayIndex,
//                                                                                 "actual_month_two"
//                                                                             )
//                                                                         }
//                                                                         className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month_two`] ? "eb-bulk-input-error" : ""}`}
//                                                                         placeholder={`Month ${arrayIndex + 1}`}
//                                                                         style={{ textAlign: "right", width: "80px" }}

//                                                                     />
//                                                                 </td>

//                                                                 <td className="eb-bulk-td" style={{ textAlign: "right" }}>
//                                                                     <input
//                                                                         type="number"
//                                                                         value={amounts[arrayIndex] ?? 0}
//                                                                         onChange={(e) => handleArrayInputChange(e, index, arrayIndex, "current_invoice_amount_two")}
//                                                                         className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_no_of_vehicle`] ? "eb-bulk-input-error" : ""}`}
//                                                                         placeholder={`Amount ${arrayIndex + 1}`}
//                                                                         style={{ textAlign: "right", width: "80px" }}
//                                                                     />
//                                                                 </td>
//                                                             </tr>
//                                                         ));
//                                                     })}
//                                                 </tbody>
//                                             </table>
//                                         </div>
//                                     </div>

//                                     <div className="eb-bulk-footer-actions">
//                                         <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
//                                             Cancel
//                                         </button>
//                                         <button
//                                             type="submit"
//                                             className="eb-bulk-btn eb-bulk-btn-submit"
//                                             disabled={loading}
//                                             onClick={handleSubmit}
//                                             style={{ background: "black" }}
//                                         >
//                                             {loading ? (
//                                                 <span className="eb-bulk-btn-loader">
//                                                     <span className="eb-bulk-spinner"></span>
//                                                     Submitting...
//                                                 </span>
//                                             ) : (
//                                                 <>
//                                                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                         <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
//                                                         <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
//                                                     </svg>
//                                                     Add
//                                                 </>
//                                             )}
//                                         </button>
//                                     </div>

//                                 </div>
//                             </div>
//                         )}

//                         <ToastContainer
//                             position="top-center"
//                             autoClose={1000}
//                             hideProgressBar={false}
//                             newestOnTop={true}
//                             closeOnClick
//                             rtl={false}
//                             pauseOnFocusLoss
//                             draggable
//                             pauseOnHover
//                         />
//                     </Modal.Body>
//                 </Modal>
//             }
//         </>
//     );

// };






// const AddTransportationInvoice = ({ p_id, invoice_id, getTransportationInvoice, month, year,logData }) => {
//     const [show, setShow] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         getTransportation();
//         setShow(true);
//     };




//     const [formData, setFormData] = useState([]);
//     const [logid, setLogId] = useState("null");
//     const [transportation, setTransportation] = useState([]);
//  const transportID = transportation.map(e => e.id);
//     const transportChangeReason = transportation[0]?.reason_of_change || "";


//     const rentData = logData.filter(item =>
//         transportID.includes(item.object_id)
//     );

//      const groupedByRandomChange = Object.entries(
//         transportData.reduce((acc, item) => {
//             const groupKey = item.data?.random_value_of_changes;
//             if (!acc[groupKey]) acc[groupKey] = [];
//             acc[groupKey].push(item);
//             return acc;
//         }, {})
//     ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

//     const selectedGroup = logid === "null"
//         ? transportation
//         : groupedByRandomChange[parseInt(logid)]?.[1] || [];
//     const getTransportation = async () => {
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/siteproject/boqtransportbyproject/${p_id}/`
//             );

//             if (Array.isArray(res.data)) {
//                 setTransportation(res.data);
//                 const initialData = selectedGroup.map((item) => ({
//                     project: p_id,
//                     invoice: invoice_id,
//                     transport: item.id,
//                     actual_month: "",
//                     month: month,
//                     year: year,
//                     // current_invoice_amount: ""
//                 }));
//                 setFormData(initialData);
//             } else {
//                 console.error("Error: Expected a list of transportation items");
//             }
//         } catch (err) {
//             console.error("Error fetching transportation data", err);
//         }
//     };
//     console.log(formData.actual_month);



//     // !  ************** Validation start **************  ! //

//     const [errors, setErrors] = useState({});

//     const validateForm = () => {
//         const newErrors = {};

//         formData.forEach((entry, index) => {
//             const requiredFields = [];
//             requiredFields.forEach((field) => {
//                 if (!entry[field]) {
//                     newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//                 } else {
//                     delete newErrors[`${index}_${field}`]; // Remove error if input is present
//                 }
//             });
//         });

//         setErrors(newErrors);

//         return Object.keys(newErrors).length === 0;
//     };

//     // ?  ************** Validation End **************  ! //

//     //! **************************** post API ***********************!//
//     const [loading, setLoading] = useState(false); //loading logic

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 // Submit the formData array as bulk data
//                 const res = await axios.post(
//                     `${BASE_URL}/siteproject/invoicetransportationbulk-auto-calculate-amount/`,
//                     formData
//                 );

//                 if (res.status === 201) {
//                     await getTransportationInvoice();
//                     setShow(false);
//                     toast.dismiss(loadingToastId);
//                     toast.success("Transportation Data added Successfully");
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 // handleErrorToast(err, loadingToastId);
//             } finally {
//                 setLoading(false); //loading logic
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };
//     console.log(formData)

//     //! **************************** post API End ***********************!//

//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;
//         const updatedFormData = formData.map((entry, i) =>
//             i === index ? { ...entry, [name]: value } : entry
//         );
//         setFormData(updatedFormData);
//     };

//     return (
//         <>
//             <button title="Add Transportation" className="upload-svg flex-row" onClick={handleShow}>
//                 <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="24"
//                     height="24"
//                     viewBox="0 0 24 24"
//                     fill="none"
//                 >
//                     <g clip-path="url(#clip0_1415_3177)">
//                         <path
//                             d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
//                             fill="white"
//                         />
//                     </g>
//                     <defs>
//                         <clipPath id="clip0_1415_3177">
//                             <rect width="24" height="24" fill="white" />
//                         </clipPath>
//                     </defs>
//                 </svg>
//                 {" "} Transportation
//             </button>

//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="three-fourth-modal"
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Transportation for Invoice</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div flex-column">
//                               <div>
//                         {(transportation.length > 0 && transportData.length >= 1) && (
//                             <select
//                                 value={logid}
//                                 onChange={(e) => setLogId(e.target.value)}
//                                 className="dropdown font-size-subheading navbar-inputt"
//                             >
//                                 <option value="null">
//                                     BOQ {groupedByRandomChange.length + 1}- {transportChangeReason}
//                                 </option>

//                                 {groupedByRandomChange.map(([groupKey, items], index) => {
//                                     const reasons = [...new Set(
//                                         items
//                                             .map(i => i.data?.reason_of_change)
//                                             .filter(reason =>
//                                                 reason !== null &&
//                                                 reason !== "null" &&
//                                                 reason?.trim() !== ""
//                                             )
//                                     )];

//                                     return (
//                                         <option key={groupKey} value={index}>
//                                             BOQ {groupedByRandomChange.length - index}
//                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                         </option>
//                                     );
//                                 })}




//                             </select>
//                         )}
//                     </div>
//                             <div className="flex-row justify-center">
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead>
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="align-left width-10vw">S no.</th>
//                                             <th className="align-center width-10vw">Transport</th>
//                                             <th className="align-center width-10vw">Actual Month</th>
//                                         </tr>
//                                     </thead>

//                                     <tbody>

//                                         {formData.map((entry, index) => (
//                                             <tr className="custom-table-head-td ">

//                                                 <td className="align-left width-5vw" >
//                                                     {index + 1}
//                                                 </td>
//                                                 <td>
//                                                     <div title="Transportation" className="flex-column form-group-selectt">
//                                                         <p>
//                                                         {transportation.find(t => t.id === entry.transport)?.vehicle_description || "Loading..."}
//                                                         </p>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div title="Actual Month" className="flex-column align-items-center">
//                                                         <input
//                                                             className={`form-input-date  width-5vw  ${errors[`${index}_actual_month`] ? "error" : ""}`}
//                                                             id={`actual_month_${index}`}
//                                                             name="actual_month"
//                                                             type="number"
//                                                             value={entry.actual_month}

//                                                             onChange={(e) => handleInputChange(e, index)}

//                                                         />
//                                                         <div>
//                                                             {errors[`${index}_actual_month`] && (
//                                                                 <span className="error-message font-size-text ">{errors[`${index}_actual_month`]}</span>
//                                                             )}
//                                                         </div>
//                                                     </div>
//                                                 </td>


//                                             </tr>
//                                         ))}

//                                     </tbody>

//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button font-weight500"
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}
//                                 >
//                                     Add
//                                 </button>
//                             </div>

//                         </div>
//                     </div>
//                     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//                 </Modal.Body>
//             </Modal >
//         </>
//     );
// };

const AddEmployeeInvoice = ({ invoiceData, p_id, invoice_id, getEmployeeInvoice, month, year, logData, usedfor }) => {
    const [show, setShow] = useState(false);
    const [employeeData, setEmployeeData] = useState([]);
    const [logid, setLogId] = useState("null");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setEmployeeListLoaded(false);
        setFetchProgress({ percent: 0, label: "" }); // reset for next open
    };
    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
    const [withHeldDeductionData, setWithHeldDeductionData] = useState([]);
    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
    const [invoiceIds, setInvoiceIds] = useState([]);
    const [months, setMonths] = useState([]);
    const [years, setyears] = useState([]);
    const [getResults, setGetResults] = useState([]);
    const [getAllResults, setGetAllResults] = useState([]);
    const [getSheetData, setGetSheetData] = useState([])
    const [getTotalWithId, setGetTotalWithid] = useState([])
    const [matchingData, setmatchingData] = useState([])
    const [modalLoading, setModalLoading] = useState(false);
    const handleShow = async () => {
        setShow(true);
        await getAttendance();
        await getData();
    };

    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [formData, setFormData] = useState([]);

    // ****************************************BOQ Attendance Data Code **********************

    const [BOQAttendanceList, setBOQAttendanceList] = useState([]);

    const getAttendance = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/attendancesitefilter/${p_id}/${month}/${year}/null/null/`);
            setBOQAttendanceList(res.data); // still set in state
            return res.data; // RETURN the data
        } catch (err) {
            handleErrorToast(err);
            return []; // fail-safe
        }
    };

    const [AttendanceformData, setAttendanceFormData] = useState([]);

    useEffect(() => {
        if (Array.isArray(BOQAttendanceList)) {
            const initialData = BOQAttendanceList.map((item) => ({
                rate: "",
                is_invoice_raised: true,
                current_amount: "",
                man_months: item.man_months,
            }));
            setAttendanceFormData(initialData);
        }
    }, [BOQAttendanceList]);

    // ****************************************End of BOQ Attendance Data Code **********************


    // **************************************Previous data Fetch CCode*****************************************
    const [employeeListLoaded, setEmployeeListLoaded] = useState(false);

    const [employeeList, setEmployeeList] = useState([]);

    useEffect(() => {
        if (show === true) {
            if (!month || !year) {
                console.error("Both month and year are required to fetch progress data.");
                return;
            }

            const getEmployeeData = async () => {
                try {
                    let currentMonth = month - 1 === 0 ? 12 : month - 1;
                    let currentYear = month - 1 === 0 ? year - 1 : year;
                    let dataFound = false;
                    let currentPercent = 0;

                    // ✅ Helper: only moves forward, never back
                    const updateProgress = (percent, label) => {
                        currentPercent = Math.max(currentPercent, percent);
                        setFetchProgress({ percent: currentPercent, label });
                    };

                    updateProgress(5, "Connecting to server...");

                    while (!dataFound) {
                        updateProgress(10, "Fetching previous invoice data...");
                        const response = await axios.get(
                            `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
                        );

                        updateProgress(20, "Fetching withheld release data...");
                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                        const releaseRawData = releaseResponse.data;
                        setWithHeldReleaseData(releaseRawData);

                        updateProgress(30, "Fetching deduction data...");
                        const deductionResponse = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/${p_id}/null/null/`);
                        setWithHeldDeductionData(deductionResponse.data);

                        const monthInt = parseInt(month, 10);
                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                        const filterReleaseData = releaseRawData.filter(i =>
                            (i.month === monthCalculation && i.year === calculatedYear) &&
                            i?.deduction_data?.project === p_id
                        );
                        setfilterwithHeldReleaseData(filterReleaseData);

                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
                        setInvoiceIds(invoiceIds);

                        let localAllResults = [];
                        let localSheetData = [];

                        if (invoiceIds.length > 0) {
                            updateProgress(40, "Fetching consultant invoices...");
                            const res = await axios.get(
                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                            );

                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

                            if (filteredData.length > 0) {
                                const months = [...new Set(filteredData.map(i => i.month))];
                                const years = [...new Set(filteredData.map(i => i.year))];
                                setMonths(months);
                                setyears(years);

                                const totalMonthYearCalls = months.length * years.length;
                                let completedMonthYearCalls = 0;

                                for (const m of months) {
                                    for (const y of years) {
                                        try {
                                            const filterRes = await axios.get(
                                                `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${m}/${y}/`
                                            );
                                            localAllResults.push(...filterRes.data);
                                        } catch (err) {
                                            console.error(`Failed for month: ${m}, year: ${y}`, err);
                                        }
                                        completedMonthYearCalls++;
                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                        updateProgress(40 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
                                    }
                                }

                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
                                const totalIdCalls = allIds.length;
                                let completedIdCalls = 0;

                                for (const id of allIds) {
                                    try {
                                        const secondRes = await axios.get(
                                            `${BASE_URL}/siteproject/newinvoiceemployeefilter/${id}/`
                                        );
                                        localSheetData.push(...secondRes.data);
                                    } catch (err) {
                                        console.error(`Failed for id: ${id}`, err);
                                    }
                                    completedIdCalls++;
                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
                                    updateProgress(55 + idPercent, `Loading employee sheet ${completedIdCalls} of ${totalIdCalls}...`);
                                }

                                setGetSheetData(localSheetData);
                                const getboqIds = localAllResults.map(i => i?.employee_details?.id);
                                setGetResults(getboqIds);
                                setGetAllResults(localAllResults);
                            }
                        }

                        updateProgress(70, "Processing invoice records...");
                        const data = response.data;
                        let selectedData = [];

                        if (data.length > 0) {
                            const uids = data.map(item => item.id).filter(Boolean);
                            let uidResults = [];
                            const totalUids = uids.length;
                            let completedUids = 0;

                            for (const uid of uids) {
                                const res = await axios.get(
                                    `${BASE_URL}/siteproject/newinvoiceemployeefilter/${uid}/`
                                );

                                if (!res.data || res.data.length === 0) {
                                    console.error(`No data found for UID ${uid}. Breaking loop.`);
                                    dataFound = false;
                                    break;
                                }

                                uidResults = [...uidResults, ...res.data];
                                completedUids++;
                                const uidPercent = Math.round((completedUids / totalUids) * 15);
                                updateProgress(70 + uidPercent, `Loading employee ${completedUids} of ${totalUids}...`);
                            }

                            if (!dataFound && uidResults.length === 0) break;
                            selectedData = uidResults;

                        } else {
                            // ✅ No data for this month — go back but DON'T reset progress
                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                            currentMonth -= 1;
                            if (currentMonth === 0) {
                                currentMonth = 12;
                                currentYear -= 1;
                            }
                            if (currentYear < year - 1) {
                                console.error("No data found for the past 1 year.");
                                break;
                            }
                            continue;
                        }

                        if (selectedData.length > 0) {
                            updateProgress(90, "Calculating cumulative totals...");

                            const updatedGetAllResults = localSheetData.map((resultItem) => {
                                const matchingReleases = filterReleaseData.filter(
                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                                );
                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
                                const total = totalReleaseAmount + totalDeductionAmount;
                                return { id: resultItem?.employee_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
                            });

                            setGetTotalWithid(updatedGetAllResults);

                            const updatedEmployeeData = selectedData.map((item) => {
                                const empId = item?.employee_details?.id;
                                const matchedData = updatedGetAllResults.filter(i => i.id === empId);
                                const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                                const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                                const prev_month_array = item.actual_month_total_previous_two?.map((i) => i);
                                const prev_amount_array = item.previous_invoice_total_two?.map((i) => i);
                                const current_amount_array = item.current_invoice_amount_two?.map((i) => i);
                                const current_month_array = item.actual_month_two?.map((i) => i);

                                const sum_previous_month = current_month_array.map((val, idx) => {
                                    const prevVal = prev_month_array?.[idx] ?? 0;
                                    return (Number(val) || 0) + (Number(prevVal) || 0) + totalMonthRelease;
                                });
                                const sum_previous_amount = current_amount_array.map((val, idx) => {
                                    const prevVal = prev_amount_array?.[idx] ?? 0;
                                    return (Number(val) || 0) + (Number(prevVal) || 0) + totalReleaseAmount;
                                });

                                return {
                                    ...item,
                                    updated_previous_invoice_total: sum_previous_amount,
                                    updated_actual_month_total_previous: sum_previous_month,
                                };
                            });

                            updateProgress(100, "Done!");
                            setEmployeeList(updatedEmployeeData);
                            setEmployeeListLoaded(true);
                            dataFound = true;
                        }
                    }

                    if (!dataFound) {
                        updateProgress(100, "No previous data found.");
                        setEmployeeListLoaded(true);
                    }

                } catch (error) {
                    console.error("Error fetching progress data:", error);
                    setFetchProgress({ percent: 100, label: "Error loading data." });
                    setEmployeeListLoaded(true);
                }
            };
            getEmployeeData();
        }
    }, [month, year, show]);

    // **************************************End of Previous data Fetch Code*****************************************

    // **************************************Revised data Fetch Code*****************************************

    const employeeID = employeeData.map(e => e.id);
    const empData = logData.filter(item =>
        employeeID.includes(item.object_id)
    );
    const empChangeReason = employeeData[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        empData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null"
        ? employeeData
        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // **************************************End of Revised data Fetch Code*****************************************

    // **************************************BOQ Fetch Code*****************************************
    const getData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqemployeebyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setEmployeeData(res.data);
            } else {
                console.error("Error: Expected a list of transportation items");
            }
        } catch (err) {
            console.error("Error fetching transportation data", err);
        }
    };

    const [finalFormData, setFinalFormData] = useState([]);

    useEffect(() => {
        if (!employeeListLoaded || employeeData.length === 0) return;

        console.log("selectedGroup");
        console.log(selectedGroup);

        const initialData = selectedGroup
            .sort((a, b) =>
                logid === "null"
                    ? a.rank - b.rank
                    : a.data.rank - b.data.rank
            )
            .flatMap((item) => {
                const empId = item.object_id ?? item.id;

                const matchedProgress = employeeList.filter(
                    (progress) => String(progress.employee) === String(empId)
                );

                const previousInvoice = employeeList.map((i) => (i))

                console.log("Matched All Progress for empId", empId, ":", matchedProgress);
                console.log("Matched Progress:", previousInvoice);

                if (logid === "null") {

                    if (
                        !item.employee_name_details ||
                        item.employee_name_details.length === 0
                    ) {

                        const rate = Number(item.rate ?? 0);
                        const cp = Number(item.MM_construction_period ?? 0);
                        const dlp = Number(item.MM_OM_period ?? 0);
                        const employee_names = item.employee_name_details?.map((i) => i.name);
                        const employee_namess = item?.employee_name_details?.map((i) => ({
                            id: i.id,
                            name: i.name,
                            replacement_deduction: i.replacement_deduction
                        }));

                        const replacementDeduction = item.employee_name_details?.map((i) => (
                            i.replacement_deduction === "" ? 0 : i.replacement_deduction
                        ));

                        const employeeMonths = employee_namess.map(emp =>
                            BOQAttendanceList.find(a => a.employee === emp.id)?.man_months || 0
                        );

                        const totalEmployeeMonths = employeeMonths.reduce((sum, val) => sum + Number(val || 0), 0);

                        const calculateAmount = employee_namess.map((emp, idx) => {
                            const manMonth = Number(employeeMonths[idx]);
                            const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

                            if (manMonth === 0) return 0; // ✅

                            let amount = 0;
                            if (replacement > 0) {
                                amount = replacement * manMonth;
                            } else if (eot_details && eot_details.length > 0) {
                                const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                                amount = manMonth * lastRate;
                            } else {
                                amount = manMonth * Number(item?.rate || 0);
                            }
                            return Number(amount.toFixed(0));
                        });

                        const totalCalculateAmount = calculateAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                        const attendance = employeeMonths.map(i => ({
                            month: i.man_months ?? 0
                        }));

                        const eot_details = item.eot_details?.map((item) => (
                            item
                        ));

                        const previousArray = previousInvoice
                            .filter((inv) => inv.employee_details?.id === empId)
                            .flatMap((inv) => inv.updated_actual_month_total_previous);

                        const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);

                        const previousAmount = previousInvoice
                            .filter((inv) => inv.employee_details?.id === empId)
                            .flatMap((inv) => inv.updated_previous_invoice_total);

                        const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                        const COMULATED_MONTH = employeeMonths.map((val, idx) => {
                            const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
                            return (Number(val) || 0) + (Number(prevVal) || 0);
                        });
                        const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
                        const COMULATED_Amount = calculateAmount.map((val, idx) => {
                            const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
                            return (Number(val) || 0) + (Number(prevVal) || 0);
                        });
                        const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

                        let remainingamount;

                        if (item.eot_details && item.eot_details.length > 0) {
                            const lastEOT = item.eot_details[item.eot_details.length - 1];
                            remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
                        } else {
                            const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
                            const TOTAL = Number(monthh) * Number(item.rate);
                            remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
                        }
                        let remainingmonth;

                        if (item.eot_details && item.eot_details.length > 0) {
                            const lastEOT = item.eot_details[item.eot_details.length - 1];
                            remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
                        } else {
                            const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
                            remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
                        }

                        return {
                            project: p_id,
                            invoice: invoice_id,
                            employee: empId,
                            actual_month: totalEmployeeMonths,
                            month: month,
                            year: year,
                            designation_name: item.designation_name,
                            actual_month_cumulative_total_two: COMULATED_MONTH,
                            actual_amount_cumulative_total: COMULATED_Amount,
                            actual_month_cumulative_total: totalCOMULATED_MONTH,
                            actual_month_two: (employeeMonths && employeeMonths.length > 0)
                                ? employeeMonths
                                : [0],
                            cumulative_invoice_total: totalCOMULATED_Amount,
                            contract_amount: "",
                            remaining_amount: remainingamount,
                            actual_month_remaining: remainingmonth,
                            invoice_amount: totalCalculateAmount,
                            actual_month_total_previous_two: previousArray,
                            previous_invoice_total_two: previousAmount,
                            current_invoice_amount_two: calculateAmount,
                            previous_invoice_total: previousAmountSum,
                            actual_month_total_previous: previousSum,
                            boq_designation: item.rank,
                            boq_rate: rate,
                            boq_empcode: "TBN",
                            boq_name_employee: "TBN",
                            boq_name_employee_two: (employee_names && employee_names.length > 0)
                                ? employee_names
                                : ["TBN"],
                            boq_construction_period: cp,
                            boq_OM_period: dlp,
                            eot_details: eot_details,
                            replacement_deduction: replacementDeduction || [0],
                        };

                    }
                    // // Step 1: Flatten all employees across all items

                    const rate = Number(item.rate ?? 0);
                    const cp = Number(item.MM_construction_period ?? 0);
                    const dlp = Number(item.MM_OM_period ?? 0);
                    const employee_names = item.employee_name_details?.map((i) => i.name);
                    const employee_namess = item?.employee_name_details?.map((i) => ({
                        id: i.id,
                        name: i.name,
                        replacement_deduction: i.replacement_deduction
                    }));

                    const replacementDeduction = item.employee_name_details?.map((i) => (
                        i.replacement_deduction === "" ? 0 : i.replacement_deduction
                    ));

                    const contractAmount = item.rate

                    const employeeMonths = employee_namess.map(emp =>
                        BOQAttendanceList.find(a => a.employee === emp.id)?.man_months || 0
                    );

                    const totalEmployeeMonths = employeeMonths.reduce((sum, val) => sum + Number(val || 0), 0);

                    const eot_details = item.eot_details?.map((item) => (
                        item
                    ));

                    const calculateAmount = employee_namess.map((emp, idx) => {
                        const manMonth = Number(employeeMonths[idx]);
                        const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

                        if (manMonth === 0) return 0; // ✅

                        let amount = 0;
                        if (replacement > 0) {
                            amount = replacement * manMonth;
                        } else if (eot_details && eot_details.length > 0) {
                            const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                            amount = manMonth * lastRate;
                        } else {
                            amount = manMonth * Number(item?.rate || 0);
                        }
                        return Number(amount.toFixed(0));
                    });
                    const totalCalculateAmount = calculateAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                    const previousArray = previousInvoice
                        .filter((inv) => inv.employee_details?.id === empId)
                        .flatMap((inv) => inv.updated_actual_month_total_previous);

                    const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);

                    const previousAmount = previousInvoice
                        .filter((inv) => inv.employee_details?.id === empId)
                        .flatMap((inv) => inv.updated_previous_invoice_total);

                    const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                    const COMULATED_MONTH = employeeMonths.map((val, idx) => {
                        const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
                        return (Number(val) || 0) + (Number(prevVal) || 0);
                    });
                    const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
                    const COMULATED_Amount = calculateAmount.map((val, idx) => {
                        const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
                        return (Number(val) || 0) + (Number(prevVal) || 0);
                    });
                    const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

                    let remainingamount;

                    if (item.eot_details && item.eot_details.length > 0) {
                        const lastEOT = item.eot_details[item.eot_details.length - 1];
                        remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
                    } else {
                        const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
                        const TOTAL = Number(monthh) * Number(item.rate);
                        remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
                    }
                    let remainingmonth;

                    if (item.eot_details && item.eot_details.length > 0) {
                        const lastEOT = item.eot_details[item.eot_details.length - 1];
                        remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
                    } else {
                        const monthh = Number(item.MM_construction_period || 0) + Number(item.MM_OM_period || 0);
                        remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
                    }

                    return {
                        project: p_id,
                        invoice: invoice_id,
                        employee: empId,
                        actual_month: totalEmployeeMonths.toFixed(2),
                        month: month,
                        rank: item.rank,

                        year: year,
                        designation_name: item.designation_name,
                        actual_month_cumulative_total_two: COMULATED_MONTH,
                        actual_amount_cumulative_total: COMULATED_Amount,
                        actual_month_cumulative_total: totalCOMULATED_MONTH,
                        actual_month_two: employeeMonths ?? 0,
                        cumulative_invoice_total: totalCOMULATED_Amount,
                        contract_amount: "",
                        remaining_amount: remainingamount,
                        actual_month_remaining: remainingmonth,
                        invoice_amount: totalCalculateAmount,
                        actual_month_total_previous_two: previousArray,
                        previous_invoice_total_two: previousAmount,
                        current_invoice_amount_two: calculateAmount,
                        previous_invoice_total: previousAmountSum,
                        actual_month_total_previous: previousSum,
                        boq_rate: rate,
                        boq_empcode: "TBN",
                        boq_name_employee: "TBN",
                        boq_name_employee_two: employee_names,
                        boq_construction_period: cp,
                        boq_OM_period: dlp,
                        boq_designation: item.rank,

                        eot_details: eot_details,
                        replacement_deduction: replacementDeduction || [0],
                    };

                }
                else {
                    if (item.employee_name?.length === 0) {
                        const empCodes = item.data.empcode; // ["emp1", "emp2"]
                        const rate = Number(item.data?.rate ?? 0);
                        const cp = Number(item.data?.MM_construction_period ?? 0);
                        const dlp = Number(item.data?.MM_OM_period ?? 0);
                        const rank = item.data.rankl;

                        const employee_names = item?.employee_name?.map((i) => i).reverse();
                        const employee_namess = item?.data?.empcode?.map((i) => (i));
                        const employeeMonths = employee_namess?.map(emp =>
                            BOQAttendanceList.find(a => a.employee === emp)?.man_months || 0
                        );

                        const replacement = item.employee_replacement_deduction === "" ? 0 : Number(item.employee_replacement_deduction);

                        const totalEmployeeMonths = employeeMonths?.reduce((sum, val) => sum + Number(val || 0), 0);

                        const calculateAmount = employee_namess.map((emp, idx) => {
                            const manMonth = Number(employeeMonths[idx]);
                            const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

                            if (manMonth === 0) return 0; // ✅

                            let amount = 0;
                            if (replacement > 0) {
                                amount = replacement * manMonth;
                            } else if (eot_details && eot_details.length > 0) {
                                const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                                amount = manMonth * lastRate;
                            } else {
                                amount = manMonth * Number(item?.rate || 0);
                            }
                            return Number(amount.toFixed(0));
                        });

                        const totalCalculateAmount = calculateAmount?.reduce((sum, val) => sum + Number(val || 0), 0);

                        const eot_details = item?.data?.eot_details?.map((item) => (
                            item
                        ));

                        const previousArray = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_actual_month_total_previous);

                        const previousSum = previousArray?.reduce((sum, val) => sum + Number(val || 0), 0);

                        const previousAmount = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_previous_invoice_total);

                        const previousAmountSum = previousAmount?.reduce((sum, val) => sum + Number(val || 0), 0);

                        const COMULATED_MONTH = employeeMonths?.map((val, idx) => {
                            const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
                            return (Number(val) || 0) + (Number(prevVal) || 0);
                        });
                        const totalCOMULATED_MONTH = COMULATED_MONTH?.reduce((sum, val) => sum + val, 0);
                        const COMULATED_Amount = calculateAmount?.map((val, idx) => {
                            const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
                            return (Number(val) || 0) + (Number(prevVal) || 0);
                        });
                        const totalCOMULATED_Amount = COMULATED_Amount?.reduce((sum, val) => sum + val, 0);

                        let remainingamount;

                        if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
                            const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
                            remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
                        } else {
                            const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
                            const TOTAL = Number(monthh) * Number(item?.data?.rate);
                            remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
                        }
                        let remainingmonth;

                        if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
                            const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
                            remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
                        } else {
                            const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
                            remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
                        }

                        return {
                            project: p_id,
                            invoice: invoice_id,
                            employee: empId,
                            actual_month: totalEmployeeMonths.toFixed(2),
                            month: month,
                            year: year,
                            designation_name: item.designation_name,
                            actual_month_cumulative_total_two: COMULATED_MONTH,
                            actual_amount_cumulative_total: COMULATED_Amount,
                            actual_month_cumulative_total: totalCOMULATED_MONTH,
                            actual_month_two: (employeeMonths && employeeMonths.length > 0)
                                ? employeeMonths
                                : ["0"],
                            cumulative_invoice_total: totalCOMULATED_Amount,
                            contract_amount: "",
                            remaining_amount: remainingamount,
                            actual_month_remaining: remainingmonth,
                            invoice_amount: totalCalculateAmount,
                            actual_month_total_previous_two: previousArray,
                            previous_invoice_total_two: previousAmount,
                            current_invoice_amount_two: calculateAmount,
                            previous_invoice_total: previousAmountSum,
                            actual_month_total_previous: previousSum,
                            rank: item.data.rank,
                            boq_designation: item.data.rank,

                            boq_rate: rate,
                            boq_empcode: "TBN",
                            boq_name_employee: "TBN",
                            boq_name_employee_two: (employee_names && employee_names.length > 0)
                                ? employee_names
                                : ["TBN"],
                            boq_construction_period: cp,
                            boq_OM_period: dlp,
                            eot_details: eot_details,
                        };
                    }

                    const empCodes = item.data.empcode; // ["emp1", "emp2"]
                    const rate = Number(item.data?.rate ?? 0);
                    const cp = Number(item.data?.MM_construction_period ?? 0);
                    const dlp = Number(item.data?.MM_OM_period ?? 0);

                    const employee_names = item?.employee_name?.map((i) => i).reverse();
                    const employee_deductions = item?.employee_replacement_deduction?.map((i) => (i));
                    const employee_namess = item?.data?.empcode?.map((i) => (i));
                    const employeeMonths = employee_namess?.map(emp =>
                        BOQAttendanceList.find(a => a.employee === emp)?.man_months || 0
                    );

                    const totalEmployeeMonths = employeeMonths?.reduce((sum, val) => sum + Number(val || 0), 0);
                    const replacement = item?.employee_replacement_deduction;

                    const eot_details = item?.data?.eot_details?.map((item) => (
                        item
                    ));

                    const calculateAmount = employee_namess.map((emp, idx) => {
                        const manMonth = Number(employeeMonths[idx]);
                        const replacement = emp.replacement_deduction === "" ? 0 : Number(emp.replacement_deduction);

                        if (manMonth === 0) return 0; // ✅

                        let amount = 0;
                        if (replacement > 0) {
                            amount = replacement * manMonth;
                        } else if (eot_details && eot_details.length > 0) {
                            const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                            amount = manMonth * lastRate;
                        } else {
                            amount = manMonth * Number(item?.rate || 0);
                        }
                        return Number(amount.toFixed(0));
                    });

                    const totalCalculateAmount = calculateAmount?.reduce((sum, val) => sum + Number(val || 0), 0);

                    const previousArray = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_actual_month_total_previous);

                    const previousSum = previousArray?.reduce((sum, val) => sum + Number(val || 0), 0);

                    const previousAmount = previousInvoice?.filter((inv) => inv.employee_details?.id === empId)?.flatMap((inv) => inv.updated_previous_invoice_total);

                    const previousAmountSum = previousAmount?.reduce((sum, val) => sum + Number(val || 0), 0);

                    const COMULATED_MONTH = employeeMonths?.map((val, idx) => {
                        const prevVal = previousArray[idx] ?? 0; // if prev array is shorter, default 0
                        return (Number(val) || 0) + (Number(prevVal) || 0);
                    });
                    const totalCOMULATED_MONTH = COMULATED_MONTH?.reduce((sum, val) => sum + val, 0);
                    const COMULATED_Amount = calculateAmount?.map((val, idx) => {
                        const prevVal = previousAmount[idx] ?? 0; // if prev array is shorter, default 0
                        return (Number(val) || 0) + (Number(prevVal) || 0);
                    });
                    const totalCOMULATED_Amount = COMULATED_Amount?.reduce((sum, val) => sum + val, 0);

                    let remainingamount;

                    if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
                        const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
                        remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCOMULATED_Amount || 0);
                    } else {
                        const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
                        const TOTAL = Number(monthh) * Number(item?.data?.rate);
                        remainingamount = Number(TOTAL) - Number(totalCOMULATED_Amount || 0);
                    }
                    let remainingmonth;

                    if (item?.data?.eot_details && item?.data?.eot_details.length > 0) {
                        const lastEOT = item?.data?.eot_details[item?.data?.eot_details.length - 1];
                        remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCOMULATED_MONTH || 0);
                    } else {
                        const monthh = Number(item?.data?.MM_construction_period || 0) + Number(item?.data?.MM_OM_period || 0);
                        remainingmonth = Number(monthh) - Number(totalCOMULATED_MONTH || 0);
                    }

                    return {
                        project: p_id,
                        invoice: invoice_id,
                        employee: empId,
                        actual_month: totalEmployeeMonths.toFixed(2),
                        month: month,
                        year: year,
                        designation_name: item.designation_name,
                        actual_month_cumulative_total_two: COMULATED_MONTH,
                        actual_amount_cumulative_total: COMULATED_Amount,
                        actual_month_cumulative_total: totalCOMULATED_MONTH,
                        actual_month_two: (employeeMonths && employeeMonths.length > 0)
                            ? employeeMonths
                            : ["0"],
                        cumulative_invoice_total: totalCOMULATED_Amount,
                        contract_amount: "",
                        remaining_amount: remainingamount,
                        actual_month_remaining: remainingmonth,
                        invoice_amount: totalCalculateAmount,
                        actual_month_total_previous_two: previousArray,
                        previous_invoice_total_two: previousAmount,
                        current_invoice_amount_two: calculateAmount,
                        previous_invoice_total: previousAmountSum,
                        actual_month_total_previous: previousSum,
                        boq_designation: item.data.rank,

                        boq_rate: rate,
                        boq_empcode: "TBN",
                        boq_name_employee: "TBN",
                        boq_name_employee_two: employee_names,
                        boq_construction_period: cp,
                        boq_OM_period: dlp,
                        eot_details: eot_details,
                        replacement_deduction: replacement || [0],
                    };
                }
            });

        setFormData(initialData);

        console.log(formData);

    }, [logid, employeeData, employeeList, employeeListLoaded]);

    console.log("formData");
    console.log(formData);
    console.log("selectedGroup");
    console.log(selectedGroup);

    useEffect(() => {
        if (formData?.length > 0) {
            setFinalFormData(formData);
        }
    }, [formData])


    useEffect(() => {
        if (formData.length === 0) return;

        const empCodeCount = formData.reduce((acc, item) => {
            const code = item.employee;
            if (code) {
                acc[code] = (acc[code] || 0) + 1;
            }
            return acc;
        }, {});

        const duplicates = formData.filter(item => empCodeCount[item.employee] > 1);
        if (duplicates.length === 0) return;

        const rate = Number(duplicates[0]?.boq_rate || 0);
        const cp = Number(duplicates[0]?.boq_construction_period || 0);
        const dlp = Number(duplicates[0]?.boq_OM_period || 0);
        const totalMonths = cp + dlp;
        const contractAmount = rate * totalMonths;

        const actual_monthSum = duplicates.reduce((sum, item) => sum + Number(item.actual_month || 0), 0);
        const actual_AMOUNTsUM = duplicates.reduce((sum, item) => sum + Number(item.invoice_amount || 0), 0);

        const previous_invoicE = Number(duplicates[0]?.prevoiusAmt || 0);
        const PREVIOUSmonth = Number(duplicates[0]?.prevoius || 0);
        const previous_ACTUAL = Number(duplicates[0]?.prevoiusACTUAL || 0);
        const PREVIOUS_ActualAmt = Number(duplicates[0]?.prevoiusactuallAmt || 0);
        const previous_invoice_total_sum = Number(duplicates[0]?.previous_invoice_total || 0);
        const PREVIOUS_MONTH = Number(duplicates[0]?.actual_month_total_previous || 0);

        const previous_invoice_totall = Number(previous_invoicE || 0) + Number(PREVIOUS_ActualAmt || 0);
        const previous_month_totall = Number(PREVIOUSmonth || 0) + Number(previous_ACTUAL || 0);

        const comulatedAmount = previous_invoice_total_sum + actual_AMOUNTsUM;
        const comulatedMonth = PREVIOUS_MONTH + actual_monthSum;

        const remainingMonth = totalMonths - comulatedMonth;
        const remainingAmount = contractAmount - comulatedAmount;

        // Build updated form data
        const updatedFormData = formData.map(item => {
            if (empCodeCount[item.employee] > 1) {
                return {
                    ...item,
                    actual_month_cumulative_total: comulatedMonth.toFixed(2),
                    cumulative_invoice_total: comulatedAmount.toFixed(2),
                    remaining_amount: remainingAmount.toFixed(2),
                    actual_month_remaining: remainingMonth.toFixed(2),
                    previous_invoice_total: previous_invoice_totall.toFixed(2),
                    actual_month_total_previous: previous_month_totall.toFixed(2),
                };
            }
            return item;
        });

        // ✅ Prevent infinite loop by checking if data actually changed
        const isChanged = JSON.stringify(formData) !== JSON.stringify(updatedFormData);
        if (isChanged) {
            setFormData(updatedFormData);
        }

    }, [formData]);


    useEffect(() => {
        if (!show) return;
        if (employeeListLoaded) {
            setModalLoading(false);
        } else {
            setModalLoading(true);
        }
    }, [employeeListLoaded, show]);

    // **************************************End of BOQ Fetch Code*****************************************

    console.log("formData Attendance:", formData);
    console.log(formData)

    // Validation start
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};

        formData.forEach((entry, index) => {
            const requiredFields = [];
            requiredFields.forEach((field) => {
                if (!entry[field]) {
                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };
    // Validation End

    // Post API
    const [loading, setLoading] = useState(false);

    console.log(formData);
    console.log("finalFormData")
    console.log(finalFormData)

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setShowProgressModal(true);
            setUploadProgress(0); // Reset progress
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            if (usedfor === "InvoiceandDeduction") {

                try {
                    const res = await axios.post(
                        `${BASE_URL}/siteproject/invoiceemployeebulk/`,
                        formData
                    );

                    if (res.status === 201) {
                        const createdData = res.data;

                        const mappedFinalData = finalFormData.map((item, index) => ({
                            ...item,
                            invoiceemployee: createdData[index]?.id, // attach the id from first API
                        }));

                        const res2 = await axios.post(
                            `${BASE_URL}/siteproject/newinvoiceemployeelistcreate/`,
                            mappedFinalData, {
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                setUploadProgress(percentCompleted);
                            },
                        }
                        );

                        if (res2.status === 201) {
                            await getEmployeeInvoice();
                            handleClose();
                            setTimeout(() => {
                                toast.dismiss(loadingToastId); // Close loading toast
                                toast.success("BOQ Added Successfully"); // Show success toast
                            }, 4000);
                        } else {
                            alert("Second API failed");
                        }

                    } else {
                        alert("First API failed");
                    }
                } catch (err) {
                    handleErrorToast(err, loadingToastId);
                } finally {
                    setTimeout(() => {
                        setShowProgressModal(false);
                    }, 2000);

                    setTimeout(() => {
                        setLoading(false); //loading logic
                        toast.dismiss(loadingToastId);
                    }, 4000)
                }
            } else if (usedfor === "OnlyDeduction") {
                try {
                    const createdData = invoiceData
                    const response = await axios.get(`${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${month}/${year}/`);

                    if (response.status === 200) {

                        const mappedFinalData = formData.map((item, index) => ({
                            ...item,
                            invoiceemployee: response.data[index]?.id, // attach the id from first API
                        }));

                        console.log("Mapped Final Data for Deduction:", mappedFinalData);

                        const res2 = await axios.post(
                            `${BASE_URL}/siteproject/newinvoiceemployeelistcreate/`,
                            mappedFinalData, {
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round(
                                    (progressEvent.loaded * 100) / progressEvent.total
                                );
                                setUploadProgress(percentCompleted);
                            },
                        }
                        );

                        if (res2.status === 201) {
                            await getEmployeeInvoice();
                            handleClose();
                            setTimeout(() => {
                                toast.dismiss(loadingToastId); // Close loading toast
                                toast.success("BOQ Added Successfully"); // Show success toast
                            }, 4000);
                        } else {
                            alert("Second API failed");
                        }
                    }

                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                } finally {
                    setTimeout(() => {
                        setShowProgressModal(false);
                    }, 2000);

                    setTimeout(() => {
                        setLoading(false); //loading logic
                        toast.dismiss(loadingToastId);
                    }, 4000)
                }

            }
        }
    };


    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = formData.map((entry, i) =>
            i === index ? { ...entry, [name]: value } : entry
        );
        setFormData(updatedFormData);
    };


    const handleArrayInputChange = (e, formIndex, arrayIndex, fieldName) => {
        const { value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== formIndex) return entry;

            const updatedArray = [...(entry[fieldName] || [])];
            updatedArray[arrayIndex] = value;

            const updatedMonths = fieldName === "actual_month_two"
                ? updatedArray
                : [...(entry.actual_month_two || [0])];

            let updatedAmounts;
            if (fieldName === "actual_month_two") {
                updatedAmounts = updatedMonths.map((month, idx) => {
                    const eot_details = entry.eot_details;
                    const replacement = entry.replacement_deduction?.[idx];
                    const manMonth = Number(month) || 0;
                    const repl = Number(replacement) || 0;

                    let amount = 0;
                    if (repl > 0) {
                        amount = repl * manMonth;
                    } else if (eot_details && eot_details.length > 0) {
                        const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                        amount = manMonth * lastRate;
                    } else {
                        amount = manMonth * Number(entry.boq_rate || 0);
                    }
                    return Number(amount.toFixed(0));
                });
            } else {
                updatedAmounts = updatedArray;
            }

            const totalActualMonth = updatedMonths.reduce((sum, val) => sum + (Number(val) || 0), 0);
            const totalInvoiceAmount = updatedAmounts.reduce((sum, val) => sum + (Number(val) || 0), 0);

            const previousArray = entry.actual_month_total_previous_two || [];
            const previousAmount = entry.previous_invoice_total_two || [];

            const COMULATED_MONTH = updatedMonths.map((val, idx) => {
                const prevVal = previousArray[idx] ?? 0;
                return (Number(val) || 0) + (Number(prevVal) || 0);
            });

            const COMULATED_Amount = updatedAmounts.map((val, idx) => {
                const prevVal = previousAmount[idx] ?? 0;
                return (Number(val) || 0) + (Number(prevVal) || 0);
            });

            const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
            const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

            let remainingamount;
            let remainingmonth;

            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                remainingamount = Number(lastEOT.total_amount || 0) - totalCOMULATED_Amount;
                remainingmonth = Number(lastEOT.t_month || 0) - totalCOMULATED_MONTH;
            } else {
                const monthh = Number(entry.boq_construction_period || 0) + Number(entry.boq_OM_period || 0);
                const TOTAL = monthh * Number(entry.boq_rate || 0);
                remainingamount = TOTAL - totalCOMULATED_Amount;
                remainingmonth = monthh - totalCOMULATED_MONTH;
            }

            return {
                ...entry,
                actual_month_two: updatedMonths,
                current_invoice_amount_two: updatedAmounts,
                actual_month: totalActualMonth,
                invoice_amount: totalInvoiceAmount,
                actual_month_cumulative_total_two: COMULATED_MONTH,
                actual_amount_cumulative_total: COMULATED_Amount,
                actual_month_cumulative_total: totalCOMULATED_MONTH,
                cumulative_invoice_total: totalCOMULATED_Amount,
                remaining_amount: remainingamount,
                actual_month_remaining: remainingmonth,
            };
        });

        setFormData(updatedFormData);
    };


    return (
        <>
            <button title="Add Employee Invoice" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>
            {showProgressModal ?
                <ProgressModal usedFor="Add" show={showProgressModal} progress={uploadProgress} /> :

                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="16" y1="13" x2="8" y2="13" />
                                <line x1="16" y1="17" x2="8" y2="17" />
                                <polyline points="10 9 9 9 8 9" />
                            </svg>
                            Add Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {(employeeData.length > 0 && groupedByRandomChange.length > 0) && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {empChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [...new Set(
                                            items.map(i => i.data?.reason_of_change).filter(reason =>
                                                reason !== null && reason !== "null" && reason?.trim() !== ""
                                            )
                                        )];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minHeight: "50vh",
                                gap: "20px",
                                padding: "40px",
                            }}>
                                {/* Spinner */}
                                <div style={{
                                    width: "44px",
                                    height: "44px",
                                    border: "3px solid #e0e0e0",
                                    borderTop: "3px solid #000",
                                    borderRadius: "50%",
                                    animation: "eb-spin 0.8s linear infinite",
                                }} />

                                {/* Label */}
                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>

                                {/* Progress bar track */}
                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{
                                        height: "100%",
                                        width: `${fetchProgress.percent}%`,
                                        background: "#111",
                                        borderRadius: "999px",
                                        transition: "width 0.3s ease",
                                    }} />
                                </div>

                                {/* Percentage */}
                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>

                                <style>{`
            @keyframes eb-spin {
                0% { transform: rotate(0deg); }
                100% { transform: rotate(360deg); }
            }
        `}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">

                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table">
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                            <span className="eb-bulk-th-label">#</span>
                                                        </th>
                                                        <th className="eb-bulk-th">
                                                            <span className="eb-bulk-th-label">Employee name</span>
                                                        </th>
                                                        <th className="eb-bulk-th">
                                                            <span className="eb-bulk-th-label">Designation</span>
                                                        </th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}>
                                                            <span className="eb-bulk-th-label">Actual month</span>
                                                        </th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}>
                                                            <span className="eb-bulk-th-label">Invoice amount</span>
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.sort((a, b) => a.rank - b.rank).map((entry, index) => {
                                                        const months = Array.isArray(entry.actual_month_two)
                                                            ? entry.actual_month_two
                                                            : [];
                                                        const amounts = entry.current_invoice_amount_two?.length > 0
                                                            ? entry.current_invoice_amount_two
                                                            : months.map(() => 0);
                                                        const names = entry.boq_name_employee_two || [];

                                                        return months.map((month, arrayIndex) => (
                                                            <tr key={`${index}-${arrayIndex}`} className="eb-bulk-row">

                                                                <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px", verticalAlign: "top" }}>
                                                                    {arrayIndex === 0 ? `${index + 1}.` : ""}
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ verticalAlign: "top" }}>
                                                                    <span style={{ fontWeight: 500 }}>
                                                                        {names[arrayIndex] || "TBN"}
                                                                    </span>
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ color: "var(--text-secondary)", verticalAlign: "top" }}>
                                                                    {arrayIndex === 0 ? entry.designation_name : ""}
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ textAlign: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        value={month ?? ""}
                                                                        onChange={(e) =>
                                                                            handleArrayInputChange(
                                                                                e,
                                                                                index,
                                                                                arrayIndex,
                                                                                "actual_month_two"
                                                                            )
                                                                        }
                                                                        onBlur={(e) => {
                                                                            const v = e.target.value;
                                                                            if (v === "" || isNaN(Number(v))) return;
                                                                            const formatted = Number(v).toFixed(2);
                                                                            if (formatted !== v) {
                                                                                handleArrayInputChange(
                                                                                    { target: { value: formatted } },
                                                                                    index,
                                                                                    arrayIndex,
                                                                                    "actual_month_two"
                                                                                );
                                                                            }
                                                                        }}
                                                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month_two`] ? "eb-bulk-input-error" : ""}`}
                                                                        placeholder={`Month ${arrayIndex + 1}`}
                                                                        style={{ textAlign: "right", width: "80px" }}
                                                                    />
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ textAlign: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        value={amounts[arrayIndex] ?? 0}
                                                                        onChange={(e) => handleArrayInputChange(e, index, arrayIndex, "current_invoice_amount_two")}
                                                                        className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_no_of_vehicle`] ? "eb-bulk-input-error" : ""}`}
                                                                        placeholder={`Amount ${arrayIndex + 1}`}
                                                                        style={{ textAlign: "right", width: "80px" }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ));
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Submitting...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Add
                                                </>
                                            )}
                                        </button>
                                    </div>

                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            }
        </>
    );

};


const UpdateEmployeeInvoice = ({ invoiceData, p_id, invoice_id, getEmployeeInvoice, month, year, logData = [], usedfor }) => {
    const [show, setShow] = useState(false);
    const [employeeData, setEmployeeData] = useState([]);
    const [logid, setLogId] = useState("null");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [employeeListLoaded, setEmployeeListLoaded] = useState(false);
    const [employeeList, setEmployeeList] = useState([]);
    const [BOQAttendanceList, setBOQAttendanceList] = useState([]);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setEmployeeListLoaded(false);
        setEmployeeList([]);
        setFormData([]);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        setShow(true);
        await getAttendance();
        await getData();
    };

    // ******************* BOQ Attendance *******************
    const getAttendance = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/attendancesitefilter/${p_id}/${month}/${year}/null/null/`);
            setBOQAttendanceList(res.data);
            return res.data;
        } catch (err) {
            handleErrorToast(err);
            return [];
        }
    };

    // ******************* Previous data fetch *******************
    useEffect(() => {
        if (show !== true) return;
        if (!month || !year) {
            console.error("Both month and year are required to fetch progress data.");
            return;
        }

        const getEmployeeData = async () => {
            try {
                let currentMonth = month - 1 === 0 ? 12 : month - 1;
                let currentYear = month - 1 === 0 ? year - 1 : year;
                let dataFound = false;
                let currentPercent = 0;

                const updateProgress = (percent, label) => {
                    currentPercent = Math.max(currentPercent, percent);
                    setFetchProgress({ percent: currentPercent, label });
                };

                updateProgress(5, "Connecting to server...");

                while (!dataFound) {
                    updateProgress(10, "Fetching previous invoice data...");
                    const response = await axios.get(
                        `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${String(currentMonth).padStart(2, "0")}/${currentYear}/`
                    );

                    updateProgress(20, "Fetching withheld release data...");
                    const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                    const releaseRawData = releaseResponse.data;

                    updateProgress(30, "Fetching deduction data...");
                    await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/${p_id}/null/null/`);

                    const monthInt = parseInt(month, 10);
                    const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, "0");
                    const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                    const filterReleaseData = releaseRawData.filter(
                        (i) =>
                            i.month === monthCalculation &&
                            i.year === calculatedYear &&
                            i?.deduction_data?.project === p_id
                    );

                    const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

                    let localAllResults = [];
                    let localSheetData = [];

                    if (invoiceIds.length > 0) {
                        updateProgress(40, "Fetching consultant invoices...");
                        const res = await axios.get(
                            `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                        );
                        const filteredData = res.data.filter((item) => invoiceIds.includes(item.id));

                        if (filteredData.length > 0) {
                            const months = [...new Set(filteredData.map((i) => i.month))];
                            const years = [...new Set(filteredData.map((i) => i.year))];

                            const totalMonthYearCalls = months.length * years.length;
                            let completedMonthYearCalls = 0;

                            for (const m of months) {
                                for (const y of years) {
                                    try {
                                        const filterRes = await axios.get(
                                            `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${m}/${y}/`
                                        );
                                        localAllResults.push(...filterRes.data);
                                    } catch (err) {
                                        console.error(`Failed for month: ${m}, year: ${y}`, err);
                                    }
                                    completedMonthYearCalls++;
                                    const pct = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                    updateProgress(40 + pct, `Fetching BOQ data for ${m}/${y}...`);
                                }
                            }

                            const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                            const totalIdCalls = allIds.length;
                            let completedIdCalls = 0;

                            for (const id of allIds) {
                                try {
                                    const secondRes = await axios.get(`${BASE_URL}/siteproject/newinvoiceemployeefilter/${id}/`);
                                    localSheetData.push(...secondRes.data);
                                } catch (err) {
                                    console.error(`Failed for id: ${id}`, err);
                                }
                                completedIdCalls++;
                                const pct = Math.round((completedIdCalls / totalIdCalls) * 15);
                                updateProgress(55 + pct, `Loading employee sheet ${completedIdCalls} of ${totalIdCalls}...`);
                            }
                        }
                    }

                    updateProgress(70, "Processing invoice records...");
                    const data = response.data;
                    let selectedData = [];

                    if (data.length > 0) {
                        const uids = data.map((item) => item.id).filter(Boolean);
                        let uidResults = [];
                        const totalUids = uids.length;
                        let completedUids = 0;

                        for (const uid of uids) {
                            const res = await axios.get(`${BASE_URL}/siteproject/newinvoiceemployeefilter/${uid}/`);

                            if (!res.data || res.data.length === 0) {
                                console.error(`No data found for UID ${uid}. Breaking loop.`);
                                dataFound = false;
                                break;
                            }

                            uidResults = [...uidResults, ...res.data];
                            completedUids++;
                            const pct = Math.round((completedUids / totalUids) * 15);
                            updateProgress(70 + pct, `Loading employee ${completedUids} of ${totalUids}...`);
                        }

                        if (!dataFound && uidResults.length === 0) break;
                        selectedData = uidResults;
                    } else {
                        updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                        currentMonth -= 1;
                        if (currentMonth === 0) {
                            currentMonth = 12;
                            currentYear -= 1;
                        }
                        if (currentYear < year - 1) {
                            console.error("No data found for the past 1 year.");
                            break;
                        }
                        continue;
                    }

                    if (selectedData.length > 0) {
                        updateProgress(90, "Calculating cumulative totals...");

                        const updatedGetAllResults = localSheetData.map((resultItem) => {
                            const matchingReleases = filterReleaseData.filter(
                                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                            );
                            const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                            const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                            const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
                            return {
                                id: resultItem?.employee_details?.id,
                                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                                total_month_release: totalMonthRelease,
                            };
                        });

                        const updatedEmployeeData = selectedData.map((item) => {
                            const empId = item?.employee_details?.id;
                            const matchedData = updatedGetAllResults.filter((i) => i.id === empId);
                            const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                            const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                            const prev_month_array = item.actual_month_total_previous_two || [];
                            const prev_amount_array = item.previous_invoice_total_two || [];
                            const current_amount_array = item.current_invoice_amount_two || [];
                            const current_month_array = item.actual_month_two || [];

                            const sum_previous_month = current_month_array.map((val, idx) => {
                                const prevVal = prev_month_array[idx] ?? 0;
                                return (Number(val) || 0) + (Number(prevVal) || 0) + totalMonthRelease;
                            });
                            const sum_previous_amount = current_amount_array.map((val, idx) => {
                                const prevVal = prev_amount_array[idx] ?? 0;
                                return (Number(val) || 0) + (Number(prevVal) || 0) + totalReleaseAmount;
                            });

                            return {
                                ...item,
                                updated_previous_invoice_total: sum_previous_amount,
                                updated_actual_month_total_previous: sum_previous_month,
                            };
                        });

                        updateProgress(100, "Done!");
                        setEmployeeList(updatedEmployeeData);
                        setEmployeeListLoaded(true);
                        dataFound = true;
                    }
                }

                if (!dataFound) {
                    updateProgress(100, "No previous data found.");
                    setEmployeeListLoaded(true);
                }
            } catch (error) {
                console.error("Error fetching progress data:", error);
                setFetchProgress({ percent: 100, label: "Error loading data." });
                setEmployeeListLoaded(true);
            }
        };
        getEmployeeData();
    }, [month, year, show]);

    // ******************* Revised (BOQ change log) data *******************
    const employeeID = employeeData.map((e) => e.id);
    const empData = (logData || []).filter((item) => employeeID.includes(item.object_id));
    const empChangeReason = employeeData[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        empData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? employeeData
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ******************* BOQ fetch *******************
    const getData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqemployeebyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setEmployeeData(res.data);
            } else {
                console.error("Error: Expected a list of items");
            }
        } catch (err) {
            console.error("Error fetching BOQ data", err);
        }
    };

    // ---- common helpers (Add wali calculation, same formulas) ----
    const calcAmounts = (employee_namess, employeeMonths, eot_details, rateFallback) =>
        employee_namess.map((emp, idx) => {
            const manMonth = Number(employeeMonths[idx]);
            const replacement = emp?.replacement_deduction === "" || emp?.replacement_deduction === undefined
                ? 0
                : Number(emp.replacement_deduction);

            if (manMonth === 0) return 0;

            let amount = 0;
            if (replacement > 0) {
                amount = replacement * manMonth;
            } else if (eot_details && eot_details.length > 0) {
                const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                amount = manMonth * lastRate;
            } else {
                amount = manMonth * Number(rateFallback || 0);
            }
            return Number(amount.toFixed(0));
        });

    const calcRemaining = (eotSrc, mmCp, mmOm, rate, totalCumAmount, totalCumMonth) => {
        let remainingamount;
        let remainingmonth;
        if (eotSrc && eotSrc.length > 0) {
            const lastEOT = eotSrc[eotSrc.length - 1];
            remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCumAmount || 0);
            remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCumMonth || 0);
        } else {
            const monthh = Number(mmCp || 0) + Number(mmOm || 0);
            remainingamount = monthh * Number(rate) - Number(totalCumAmount || 0);
            remainingmonth = monthh - Number(totalCumMonth || 0);
        }
        return { remainingamount, remainingmonth };
    };

    const [finalFormData, setFinalFormData] = useState([]);

    useEffect(() => {
        if (!employeeListLoaded || employeeData.length === 0) return;

        const previousInvoice = employeeList.map((i) => i);

        const initialData = [...selectedGroup]
            .sort((a, b) => (logid === "null" ? a.rank - b.rank : a.data.rank - b.data.rank))
            .flatMap((item) => {
                const empId = item.object_id ?? item.id;

                // ---------------- Current BOQ (logid === "null") ----------------
                if (logid === "null") {
                    const rate = Number(item.rate ?? 0);
                    const cp = Number(item.MM_construction_period ?? 0);
                    const dlp = Number(item.MM_OM_period ?? 0);
                    const eot_details = item.eot_details?.map((e) => e);

                    const nameDetails = item.employee_name_details || [];
                    const hasNames = nameDetails.length > 0;

                    const employee_names = nameDetails.map((i) => i.name);
                    const employee_namess = nameDetails.map((i) => ({
                        id: i.id,
                        name: i.name,
                        replacement_deduction: i.replacement_deduction,
                    }));
                    const replacementDeduction = nameDetails.map((i) =>
                        i.replacement_deduction === "" ? 0 : i.replacement_deduction
                    );

                    const employeeMonths = employee_namess.map(
                        (emp) => BOQAttendanceList.find((a) => a.employee === emp.id)?.man_months || 0
                    );
                    const totalEmployeeMonths = employeeMonths.reduce((sum, val) => sum + Number(val || 0), 0);

                    const calculateAmount = calcAmounts(employee_namess, employeeMonths, eot_details, item?.rate);
                    const totalCalculateAmount = calculateAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                    const previousArray = previousInvoice
                        .filter((inv) => inv.employee_details?.id === empId)
                        .flatMap((inv) => inv.updated_actual_month_total_previous);
                    const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);

                    const previousAmount = previousInvoice
                        .filter((inv) => inv.employee_details?.id === empId)
                        .flatMap((inv) => inv.updated_previous_invoice_total);
                    const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                    const COMULATED_MONTH = employeeMonths.map((val, idx) => (Number(val) || 0) + (Number(previousArray[idx] ?? 0) || 0));
                    const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
                    const COMULATED_Amount = calculateAmount.map((val, idx) => (Number(val) || 0) + (Number(previousAmount[idx] ?? 0) || 0));
                    const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

                    const { remainingamount, remainingmonth } = calcRemaining(
                        item.eot_details, item.MM_construction_period, item.MM_OM_period, item.rate,
                        totalCOMULATED_Amount, totalCOMULATED_MONTH
                    );

                    return {
                        project: p_id,
                        invoice: invoice_id,
                        employee: empId,
                        actual_month: hasNames ? totalEmployeeMonths.toFixed(2) : totalEmployeeMonths,
                        month: month,
                        year: year,
                        rank: item.rank,
                        designation_name: item.designation_name,
                        actual_month_cumulative_total_two: COMULATED_MONTH,
                        actual_amount_cumulative_total: COMULATED_Amount,
                        actual_month_cumulative_total: totalCOMULATED_MONTH,
                        actual_month_two: hasNames ? employeeMonths : [0],
                        cumulative_invoice_total: totalCOMULATED_Amount,
                        contract_amount: "",
                        remaining_amount: remainingamount,
                        actual_month_remaining: remainingmonth,
                        invoice_amount: totalCalculateAmount,
                        actual_month_total_previous_two: previousArray,
                        previous_invoice_total_two: previousAmount,
                        current_invoice_amount_two: calculateAmount,
                        previous_invoice_total: previousAmountSum,
                        actual_month_total_previous: previousSum,
                        boq_designation: item.rank,
                        boq_professional_type: item.professional_type,
                        boq_rate: rate,
                        boq_empcode: "TBN",
                        boq_name_employee: "TBN",
                        boq_name_employee_two: employee_names.length > 0 ? employee_names : ["TBN"],
                        boq_construction_period: cp,
                        boq_OM_period: dlp,
                        eot_details: eot_details,
                        replacement_deduction: replacementDeduction.length > 0 ? replacementDeduction : [0],
                    };
                }

                // ---------------- Old BOQ revision (logid !== "null") ----------------
                const d = item.data || {};
                const rate = Number(d.rate ?? 0);
                const cp = Number(d.MM_construction_period ?? 0);
                const dlp = Number(d.MM_OM_period ?? 0);
                const eot_details = d.eot_details?.map((e) => e);

                const noNames = item.employee_name?.length === 0;

                const employee_names = item?.employee_name?.map((i) => i).reverse();
                const employee_namess = (d.empcode || []).map((i) => i);
                const employeeMonths = employee_namess.map(
                    (emp) => BOQAttendanceList.find((a) => a.employee === emp)?.man_months || 0
                );
                const totalEmployeeMonths = employeeMonths.reduce((sum, val) => sum + Number(val || 0), 0);

                const calculateAmount = calcAmounts(employee_namess, employeeMonths, eot_details, item?.rate);
                const totalCalculateAmount = calculateAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                const previousArray = previousInvoice
                    .filter((inv) => inv.employee_details?.id === empId)
                    .flatMap((inv) => inv.updated_actual_month_total_previous);
                const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);

                const previousAmount = previousInvoice
                    .filter((inv) => inv.employee_details?.id === empId)
                    .flatMap((inv) => inv.updated_previous_invoice_total);
                const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);

                const COMULATED_MONTH = employeeMonths.map((val, idx) => (Number(val) || 0) + (Number(previousArray[idx] ?? 0) || 0));
                const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
                const COMULATED_Amount = calculateAmount.map((val, idx) => (Number(val) || 0) + (Number(previousAmount[idx] ?? 0) || 0));
                const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

                const { remainingamount, remainingmonth } = calcRemaining(
                    d.eot_details, d.MM_construction_period, d.MM_OM_period, d.rate,
                    totalCOMULATED_Amount, totalCOMULATED_MONTH
                );

                return {
                    project: p_id,
                    invoice: invoice_id,
                    employee: empId,
                    actual_month: totalEmployeeMonths.toFixed(2),
                    month: month,
                    year: year,
                    designation_name: item.designation_name,
                    actual_month_cumulative_total_two: COMULATED_MONTH,
                    actual_amount_cumulative_total: COMULATED_Amount,
                    actual_month_cumulative_total: totalCOMULATED_MONTH,
                    actual_month_two: employeeMonths.length > 0 ? employeeMonths : ["0"],
                    cumulative_invoice_total: totalCOMULATED_Amount,
                    contract_amount: "",
                    remaining_amount: remainingamount,
                    actual_month_remaining: remainingmonth,
                    invoice_amount: totalCalculateAmount,
                    actual_month_total_previous_two: previousArray,
                    previous_invoice_total_two: previousAmount,
                    current_invoice_amount_two: calculateAmount,
                    previous_invoice_total: previousAmountSum,
                    actual_month_total_previous: previousSum,
                    rank: d.rank,
                    boq_designation: d.rank,
                    boq_rate: rate,
                    boq_empcode: "TBN",
                    boq_name_employee: "TBN",
                    boq_name_employee_two: employee_names && employee_names.length > 0 ? employee_names : ["TBN"],
                    boq_construction_period: cp,
                    boq_OM_period: dlp,
                    eot_details: eot_details,
                    replacement_deduction: noNames ? [0] : item?.employee_replacement_deduction || [0],
                };
            });

        setFormData(initialData);
    }, [logid, employeeData, employeeList, employeeListLoaded]);

    useEffect(() => {
        if (formData?.length > 0) {
            setFinalFormData(formData);
        }
    }, [formData]);

    // Duplicate employee cumulative fix (same as Add)
    useEffect(() => {
        if (formData.length === 0) return;

        const empCodeCount = formData.reduce((acc, item) => {
            const code = item.employee;
            if (code) acc[code] = (acc[code] || 0) + 1;
            return acc;
        }, {});

        const duplicates = formData.filter((item) => empCodeCount[item.employee] > 1);
        if (duplicates.length === 0) return;

        const rate = Number(duplicates[0]?.boq_rate || 0);
        const cp = Number(duplicates[0]?.boq_construction_period || 0);
        const dlp = Number(duplicates[0]?.boq_OM_period || 0);
        const totalMonths = cp + dlp;
        const contractAmount = rate * totalMonths;

        const actual_monthSum = duplicates.reduce((sum, item) => sum + Number(item.actual_month || 0), 0);
        const actual_AMOUNTsUM = duplicates.reduce((sum, item) => sum + Number(item.invoice_amount || 0), 0);

        const previous_invoicE = Number(duplicates[0]?.prevoiusAmt || 0);
        const PREVIOUSmonth = Number(duplicates[0]?.prevoius || 0);
        const previous_ACTUAL = Number(duplicates[0]?.prevoiusACTUAL || 0);
        const PREVIOUS_ActualAmt = Number(duplicates[0]?.prevoiusactuallAmt || 0);
        const previous_invoice_total_sum = Number(duplicates[0]?.previous_invoice_total || 0);
        const PREVIOUS_MONTH = Number(duplicates[0]?.actual_month_total_previous || 0);

        const previous_invoice_totall = Number(previous_invoicE || 0) + Number(PREVIOUS_ActualAmt || 0);
        const previous_month_totall = Number(PREVIOUSmonth || 0) + Number(previous_ACTUAL || 0);

        const comulatedAmount = previous_invoice_total_sum + actual_AMOUNTsUM;
        const comulatedMonth = PREVIOUS_MONTH + actual_monthSum;

        const remainingMonth = totalMonths - comulatedMonth;
        const remainingAmount = contractAmount - comulatedAmount;

        const updatedFormData = formData.map((item) => {
            if (empCodeCount[item.employee] > 1) {
                return {
                    ...item,
                    actual_month_cumulative_total: comulatedMonth.toFixed(2),
                    cumulative_invoice_total: comulatedAmount.toFixed(2),
                    remaining_amount: remainingAmount.toFixed(2),
                    actual_month_remaining: remainingMonth.toFixed(2),
                    previous_invoice_total: previous_invoice_totall.toFixed(2),
                    actual_month_total_previous: previous_month_totall.toFixed(2),
                };
            }
            return item;
        });

        if (JSON.stringify(formData) !== JSON.stringify(updatedFormData)) {
            setFormData(updatedFormData);
        }
    }, [formData]);

    useEffect(() => {
        if (!show) return;
        setModalLoading(!employeeListLoaded);
    }, [employeeListLoaded, show]);

    // ******************* Validation *******************
    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            const requiredFields = [];
            requiredFields.forEach((field) => {
                if (!entry[field]) {
                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ******************* Submit: UPDATE *******************
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm()) return;

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing invoiceemployee rows -> unki id attach karni hai
    //         const existingRes = await axios.get(
    //             `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${month}/${year}/`
    //         );
    //         const existingRows = Array.isArray(existingRes.data) ? existingRes.data : [];

    //         // employee -> [ids...] (same employee multiple rows ho to order ke hisaab se)
    //         const idQueue = {};
    //         existingRows.forEach((row) => {
    //             const key = String(row.employee);
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = formData
    //             .map((item) => {
    //                 const queue = idQueue[String(item.employee)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("Koi existing invoice row nahi mili update karne ke liye");
    //             return;
    //         }

    //         const res = await axios.put(
    //             `${BASE_URL}/siteproject/invoiceemployee/bulk-update/`,
    //             payload,
    //             {
    //                 onUploadProgress: (progressEvent) => {
    //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //                     setUploadProgress(percentCompleted);
    //                 },
    //             }
    //         );

    //         if (res.status === 200 || res.status === 201) {
    //             await getEmployeeInvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Employee Invoice Updated Successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };


    // ******************* Submit: UPDATE *******************
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing invoiceemployee rows -> unki id attach karni hai
            const existingRes = await axios.get(
                `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id}/${month}/${year}/`
            );
            const existingRows = Array.isArray(existingRes.data) ? existingRes.data : [];

            const idQueue = {};
            existingRows.forEach((row) => {
                const key = String(row.employee);
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = formData
                .map((item) => {
                    const queue = idQueue[String(item.employee)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("Koi existing invoice row nahi mili update karne ke liye");
                return;
            }

            // 1st API: invoiceemployee bulk update
            const res = await axios.put(
                `${BASE_URL}/siteproject/invoiceemployee/bulk-update/`,
                payload,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(Math.min(percentCompleted, 50));
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: new invoice employee rows fetch (invoice_id + month + year)
                const newEmpRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoiceemployeefiltermonthyear/${invoice_id}/${month}/${year}/`
                );
                const newEmpRows = Array.isArray(newEmpRes.data) ? newEmpRes.data : [];

                // invoiceemployee ki id  ==  newinvoiceemployee ka item_id
                const newPayload = payload.flatMap((item) => {
                    const matches = newEmpRows.filter(
                        (row) => String(row.invoiceemployee) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...item,                 // updated invoice data replicate
                        id: row.id,              // new employee row ki apni id
                        item_id: item.id,        // invoiceemployee ki id (link)
                    }));
                });

                if (newPayload.length > 0) {
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoiceemployeeupdatedelete/null/`,
                        newPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("New invoice employee me koi matching item_id nahi mili");
                }

                setUploadProgress(100);

                await getEmployeeInvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Employee Invoice Updated Successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // ******************* Input handler (same as Add) *******************
    const handleArrayInputChange = (e, formIndex, arrayIndex, fieldName) => {
        const { value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== formIndex) return entry;

            const updatedArray = [...(entry[fieldName] || [])];
            updatedArray[arrayIndex] = value;

            const updatedMonths =
                fieldName === "actual_month_two" ? updatedArray : [...(entry.actual_month_two || [0])];

            let updatedAmounts;
            if (fieldName === "actual_month_two") {
                updatedAmounts = updatedMonths.map((month, idx) => {
                    const eot_details = entry.eot_details;
                    const replacement = entry.replacement_deduction?.[idx];
                    const manMonth = Number(month) || 0;
                    const repl = Number(replacement) || 0;

                    let amount = 0;
                    if (repl > 0) {
                        amount = repl * manMonth;
                    } else if (eot_details && eot_details.length > 0) {
                        const lastRate = Number(eot_details[eot_details.length - 1]?.rate || 0);
                        amount = manMonth * lastRate;
                    } else {
                        amount = manMonth * Number(entry.boq_rate || 0);
                    }
                    return Number(amount.toFixed(0));
                });
            } else {
                updatedAmounts = updatedArray;
            }

            const totalActualMonth = updatedMonths.reduce((sum, val) => sum + (Number(val) || 0), 0);
            const totalInvoiceAmount = updatedAmounts.reduce((sum, val) => sum + (Number(val) || 0), 0);

            const previousArray = entry.actual_month_total_previous_two || [];
            const previousAmount = entry.previous_invoice_total_two || [];

            const COMULATED_MONTH = updatedMonths.map((val, idx) => (Number(val) || 0) + (Number(previousArray[idx] ?? 0) || 0));
            const COMULATED_Amount = updatedAmounts.map((val, idx) => (Number(val) || 0) + (Number(previousAmount[idx] ?? 0) || 0));

            const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, val) => sum + val, 0);
            const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, val) => sum + val, 0);

            let remainingamount;
            let remainingmonth;

            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                remainingamount = Number(lastEOT.total_amount || 0) - totalCOMULATED_Amount;
                remainingmonth = Number(lastEOT.t_month || 0) - totalCOMULATED_MONTH;
            } else {
                const monthh = Number(entry.boq_construction_period || 0) + Number(entry.boq_OM_period || 0);
                const TOTAL = monthh * Number(entry.boq_rate || 0);
                remainingamount = TOTAL - totalCOMULATED_Amount;
                remainingmonth = monthh - totalCOMULATED_MONTH;
            }

            return {
                ...entry,
                actual_month_two: updatedMonths,
                current_invoice_amount_two: updatedAmounts,
                actual_month: totalActualMonth,
                invoice_amount: totalInvoiceAmount,
                actual_month_cumulative_total_two: COMULATED_MONTH,
                actual_amount_cumulative_total: COMULATED_Amount,
                actual_month_cumulative_total: totalCOMULATED_MONTH,
                cumulative_invoice_total: totalCOMULATED_Amount,
                remaining_amount: remainingamount,
                actual_month_remaining: remainingmonth,
            };
        });

        setFormData(updatedFormData);
    };

    return (
        <>
            <button
                title="Update Employee Invoice"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="16" y1="13" x2="8" y2="13" />
                                <line x1="16" y1="17" x2="8" y2="17" />
                                <polyline points="10 9 9 9 8 9" />
                            </svg>
                            Update Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {employeeData.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {empChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />

                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>

                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>

                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>

                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table">
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}><span className="eb-bulk-th-label">#</span></th>
                                                        <th className="eb-bulk-th"><span className="eb-bulk-th-label">Employee name</span></th>
                                                        <th className="eb-bulk-th"><span className="eb-bulk-th-label">Designation</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}><span className="eb-bulk-th-label">Actual month</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}><span className="eb-bulk-th-label">Invoice amount</span></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData
                                                        .map((entry, originalIndex) => ({ entry, originalIndex }))
                                                        .sort((a, b) => {
                                                            const typeOrder = {
                                                                "Key Professional": 1,
                                                                "Sub Professional": 2,
                                                                "Support Staff": 3,
                                                            };

                                                            const typeA = typeOrder[a.entry.boq_professional_type] ?? 99;
                                                            const typeB = typeOrder[b.entry.boq_professional_type] ?? 99;

                                                            if (typeA !== typeB) return typeA - typeB;

                                                            return Number(a.entry.boq_designation) - Number(b.entry.boq_designation);
                                                        })
                                                        .map(({ entry, originalIndex }, displayIndex) => {
                                                            const months = Array.isArray(entry.actual_month_two) ? entry.actual_month_two : [];
                                                            const amounts =
                                                                entry.current_invoice_amount_two?.length > 0
                                                                    ? entry.current_invoice_amount_two
                                                                    : months.map(() => 0);
                                                            const names = entry.boq_name_employee_two || [];

                                                            return months.map((month, arrayIndex) => (
                                                                <tr key={`${originalIndex}-${arrayIndex}`} className="eb-bulk-row">
                                                                    <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px", verticalAlign: "top" }}>
                                                                        {arrayIndex === 0 ? `${displayIndex + 1}.` : ""}
                                                                    </td>

                                                                    <td className="eb-bulk-td" style={{ verticalAlign: "top" }}>
                                                                        <span style={{ fontWeight: 500 }}>{names[arrayIndex] || "TBN"}</span>
                                                                    </td>

                                                                    <td className="eb-bulk-td" style={{ color: "var(--text-secondary)", verticalAlign: "top" }}>
                                                                        {arrayIndex === 0 ? entry.designation_name : ""}
                                                                    </td>

                                                                    <td className="eb-bulk-td" style={{ textAlign: "right" }}>
                                                                        <input
                                                                            type="number"
                                                                            step="0.01"
                                                                            min="0"
                                                                            value={month ?? ""}
                                                                            onChange={(e) =>
                                                                                handleArrayInputChange(e, originalIndex, arrayIndex, "actual_month_two")
                                                                            }
                                                                            onBlur={(e) => {
                                                                                const v = e.target.value;
                                                                                if (v === "" || isNaN(Number(v))) return;
                                                                                const formatted = Number(v).toFixed(2);
                                                                                if (formatted !== v) {
                                                                                    handleArrayInputChange(
                                                                                        { target: { value: formatted } },
                                                                                        originalIndex,
                                                                                        arrayIndex,
                                                                                        "actual_month_two"
                                                                                    );
                                                                                }
                                                                            }}
                                                                            className={`eb-bulk-input eb-bulk-input-number ${errors[`${originalIndex}_actual_month_two`] ? "eb-bulk-input-error" : ""}`}
                                                                            placeholder={`Month ${arrayIndex + 1}`}
                                                                            style={{ textAlign: "right", width: "80px" }}
                                                                        />
                                                                    </td>

                                                                    <td className="eb-bulk-td" style={{ textAlign: "right" }}>
                                                                        <input
                                                                            type="number"
                                                                            value={amounts[arrayIndex] ?? 0}
                                                                            onChange={(e) =>
                                                                                handleArrayInputChange(e, originalIndex, arrayIndex, "current_invoice_amount_two")
                                                                            }
                                                                            className="eb-bulk-input eb-bulk-input-number"
                                                                            placeholder={`Amount ${arrayIndex + 1}`}
                                                                            style={{ textAlign: "right", width: "80px" }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                            ));
                                                        })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const UpdateNewEmployeeInvoice = ({ invoice_id, month, year, getEmployeeInvoice, usedfor }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [loading, setLoading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const toNum = (v) => Number(String(v ?? 0).replace(/,/g, "")) || 0;

    // ---------- Fetch: sirf new invoice employee ----------
    const getNewEmployeeRows = async () => {
        setModalLoading(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceemployeefiltermonthyear/${invoice_id}/${month}/${year}/`
            );
            const rows = Array.isArray(res.data) ? res.data : [];
            const sorted = [...rows].sort(
                (a, b) => Number(a?.employee_details?.rank || 0) - Number(b?.employee_details?.rank || 0)
            );
            setFormData(sorted);
        } catch (err) {
            handleErrorToast(err);
            setFormData([]);
        } finally {
            setModalLoading(false);
        }
    };

    const handleShow = async () => {
        setShow(true);
        await getNewEmployeeRows();
    };

    const handleClose = () => {
        setShow(false);
        setFormData([]);
        setModalLoading(false);
    };

    // ---------- Recalculate one row ----------
    const recalcRow = (entry, updatedMonths, updatedAmounts) => {
        const prevMonths = entry.actual_month_total_previous_two || [];
        const prevAmounts = entry.previous_invoice_total_two || [];

        const cumMonthArr = updatedMonths.map((v, i) => toNum(v) + toNum(prevMonths[i]));
        const cumAmountArr = updatedAmounts.map((v, i) => toNum(v) + toNum(prevAmounts[i]));

        const totalActualMonth = updatedMonths.reduce((s, v) => s + toNum(v), 0);
        const totalInvoiceAmount = updatedAmounts.reduce((s, v) => s + toNum(v), 0);
        const totalCumMonth = cumMonthArr.reduce((s, v) => s + v, 0);
        const totalCumAmount = cumAmountArr.reduce((s, v) => s + v, 0);

        const emp = entry.employee_details || {};
        const eot = emp.eot_details || [];
        let remainingamount, remainingmonth;
        if (eot.length > 0) {
            const last = eot[eot.length - 1];
            remainingamount = toNum(last.total_amount) - totalCumAmount;
            remainingmonth = toNum(last.t_month) - totalCumMonth;
        } else {
            const monthh = toNum(emp.MM_construction_period) + toNum(emp.MM_OM_period);
            remainingamount = monthh * toNum(emp.rate) - totalCumAmount;
            remainingmonth = monthh - totalCumMonth;
        }

        return {
            ...entry,
            actual_month_two: updatedMonths,
            current_invoice_amount_two: updatedAmounts,
            actual_month: totalActualMonth,
            invoice_amount: totalInvoiceAmount,
            actual_month_cumulative_total_two: cumMonthArr,
            actual_amount_cumulative_total: cumAmountArr,
            actual_month_cumulative_total: totalCumMonth,
            cumulative_invoice_total: totalCumAmount,
            remaining_amount: remainingamount,
            actual_month_remaining: remainingmonth,
        };
    };

    // ---------- Input handler ----------
    const handleArrayInputChange = (e, formIndex, arrayIndex, fieldName) => {
        const { value } = e.target;

        setFormData((prev) =>
            prev.map((entry, i) => {
                if (i !== formIndex) return entry;

                const months = [...(entry.actual_month_two || [])];
                let amounts = [...(entry.current_invoice_amount_two || [])];

                if (fieldName === "actual_month_two") {
                    months[arrayIndex] = value;

                    // Month change -> amount auto calculate (Add wali same formula)
                    const emp = entry.employee_details || {};
                    const eot = emp.eot_details || [];
                    const repl = toNum(entry.replacement_deduction?.[arrayIndex]);
                    const manMonth = toNum(value);

                    let amount = 0;
                    if (repl > 0) amount = repl * manMonth;
                    else if (eot.length > 0) amount = manMonth * toNum(eot[eot.length - 1]?.rate);
                    else amount = manMonth * toNum(emp.rate);

                    amounts[arrayIndex] = Number(amount.toFixed(0));
                } else {
                    amounts[arrayIndex] = value;
                }

                return recalcRow(entry, months, amounts);
            })
        );
    };

    console.log(formData, "FormdataDeduction")

    // ---------- Submit: sirf new invoice employee PUT ----------
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.length === 0) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            const payload = formData.map((item) => ({
                id: item.id,
                deduction_amount: item.deduction_amount,
                deduction_reason: item.deduction_reason,
                actual_month_two: item.actual_month_two,
                current_invoice_amount_two: item.current_invoice_amount_two,
                actual_month_cumulative_total_two: item.actual_month_cumulative_total_two,
                actual_amount_cumulative_total: item.actual_amount_cumulative_total,
                actual_month: item.actual_month,
                invoice_amount: item.invoice_amount,
                actual_month_cumulative_total: item.actual_month_cumulative_total,
                cumulative_invoice_total: item.cumulative_invoice_total,
                remaining_amount: item.remaining_amount,
                actual_month_remaining: item.actual_month_remaining,
                previous_invoice_total_two: item.previous_invoice_total_two,
                actual_month_total_previous_two: item.actual_month_total_previous_two,
                boq_name_employee_two: item.boq_name_employee_two,
            }));

            const res = await axios.put(
                `${BASE_URL}/siteproject/newinvoiceemployeeupdatedelete/null/`,
                payload,
                {
                    onUploadProgress: (progressEvent) => {
                        const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(pct);
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                if (getEmployeeInvoice) await getEmployeeInvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Employee Invoice Updated Successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    return (
        <>
            <button
                title="Update New Employee Invoice"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width90vw max-heightModal">
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z" />
                                <polyline points="14 2 14 8 20 8" />
                                <line x1="16" y1="13" x2="8" y2="13" />
                                <line x1="16" y1="17" x2="8" y2="17" />
                            </svg>
                            Update Employee {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "16px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />
                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0 }}>Loading data...</p>
                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table">
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}><span className="eb-bulk-th-label">#</span></th>
                                                        <th className="eb-bulk-th"><span className="eb-bulk-th-label">Employee name</span></th>
                                                        <th className="eb-bulk-th"><span className="eb-bulk-th-label">Designation</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}><span className="eb-bulk-th-label">Actual month</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}><span className="eb-bulk-th-label">Invoice amount</span></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.length === 0 && (
                                                        <tr>
                                                            <td className="eb-bulk-td" colSpan={5} style={{ textAlign: "center", color: "var(--text-muted)", padding: "24px" }}>
                                                                No employee invoice data found
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {formData.map((entry, index) => {
                                                        const months = Array.isArray(entry.actual_month_two) ? entry.actual_month_two : [];
                                                        const amounts =
                                                            entry.current_invoice_amount_two?.length > 0
                                                                ? entry.current_invoice_amount_two
                                                                : months.map(() => 0);
                                                        const names = entry.boq_name_employee_two || [];

                                                        return months.map((month, arrayIndex) => (
                                                            <tr key={`${entry.id}-${arrayIndex}`} className="eb-bulk-row">
                                                                <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px", verticalAlign: "top" }}>
                                                                    {arrayIndex === 0 ? `${index + 1}.` : ""}
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ verticalAlign: "top" }}>
                                                                    <span style={{ fontWeight: 500 }}>{names[arrayIndex] || "TBN"}</span>
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ color: "var(--text-secondary)", verticalAlign: "top" }}>
                                                                    {arrayIndex === 0 ? entry?.employee_details?.designation_name : ""}
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ textAlign: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        value={month ?? ""}
                                                                        onChange={(e) => handleArrayInputChange(e, index, arrayIndex, "actual_month_two")}
                                                                        onBlur={(e) => {
                                                                            const v = e.target.value;
                                                                            if (v === "" || isNaN(Number(v))) return;
                                                                            const formatted = Number(v).toFixed(2);
                                                                            if (formatted !== v) {
                                                                                handleArrayInputChange({ target: { value: formatted } }, index, arrayIndex, "actual_month_two");
                                                                            }
                                                                        }}
                                                                        className="eb-bulk-input eb-bulk-input-number"
                                                                        placeholder={`Month ${arrayIndex + 1}`}
                                                                        style={{ textAlign: "right", width: "80px" }}
                                                                    />
                                                                </td>

                                                                <td className="eb-bulk-td" style={{ textAlign: "right" }}>
                                                                    <input
                                                                        type="number"
                                                                        value={amounts[arrayIndex] ?? 0}
                                                                        onChange={(e) => handleArrayInputChange(e, index, arrayIndex, "current_invoice_amount_two")}
                                                                        className="eb-bulk-input eb-bulk-input-number"
                                                                        placeholder={`Amount ${arrayIndex + 1}`}
                                                                        style={{ textAlign: "right", width: "80px" }}
                                                                    />
                                                                </td>
                                                            </tr>
                                                        ));
                                                    })}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading || formData.length === 0}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};


const AddTransportationInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getTransportationInvoice, month, year, logData }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [logid, setLogId] = useState("null");
    const [transportation, setTransportation] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
    const [invoiceIds, setInvoiceIds] = useState([]);
    const [months, setMonths] = useState([]);
    const [years, setyears] = useState([]);
    const [getResults, setGetResults] = useState([]);
    const [getSheetData, setGetSheetData] = useState([])
    const [getAllResults, setGetAllResults] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [transportListLoaded, setTransportListLoaded] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [getTotalWithId, setGetTotalWithid] = useState([])

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setTransportListLoaded(false);
        setFetchProgress({ percent: 0, label: "" });
    };
    console.log(invoiceIds, "invoiceIds")

    const handleShow = () => {
        setShow(true);
        getTransportation();
    };
    useEffect(() => {
        if (!show) return;
        if (transportListLoaded) {
            setModalLoading(false);
        } else {
            setModalLoading(true);
        }
    }, [transportListLoaded, show]);

    const [transportList, setTransportList] = useState([]);
    useEffect(() => {
        if (show === true) {


            if (!month || !year) {
                console.error("Both month and year are required to fetch progress data.");
                return;
            }


            const getTransportData = async () => {
                try {
                    let currentMonth = month - 1 === 0 ? 12 : month - 1;
                    let currentYear = month - 1 === 0 ? year - 1 : year;
                    let dataFound = false;
                    let currentPercent = 0;

                    const updateProgress = (percent, label) => {
                        currentPercent = Math.max(currentPercent, percent);
                        setFetchProgress({ percent: currentPercent, label });
                    };

                    updateProgress(5, "Connecting to server...");

                    while (!dataFound) {
                        updateProgress(10, "Fetching previous transport data...");
                        const response = await axios.get(
                            `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
                        );

                        updateProgress(20, "Fetching withheld release data...");
                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                        const releaseRawData = releaseResponse.data;
                        setWithHeldReleaseData(releaseRawData);

                        const monthInt = parseInt(month, 10);
                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                        const filterReleaseData = releaseRawData.filter(i =>
                            (i.month === monthCalculation && i.year === calculatedYear) &&
                            i?.deduction_data?.project === p_id
                        );
                        setfilterwithHeldReleaseData(filterReleaseData);

                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
                        setInvoiceIds(invoiceIds);

                        let localAllResults = [];
                        let localSheetData = [];

                        if (invoiceIds.length > 0) {
                            updateProgress(35, "Fetching consultant invoices...");
                            const res = await axios.get(
                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                            );

                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

                            if (filteredData.length > 0) {
                                const months = [...new Set(filteredData.map(i => i.month))];
                                const years = [...new Set(filteredData.map(i => i.year))];
                                setMonths(months);
                                setyears(years);

                                const totalMonthYearCalls = months.length * years.length;
                                let completedMonthYearCalls = 0;

                                for (const m of months) {
                                    for (const y of years) {
                                        try {
                                            const filterRes = await axios.get(
                                                `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id}/${m}/${y}/`
                                            );
                                            localAllResults.push(...filterRes.data);
                                        } catch (err) {
                                            console.error(`Failed for month: ${m}, year: ${y}`, err);
                                        }
                                        completedMonthYearCalls++;
                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
                                    }
                                }

                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
                                const totalIdCalls = allIds.length;
                                let completedIdCalls = 0;

                                for (const id of allIds) {
                                    try {
                                        const secondRes = await axios.get(
                                            `${BASE_URL}/siteproject/newinvoicetrasportfilter/${id}/`
                                        );
                                        localSheetData.push(...secondRes.data);
                                    } catch (err) {
                                        console.error(`Failed for id: ${id}`, err);
                                    }
                                    completedIdCalls++;
                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
                                    updateProgress(50 + idPercent, `Loading transport sheet ${completedIdCalls} of ${totalIdCalls}...`);
                                }

                                setGetSheetData(localSheetData);
                                const getboqIds = localAllResults.map(i => i?.transport_details?.id);
                                setGetResults(getboqIds);
                                setGetAllResults(localAllResults);
                            }
                        }

                        updateProgress(70, "Processing transport records...");
                        const data = response.data;
                        let selectedData = [];

                        if (data.length > 0) {
                            const uids = data.map(item => item.id).filter(Boolean);
                            let uidResults = [];
                            const totalUids = uids.length;
                            let completedUids = 0;

                            for (const uid of uids) {
                                const res = await axios.get(
                                    `${BASE_URL}/siteproject/newinvoicetrasportfilter/${uid}/`
                                );

                                if (!res.data || res.data.length === 0) {
                                    console.error(`No data found for UID ${uid}. Breaking loop.`);
                                    dataFound = false;
                                    break;
                                }

                                uidResults = [...uidResults, ...res.data];
                                completedUids++;
                                const uidPercent = Math.round((completedUids / totalUids) * 15);
                                updateProgress(70 + uidPercent, `Loading transport ${completedUids} of ${totalUids}...`);
                            }

                            if (!dataFound && uidResults.length === 0) break;
                            selectedData = uidResults;

                        } else {
                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                            currentMonth -= 1;
                            if (currentMonth === 0) {
                                currentMonth = 12;
                                currentYear -= 1;
                            }
                            if (currentYear < year - 1) {
                                console.error("No data found for the past 1 year.");
                                break;
                            }
                            continue;
                        }

                        if (selectedData.length > 0) {
                            updateProgress(90, "Calculating cumulative totals...");
                            console.log("filterReleaseData", filterwithHeldReleaseData);


                            const updatedGetAllResults = localSheetData.map((resultItem) => {
                                const matchingReleases = filterReleaseData.filter(
                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                                );

                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
                                const total = totalReleaseAmount + totalDeductionAmount;
                                return { id: resultItem?.transport_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
                            });

                            setGetTotalWithid(updatedGetAllResults);


                            const updatedTransportData = selectedData.map((item) => {
                                const boqId = item?.transport_details?.id;
                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);
                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                                const prev_month_array = item.actual_month_total_previous_two?.map((i) => i);
                                const prev_amount_array = item.previous_invoice_total_two?.map((i) => i);
                                const current_amount_array = item.current_invoice_amount_two?.map((i) => i);
                                const current_month_array = item.actual_month_two?.map((i) => i);

                                const sum_previous_month = current_month_array.map((val, idx) => {
                                    const prevVal = prev_month_array?.[idx] ?? 0;
                                    return (Number(val) || 0) + (Number(prevVal) || 0) + totalMonthRelease;
                                });
                                const sum_previous_amount = current_amount_array.map((val, idx) => {
                                    const prevVal = prev_amount_array?.[idx] ?? 0;
                                    return (Number(val) || 0) + (Number(prevVal) || 0) + totalReleaseAmount;
                                });

                                return {
                                    ...item,
                                    updated_previous_invoice_total: sum_previous_amount,
                                    updated_actual_month_total_previous: sum_previous_month,
                                };
                            });

                            updateProgress(100, "Done!");
                            setTransportList(updatedTransportData);
                            setTransportListLoaded(true);
                            dataFound = true;
                        }
                    }

                    if (!dataFound) {
                        updateProgress(100, "No previous data found.");
                        setTransportListLoaded(true);
                    }

                } catch (error) {
                    console.error("Error fetching progress data:", error);
                    setFetchProgress({ percent: 100, label: "Error loading data." });
                    setTransportListLoaded(true);
                }
            };


            getTransportData();
        }
    }, [month, year, show]);

    console.log("transportList", transportList);
    console.log("filterwithHeldReleaseData", filterwithHeldReleaseData);
    console.log("getSheetData", getSheetData);

    const transportID = transportation.map(e => e.id);
    const transportData = logData.filter(item =>
        transportID.includes(item.object_id)
    );
    const transportChangeReason = transportation[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        transportData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null"
        ? transportation
        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];




    const getTransportation = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqtransportbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setTransportation(res.data);
            } else {
                console.error("Error: Expected a list of transportation items");
            }
        } catch (err) {
            console.error("Error fetching transportation data", err);
        }
    };


    useEffect(() => {
        if (transportation.length === 0) return;

        const initialData = selectedGroup.map((item) => {
            const transportId = item.object_id ?? item.id;

            // Find matching progress entry from previousProgressData
            const matchedProgress = transportList.find(
                (progress) => progress.transport === transportId
            );

            let eot_details;
            if (logid === "null") {
                eot_details = item.eot_details?.map((item) => (
                    item
                ));
            }
            else {
                eot_details = item?.data?.eot_details?.map((item) => (
                    item
                ));
            }

            const previousInvoice = transportList.map((i) => (i))
            console.log("previousInvoice")
            console.log(previousInvoice)

            const previousArray = previousInvoice?.filter((inv) => inv.transport_details?.id === transportId)?.flatMap((inv) => inv.updated_actual_month_total_previous);

            const previousSum = previousArray?.reduce((sum, val) => sum + Number(val || 0), 0);



            const previousAmount = previousInvoice?.filter((inv) => inv.transport_details?.id === transportId)?.flatMap((inv) => inv.updated_previous_invoice_total);

            const previousAmountSum = previousAmount?.reduce((sum, val) => sum + Number(val || 0), 0);


            return {
                project: p_id,
                invoice: invoice_id,
                transport: transportId,
                actual_month: 0,
                month: month,
                previous_invoice_total_two: previousAmount,
                actual_month_total_previous_two: previousArray,
                actual_month_cumulative_total_two: [],
                actual_amount_cumulative_total: [],
                actual_month_two: [],
                current_invoice_amount_two: [],
                year: year,
                actual_month_cumulative_total: "",
                cumulative_invoice_total: "",
                contract_amount: "",
                remaining_amount: "",
                actual_month_remaining: "",
                invoice_amount: "",
                previous_invoice_total: previousAmountSum,
                actual_month_total_previous: previousSum,
                boq_rate: item.rate ?? item.data?.rate,
                boq_vehicle_description: item.vehicle_description ?? item.data?.vehicle_description,
                boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,
                boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,
                eot_details: eot_details,
                no_of_vehicle: "",
            };
        });

        setFormData(initialData);
    }, [logid, transportation, transportList]);

    console.log("formData");
    console.log(formData);
    const validateForm = () => {
        const newErrors = {};

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    console.log("error", errors);

    // IMPORTANT: The backend auto-calculate endpoint may recompute an invoice
    // using the rounded actual_month fields. If it does, the backend must be
    // updated to compute from raw precision BEFORE rounding stored month values.
    // Keep the money/cumulative values below as calculated from original inputs.
    // Keep the original decimals for ALL frontend calculations.
    // Round ONLY the Actual Month fields in the payload sent to the APIs.
    const roundActualMonthForUpload = (value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? Number(numericValue.toFixed(2)) : 0;
    };

    const prepareUploadData = (data) => data.map((item) => ({
        ...item,
        actual_month: roundActualMonthForUpload(item.actual_month),
        actual_month_two: (item.actual_month_two || []).map(roundActualMonthForUpload),
        // Amount/cumulative fields remain calculated using the ORIGINAL decimals.
    }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        // A single immutable snapshot is used for both API requests, so they
        // receive the same two-decimal Actual Month values.
        const uploadFormData = prepareUploadData(formData);

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        if (usedfor === "InvoiceandDeduction") {

            try {
                const res = await axios.post(
                    `${BASE_URL}/siteproject/invoicetransportationbulk-auto-calculate-amount/`,
                    uploadFormData
                );

                if (res.status === 201) {
                    const createdData = res.data;

                    const mappedFinalData = uploadFormData.map((item, index) => ({
                        ...item,
                        invoicetrasport: createdData[index]?.id,
                    }));

                    const res2 = await axios.post(
                        `${BASE_URL}/siteproject/newinvoicetransportationlistcreate/`,
                        mappedFinalData
                    );

                    if (res2.status === 201) {
                        await getTransportationInvoice();
                        setShow(false);
                        toast.dismiss(loadingToastId);
                        toast.success("Transportation Data added Successfully");
                    } else {
                        alert("Second API failed");
                    }

                } else {
                    alert("First API failed");
                }
            } catch (err) {
                console.error("Error submitting transportation invoice", err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
        else if (usedfor === "OnlyDeduction") {
            try {
                const createdData = invoiceData;

                const mappedFinalData = uploadFormData.map((item, index) => ({
                    ...item,
                    invoicetrasport: createdData[index]?.id,
                }));

                const res2 = await axios.post(
                    `${BASE_URL}/siteproject/newinvoicetransportationlistcreate/`,
                    mappedFinalData
                );

                if (res2.status === 201) {
                    await getTransportationInvoice();
                    setShow(false);
                    toast.dismiss(loadingToastId);
                    toast.success("Transportation Data added Successfully");
                } else {
                    alert("Second API failed");
                }
            } catch (error) {
                handleErrorToast(error, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        };
    }

    // const handleInputChange = (e, index) => {
    //     const { name, value } = e.target;

    //     const updatedFormData = formData.map((entry, i) => {
    //         if (i !== index) return entry;

    //         const updatedEntry = { ...entry, [name]: value };

    //         const rate = entry.boq_rate
    //         const cp = entry.boq_during_construction_period
    //         const dlp = entry.boq_during_dlp_OM_period
    //         const month = Number(cp) + Number(dlp);
    //         const total = Number(rate) * Number(month)

    //         const previous = entry.actual_month_total_previous;
    //         const previousAmount = entry.previous_invoice_total;
    //         const actualMonth = name === "actual_month"
    //             ? parseFloat(value) || 0
    //             : parseFloat(entry.actual_month) || 0;


    //         let invoiceAmount;

    //         if (entry.eot_details && entry.eot_details.length > 0) {
    //             const lastEOT = entry.eot_details[entry.eot_details.length - 1];
    //             invoiceAmount = Number(lastEOT.rate || 0) * Number(actualMonth);
    //         } else {

    //             invoiceAmount = Number(rate) * Number(actualMonth);
    //         }

    //         updatedEntry.invoice_amount = invoiceAmount;

    //         updatedEntry.actual_month_cumulative_total = Number(previous) + Number(actualMonth);
    //         updatedEntry.cumulative_invoice_total = Number(previousAmount) + Number(updatedEntry.invoice_amount);

    //         let remainingamount;

    //         if (entry.eot_details && entry.eot_details.length > 0) {
    //             const lastEOT = entry.eot_details[entry.eot_details.length - 1];
    //             remainingamount = Number(lastEOT.total_amount || 0) - Number(updatedEntry.cumulative_invoice_total || 0);
    //         } else {
    //             const monthh = Number(entry.MM_construction_period || 0) + Number(entry.MM_OM_period || 0);
    //             const TOTAL = Number(monthh) * Number(entry.rate);
    //             remainingamount = Number(TOTAL) - Number(updatedEntry.cumulative_invoice_total || 0);
    //         }
    //         let remainingmonth;

    //         if (entry.eot_details && entry.eot_details.length > 0) {
    //             const lastEOT = entry.eot_details[entry.eot_details.length - 1];
    //             remainingmonth = Number(lastEOT.t_month || 0) - Number(updatedEntry.actual_month_cumulative_total || 0);
    //         } else {
    //             const monthh = Number(entry.MM_construction_period || 0) + Number(entry.MM_OM_period || 0);
    //             remainingmonth = Number(monthh) - Number(updatedEntry.actual_month_cumulative_total || 0);
    //         }

    //         updatedEntry.actual_month_remaining = Number(remainingmonth);
    //         updatedEntry.remaining_amount = Number(remainingamount);


    //         const vehicleCount = Array.isArray(entry.vehicles)
    //             ? entry.vehicles.length
    //             : Number(entry.vehicles) || 0;

    //         updatedEntry.actual_month_two = new Array(vehicleCount).fill(0);

    //         return updatedEntry;
    //     });

    //     setFormData(updatedFormData);
    // };


    const handleInputChange = (e, index, subIndex = null) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;
            const updatedEntry = { ...entry };

            // --- Case 1: Updating no_of_vehicle ---
            if (name === "no_of_vehicle") {
                const vehicleCount = Number(value) || 0;
                updatedEntry.no_of_vehicle = vehicleCount;

                const existingActual = updatedEntry.actual_month_two || [];
                updatedEntry.actual_month_two = Array.from(
                    { length: vehicleCount },
                    (_, j) => existingActual[j] || 0
                );
            }

            // --- Case 2: Updating actual_month_two element ---
            else if (name === "actual_month_two" && subIndex !== null) {
                const arr = [...(updatedEntry.actual_month_two || [])];
                // Preserve the typed text (e.g. "0.", "0.322211566569")
                // so React does not remove decimals while the user is typing.
                arr[subIndex] = value;
                updatedEntry.actual_month_two = arr;
            }

            // --- Case 3: Normal field update ---
            else {
                updatedEntry[name] = value;
            }

            // --- Normalize arrays safely ---
            const normalizeLength = (arr, len) =>
                Array.from({ length: len }, (_, i) => Number(arr?.[i]) || 0);

            // 🔹 Aggregate calculations
            const actualMonthArray = updatedEntry.actual_month_two || [];
            const actualMonth = actualMonthArray.reduce((sum, v) => sum + Number(v || 0), 0);

            // --- Rate logic ---
            let rate;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                rate = Number(lastEOT.rate || 0);
            } else {
                rate = Number(entry.boq_rate || 0);
            }

            // --- Current invoice amounts ---
            updatedEntry.current_invoice_amount_two = actualMonthArray.map(
                v => Number(v || 0) * rate
            );
            const invoiceAmount = updatedEntry.current_invoice_amount_two.reduce((a, b) => a + b, 0);

            updatedEntry.actual_month = actualMonth;
            updatedEntry.invoice_amount = Number(invoiceAmount).toFixed(2);

            // --- Previous arrays ---
            const previousArr = entry.previous_invoice_total_two || [];
            const prevMonth = entry.actual_month_total_previous_two || [];

            // ✅ Normalize all arrays to the longest length
            const maxLength = Math.max(
                actualMonthArray.length,
                previousArr.length,
                prevMonth.length
            );

            const safeActualMonths = normalizeLength(actualMonthArray, maxLength);
            const safeCurrentAmounts = normalizeLength(updatedEntry.current_invoice_amount_two, maxLength);
            const safePrevAmounts = normalizeLength(previousArr, maxLength);
            const safePrevMonths = normalizeLength(prevMonth, maxLength);

            // --- Previous total ---
            updatedEntry.previous_invoice_total_two = safePrevAmounts;
            updatedEntry.previous_invoice_total = safePrevAmounts.reduce((a, b) => a + b, 0);

            // --- Cumulative totals ---
            updatedEntry.actual_amount_cumulative_total = safeCurrentAmounts.map(
                (amt, idx) => amt + safePrevAmounts[idx]
            );
            updatedEntry.cumulative_invoice_total = updatedEntry.actual_amount_cumulative_total.reduce((a, b) => a + b, 0);

            // --- Cumulative months ---
            updatedEntry.actual_month_total_previous_two = safePrevMonths;
            updatedEntry.actual_month_cumulative_total_two = safeActualMonths.map(
                (m, idx) => m + safePrevMonths[idx]
            );
            updatedEntry.actual_month_cumulative_total = updatedEntry.actual_month_cumulative_total_two.reduce((a, b) => a + b, 0);


            let remainingamount;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                remainingamount =
                    Number(lastEOT.total_amount || 0) -
                    Number(updatedEntry.cumulative_invoice_total || 0);
            } else {
                const monthh =
                    Number(entry.boq_during_construction_period || 0) +
                    Number(entry.boq_during_dlp_OM_period || 0);
                const TOTAL = Number(monthh) * Number(entry.boq_rate);
                remainingamount =
                    Number(TOTAL) - Number(updatedEntry.cumulative_invoice_total || 0);
            }

            let remainingmonth;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                remainingmonth =
                    Number(lastEOT.t_month || 0) -
                    Number(updatedEntry.actual_month_cumulative_total || 0);
            } else {
                const monthh =
                    Number(entry.boq_during_construction_period || 0) +
                    Number(entry.boq_during_dlp_OM_period || 0);
                remainingmonth =
                    Number(monthh) -
                    Number(updatedEntry.actual_month_cumulative_total || 0);
            }

            updatedEntry.actual_month_remaining = Number(remainingmonth);
            updatedEntry.remaining_amount = Number(remainingamount);

            return updatedEntry;
        });

        setFormData(updatedFormData);
    };


    // return (
    //     <>
    //         <button title="Add Transportation" className="upload-svg flex-row" onClick={handleShow}>
    //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    //                 <g clipPath="url(#clip0_1415_3177)">
    //                     <path
    //                         d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
    //                         fill="white"
    //                     />
    //                 </g>
    //                 <defs>
    //                     <clipPath id="clip0_1415_3177">
    //                         <rect width="24" height="24" fill="white" />
    //                     </clipPath>
    //                 </defs>
    //             </svg>{" "} Transportation {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
    //         </button>

    //         <Modal show={show} onHide={handleClose} dialogClassName="three-fourth-modal">
    //             <Modal.Header closeButton>
    //                 <Modal.Title>Add Transportation {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}</Modal.Title>
    //             </Modal.Header>
    //             <Modal.Body>
    //                 <div className="parent-div">
    //                     <div className="bdy-div flex-column">
    //                         <div>
    //                             {(transportation.length > 0 && groupedByRandomChange.length > 0) && (
    //                                 <select
    //                                     value={logid}
    //                                     onChange={(e) => setLogId(e.target.value)}
    //                                     className="dropdown font-size-subheading navbar-inputt"
    //                                 >
    //                                     <option value="null">
    //                                         BOQ {groupedByRandomChange.length + 1} - {transportChangeReason}
    //                                     </option>
    //                                     {groupedByRandomChange.map(([groupKey, items], index) => {
    //                                         const reasons = [...new Set(
    //                                             items.map(i => i.data?.reason_of_change).filter(reason =>
    //                                                 reason !== null && reason !== "null" && reason?.trim() !== ""
    //                                             )
    //                                         )];
    //                                         return (
    //                                             <option key={groupKey} value={groupKey}>
    //                                                 BOQ {groupedByRandomChange.length - index}
    //                                                 {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
    //                                             </option>
    //                                         );
    //                                     })}
    //                                 </select>
    //                             )}
    //                         </div>

    //                         <div className="flex-row justify-center">
    //                             <table className="nested-table-lightblue width-90vw payment">
    //                                 <thead>
    //                                     <tr className="custom-table-head-td width-10vw">
    //                                         <th className=" width-10vw">S no.</th>
    //                                         <th className=" width-10vw">Transport</th>
    //                                         <th className=" width-10vw">No. of Veicles</th>
    //                                         <th className="align-center width-10vw">Actual Month</th>
    //                                     </tr>
    //                                 </thead>
    //                                 <tbody>
    //                                     {formData.map((entry, index) => (
    //                                         <tr className="custom-table-head-td" key={index}>
    //                                             <td className="align-left width-5vw">{index + 1}.</td>
    //                                             <td>
    //                                                 <div className="flex-column form-group-selectt">
    //                                                     <p className="" >
    //                                                         {entry.boq_vehicle_description}
    //                                                     </p>

    //                                                 </div>
    //                                             </td>
    //                                             <td>
    //                                                 <div className="flex-column align-items-center">
    //                                                     <input
    //                                                         className={`form-input-date width-5vw ${errors[`${index}_no_of_vehicle`] ? "error" : ""}`}
    //                                                         name="no_of_vehicle"
    //                                                         type="number"
    //                                                         value={entry.no_of_vehicle}
    //                                                         onChange={(e) => handleInputChange(e, index)}
    //                                                     />
    //                                                     {errors[`${index}_no_of_vehicle`] && (
    //                                                         <span className="error-message font-size-text">
    //                                                             {errors[`${index}_no_of_vehicle`]}
    //                                                         </span>
    //                                                     )}
    //                                                 </div>
    //                                             </td>
    //                                             <td>
    //                                                 <div className="flex-column align-items-center">
    //                                                     {entry.actual_month_two?.map((val, subIndex) => (
    //                                                         <input
    //                                                             key={subIndex}
    //                                                             className="form-input-date width-5vw mt-2"
    //                                                             name="actual_month_two"
    //                                                             type="number"
    //                                                             value={val}
    //                                                             onChange={(e) => handleInputChange(e, index, subIndex)}
    //                                                         />
    //                                                     ))}
    //                                                 </div>
    //                                             </td>
    //                                         </tr>
    //                                     ))}
    //                                 </tbody>
    //                             </table>
    //                         </div>

    //                         <div className="button-models">
    //                             <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
    //                                 Cancel
    //                             </button>
    //                             <button
    //                                 type="submit"
    //                                 className="model-button font-weight500 model-button-submit font-size-heading"
    //                                 disabled={loading}
    //                                 onClick={handleSubmit}
    //                             >
    //                                 Add
    //                             </button>
    //                         </div>
    //                     </div>
    //                 </div>
    //                 <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} />
    //             </Modal.Body>
    //         </Modal>
    //     </>
    // );

    return (
        <>
            <button title="Add Transportation" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Transportation {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
            >
                <Modal.Header className="eb-bulk-modal-header">
                    <Modal.Title className="eb-bulk-modal-title">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="1" y="3" width="15" height="13" rx="1" />
                            <path d="M16 8h4l3 3v5h-7V8z" />
                            <circle cx="5.5" cy="18.5" r="2.5" />
                            <circle cx="18.5" cy="18.5" r="2.5" />
                        </svg>
                        Add Transportation {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                    </Modal.Title>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {(transportation.length > 0 && groupedByRandomChange.length > 0) && (
                            <select
                                value={logid}
                                onChange={(e) => setLogId(e.target.value)}
                                style={{
                                    fontSize: "13px",
                                    background: "var(--surface-2, #fff)",
                                    border: "0.5px solid var(--border-strong, #ccc)",
                                    borderRadius: "var(--radius, 8px)",
                                    padding: "4px 10px",
                                    cursor: "pointer",
                                    color: "var(--text-primary)",
                                }}
                            >
                                <option value="null">
                                    BOQ {groupedByRandomChange.length + 1} - {transportChangeReason}
                                </option>
                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                    const reasons = [...new Set(
                                        items.map(i => i.data?.reason_of_change).filter(reason =>
                                            reason !== null && reason !== "null" && reason?.trim() !== ""
                                        )
                                    )];
                                    return (
                                        <option key={groupKey} value={groupKey}>
                                            BOQ {groupedByRandomChange.length - index}
                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                        </option>
                                    );
                                })}
                            </select>
                        )}
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body className="eb-bulk-modal-body">
                    {modalLoading ? (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "50vh",
                            gap: "20px",
                            padding: "40px",
                        }}>
                            <div style={{
                                width: "44px",
                                height: "44px",
                                border: "3px solid #e0e0e0",
                                borderTop: "3px solid #000",
                                borderRadius: "50%",
                                animation: "eb-spin 0.8s linear infinite",
                            }} />
                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                {fetchProgress.label || "Loading data..."}
                            </p>
                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                <div style={{
                                    height: "100%",
                                    width: `${fetchProgress.percent}%`,
                                    background: "#111",
                                    borderRadius: "999px",
                                    transition: "width 0.3s ease",
                                }} />
                            </div>
                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                {fetchProgress.percent}%
                            </p>
                            <style>{`
                            @keyframes eb-spin {
                                0% { transform: rotate(0deg); }
                                100% { transform: rotate(360deg); }
                            }
                        `}</style>
                        </div>
                    ) : (
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div
                                        className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                    >
                                        <table className="eb-bulk-table">
                                            <thead className="eb-bulk-table-head">
                                                <tr className="eb-bulk-table-header-row">
                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                        <span className="eb-bulk-th-label">#</span>
                                                    </th>
                                                    <th className="eb-bulk-th">
                                                        <span className="eb-bulk-th-label">Transport</span>
                                                    </th>
                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>
                                                        <span className="eb-bulk-th-label">No. of vehicles</span>
                                                    </th>
                                                    <th className="eb-bulk-th" style={{ textAlign: "right" }}>
                                                        <span className="eb-bulk-th-label">Actual month <span className="required">(Input no. of Vehicles first)</span></span>
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {formData.map((entry, index) => (
                                                    <tr key={index} className="eb-bulk-row">
                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px", verticalAlign: "top" }}>
                                                            {index + 1}.
                                                        </td>

                                                        <td className="eb-bulk-td" style={{ verticalAlign: "top" }}>
                                                            <span style={{ fontWeight: 500 }}>
                                                                {entry.boq_vehicle_description}
                                                            </span>
                                                        </td>

                                                        <td className="eb-bulk-td" style={{ textAlign: "center", verticalAlign: "top" }}>
                                                            <input
                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_no_of_vehicle`] ? "eb-bulk-input-error" : ""}`}
                                                                name="no_of_vehicle"
                                                                type="number"
                                                                value={entry.no_of_vehicle}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                                style={{ width: "80px", textAlign: "center" }}
                                                                placeholder="0"
                                                            />
                                                            {errors[`${index}_no_of_vehicle`] && (
                                                                <span className="eb-bulk-error-text">
                                                                    {errors[`${index}_no_of_vehicle`]}
                                                                </span>
                                                            )}
                                                        </td>

                                                        <td className="eb-bulk-td" style={{ textAlign: "right", verticalAlign: "top" }}>
                                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                                                                {entry.actual_month_two?.map((val, subIndex) => (
                                                                    <input
                                                                        key={subIndex}
                                                                        className="eb-bulk-input eb-bulk-input-number"
                                                                        name="actual_month_two"
                                                                        type="number"
                                                                        step="any"
                                                                        value={val ?? ""}
                                                                        onChange={(e) => handleInputChange(e, index, subIndex)}
                                                                        style={{ width: "80px", textAlign: "right" }}
                                                                        placeholder={`Vehicle ${subIndex + 1}`}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

// NOTE: imports same rahenge (useState, useEffect, axios, Modal, X, toast, ToastContainer,
// BASE_URL, handleErrorToast, ProgressModal).
const UpdateTransportationInvoice = ({ invoiceData, p_id, invoice_id, getTransportationInvoice, month, year, logData = [], usedfor }) => {
    const [show, setShow] = useState(false);
    const [transportation, setTransportation] = useState([]);
    const [logid, setLogId] = useState("null");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [transportListLoaded, setTransportListLoaded] = useState(false);
    const [transportList, setTransportList] = useState([]);
    const [existingRows, setExistingRows] = useState([]);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setTransportListLoaded(false);
        setTransportList([]);
        setExistingRows([]);
        setFormData([]);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        setShow(true);
        await getExistingRows();
        await getTransportation();
    };

    // ******************* Current month ki already saved rows *******************
    const fetchExistingRows = async () => {
        const res = await axios.get(
            `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id}/${String(month).padStart(2, "0")}/${year}/`
        );
        return Array.isArray(res.data) ? res.data : [];
    };

    const getExistingRows = async () => {
        try {
            const rows = await fetchExistingRows();
            setExistingRows(rows);
            return rows;
        } catch (err) {
            handleErrorToast(err);
            return [];
        }
    };

    const getRowTransportId = (row) => row?.transport ?? row?.transport_details?.id;

    // ******************* Previous data fetch *******************
    useEffect(() => {
        if (show !== true) return;
        if (!month || !year) {
            console.error("Both month and year are required to fetch progress data.");
            return;
        }

        const getTransportData = async () => {
            try {
                let currentMonth = month - 1 === 0 ? 12 : month - 1;
                let currentYear = month - 1 === 0 ? year - 1 : year;
                let dataFound = false;
                let currentPercent = 0;

                const updateProgress = (percent, label) => {
                    currentPercent = Math.max(currentPercent, percent);
                    setFetchProgress({ percent: currentPercent, label });
                };

                updateProgress(5, "Connecting to server...");

                while (!dataFound) {
                    updateProgress(10, "Fetching previous transport data...");
                    const response = await axios.get(
                        `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, "0")}/${currentYear}/`
                    );

                    updateProgress(20, "Fetching withheld release data...");
                    const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                    const releaseRawData = releaseResponse.data;

                    const monthInt = parseInt(month, 10);
                    const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, "0");
                    const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                    const filterReleaseData = releaseRawData.filter(
                        (i) =>
                            i.month === monthCalculation &&
                            i.year === calculatedYear &&
                            i?.deduction_data?.project === p_id
                    );

                    const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

                    let localAllResults = [];
                    let localSheetData = [];

                    if (invoiceIds.length > 0) {
                        updateProgress(35, "Fetching consultant invoices...");
                        const res = await axios.get(
                            `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                        );
                        const filteredData = res.data.filter((item) => invoiceIds.includes(item.id));

                        if (filteredData.length > 0) {
                            const months = [...new Set(filteredData.map((i) => i.month))];
                            const years = [...new Set(filteredData.map((i) => i.year))];

                            const totalMonthYearCalls = months.length * years.length;
                            let completedMonthYearCalls = 0;

                            for (const m of months) {
                                for (const y of years) {
                                    try {
                                        const filterRes = await axios.get(
                                            `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id}/${m}/${y}/`
                                        );
                                        localAllResults.push(...filterRes.data);
                                    } catch (err) {
                                        console.error(`Failed for month: ${m}, year: ${y}`, err);
                                    }
                                    completedMonthYearCalls++;
                                    const pct = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                    updateProgress(35 + pct, `Fetching BOQ data for ${m}/${y}...`);
                                }
                            }

                            const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                            const totalIdCalls = allIds.length;
                            let completedIdCalls = 0;

                            for (const id of allIds) {
                                try {
                                    const secondRes = await axios.get(`${BASE_URL}/siteproject/newinvoicetrasportfilter/${id}/`);
                                    localSheetData.push(...secondRes.data);
                                } catch (err) {
                                    console.error(`Failed for id: ${id}`, err);
                                }
                                completedIdCalls++;
                                const pct = Math.round((completedIdCalls / totalIdCalls) * 15);
                                updateProgress(50 + pct, `Loading transport sheet ${completedIdCalls} of ${totalIdCalls}...`);
                            }
                        }
                    }

                    updateProgress(70, "Processing transport records...");
                    const data = response.data;
                    let selectedData = [];

                    if (data.length > 0) {
                        const uids = data.map((item) => item.id).filter(Boolean);
                        let uidResults = [];
                        const totalUids = uids.length;
                        let completedUids = 0;

                        for (const uid of uids) {
                            const res = await axios.get(`${BASE_URL}/siteproject/newinvoicetrasportfilter/${uid}/`);

                            if (!res.data || res.data.length === 0) {
                                console.error(`No data found for UID ${uid}. Breaking loop.`);
                                dataFound = false;
                                break;
                            }

                            uidResults = [...uidResults, ...res.data];
                            completedUids++;
                            const pct = Math.round((completedUids / totalUids) * 15);
                            updateProgress(70 + pct, `Loading transport ${completedUids} of ${totalUids}...`);
                        }

                        if (!dataFound && uidResults.length === 0) break;
                        selectedData = uidResults;
                    } else {
                        updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                        currentMonth -= 1;
                        if (currentMonth === 0) {
                            currentMonth = 12;
                            currentYear -= 1;
                        }
                        if (currentYear < year - 1) {
                            console.error("No data found for the past 1 year.");
                            break;
                        }
                        continue;
                    }

                    if (selectedData.length > 0) {
                        updateProgress(90, "Calculating cumulative totals...");

                        const updatedGetAllResults = localSheetData.map((resultItem) => {
                            const matchingReleases = filterReleaseData.filter(
                                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                            );
                            const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                            const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                            const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
                            return {
                                id: resultItem?.transport_details?.id,
                                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                                total_month_release: totalMonthRelease,
                            };
                        });

                        const updatedTransportData = selectedData.map((item) => {
                            const boqId = item?.transport_details?.id;
                            const matchedData = updatedGetAllResults.filter((i) => i.id === boqId);
                            const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                            const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                            const prev_month_array = item.actual_month_total_previous_two || [];
                            const prev_amount_array = item.previous_invoice_total_two || [];
                            const current_amount_array = item.current_invoice_amount_two || [];
                            const current_month_array = item.actual_month_two || [];

                            const sum_previous_month = current_month_array.map((val, idx) => {
                                const prevVal = prev_month_array[idx] ?? 0;
                                return (Number(val) || 0) + (Number(prevVal) || 0) + totalMonthRelease;
                            });
                            const sum_previous_amount = current_amount_array.map((val, idx) => {
                                const prevVal = prev_amount_array[idx] ?? 0;
                                return (Number(val) || 0) + (Number(prevVal) || 0) + totalReleaseAmount;
                            });

                            return {
                                ...item,
                                updated_previous_invoice_total: sum_previous_amount,
                                updated_actual_month_total_previous: sum_previous_month,
                            };


                        });

                        updateProgress(100, "Done!");
                        setTransportList(updatedTransportData);
                        console.log("Updated Transport Data:", updatedTransportData);

                        setTransportListLoaded(true);
                        dataFound = true;
                    }
                }

                if (!dataFound) {
                    updateProgress(100, "No previous data found.");
                    setTransportListLoaded(true);
                }
            } catch (error) {
                console.error("Error fetching progress data:", error);
                setFetchProgress({ percent: 100, label: "Error loading data." });
                setTransportListLoaded(true);
            }
        };
        getTransportData();
    }, [month, year, show]);

    // ******************* Revised (BOQ change log) data *******************
    const transportID = transportation.map((e) => e.id);
    const transportData = (logData || []).filter((item) => transportID.includes(item.object_id));
    const transportChangeReason = transportation[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        transportData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? transportation
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ******************* BOQ fetch *******************
    const getTransportation = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqtransportbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setTransportation(res.data);
            } else {
                console.error("Error: Expected a list of transportation items");
            }
        } catch (err) {
            console.error("Error fetching BOQ data", err);
        }
    };

    // ---- common helpers (same formulas as Add) ----
    const calcRemaining = (eotSrc, cp, dlp, rate, totalCumAmount, totalCumMonth) => {
        let remainingamount;
        let remainingmonth;
        if (eotSrc && eotSrc.length > 0) {
            const lastEOT = eotSrc[eotSrc.length - 1];
            remainingamount = Number(lastEOT.total_amount || 0) - Number(totalCumAmount || 0);
            remainingmonth = Number(lastEOT.t_month || 0) - Number(totalCumMonth || 0);
        } else {
            const monthh = Number(cp || 0) + Number(dlp || 0);
            remainingamount = monthh * Number(rate) - Number(totalCumAmount || 0);
            remainingmonth = monthh - Number(totalCumMonth || 0);
        }
        return { remainingamount, remainingmonth };
    };

    // actual_month_two (vehicle-wise months) se baaki saari values nikalta hai
    const calcEntry = (entry, actualMonthArray) => {
        const eot_details = entry.eot_details;
        const rate =
            eot_details && eot_details.length > 0
                ? Number(eot_details[eot_details.length - 1]?.rate || 0)
                : Number(entry.boq_rate || 0);

        const previousArray = entry.actual_month_total_previous_two || [];
        const previousAmount = entry.previous_invoice_total_two || [];

        const currentAmounts = actualMonthArray.map((v) => Number(v || 0) * rate);
        const totalActualMonth = actualMonthArray.reduce((sum, v) => sum + (Number(v) || 0), 0);
        const totalInvoiceAmount = currentAmounts.reduce((sum, v) => sum + v, 0);

        const COMULATED_MONTH = actualMonthArray.map((v, idx) => (Number(v) || 0) + (Number(previousArray[idx] ?? 0) || 0));
        const COMULATED_Amount = currentAmounts.map((v, idx) => v + (Number(previousAmount[idx] ?? 0) || 0));
        const totalCOMULATED_MONTH = COMULATED_MONTH.reduce((sum, v) => sum + v, 0);
        const totalCOMULATED_Amount = COMULATED_Amount.reduce((sum, v) => sum + v, 0);

        const { remainingamount, remainingmonth } = calcRemaining(
            eot_details,
            entry.boq_during_construction_period,
            entry.boq_during_dlp_OM_period,
            entry.boq_rate,
            totalCOMULATED_Amount,
            totalCOMULATED_MONTH
        );

        return {
            ...entry,
            actual_month_two: actualMonthArray,
            current_invoice_amount_two: currentAmounts,
            actual_month: totalActualMonth,
            invoice_amount: Number(totalInvoiceAmount).toFixed(2),
            actual_month_cumulative_total_two: COMULATED_MONTH,
            actual_amount_cumulative_total: COMULATED_Amount,
            actual_month_cumulative_total: totalCOMULATED_MONTH,
            cumulative_invoice_total: totalCOMULATED_Amount,
            remaining_amount: remainingamount,
            actual_month_remaining: remainingmonth,
        };
    };

    // ******************* Initial form (BOQ + previous data + saved values) *******************
    useEffect(() => {
        if (!transportListLoaded || transportation.length === 0) return;

        const previousInvoice = transportList.map((i) => i);
        const usedCount = {};

        const initialData = selectedGroup.map((item) => {
            const transportId = item.object_id ?? item.id;
            const d = logid === "null" ? item : item.data || {};

            // Saved (current invoice) row, same transport ke multiple rows ho to order se
            const savedRows = existingRows.filter((r) => String(getRowTransportId(r)) === String(transportId));
            const k = usedCount[transportId] || 0;
            usedCount[transportId] = k + 1;
            const saved = savedRows[k];
            const savedMonths = Array.isArray(saved?.actual_month_two) ? saved.actual_month_two : [];

            const previousArray = previousInvoice
                .filter((inv) => inv.transport_details?.id === transportId)
                .flatMap((inv) => inv.updated_actual_month_total_previous);
            const previousSum = previousArray.reduce((sum, val) => sum + Number(val || 0), 0);

            const previousAmount = previousInvoice
                .filter((inv) => inv.transport_details?.id === transportId)
                .flatMap((inv) => inv.updated_previous_invoice_total);
            const previousAmountSum = previousAmount.reduce((sum, val) => sum + Number(val || 0), 0);

            const baseEntry = {
                project: p_id,
                invoice: invoice_id,
                transport: transportId,
                month: month,
                year: year,
                no_of_vehicle: savedMonths.length,
                contract_amount: "",
                actual_month_total_previous_two: previousArray,
                previous_invoice_total_two: previousAmount,
                previous_invoice_total: previousAmountSum,
                actual_month_total_previous: previousSum,
                boq_rate: d.rate,
                boq_vehicle_description: d.vehicle_description,
                boq_during_construction_period: d.during_construction_period,
                boq_during_dlp_OM_period: d.during_dlp_OM_period,
                eot_details: d.eot_details?.map((e) => e),
            };

            return calcEntry(baseEntry, savedMonths);
        });

        setFormData(initialData);
    }, [logid, transportation, transportList, transportListLoaded, existingRows]);

    console.log(formData, "formdata")

    useEffect(() => {
        if (!show) return;
        setModalLoading(!transportListLoaded);
    }, [transportListLoaded, show]);

    // ******************* Validation *******************
    const validateForm = () => {
        const newErrors = {};
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Sirf Actual Month fields 2 decimal me round hoti hain; amounts original decimals se
    const roundActualMonthForUpload = (value) => {
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? Number(numericValue.toFixed(2)) : 0;
    };

    const prepareUploadData = (data) =>
        data.map((item) => ({
            ...item,
            actual_month: roundActualMonthForUpload(item.actual_month),
            actual_month_two: (item.actual_month_two || []).map(roundActualMonthForUpload),
        }));

    // // ******************* Submit: UPDATE *******************
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm()) return;

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing invoicetransportation rows -> unki id attach karni hai
    //         const freshRows = await fetchExistingRows();

    //         // transport -> [ids...] (same transport multiple rows ho to order ke hisaab se)
    //         const idQueue = {};
    //         freshRows.forEach((row) => {
    //             const key = String(getRowTransportId(row));
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = prepareUploadData(formData)
    //             .map((item) => {
    //                 const queue = idQueue[String(item.transport)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("No existing transportation rows found to update");
    //             return;
    //         }

    //         const res = await axios.put(
    //             `${BASE_URL}/siteproject/invoicetransportation/bulk-update/`,
    //             payload,
    //             {
    //                 onUploadProgress: (progressEvent) => {
    //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //                     setUploadProgress(percentCompleted);
    //                 },
    //             }
    //         );

    //         if (res.status === 200 || res.status === 201) {
    //             console.log(payload, "payload")
    //             await getTransportationInvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Transportation Invoice Updated Successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };


    // ******************* Submit: UPDATE *******************
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing invoicetransportation rows -> unki id attach karni hai
            const freshRows = await fetchExistingRows();

            // transport -> [ids...] (same transport multiple rows ho to order ke hisaab se)
            const idQueue = {};
            freshRows.forEach((row) => {
                const key = String(getRowTransportId(row));
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = prepareUploadData(formData)
                .map((item) => {
                    const queue = idQueue[String(item.transport)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("No existing transportation rows found to update");
                return;
            }

            // 1st API: invoicetransportation bulk update
            const res = await axios.put(
                `${BASE_URL}/siteproject/invoicetransportation/bulk-update/`,
                payload,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(Math.min(Math.round(percentCompleted * 0.5), 50));
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: claim (new invoice transportation) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoicetransportationfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoicetransportation.id == claim.invoicetrasport
                const claimPayload = payload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoicetrasport) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                     // claim ke baaki fields bache rahein
                        ...item,                    // updated invoice data replicate
                        id: row.id,                 // claim row ki apni id
                        invoicetrasport: item.id,   // link wapas invoicetransportation se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoicetransportationupdatedelete/null/`,
                        claimPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("Claim me koi matching invoicetrasport nahi mili");
                }

                setUploadProgress(100);

                await getTransportationInvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Transportation Invoice Updated Successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // ******************* Input handler *******************
    const handleInputChange = (e, index, subIndex = null) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;

            // Vehicles count badla -> actual_month_two ki length adjust
            if (name === "no_of_vehicle") {
                const vehicleCount = Number(value) || 0;
                const existing = entry.actual_month_two || [];
                const newMonths = Array.from({ length: vehicleCount }, (_, j) => existing[j] || 0);
                return { ...calcEntry(entry, newMonths), no_of_vehicle: vehicleCount };
            }

            // Kisi vehicle ka actual month badla
            if (name === "actual_month_two" && subIndex !== null) {
                const arr = [...(entry.actual_month_two || [])];
                // typed text as-is (e.g. "0.", "0.3222") taaki decimals na ud jaayein
                arr[subIndex] = value;
                return calcEntry(entry, arr);
            }

            return { ...entry, [name]: value };
        });

        setFormData(updatedFormData);
    };

    return (
        <>
            <button
                title="Update Transportation Invoice"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Transportation {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width90vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="1" y="3" width="15" height="13" rx="1" />
                                <path d="M16 8h4l3 3v5h-7V8z" />
                                <circle cx="5.5" cy="18.5" r="2.5" />
                                <circle cx="18.5" cy="18.5" r="2.5" />
                            </svg>
                            Update Transportation {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {transportation.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {transportChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />

                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>

                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>

                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>

                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table">
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}><span className="eb-bulk-th-label">#</span></th>
                                                        <th className="eb-bulk-th"><span className="eb-bulk-th-label">Transport</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "center" }}><span className="eb-bulk-th-label">No. of vehicles</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "right" }}>
                                                            <span className="eb-bulk-th-label">
                                                                Actual month <span className="required">(Input no. of Vehicles first)</span>
                                                            </span>
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.map((entry, index) => (
                                                        <tr key={index} className="eb-bulk-row">
                                                            <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px", verticalAlign: "top" }}>
                                                                {index + 1}.
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ verticalAlign: "top" }}>
                                                                <span style={{ fontWeight: 500 }}>{entry.boq_vehicle_description}</span>
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "center", verticalAlign: "top" }}>
                                                                <input
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_no_of_vehicle`] ? "eb-bulk-input-error" : ""}`}
                                                                    name="no_of_vehicle"
                                                                    type="number"
                                                                    value={entry.no_of_vehicle ?? ""}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    style={{ width: "80px", textAlign: "center" }}
                                                                    placeholder="0"
                                                                />
                                                                {errors[`${index}_no_of_vehicle`] && (
                                                                    <span className="eb-bulk-error-text">
                                                                        {errors[`${index}_no_of_vehicle`]}
                                                                    </span>
                                                                )}
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "right", verticalAlign: "top" }}>
                                                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
                                                                    {entry.actual_month_two?.map((val, subIndex) => (
                                                                        <input
                                                                            key={subIndex}
                                                                            className="eb-bulk-input eb-bulk-input-number"
                                                                            name="actual_month_two"
                                                                            type="number"
                                                                            step="any"
                                                                            value={val ?? ""}
                                                                            onChange={(e) => handleInputChange(e, index, subIndex)}
                                                                            style={{ width: "80px", textAlign: "right" }}
                                                                            placeholder={`Vehicle ${subIndex + 1}`}
                                                                        />
                                                                    ))}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const UpdateTransportationInvoices = ({ i, p_id, invoice_id, getTransportationInvoice }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    }
    const handleShow = () => {
        getTransportation();
        setShow(true);

    }
    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        transport: "",
        month: "",
        current_invoice_amount: "",

    });
    const [transportation, setTransportation] = useState([]);
    const getTransportation = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqtransportbyproject/${p_id}`);
            setTransportation(res.data);
        } catch (err) { }
    };

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            // "project",
            // "invoice",
            // "transport",
            // "month",
            // "current_invoice_amount",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoicetransportation/${i.id}/`,
                    formData
                );

                if (res.status === 201) {
                    await getTransportationInvoice();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Data Updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button className="model-edit-button" title="Update Transportation" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Transportation for Invoice</Modal.Title> </h1>

                            <div title="Transportation" className="flex-column form-group-selectt">
                                <label htmlFor="transport" className="form-labels  font-weight500    font-size-subheading">
                                    Transportation<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="transport"
                                    name="transport"
                                    placeholder="transport"
                                    value={formData.transport}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.transport ? "error" : inputState.transport ? "success" : ""}`}
                                >
                                    <option value="">Select Transport</option>
                                    {transportation?.sort((a, b) => a.vehicle_description.localeCompare(b.vehicle_description, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.vehicle_description}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.transport && <span className="error-message font-size-text ">{errors.transport}</span>}
                            </div>

                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    Current Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>

                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}

                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );

}

const DeleteTransportationInvoice = ({ i, getTransportationInvoice }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
        getTransportationInvoice();
    }
    const [loading, setLoading] = useState(false); //loading logic


    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoicetransportation/${i.id}/`);
            if (response.status === 200) {
                getTransportationInvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data Deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false); //loading logic
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Transportation Invoice" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.transport_details.vehicle_description}</Modal.Title> </h1>

                        Are You Sure You Want to Delete {i.transport_details.vehicle_description}
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )
}
const DeleteTransportationInvoiceDeduction = ({ i, getTransportationInvoice }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
        getTransportationInvoice();
    }
    const [loading, setLoading] = useState(false); //loading logic


    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true); //loading logic
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/newinvoicetransportationupdatedelete/${i.id}/`);
            if (response.status === 200) {
                getTransportationInvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data Deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false); //loading logic
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Transportation Invoice" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.transport_details.vehicle_description}</Modal.Title> </h1>

                        Are You Sure You Want to Delete {i.transport_details.vehicle_description}
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )
}



// const DutyTravelInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getDutyTravelinvoice, month, year, logData }) => {
//     const [show, setShow] = useState(false);
//     const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
//     const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
//     const [invoiceIds, setInvoiceIds] = useState([]);
//     const [months, setMonths] = useState([]);
//     const [years, setyears] = useState([]);
//     const [getResults, setGetResults] = useState([]);
//     const [getSheetData, setGetSheetData] = useState([])
//     const [getAllResults, setGetAllResults] = useState([]);

//     const [getTotalWithId, setGetTotalWithid] = useState([])

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         getDutyTravel();
//         setShow(true);
//     };

//     const [dutytravelList, setDutyTravelList] = useState([])
//     useEffect(() => {
//         if (show === true) {


//             if (!month || !year) {
//                 console.error("Both month and year are required to fetch progress data.");
//                 return;
//             }

//             const getDutyTravelData = async () => {
//                 try {
//                     let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
//                     let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
//                     let dataFound = false; // Flag to check if data is found



//                     while (!dataFound) {
//                         const response = await axios.get(
//                             `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//                         );
//                         const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//                         // ✅ Store raw data in local variable
//                         const releaseRawData = releaseResponse.data;
//                         setWithHeldReleaseData(releaseRawData);

//                         const monthInt = parseInt(month, 10);
//                         const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//                         const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//                         const filterReleaseData = releaseRawData.filter(i =>
//                             (i.month === monthCalculation && i.year === calculatedYear) &&
//                             i?.deduction_data?.project === p_id
//                         );
//                         setfilterwithHeldReleaseData(filterReleaseData);

//                         const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
//                         setInvoiceIds(invoiceIds);

//                         let localAllResults = [];
//                         let localSheetData = [];

//                         if (invoiceIds.length > 0) {
//                             const res = await axios.get(
//                                 `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//                             );

//                             const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

//                             if (filteredData.length > 0) {
//                                 const months = [...new Set(filteredData.map(i => i.month))];
//                                 const years = [...new Set(filteredData.map(i => i.year))];

//                                 setMonths(months);
//                                 setyears(years);

//                                 for (const m of months) {
//                                     for (const y of years) {
//                                         try {
//                                             const filterRes = await axios.get(
//                                                 `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${m}/${y}/`
//                                             );
//                                             localAllResults.push(...filterRes.data);
//                                         } catch (err) {
//                                             console.error(`Failed for month: ${m}, year: ${y}`, err);
//                                         }
//                                     }
//                                 }

//                                 const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
//                                 console.log("All IDs:", allIds);

//                                 for (const id of allIds) {
//                                     try {
//                                         const secondRes = await axios.get(
//                                             `${BASE_URL}/siteproject/newinvoicedutytravelfilter/${id}/`
//                                         );
//                                         localSheetData.push(...secondRes.data);
//                                     } catch (err) {
//                                         console.error(`Failed for id: ${id}`, err);
//                                     }
//                                 }

//                                 console.log("Secondary Results:", localSheetData);
//                                 setGetSheetData(localSheetData);

//                                 const getboqIds = localAllResults.map(i => i?.duty_travel_details?.id);
//                                 setGetResults(getboqIds);
//                                 setGetAllResults(localAllResults);

//                                 console.log(localAllResults, "allresults");
//                                 console.log(getboqIds, "getboqIds");
//                             }
//                         }


//                         const data = response.data;

//                         let selectedData = [];

//                         if (data.length > 0) {
//                             const uids = data.map(item => item.id).filter(Boolean);

//                             let uidResults = [];

//                             for (const uid of uids) {
//                                 const res = await axios.get(
//                                     `${BASE_URL}/siteproject/newinvoicedutytravelfilter/${uid}/`
//                                 );

//                                 if (!res.data || res.data.length === 0) {
//                                     console.error(`No data found for UID ${uid}. Breaking loop.`);
//                                     dataFound = false;
//                                     break; // stop everything
//                                 }

//                                 uidResults = [...uidResults, ...res.data];
//                             }

//                             if (!dataFound && uidResults.length === 0) {
//                                 break; // if any uid fails, exit while loop
//                             }

//                             selectedData = uidResults;
//                         } else {
//                             // ❌ No data -> skip calling second API
//                             console.warn(
//                                 `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
//                             );

//                             currentMonth -= 1;
//                             if (currentMonth === 0) {
//                                 currentMonth = 12;
//                                 currentYear -= 1;
//                             }

//                             if (currentYear < year - 1) {
//                                 console.error("No data found for the past 1 year.");
//                                 break;
//                             }

//                             continue; // retry loop with new month/year
//                         }

//                         if (selectedData.length > 0) {

//                             const updatedGetAllResults = localSheetData.map((resultItem) => {

//                                 const matchingReleases = filterReleaseData.filter(
//                                     (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
//                                 );

//                                 const totalReleaseAmount = matchingReleases.reduce(
//                                     (sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0),
//                                     0
//                                 );

//                                 const totalDeductionAmount = matchingReleases.reduce(
//                                     (sum, r) => sum + (Number(r.deduction_amount) || 0),
//                                     0
//                                 );

//                                 const totalMonthRelease = matchingReleases.reduce(
//                                     (sum, r) => sum + (r.release_month || 0),
//                                     0
//                                 );

//                                 const total = totalReleaseAmount + totalDeductionAmount;

//                                 return {
//                                     id: resultItem?.employee_details?.id,
//                                     total_AMOUNT: total,
//                                     total_month_release: totalMonthRelease,
//                                 };
//                             });
//                             setGetTotalWithid(updatedGetAllResults);
//                             const updatedTravelData = selectedData.map((item) => {
//                                 const boqId = item?.duty_travel_details?.id;
//                                 const getTotalWithid = getTotalWithId.filter(i => i.id === boqId);
//                                 const totalReleaseAmount = getTotalWithid.reduce(
//                                     (sum, i) => sum + (Number(i.total_AMOUNT) || 0),
//                                     0
//                                 );

//                                 const totalMonthRelease = getTotalWithid.reduce(
//                                     (sum, i) => sum + (Number(i.total_month_release) || 0),
//                                     0
//                                 );

//                                 const prevAmount = parseFloat(item.previous_invoice_total || 0);
//                                 const currentAmount = item.invoice_amount === null
//                                     ? parseFloat(item.current_invoice_amount)
//                                     : parseFloat(item.invoice_amount || 0);
//                                 const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

//                                 const prevTrips = parseFloat(item.actual_month_total_previous || 0);
//                                 const currentTrips = parseFloat(item.actual_trip || 0);
//                                 const newPreviousTrips = prevTrips + currentTrips + totalMonthRelease;

//                                 return {
//                                     ...item,
//                                     updated_previous_invoice_total: newPreviousAmount,
//                                     updated_actual_month_total_previous: newPreviousTrips,
//                                 };
//                             });




//                             console.log("Updated Progress Data:", updatedTravelData);

//                             // You can set it in state or pass to other components
//                             setDutyTravelList(updatedTravelData);
//                             dataFound = true;
//                         }
//                     }
//                 } catch (error) {
//                     console.error("Error fetching progress data:", error);
//                 }
//             };




//             getDutyTravelData();
//         }
//     }, [month, year, show]);

//     const [formData, setFormData] = useState([]);



//     const [logid, setLogId] = useState("null");


//     const [dutyTravel, setDutyTravel] = useState([]);
//     const travelID = dutyTravel.map(e => e.id);
//     const dutyTravelData = logData.filter(item =>
//         travelID.includes(item.object_id)
//     );
//     const travelChangeReason = dutyTravel[0]?.reason_of_change || "";

//     const groupedByRandomChange = Object.entries(
//         dutyTravelData.reduce((acc, item) => {
//             const groupKey = item.data?.random_value_of_changes;
//             if (!acc[groupKey]) acc[groupKey] = [];
//             acc[groupKey].push(item);
//             return acc;
//         }, {})
//     ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

//     const selectedGroup = logid === "null"
//         ? dutyTravel
//         : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];


//     // useEffect(() => {

//     //     const initialData = selectedGroup.map((item) => ({
//     //         project: p_id,
//     //         invoice: invoice_id,
//     //         dutytravel: item.object_id ?? item.id,
//     //         actual_month: "",
//     //         month,
//     //         year,
//     //         previous_invoice_total:"",
//     //         actual_month_total_previous:"",
//     //         boq_rate_per_trip: item.rate_per_trip ?? item.data?.rate_per_trip,
//     //         boq_trips: item.trips ?? item.data?.trips,
//     //         boq_num_of_min_trip: item.num_of_min_trip ?? item.data?.num_of_min_trip,
//     //     }));
//     //     setFormData(initialData);
//     // }, [logid, dutyTravel]);

//     useEffect(() => {
//         if (dutyTravel.length === 0) return;

//         const initialData = selectedGroup.map((item) => {
//             const dutytravelId = item.object_id ?? item.id;

//             // Find matching progress entry from previousProgressData
//             const matchedProgress = dutytravelList.find(
//                 (progress) => progress.dutytravel === dutytravelId
//             );


//             let eot_details;
//             if (logid === "null") {
//                 eot_details = item.eot_details?.map((item) => (
//                     item
//                 ));
//             }
//             else {
//                 eot_details = item?.data?.eot_details?.map((item) => (
//                     item
//                 ));
//             }
//             return {
//                 project: p_id,
//                 invoice: invoice_id,
//                 dutytravel: dutytravelId,
//                 actual_trip: "",
//                 month: month,
//                 year: year,
//                 actual_month_cumulative_total: "",
//                 cumulative_invoice_total: "",
//                 contract_amount: "",
//                 remaining_amount: "",
//                 actual_month_remaining: "",
//                 invoice_amount: "",
//                 previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
//                 actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
//                 boq_rate_per_trip: item.rate_per_trip ?? item.data?.rate_per_trip,
//                 boq_trips: item.trips ?? item.data?.trips,
//                 boq_num_of_min_trip: item.num_of_min_trip ?? item.data?.num_of_min_trip,
//                 eot_details: eot_details,

//             };
//         });

//         setFormData(initialData);
//     }, [logid, dutyTravel, dutytravelList]);

//     const [finalFormData, setFinalFormData] = useState([]);


//     useEffect(() => {
//         if (formData?.length > 0) {
//             setFinalFormData(formData);
//         }
//     }, [formData])

//     console.log("formData");
//     console.log(formData);
//     console.log("selectedGroup");
//     console.log(selectedGroup);
//     console.log("logData");
//     console.log(logData);
//     console.log("logid");
//     console.log(logid);

//     const getDutyTravel = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/boqtravelbyproject/${p_id}/`);
//             if (Array.isArray(res.data)) {
//                 setDutyTravel(res.data);
//             } else {
//                 console.error("Error: Expected a list of duty travel items");
//             }
//         } catch (err) {
//             console.error("Error fetching duty travel data", err);
//         }
//     };

//     // Validation logic
//     const [errors, setErrors] = useState({});

//     // const validateForm = () => {
//     //     const newErrors = {};
//     //     formData.forEach((entry, index) => {
//     //         const requiredFields = [];
//     //         requiredFields.forEach(field => {
//     //             if (!entry[field]) {
//     //                 newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//     //             }
//     //         });
//     //     });

//     //     setErrors(newErrors);
//     //     return Object.keys(newErrors).length === 0;
//     // };

//     // Loading state
//     const [loading, setLoading] = useState(false);

//     console.log("finalFormData", finalFormData)

//     const handleSubmit = async (e) => {
//         e.preventDefault();


//         setLoading(true);
//         if (usedfor === "InvoiceandDeduction") {
//             const loadingToastId = toast.loading("Loading: Please wait...");

//             try {
//                 const res = await axios.post(
//                     `${BASE_URL}/siteproject/bulkinvoicedutytravelapi1/`,
//                     formData
//                 );

//                 if (res.status === 201) {
//                     const createdData = res.data;

//                     const mappedFinalData = finalFormData.map((item, index) => ({
//                         ...item,
//                         invoicedutytravel: createdData[index]?.id,
//                     }));

//                     const res2 = await axios.post(
//                         `${BASE_URL}/siteproject/newinvoicedutytravellistcreate/`,
//                         mappedFinalData
//                     );

//                     if (res2.status === 201) {
//                         await getDutyTravelinvoice();
//                         setShow(false);
//                         toast.dismiss(loadingToastId);
//                         toast.success("Duty travel Data added Successfully");
//                     } else {
//                         alert("Second API failed");
//                     }

//                 } else {
//                     alert("First API failed");
//                 }
//             }
//             catch (err) {
//                 handleErrorToast(err, loadingToastId);
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }
//         }
//         if (usedfor === "OnlyDeduction") {
//             const loadingToastId = toast.loading("Loading: Please wait...");

//             try {
//                 const createdData = invoiceData
//                 const mappedFinalData = finalFormData.map((item, index) => ({
//                     ...item,
//                     invoicedutytravel: createdData[index]?.id,
//                 }));

//                 const res2 = await axios.post(
//                     `${BASE_URL}/siteproject/newinvoicedutytravellistcreate/`,
//                     mappedFinalData
//                 );

//                 if (res2.status === 201) {
//                     await getDutyTravelinvoice();
//                     setShow(false);
//                     toast.dismiss(loadingToastId);
//                     toast.success("Duty travel Data added Successfully");
//                 } else {
//                     alert("Second API failed");
//                 }
//             } catch (error) {
//                 handleErrorToast(error, loadingToastId);
//             }
//         }
//     };

//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;

//         const updatedFormData = formData.map((entry, i) => {
//             if (i !== index) return entry;

//             const updatedEntry = { ...entry, [name]: value };

//             let rate;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 rate = Number(lastEOT.rate || 0);
//             } else {
//                 rate = Number(entry.boq_rate_per_trip || 0);
//             }
//             let trips;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 trips = Number(lastEOT.t_trips || 0);
//             } else {
//                 trips = Number(entry.boq_num_of_min_trip || 0);
//             }
//             const total = Number(rate) * Number(trips)

//             const previousTrip = entry.actual_month_total_previous;
//             const previousTripAmount = entry.previous_invoice_total;
//             const actualTrip = name === "actual_trip"
//                 ? parseFloat(value) || 0
//                 : parseFloat(entry.actual_trip) || 0;

//             updatedEntry.invoice_amount = Number(rate) * Number(actualTrip);


//             updatedEntry.actual_month_cumulative_total = Number(previousTrip) + Number(actualTrip);
//             updatedEntry.cumulative_invoice_total = Number(previousTripAmount) + Number(updatedEntry.invoice_amount);


//             updatedEntry.actual_month_remaining = Number(trips) - Number(updatedEntry.actual_month_cumulative_total);
//             updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

//             return updatedEntry;
//         });

//         setFormData(updatedFormData);
//     };




//     return (
//         <>
//             <button title="Add Duty & Travels" className="upload-svg flex-row" onClick={handleShow}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                     <g clipPath="url(#clip0_1415_3177)">
//                         <path
//                             d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
//                             fill="white"
//                         />
//                     </g>
//                     <defs>
//                         <clipPath id="clip0_1415_3177">
//                             <rect width="24" height="24" fill="white" />
//                         </clipPath>
//                     </defs>
//                 </svg>
//                 {" "} DutyTravel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="three-fourth-modal">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Duty & Travel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div flex-column">
//                             <div>
//                                 {(dutyTravel.length > 0 && groupedByRandomChange.length > 0) && (
//                                     <select
//                                         value={logid}
//                                         onChange={(e) => setLogId(e.target.value)}
//                                         className="dropdown font-size-subheading navbar-inputt"
//                                     >
//                                         <option value="null">
//                                             BOQ {groupedByRandomChange.length + 1} - {travelChangeReason}
//                                         </option>
//                                         {groupedByRandomChange.map(([groupKey, items], index) => {
//                                             const reasons = [...new Set(
//                                                 items.map(i => i.data?.reason_of_change).filter(reason =>
//                                                     reason !== null && reason !== "null" && reason?.trim() !== ""
//                                                 )
//                                             )];
//                                             return (
//                                                 <option key={groupKey} value={groupKey}>
//                                                     BOQ {groupedByRandomChange.length - index}
//                                                     {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                                 </option>
//                                             );
//                                         })}
//                                     </select>
//                                 )}
//                             </div>
//                             <div className="flex-row justify-center">
//                                 <table className="nested-table-lightblue width-90vw payment">
//                                     <thead>
//                                         <tr className="custom-table-head-tr width-10vw">
//                                             <th className="align-left width-10vw">S no.</th>
//                                             <th className="align-center width-10vw">Description of Trips</th>
//                                             <th className="align-center width-10vw">Actual Trip</th>
//                                         </tr>
//                                     </thead>

//                                     <tbody>
//                                         {formData.map((entry, index) => (
//                                             <tr className="custom-table-head-td" key={index}>
//                                                 <td className="align-left width-5vw">{index + 1}</td>
//                                                 <td>
//                                                     <div title="Duty & Travel" className="flex-column form-group-selectt">
//                                                         {/* <input
//                                                             id={`dutytravel_${index}`}
//                                                             name="dutytravel"
//                                                             value={dutyTravel.find(t => t.id === entry.dutytravel)?.trips || "Loading..."}
//                                                             className={`form-input-date width-10vw ${errors[`${index}_dutytravel`] ? "error" : ""}`}
//                                                             disabled
//                                                         /> */}
//                                                         <p>{entry.boq_trips}</p>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div title="Actual Trip" className="flex-column align-items-center">
//                                                         <input
//                                                             type="number"
//                                                             id={`actual_trip_${index}`}
//                                                             name="actual_trip"
//                                                             placeholder="Actual Trip"
//                                                             value={entry.actual_trip}
//                                                             onChange={(e) => handleInputChange(e, index)}
//                                                             className={`form-input-date width-5vw ${errors[`${index}_actual_trip`] ? "error" : ""}`}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {/* <td>
//                                                     <div title="Invoice Amount" className="flex-column form-group-selectt">
//                                                         <input
//                                                             id={`current_invoice_amount_${index}`}
//                                                             name="current_invoice_amount"
//                                                             type="number"
//                                                             value={entry.current_invoice_amount}
//                                                             placeholder="Current Invoice Amount"
//                                                             onChange={(e) => handleInputChange(e, index)}
//                                                             className={`form-input-date width-5vw ${errors[`${index}_current_invoice_amount`] ? "error" : ""}`}
//                                                         />
//                                                     </div>
//                                                 </td> */}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     onClick={handleSubmit}
//                                     disabled={loading}
//                                 >
//                                     Add
//                                 </button>
//                             </div>

//                         </div>
//                     </div>
//                     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//                 </Modal.Body>
//             </Modal >

//         </>
//     );
// };


// const DutyTravelInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getDutyTravelinvoice, month, year, logData }) => {
//     const [show, setShow] = useState(false);
//     const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
//     const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
//     const [invoiceIds, setInvoiceIds] = useState([]);
//     const [months, setMonths] = useState([]);
//     const [years, setyears] = useState([]);
//     const [getResults, setGetResults] = useState([]);
//     const [getSheetData, setGetSheetData] = useState([]);
//     const [getAllResults, setGetAllResults] = useState([]);
//     const [getTotalWithId, setGetTotalWithid] = useState([]);
//     const [modalLoading, setModalLoading] = useState(false);
//     const [listLoaded, setListLoaded] = useState(false);
//     const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });

//     const handleClose = () => {
//         setShow(false);
//         setModalLoading(false);
//         setListLoaded(false);
//         setFetchProgress({ percent: 0, label: "" });
//     };

//     const handleShow = () => {
//         getDutyTravel();
//         setShow(true);
//     };

//     useEffect(() => {
//         if (!show) return;
//         if (listLoaded) {
//             setModalLoading(false);
//         } else {
//             setModalLoading(true);
//         }
//     }, [listLoaded, show]);

//     const [dutytravelList, setDutyTravelList] = useState([]);

//     useEffect(() => {
//         if (show === true) {
//             if (!month || !year) {
//                 console.error("Both month and year are required to fetch progress data.");
//                 return;
//             }

//             const getDutyTravelData = async () => {
//                 try {
//                     let currentMonth = month - 1 === 0 ? 12 : month - 1;
//                     let currentYear = month - 1 === 0 ? year - 1 : year;
//                     let dataFound = false;
//                     let currentPercent = 0;

//                     const updateProgress = (percent, label) => {
//                         currentPercent = Math.max(currentPercent, percent);
//                         setFetchProgress({ percent: currentPercent, label });
//                     };

//                     updateProgress(5, "Connecting to server...");

//                     while (!dataFound) {
//                         updateProgress(10, "Fetching previous duty travel data...");
//                         const response = await axios.get(
//                             `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//                         );

//                         updateProgress(20, "Fetching withheld release data...");
//                         const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//                         const releaseRawData = releaseResponse.data;
//                         setWithHeldReleaseData(releaseRawData);

//                         const monthInt = parseInt(month, 10);
//                         const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//                         const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//                         const filterReleaseData = releaseRawData.filter(i =>
//                             (i.month === monthCalculation && i.year === calculatedYear) &&
//                             i?.deduction_data?.project === p_id
//                         );
//                         setfilterwithHeldReleaseData(filterReleaseData);

//                         const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
//                         setInvoiceIds(invoiceIds);

//                         let localAllResults = [];
//                         let localSheetData = [];

//                         if (invoiceIds.length > 0) {
//                             updateProgress(35, "Fetching consultant invoices...");
//                             const res = await axios.get(
//                                 `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//                             );

//                             const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

//                             if (filteredData.length > 0) {
//                                 const months = [...new Set(filteredData.map(i => i.month))];
//                                 const years = [...new Set(filteredData.map(i => i.year))];
//                                 setMonths(months);
//                                 setyears(years);

//                                 const totalMonthYearCalls = months.length * years.length;
//                                 let completedMonthYearCalls = 0;

//                                 for (const m of months) {
//                                     for (const y of years) {
//                                         try {
//                                             const filterRes = await axios.get(
//                                                 `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${m}/${y}/`
//                                             );
//                                             localAllResults.push(...filterRes.data);
//                                         } catch (err) {
//                                             console.error(`Failed for month: ${m}, year: ${y}`, err);
//                                         }
//                                         completedMonthYearCalls++;
//                                         const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
//                                         updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
//                                     }
//                                 }

//                                 const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
//                                 const totalIdCalls = allIds.length;
//                                 let completedIdCalls = 0;

//                                 for (const id of allIds) {
//                                     try {
//                                         const secondRes = await axios.get(
//                                             `${BASE_URL}/siteproject/newinvoicedutytravelfilter/${id}/`
//                                         );
//                                         localSheetData.push(...secondRes.data);
//                                     } catch (err) {
//                                         console.error(`Failed for id: ${id}`, err);
//                                     }
//                                     completedIdCalls++;
//                                     const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
//                                     updateProgress(50 + idPercent, `Loading duty travel sheet ${completedIdCalls} of ${totalIdCalls}...`);
//                                 }

//                                 setGetSheetData(localSheetData);
//                                 const getboqIds = localAllResults.map(i => i?.duty_travel_details?.id);
//                                 setGetResults(getboqIds);
//                                 setGetAllResults(localAllResults);
//                             }
//                         }

//                         updateProgress(70, "Processing duty travel records...");
//                         const data = response.data;
//                         let selectedData = [];

//                         if (data.length > 0) {
//                             const uids = data.map(item => item.id).filter(Boolean);
//                             let uidResults = [];
//                             const totalUids = uids.length;
//                             let completedUids = 0;

//                             for (const uid of uids) {
//                                 const res = await axios.get(
//                                     `${BASE_URL}/siteproject/newinvoicedutytravelfilter/${uid}/`
//                                 );

//                                 if (!res.data || res.data.length === 0) {
//                                     console.error(`No data found for UID ${uid}. Breaking loop.`);
//                                     dataFound = false;
//                                     break;
//                                 }

//                                 uidResults = [...uidResults, ...res.data];
//                                 completedUids++;
//                                 const uidPercent = Math.round((completedUids / totalUids) * 15);
//                                 updateProgress(70 + uidPercent, `Loading duty travel ${completedUids} of ${totalUids}...`);
//                             }

//                             if (!dataFound && uidResults.length === 0) break;
//                             selectedData = uidResults;

//                         } else {
//                             updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);
//                             currentMonth -= 1;
//                             if (currentMonth === 0) {
//                                 currentMonth = 12;
//                                 currentYear -= 1;
//                             }
//                             if (currentYear < year - 1) {
//                                 console.error("No data found for the past 1 year.");
//                                 break;
//                             }
//                             continue;
//                         }

//                         if (selectedData.length > 0) {
//                             updateProgress(90, "Calculating cumulative totals...");

//                             const updatedGetAllResults = localSheetData.map((resultItem) => {
//                                 const matchingReleases = filterReleaseData.filter(
//                                     (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
//                                 );
//                                 const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
//                                 const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
//                                 const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
//                                 const total = totalReleaseAmount + totalDeductionAmount;
//                                 return { id: resultItem?.duty_travel_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
//                             });
//                             setGetTotalWithid(updatedGetAllResults);

//                             const updatedTravelData = selectedData.map((item) => {
//                                 const boqId = item?.duty_travel_details?.id;
//                                 const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);
//                                 const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
//                                 const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

//                                 const prevAmount = parseFloat(item.previous_invoice_total || 0);
//                                 const currentAmount = item.invoice_amount === null
//                                     ? parseFloat(item.current_invoice_amount)
//                                     : parseFloat(item.invoice_amount || 0);
//                                 const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

//                                 const prevTrips = parseFloat(item.actual_month_total_previous || 0);
//                                 const currentTrips = parseFloat(item.actual_trip || 0);
//                                 const newPreviousTrips = prevTrips + currentTrips + totalMonthRelease;

//                                 return {
//                                     ...item,
//                                     updated_previous_invoice_total: newPreviousAmount,
//                                     updated_actual_month_total_previous: newPreviousTrips,
//                                 };
//                             });

//                             updateProgress(100, "Done!");
//                             setDutyTravelList(updatedTravelData);
//                             setListLoaded(true);
//                             dataFound = true;
//                         }
//                     }

//                     if (!dataFound) {
//                         updateProgress(100, "No previous data found.");
//                         setListLoaded(true);
//                     }

//                 } catch (error) {
//                     console.error("Error fetching progress data:", error);
//                     setFetchProgress({ percent: 100, label: "Error loading data." });
//                     setListLoaded(true);
//                 }
//             };

//             getDutyTravelData();
//         }
//     }, [month, year, show]);

//     const [formData, setFormData] = useState([]);
//     const [logid, setLogId] = useState("null");
//     const [dutyTravel, setDutyTravel] = useState([]);

//     const travelID = dutyTravel.map(e => e.id);
//     const dutyTravelData = logData.filter(item => travelID.includes(item.object_id));
//     const travelChangeReason = dutyTravel[0]?.reason_of_change || "";

//     const groupedByRandomChange = Object.entries(
//         dutyTravelData.reduce((acc, item) => {
//             const groupKey = item.data?.random_value_of_changes;
//             if (!acc[groupKey]) acc[groupKey] = [];
//             acc[groupKey].push(item);
//             return acc;
//         }, {})
//     ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

//     const selectedGroup = logid === "null"
//         ? dutyTravel
//         : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

//     useEffect(() => {
//         if (dutyTravel.length === 0) return;

//         const initialData = selectedGroup.map((item) => {
//             const dutytravelId = item.object_id ?? item.id;
//             const matchedProgress = dutytravelList.find((progress) => progress.dutytravel === dutytravelId);

//             let eot_details;
//             if (logid === "null") {
//                 eot_details = item.eot_details?.map((item) => item);
//             } else {
//                 eot_details = item?.data?.eot_details?.map((item) => item);
//             }

//             return {
//                 project: p_id,
//                 invoice: invoice_id,
//                 dutytravel: dutytravelId,
//                 actual_trip: "",
//                 month: month,
//                 year: year,
//                 actual_month_cumulative_total: "",
//                 cumulative_invoice_total: "",
//                 contract_amount: "",
//                 remaining_amount: "",
//                 actual_month_remaining: "",
//                 invoice_amount: "",
//                 previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
//                 actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
//                 boq_rate_per_trip: item.rate_per_trip ?? item.data?.rate_per_trip,
//                 boq_trips: item.trips ?? item.data?.trips,
//                 boq_num_of_min_trip: item.num_of_min_trip ?? item.data?.num_of_min_trip,
//                 eot_details: eot_details,
//             };
//         });

//         setFormData(initialData);
//     }, [logid, dutyTravel, dutytravelList]);

//     const [finalFormData, setFinalFormData] = useState([]);

//     useEffect(() => {
//         if (formData?.length > 0) {
//             setFinalFormData(formData);
//         }
//     }, [formData]);

//     const getDutyTravel = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/boqtravelbyproject/${p_id}/`);
//             if (Array.isArray(res.data)) {
//                 setDutyTravel(res.data);
//             } else {
//                 console.error("Error: Expected a list of duty travel items");
//             }
//         } catch (err) {
//             console.error("Error fetching duty travel data", err);
//         }
//     };

//     const [errors, setErrors] = useState({});
//     const [loading, setLoading] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         setLoading(true);

//         if (usedfor === "InvoiceandDeduction") {
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             try {
//                 const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicedutytravelapi1/`, formData);

//                 if (res.status === 201) {
//                     const createdData = res.data;
//                     const mappedFinalData = finalFormData.map((item, index) => ({
//                         ...item,
//                         invoicedutytravel: createdData[index]?.id,
//                     }));

//                     const res2 = await axios.post(`${BASE_URL}/siteproject/newinvoicedutytravellistcreate/`, mappedFinalData);

//                     if (res2.status === 201) {
//                         await getDutyTravelinvoice();
//                         setShow(false);
//                         toast.dismiss(loadingToastId);
//                         toast.success("Duty travel Data added Successfully");
//                     } else {
//                         alert("Second API failed");
//                     }
//                 } else {
//                     alert("First API failed");
//                 }
//             } catch (err) {
//                 handleErrorToast(err, loadingToastId);
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }
//         }

//         if (usedfor === "OnlyDeduction") {
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             try {
//                 const createdData = invoiceData;
//                 const mappedFinalData = finalFormData.map((item, index) => ({
//                     ...item,
//                     invoicedutytravel: createdData[index]?.id,
//                 }));

//                 const res2 = await axios.post(`${BASE_URL}/siteproject/newinvoicedutytravellistcreate/`, mappedFinalData);

//                 if (res2.status === 201) {
//                     await getDutyTravelinvoice();
//                     setShow(false);
//                     toast.dismiss(loadingToastId);
//                     toast.success("Duty travel Data added Successfully");
//                 } else {
//                     alert("Second API failed");
//                 }
//             } catch (error) {
//                 handleErrorToast(error, loadingToastId);
//             } finally {
//                 setLoading(false);
//             }
//         }
//     };

//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;

//         const updatedFormData = formData.map((entry, i) => {
//             if (i !== index) return entry;

//             const updatedEntry = { ...entry, [name]: value };

//             let rate;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 rate = Number(lastEOT.rate || 0);
//             } else {
//                 rate = Number(entry.boq_rate_per_trip || 0);
//             }
//             let trips;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 trips = Number(lastEOT.t_trips || 0);
//             } else {
//                 trips = Number(entry.boq_num_of_min_trip || 0);
//             }
//             const total = Number(rate) * Number(trips);

//             const previousTrip = entry.actual_month_total_previous;
//             const previousTripAmount = entry.previous_invoice_total;
//             const actualTrip = name === "actual_trip"
//                 ? parseFloat(value) || 0
//                 : parseFloat(entry.actual_trip) || 0;

//             updatedEntry.invoice_amount = Number(rate) * Number(actualTrip);
//             updatedEntry.actual_month_cumulative_total = Number(previousTrip) + Number(actualTrip);
//             updatedEntry.cumulative_invoice_total = Number(previousTripAmount) + Number(updatedEntry.invoice_amount);
//             updatedEntry.actual_month_remaining = Number(trips) - Number(updatedEntry.actual_month_cumulative_total);
//             updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

//             return updatedEntry;
//         });

//         setFormData(updatedFormData);
//     };

//     return (
//         <>
//             <button title="Add Duty & Travels" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
//                 <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <circle cx="12" cy="12" r="10" />
//                     <line x1="12" y1="8" x2="12" y2="16" />
//                     <line x1="8" y1="12" x2="16" y2="12" />
//                 </svg>
//                 DutyTravel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
//                 <Modal.Header className="eb-bulk-modal-header">
//                     <Modal.Title className="eb-bulk-modal-title">
//                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <path d="M3 17l2-7h14l2 7" />
//                             <path d="M5 17a2 2 0 104 0M15 17a2 2 0 104 0" />
//                             <path d="M3 10V7a1 1 0 011-1h1l2-3h8l2 3h1a1 1 0 011 1v3" />
//                         </svg>
//                         Add Duty &amp; Travel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//                     </Modal.Title>

//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                         {(dutyTravel.length > 0 && groupedByRandomChange.length > 0) && (
//                             <select
//                                 value={logid}
//                                 onChange={(e) => setLogId(e.target.value)}
//                                 style={{
//                                     fontSize: "13px",
//                                     background: "var(--surface-2, #fff)",
//                                     border: "0.5px solid var(--border-strong, #ccc)",
//                                     borderRadius: "var(--radius, 8px)",
//                                     padding: "4px 10px",
//                                     cursor: "pointer",
//                                     color: "var(--text-primary)",
//                                 }}
//                             >
//                                 <option value="null">
//                                     BOQ {groupedByRandomChange.length + 1} - {travelChangeReason}
//                                 </option>
//                                 {groupedByRandomChange.map(([groupKey, items], index) => {
//                                     const reasons = [...new Set(
//                                         items.map(i => i.data?.reason_of_change).filter(reason =>
//                                             reason !== null && reason !== "null" && reason?.trim() !== ""
//                                         )
//                                     )];
//                                     return (
//                                         <option key={groupKey} value={groupKey}>
//                                             BOQ {groupedByRandomChange.length - index}
//                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                         </option>
//                                     );
//                                 })}
//                             </select>
//                         )}
//                         <button className="close-btn" onClick={handleClose}>
//                             <X size={20} />
//                         </button>
//                     </div>
//                 </Modal.Header>

//                 <Modal.Body className="eb-bulk-modal-body">
//                     {modalLoading ? (
//                         <div style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             minHeight: "50vh",
//                             gap: "20px",
//                             padding: "40px",
//                         }}>
//                             <div style={{
//                                 width: "44px",
//                                 height: "44px",
//                                 border: "3px solid #e0e0e0",
//                                 borderTop: "3px solid #000",
//                                 borderRadius: "50%",
//                                 animation: "eb-spin 0.8s linear infinite",
//                             }} />
//                             <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
//                                 {fetchProgress.label || "Loading data..."}
//                             </p>
//                             <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
//                                 <div style={{
//                                     height: "100%",
//                                     width: `${fetchProgress.percent}%`,
//                                     background: "#111",
//                                     borderRadius: "999px",
//                                     transition: "width 0.3s ease",
//                                 }} />
//                             </div>
//                             <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
//                                 {fetchProgress.percent}%
//                             </p>
//                             <style>{`
//                                 @keyframes eb-spin {
//                                     0% { transform: rotate(0deg); }
//                                     100% { transform: rotate(360deg); }
//                                 }
//                             `}</style>
//                         </div>
//                     ) : (
//                         <div className="eb-bulk-container">
//                             <div className="eb-bulk-content">
//                                 <div className="eb-bulk-table-wrapper">
//                                     <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"
//                                         style={{ maxHeight: "50vh", minHeight: "50vh" }}>
//                                         <table className="eb-bulk-table" style={{ width: "100%", minWidth: "100%" }}>
//                                             <thead className="eb-bulk-table-head">
//                                                 <tr className="eb-bulk-table-header-row">
//                                                     <th className="eb-bulk-th" style={{ width: "48px" }}>
//                                                         <span className="eb-bulk-th-label">#</span>
//                                                     </th>
//                                                     <th className="eb-bulk-th text-start">
//                                                         <span className="eb-bulk-th-label ">Description of Trips</span>
//                                                     </th>
//                                                     <th className="eb-bulk-th" style={{ textAlign: "center" }}>
//                                                         <span className="eb-bulk-th-label">Actual Trip</span>
//                                                     </th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {formData.map((entry, index) => (
//                                                     <tr key={index} className="eb-bulk-row">
//                                                         <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
//                                                             {index + 1}.
//                                                         </td>
//                                                         <td className="eb-bulk-td">
//                                                             <span style={{ fontWeight: 500 }}>{entry.boq_trips}</span>
//                                                         </td>
//                                                         <td className="eb-bulk-td" style={{ textAlign: "center" }}>
//                                                             <input
//                                                                 type="number"
//                                                                 id={`actual_trip_${index}`}
//                                                                 name="actual_trip"
//                                                                 placeholder="Actual Trip"
//                                                                 value={entry.actual_trip}
//                                                                 onChange={(e) => handleInputChange(e, index)}
//                                                                 className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_trip`] ? "eb-bulk-input-error" : ""}`}
//                                                                 style={{ width: "100px", textAlign: "center" }}
//                                                             />
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>

//                                 <div className="eb-bulk-footer-actions">
//                                     <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
//                                         Cancel
//                                     </button>
//                                     <button
//                                         type="submit"
//                                         className="eb-bulk-btn eb-bulk-btn-submit"
//                                         disabled={loading}
//                                         onClick={handleSubmit}
//                                         style={{ background: "black" }}
//                                     >
//                                         {loading ? (
//                                             <span className="eb-bulk-btn-loader">
//                                                 <span className="eb-bulk-spinner"></span>
//                                                 Submitting...
//                                             </span>
//                                         ) : (
//                                             <>
//                                                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                     <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
//                                                     <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
//                                                 </svg>
//                                                 Add
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const DutyTravelInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getDutyTravelinvoice, month, year, logData }) => {

    const [show, setShow] = useState(false);

    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);

    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);

    const [invoiceIds, setInvoiceIds] = useState([]);

    const [months, setMonths] = useState([]);

    const [years, setyears] = useState([]);

    const [getResults, setGetResults] = useState([]);

    const [getSheetData, setGetSheetData] = useState([]);

    const [getAllResults, setGetAllResults] = useState([]);

    const [getTotalWithId, setGetTotalWithid] = useState([]);

    const [modalLoading, setModalLoading] = useState(false);

    const [listLoaded, setListLoaded] = useState(false);

    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });



    const handleClose = () => {

        setShow(false);

        setModalLoading(false);

        setListLoaded(false);

        setFetchProgress({ percent: 0, label: "" });

    };



    const handleShow = () => {

        getDutyTravel();

        setShow(true);

    };



    useEffect(() => {

        if (!show) return;

        if (listLoaded) {

            setModalLoading(false);

        } else {

            setModalLoading(true);

        }

    }, [listLoaded, show]);



    const [dutytravelList, setDutyTravelList] = useState([]);



    useEffect(() => {

        if (show === true) {

            if (!month || !year) {

                console.error("Both month and year are required to fetch progress data.");

                return;

            }



            const getDutyTravelData = async () => {

                try {

                    let currentMonth = month - 1 === 0 ? 12 : month - 1;

                    let currentYear = month - 1 === 0 ? year - 1 : year;

                    let dataFound = false;

                    let currentPercent = 0;



                    const updateProgress = (percent, label) => {

                        currentPercent = Math.max(currentPercent, percent);

                        setFetchProgress({ percent: currentPercent, label });

                    };



                    updateProgress(5, "Connecting to server...");



                    while (!dataFound) {

                        updateProgress(10, "Fetching previous duty travel data...");

                        const response = await axios.get(

                            `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`

                        );



                        updateProgress(20, "Fetching withheld release data...");

                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);

                        const releaseRawData = releaseResponse.data;

                        setWithHeldReleaseData(releaseRawData);



                        const monthInt = parseInt(month, 10);

                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');

                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;



                        const filterReleaseData = releaseRawData.filter(i =>

                            (i.month === monthCalculation && i.year === calculatedYear) &&

                            i?.deduction_data?.project === p_id

                        );

                        setfilterwithHeldReleaseData(filterReleaseData);



                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];

                        setInvoiceIds(invoiceIds);



                        let localAllResults = [];

                        let localSheetData = [];



                        if (invoiceIds.length > 0) {

                            updateProgress(35, "Fetching consultant invoices...");

                            const res = await axios.get(

                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`

                            );



                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));



                            if (filteredData.length > 0) {

                                const months = [...new Set(filteredData.map(i => i.month))];

                                const years = [...new Set(filteredData.map(i => i.year))];

                                setMonths(months);

                                setyears(years);



                                const totalMonthYearCalls = months.length * years.length;

                                let completedMonthYearCalls = 0;



                                for (const m of months) {

                                    for (const y of years) {

                                        try {

                                            const filterRes = await axios.get(

                                                `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${m}/${y}/`

                                            );

                                            localAllResults.push(...filterRes.data);

                                        } catch (err) {

                                            console.error(`Failed for month: ${m}, year: ${y}`, err);

                                        }

                                        completedMonthYearCalls++;

                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);

                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);

                                    }

                                }



                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];

                                const totalIdCalls = allIds.length;

                                let completedIdCalls = 0;



                                for (const id of allIds) {

                                    try {

                                        const secondRes = await axios.get(

                                            `${BASE_URL}/siteproject/newinvoicedutytravelfilter/${id}/`

                                        );

                                        localSheetData.push(...secondRes.data);

                                    } catch (err) {

                                        console.error(`Failed for id: ${id}`, err);

                                    }

                                    completedIdCalls++;

                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);

                                    updateProgress(50 + idPercent, `Loading duty travel sheet ${completedIdCalls} of ${totalIdCalls}...`);

                                }



                                setGetSheetData(localSheetData);

                                const getboqIds = localAllResults.map(i => i?.duty_travel_details?.id);

                                setGetResults(getboqIds);

                                setGetAllResults(localAllResults);

                            }

                        }



                        updateProgress(70, "Processing duty travel records...");

                        const data = response.data;

                        let selectedData = [];



                        if (data.length > 0) {

                            const uids = data.map(item => item.id).filter(Boolean);

                            let uidResults = [];

                            const totalUids = uids.length;

                            let completedUids = 0;



                            for (const uid of uids) {

                                const res = await axios.get(

                                    `${BASE_URL}/siteproject/newinvoicedutytravelfilter/${uid}/`

                                );



                                if (!res.data || res.data.length === 0) {

                                    console.error(`No data found for UID ${uid}. Breaking loop.`);

                                    dataFound = false;

                                    break;

                                }



                                uidResults = [...uidResults, ...res.data];

                                completedUids++;

                                const uidPercent = Math.round((completedUids / totalUids) * 15);

                                updateProgress(70 + uidPercent, `Loading duty travel ${completedUids} of ${totalUids}...`);

                            }



                            if (!dataFound && uidResults.length === 0) break;

                            selectedData = uidResults;



                        } else {

                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                            currentMonth -= 1;

                            if (currentMonth === 0) {

                                currentMonth = 12;

                                currentYear -= 1;

                            }

                            if (currentYear < year - 1) {

                                console.error("No data found for the past 1 year.");

                                break;

                            }

                            continue;

                        }



                        if (selectedData.length > 0) {

                            updateProgress(90, "Calculating cumulative totals...");



                            const updatedGetAllResults = localSheetData.map((resultItem) => {

                                const matchingReleases = filterReleaseData.filter(

                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)

                                );

                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);

                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);

                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (Number(r.release_month) || 0), 0);

                                const total = totalReleaseAmount + totalDeductionAmount;

                                return { id: resultItem?.duty_travel_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };

                            });

                            setGetTotalWithid(updatedGetAllResults);



                            const updatedTravelData = selectedData.map((item) => {

                                const boqId = item?.duty_travel_details?.id;

                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);

                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);

                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);



                                const prevAmount = parseFloat(item.previous_invoice_total || 0);

                                const currentAmount = item.invoice_amount === null

                                    ? parseFloat(item.current_invoice_amount)

                                    : parseFloat(item.invoice_amount || 0);

                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;



                                const prevTrips = parseFloat(item.actual_month_total_previous || 0);

                                const currentTrips = parseFloat(item.actual_trip || 0);

                                const newPreviousTrips = prevTrips + currentTrips + totalMonthRelease;



                                return {

                                    ...item,

                                    updated_previous_invoice_total: newPreviousAmount,

                                    updated_actual_month_total_previous: newPreviousTrips,

                                };

                            });



                            updateProgress(100, "Done!");

                            setDutyTravelList(updatedTravelData);

                            setListLoaded(true);

                            dataFound = true;

                        }

                    }



                    if (!dataFound) {

                        updateProgress(100, "No previous data found.");

                        setListLoaded(true);

                    }



                } catch (error) {

                    console.error("Error fetching progress data:", error);

                    setFetchProgress({ percent: 100, label: "Error loading data." });

                    setListLoaded(true);

                }

            };



            getDutyTravelData();

        }

    }, [month, year, show]);



    const [formData, setFormData] = useState([]);

    const [logid, setLogId] = useState("null");

    const [dutyTravel, setDutyTravel] = useState([]);



    const travelID = dutyTravel.map(e => e.id);

    const dutyTravelData = logData.filter(item => travelID.includes(item.object_id));

    const travelChangeReason = dutyTravel[0]?.reason_of_change || "";



    const groupedByRandomChange = Object.entries(

        dutyTravelData.reduce((acc, item) => {

            const groupKey = item.data?.random_value_of_changes;

            if (!acc[groupKey]) acc[groupKey] = [];

            acc[groupKey].push(item);

            return acc;

        }, {})

    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));



    const selectedGroup = logid === "null"

        ? dutyTravel

        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];



    useEffect(() => {

        if (dutyTravel.length === 0) return;



        const initialData = selectedGroup.map((item) => {

            const dutytravelId = item.object_id ?? item.id;

            const matchedProgress = dutytravelList.find((progress) => progress.dutytravel === dutytravelId);



            let eot_details;

            if (logid === "null") {

                eot_details = item.eot_details?.map((item) => item);

            } else {

                eot_details = item?.data?.eot_details?.map((item) => item);

            }



            return {

                project: p_id,

                invoice: invoice_id,

                dutytravel: dutytravelId,

                actual_trip: "",

                month: month,

                year: year,

                actual_month_cumulative_total: "",

                cumulative_invoice_total: "",

                contract_amount: "",

                remaining_amount: "",

                actual_month_remaining: "",

                invoice_amount: "",

                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",

                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",

                boq_rate_per_trip: item.rate_per_trip ?? item.data?.rate_per_trip,

                boq_trips: item.trips ?? item.data?.trips,

                boq_num_of_min_trip: item.num_of_min_trip ?? item.data?.num_of_min_trip,

                eot_details: eot_details,

            };

        });



        setFormData(initialData);

    }, [logid, dutyTravel, dutytravelList]);



    // formData is the source of truth. Keep exact entered values here;
    // prepare a separate rounded copy only at the moment of POST.



    const getDutyTravel = async () => {

        try {

            const res = await axios.get(`${BASE_URL}/siteproject/boqtravelbyproject/${p_id}/`);

            if (Array.isArray(res.data)) {

                setDutyTravel(res.data);

            } else {

                console.error("Error: Expected a list of duty travel items");

            }

        } catch (err) {

            console.error("Error fetching duty travel data", err);

        }

    };



    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(false);



    // Only round calculated trip/month and monetary fields at the API boundary.
    // The input/state, invoice calculation, cumulative and remaining calculations
    // all continue using the original values (no toFixed during editing).
    const TWO_DECIMAL_POST_FIELDS = [
        "actual_trip",
        "actual_month_total_previous",
        "actual_month_cumulative_total",
        "actual_month_remaining",
        "invoice_amount",
        "previous_invoice_total",
        "cumulative_invoice_total",
        "remaining_amount",
        "contract_amount",
    ];

    const roundForPost = (value) => {
        if (value === "" || value === null || value === undefined) return value;
        const number = Number(value);
        return Number.isFinite(number) ? Number(number.toFixed(2)) : value;
    };

    const preparePostData = (records) => records.map(record => {
        const payload = { ...record };
        TWO_DECIMAL_POST_FIELDS.forEach(field => {
            if (Object.prototype.hasOwnProperty.call(payload, field)) {
                payload[field] = roundForPost(payload[field]);
            }
        });
        return payload;
    });

    const handleSubmit = async (e) => {

        e.preventDefault();

        // Compute from full precision first; never round React state itself.
        const postData = preparePostData(formData);

        setLoading(true);



        if (usedfor === "InvoiceandDeduction") {

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {

                const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoicedutytravelapi1/`, postData);



                if (res.status === 201) {

                    const createdData = res.data;

                    const mappedFinalData = postData.map((item, index) => ({

                        ...item,

                        invoicedutytravel: createdData[index]?.id,

                    }));



                    const res2 = await axios.post(`${BASE_URL}/siteproject/newinvoicedutytravellistcreate/`, mappedFinalData);



                    if (res2.status === 201) {

                        await getDutyTravelinvoice();

                        setShow(false);

                        toast.dismiss(loadingToastId);

                        toast.success("Duty travel Data added Successfully");

                    } else {

                        alert("Second API failed");

                    }

                } else {

                    alert("First API failed");

                }

            } catch (err) {

                handleErrorToast(err, loadingToastId);

            } finally {

                setLoading(false);

                toast.dismiss(loadingToastId);

            }

        }



        if (usedfor === "OnlyDeduction") {

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {

                const createdData = invoiceData;

                const mappedFinalData = postData.map((item, index) => ({

                    ...item,

                    invoicedutytravel: createdData[index]?.id,

                }));



                const res2 = await axios.post(`${BASE_URL}/siteproject/newinvoicedutytravellistcreate/`, mappedFinalData);



                if (res2.status === 201) {

                    await getDutyTravelinvoice();

                    setShow(false);

                    toast.dismiss(loadingToastId);

                    toast.success("Duty travel Data added Successfully");

                } else {

                    alert("Second API failed");

                }

            } catch (error) {

                handleErrorToast(error, loadingToastId);

            } finally {

                setLoading(false);

            }

        }

    };



    const handleInputChange = (e, index) => {

        const { name, value } = e.target;



        const updatedFormData = formData.map((entry, i) => {

            if (i !== index) return entry;



            const updatedEntry = { ...entry, [name]: value };



            let rate;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                rate = Number(lastEOT.rate || 0);

            } else {

                rate = Number(entry.boq_rate_per_trip || 0);

            }

            let trips;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                trips = Number(lastEOT.t_trips || 0);

            } else {

                trips = Number(entry.boq_num_of_min_trip || 0);

            }

            const total = Number(rate) * Number(trips);



            const previousTrip = entry.actual_month_total_previous;

            const previousTripAmount = entry.previous_invoice_total;

            // Keep the user's complete number for every intermediate calculation.
            // Example: 0.322211566569 remains 0.322211566569 until POST.
            const actualTrip = name === "actual_trip"

                ? Number(value) || 0

                : Number(entry.actual_trip) || 0;



            updatedEntry.invoice_amount = Number(rate) * Number(actualTrip);

            updatedEntry.actual_month_cumulative_total = Number(previousTrip) + Number(actualTrip);

            updatedEntry.cumulative_invoice_total = Number(previousTripAmount) + Number(updatedEntry.invoice_amount);

            updatedEntry.actual_month_remaining = Number(trips) - Number(updatedEntry.actual_month_cumulative_total);

            updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);



            return updatedEntry;

        });



        setFormData(updatedFormData);

    };



    return (

        <>

            <button title="Add Duty & Travels" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>

                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                    <circle cx="12" cy="12" r="10" />

                    <line x1="12" y1="8" x2="12" y2="16" />

                    <line x1="8" y1="12" x2="16" y2="12" />

                </svg>

                DutyTravel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

            </button>



            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">

                <Modal.Header className="eb-bulk-modal-header">

                    <Modal.Title className="eb-bulk-modal-title">

                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                            <path d="M3 17l2-7h14l2 7" />

                            <path d="M5 17a2 2 0 104 0M15 17a2 2 0 104 0" />

                            <path d="M3 10V7a1 1 0 011-1h1l2-3h8l2 3h1a1 1 0 011 1v3" />

                        </svg>

                        Add Duty &amp; Travel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

                    </Modal.Title>



                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                        {(dutyTravel.length > 0 && groupedByRandomChange.length > 0) && (

                            <select

                                value={logid}

                                onChange={(e) => setLogId(e.target.value)}

                                style={{

                                    fontSize: "13px",

                                    background: "var(--surface-2, #fff)",

                                    border: "0.5px solid var(--border-strong, #ccc)",

                                    borderRadius: "var(--radius, 8px)",

                                    padding: "4px 10px",

                                    cursor: "pointer",

                                    color: "var(--text-primary)",

                                }}

                            >

                                <option value="null">

                                    BOQ {groupedByRandomChange.length + 1} - {travelChangeReason}

                                </option>

                                {groupedByRandomChange.map(([groupKey, items], index) => {

                                    const reasons = [...new Set(

                                        items.map(i => i.data?.reason_of_change).filter(reason =>

                                            reason !== null && reason !== "null" && reason?.trim() !== ""

                                        )

                                    )];

                                    return (

                                        <option key={groupKey} value={groupKey}>

                                            BOQ {groupedByRandomChange.length - index}

                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}

                                        </option>

                                    );

                                })}

                            </select>

                        )}

                        <button className="close-btn" onClick={handleClose}>

                            <X size={20} />

                        </button>

                    </div>

                </Modal.Header>



                <Modal.Body className="eb-bulk-modal-body">

                    {modalLoading ? (

                        <div style={{

                            display: "flex",

                            flexDirection: "column",

                            alignItems: "center",

                            justifyContent: "center",

                            minHeight: "50vh",

                            gap: "20px",

                            padding: "40px",

                        }}>

                            <div style={{

                                width: "44px",

                                height: "44px",

                                border: "3px solid #e0e0e0",

                                borderTop: "3px solid #000",

                                borderRadius: "50%",

                                animation: "eb-spin 0.8s linear infinite",

                            }} />

                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>

                                {fetchProgress.label || "Loading data..."}

                            </p>

                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>

                                <div style={{

                                    height: "100%",

                                    width: `${fetchProgress.percent}%`,

                                    background: "#111",

                                    borderRadius: "999px",

                                    transition: "width 0.3s ease",

                                }} />

                            </div>

                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>

                                {fetchProgress.percent}%

                            </p>

                            <style>{`

                                @keyframes eb-spin {

                                    0% { transform: rotate(0deg); }

                                    100% { transform: rotate(360deg); }

                                }

                            `}</style>

                        </div>

                    ) : (

                        <div className="eb-bulk-container">

                            <div className="eb-bulk-content">

                                <div className="eb-bulk-table-wrapper">

                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"

                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}>

                                        <table className="eb-bulk-table" style={{ width: "100%", minWidth: "100%" }}>

                                            <thead className="eb-bulk-table-head">

                                                <tr className="eb-bulk-table-header-row">

                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>

                                                        <span className="eb-bulk-th-label">#</span>

                                                    </th>

                                                    <th className="eb-bulk-th text-start">

                                                        <span className="eb-bulk-th-label ">Description of Trips</span>

                                                    </th>

                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>

                                                        <span className="eb-bulk-th-label">Actual Trip</span>

                                                    </th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {formData.map((entry, index) => (

                                                    <tr key={index} className="eb-bulk-row">

                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>

                                                            {index + 1}.

                                                        </td>

                                                        <td className="eb-bulk-td">

                                                            <span style={{ fontWeight: 500 }}>{entry.boq_trips}</span>

                                                        </td>

                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>

                                                            <input

                                                                type="number"


                                                                step="any"


                                                                inputMode="decimal"

                                                                id={`actual_trip_${index}`}

                                                                name="actual_trip"

                                                                placeholder="Actual Trip"

                                                                value={entry.actual_trip}

                                                                onChange={(e) => handleInputChange(e, index)}

                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_trip`] ? "eb-bulk-input-error" : ""}`}

                                                                style={{ width: "100px", textAlign: "center" }}

                                                            />

                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>



                                <div className="eb-bulk-footer-actions">

                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>

                                        Cancel

                                    </button>

                                    <button

                                        type="submit"

                                        className="eb-bulk-btn eb-bulk-btn-submit"

                                        disabled={loading}

                                        onClick={handleSubmit}

                                        style={{ background: "black" }}

                                    >

                                        {loading ? (

                                            <span className="eb-bulk-btn-loader">

                                                <span className="eb-bulk-spinner"></span>

                                                Submitting...

                                            </span>

                                        ) : (

                                            <>

                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />

                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />

                                                </svg>

                                                Add

                                            </>

                                        )}

                                    </button>

                                </div>

                            </div>

                        </div>

                    )}

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>

            </Modal>

        </>

    );

};

const UpdateDutyTravelInvoice = ({ invoiceData, p_id, invoice_id, getDutyTravelinvoice, month, year, logData = [], usedfor }) => {
    const [show, setShow] = useState(false);
    const [dutyTravel, setDutyTravel] = useState([]);
    const [logid, setLogId] = useState("null");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [listLoaded, setListLoaded] = useState(false);
    const [dutytravelList, setDutyTravelList] = useState([]);
    const [existingRows, setExistingRows] = useState([]);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setListLoaded(false);
        setDutyTravelList([]);
        setExistingRows([]);
        setFormData([]);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        setShow(true);
        await getExistingRows();
        await getDutyTravel();
    };

    // ******************* Current month ki already saved rows *******************
    const fetchExistingRows = async () => {
        const res = await axios.get(
            `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${String(month).padStart(2, "0")}/${year}/`
        );
        return Array.isArray(res.data) ? res.data : [];
    };

    const getExistingRows = async () => {
        try {
            const rows = await fetchExistingRows();
            setExistingRows(rows);
            return rows;
        } catch (err) {
            handleErrorToast(err);
            return [];
        }
    };

    const getRowDutyTravelId = (row) => row?.dutytravel ?? row?.duty_travel_details?.id;

    // ******************* Previous data fetch *******************
    useEffect(() => {
        if (show !== true) return;
        if (!month || !year) {
            console.error("Both month and year are required to fetch progress data.");
            return;
        }

        const getDutyTravelData = async () => {
            try {
                let currentMonth = month - 1 === 0 ? 12 : month - 1;
                let currentYear = month - 1 === 0 ? year - 1 : year;
                let dataFound = false;
                let currentPercent = 0;

                const updateProgress = (percent, label) => {
                    currentPercent = Math.max(currentPercent, percent);
                    setFetchProgress({ percent: currentPercent, label });
                };

                updateProgress(5, "Connecting to server...");

                while (!dataFound) {
                    updateProgress(10, "Fetching previous duty travel data...");
                    const response = await axios.get(
                        `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${String(currentMonth).padStart(2, "0")}/${currentYear}/`
                    );

                    updateProgress(20, "Fetching withheld release data...");
                    const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                    const releaseRawData = releaseResponse.data;

                    const monthInt = parseInt(month, 10);
                    const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, "0");
                    const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                    const filterReleaseData = releaseRawData.filter(
                        (i) =>
                            i.month === monthCalculation &&
                            i.year === calculatedYear &&
                            i?.deduction_data?.project === p_id
                    );

                    const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

                    let localAllResults = [];
                    let localSheetData = [];

                    if (invoiceIds.length > 0) {
                        updateProgress(35, "Fetching consultant invoices...");
                        const res = await axios.get(
                            `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                        );
                        const filteredData = res.data.filter((item) => invoiceIds.includes(item.id));

                        if (filteredData.length > 0) {
                            const months = [...new Set(filteredData.map((i) => i.month))];
                            const years = [...new Set(filteredData.map((i) => i.year))];

                            const totalMonthYearCalls = months.length * years.length;
                            let completedMonthYearCalls = 0;

                            for (const m of months) {
                                for (const y of years) {
                                    try {
                                        const filterRes = await axios.get(
                                            `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id}/${m}/${y}/`
                                        );
                                        localAllResults.push(...filterRes.data);
                                    } catch (err) {
                                        console.error(`Failed for month: ${m}, year: ${y}`, err);
                                    }
                                    completedMonthYearCalls++;
                                    const pct = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                    updateProgress(35 + pct, `Fetching BOQ data for ${m}/${y}...`);
                                }
                            }

                            const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                            const totalIdCalls = allIds.length;
                            let completedIdCalls = 0;

                            for (const id of allIds) {
                                try {
                                    const secondRes = await axios.get(`${BASE_URL}/siteproject/newinvoicedutytravelfilter/${id}/`);
                                    localSheetData.push(...secondRes.data);
                                } catch (err) {
                                    console.error(`Failed for id: ${id}`, err);
                                }
                                completedIdCalls++;
                                const pct = Math.round((completedIdCalls / totalIdCalls) * 15);
                                updateProgress(50 + pct, `Loading duty travel sheet ${completedIdCalls} of ${totalIdCalls}...`);
                            }
                        }
                    }

                    updateProgress(70, "Processing duty travel records...");
                    const data = response.data;
                    let selectedData = [];

                    if (data.length > 0) {
                        const uids = data.map((item) => item.id).filter(Boolean);
                        let uidResults = [];
                        const totalUids = uids.length;
                        let completedUids = 0;

                        for (const uid of uids) {
                            const res = await axios.get(`${BASE_URL}/siteproject/newinvoicedutytravelfilter/${uid}/`);

                            if (!res.data || res.data.length === 0) {
                                console.error(`No data found for UID ${uid}. Breaking loop.`);
                                dataFound = false;
                                break;
                            }

                            uidResults = [...uidResults, ...res.data];
                            completedUids++;
                            const pct = Math.round((completedUids / totalUids) * 15);
                            updateProgress(70 + pct, `Loading duty travel ${completedUids} of ${totalUids}...`);
                        }

                        if (!dataFound && uidResults.length === 0) break;
                        selectedData = uidResults;
                    } else {
                        updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                        currentMonth -= 1;
                        if (currentMonth === 0) {
                            currentMonth = 12;
                            currentYear -= 1;
                        }
                        if (currentYear < year - 1) {
                            console.error("No data found for the past 1 year.");
                            break;
                        }
                        continue;
                    }

                    if (selectedData.length > 0) {
                        updateProgress(90, "Calculating cumulative totals...");

                        const updatedGetAllResults = localSheetData.map((resultItem) => {
                            const matchingReleases = filterReleaseData.filter(
                                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                            );
                            const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                            const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                            const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (Number(r.release_month) || 0), 0);
                            return {
                                id: resultItem?.duty_travel_details?.id,
                                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                                total_month_release: totalMonthRelease,
                            };
                        });

                        const updatedTravelData = selectedData.map((item) => {
                            const boqId = item?.duty_travel_details?.id;
                            const matchedData = updatedGetAllResults.filter((i) => i.id === boqId);
                            const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                            const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                            const prevAmount = parseFloat(item.previous_invoice_total || 0);
                            const currentAmount =
                                item.invoice_amount === null
                                    ? parseFloat(item.current_invoice_amount)
                                    : parseFloat(item.invoice_amount || 0);
                            const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

                            const prevTrips = parseFloat(item.actual_month_total_previous || 0);
                            const currentTrips = parseFloat(item.actual_trip || 0);
                            const newPreviousTrips = prevTrips + currentTrips + totalMonthRelease;

                            return {
                                ...item,
                                updated_previous_invoice_total: newPreviousAmount,
                                updated_actual_month_total_previous: newPreviousTrips,
                            };
                        });

                        updateProgress(100, "Done!");
                        setDutyTravelList(updatedTravelData);
                        setListLoaded(true);
                        dataFound = true;
                    }
                }

                if (!dataFound) {
                    updateProgress(100, "No previous data found.");
                    setListLoaded(true);
                }
            } catch (error) {
                console.error("Error fetching progress data:", error);
                setFetchProgress({ percent: 100, label: "Error loading data." });
                setListLoaded(true);
            }
        };
        getDutyTravelData();
    }, [month, year, show]);

    // ******************* Revised (BOQ change log) data *******************
    const travelID = dutyTravel.map((e) => e.id);
    const dutyTravelData = (logData || []).filter((item) => travelID.includes(item.object_id));
    const travelChangeReason = dutyTravel[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        dutyTravelData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? dutyTravel
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ******************* BOQ fetch *******************
    const getDutyTravel = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqtravelbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setDutyTravel(res.data);
            } else {
                console.error("Error: Expected a list of duty travel items");
            }
        } catch (err) {
            console.error("Error fetching duty travel data", err);
        }
    };

    // actual_trip se invoice / cumulative / remaining nikalta hai (original precision, koi toFixed nahi)
    const calcEntry = (entry, actualTripValue) => {
        const hasEot = entry.eot_details && entry.eot_details.length > 0;
        const lastEOT = hasEot ? entry.eot_details[entry.eot_details.length - 1] : null;

        const rate = hasEot ? Number(lastEOT.rate || 0) : Number(entry.boq_rate_per_trip || 0);
        const trips = hasEot ? Number(lastEOT.t_trips || 0) : Number(entry.boq_num_of_min_trip || 0);
        const total = rate * trips;

        const actualTrip = Number(actualTripValue) || 0;
        const previousTrip = entry.actual_month_total_previous;
        const previousTripAmount = entry.previous_invoice_total;

        const invoiceAmount = rate * actualTrip;
        const cumulativeTrip = Number(previousTrip) + actualTrip;
        const cumulativeAmount = Number(previousTripAmount) + invoiceAmount;

        return {
            ...entry,
            actual_trip: actualTripValue,
            invoice_amount: invoiceAmount,
            actual_month_cumulative_total: cumulativeTrip,
            cumulative_invoice_total: cumulativeAmount,
            actual_month_remaining: trips - cumulativeTrip,
            remaining_amount: total - cumulativeAmount,
        };
    };

    // ******************* Initial form (BOQ + previous data + saved values) *******************
    useEffect(() => {
        if (!listLoaded || dutyTravel.length === 0) return;

        const usedCount = {};

        const initialData = selectedGroup.map((item) => {
            const dutytravelId = item.object_id ?? item.id;
            const d = logid === "null" ? item : item.data || {};

            const matchedProgress = dutytravelList.find(
                (progress) => (progress.dutytravel ?? progress.duty_travel_details?.id) === dutytravelId
            );

            // Saved (current invoice) row, same duty travel ke multiple rows ho to order se
            const savedRows = existingRows.filter((r) => String(getRowDutyTravelId(r)) === String(dutytravelId));
            const k = usedCount[dutytravelId] || 0;
            usedCount[dutytravelId] = k + 1;
            const saved = savedRows[k];
            const savedTrip = saved?.actual_trip ?? "";

            const baseEntry = {
                project: p_id,
                invoice: invoice_id,
                dutytravel: dutytravelId,
                month: month,
                year: year,
                contract_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_rate_per_trip: d.rate_per_trip,
                boq_trips: d.trips,
                boq_num_of_min_trip: d.num_of_min_trip,
                eot_details: d.eot_details?.map((e) => e),
            };

            return calcEntry(baseEntry, savedTrip);
        });

        setFormData(initialData);
    }, [logid, dutyTravel, dutytravelList, listLoaded, existingRows]);

    useEffect(() => {
        if (!show) return;
        setModalLoading(!listLoaded);
    }, [listLoaded, show]);

    // ******************* Validation *******************
    const validateForm = () => {
        const newErrors = {};
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Sirf API boundary par 2 decimal rounding; state/calculation original precision me
    const TWO_DECIMAL_POST_FIELDS = [
        "actual_trip",
        "actual_month_total_previous",
        "actual_month_cumulative_total",
        "actual_month_remaining",
        "invoice_amount",
        "previous_invoice_total",
        "cumulative_invoice_total",
        "remaining_amount",
        "contract_amount",
    ];

    const roundForPost = (value) => {
        if (value === "" || value === null || value === undefined) return value;
        const number = Number(value);
        return Number.isFinite(number) ? Number(number.toFixed(2)) : value;
    };

    const preparePostData = (records) =>
        records.map((record) => {
            const payload = { ...record };
            TWO_DECIMAL_POST_FIELDS.forEach((field) => {
                if (Object.prototype.hasOwnProperty.call(payload, field)) {
                    payload[field] = roundForPost(payload[field]);
                }
            });
            return payload;
        });

    // // ******************* Submit: UPDATE *******************
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm()) return;

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing invoicedutytravel rows -> unki id attach karni hai
    //         const freshRows = await fetchExistingRows();

    //         // dutytravel -> [ids...] (same duty travel multiple rows ho to order ke hisaab se)
    //         const idQueue = {};
    //         freshRows.forEach((row) => {
    //             const key = String(getRowDutyTravelId(row));
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = preparePostData(formData)
    //             .map((item) => {
    //                 const queue = idQueue[String(item.dutytravel)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("No existing duty travel rows found to update");
    //             return;
    //         }

    //         const res = await axios.put(
    //             `${BASE_URL}/siteproject/invoicedutytravel/bulk-update/`,
    //             payload,
    //             {
    //                 onUploadProgress: (progressEvent) => {
    //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //                     setUploadProgress(percentCompleted);
    //                 },
    //             }
    //         );

    //         if (res.status === 200 || res.status === 201) {
    //             await getDutyTravelinvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Duty Travel Invoice Updated Successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };


    // ******************* Submit: UPDATE *******************
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing invoicedutytravel rows -> unki id attach karni hai
            const freshRows = await fetchExistingRows();

            // dutytravel -> [ids...] (same duty travel multiple rows ho to order ke hisaab se)
            const idQueue = {};
            freshRows.forEach((row) => {
                const key = String(getRowDutyTravelId(row));
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = preparePostData(formData)
                .map((item) => {
                    const queue = idQueue[String(item.dutytravel)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("No existing duty travel rows found to update");
                return;
            }

            // 1st API: invoicedutytravel bulk update
            const res = await axios.put(
                `${BASE_URL}/siteproject/invoicedutytravel/bulk-update/`,
                payload,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(Math.min(Math.round(percentCompleted * 0.5), 50));
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: claim (new invoice duty travel) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoicedutytravelfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoicedutytravel.id == claim.invoicedutytravel
                const claimPayload = payload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoicedutytravel) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                        // claim ke baaki fields bache rahein
                        ...item,                       // updated invoice data replicate
                        id: row.id,                    // claim row ki apni id
                        invoicedutytravel: item.id,    // link wapas invoicedutytravel se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoicedutytravelupdatedelete/null/`,
                        claimPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("Claim me koi matching invoicedutytravel nahi mili");
                }

                setUploadProgress(100);

                await getDutyTravelinvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Duty Travel Invoice Updated Successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };
    // ******************* Input handler *******************
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;

            if (name === "actual_trip") {
                // typed text as-is (e.g. "0.", "0.3222") taaki decimals na ud jaayein
                return calcEntry(entry, value);
            }
            return { ...entry, [name]: value };
        });

        setFormData(updatedFormData);
    };

    return (
        <>
            <button
                title="Update Duty & Travels"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update DutyTravel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width50vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M3 17l2-7h14l2 7" />
                                <path d="M5 17a2 2 0 104 0M15 17a2 2 0 104 0" />
                                <path d="M3 10V7a1 1 0 011-1h1l2-3h8l2 3h1a1 1 0 011 1v3" />
                            </svg>
                            Update Duty &amp; Travel {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {dutyTravel.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {travelChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />

                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>

                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>

                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>

                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table" style={{ width: "100%", minWidth: "100%" }}>
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}><span className="eb-bulk-th-label">#</span></th>
                                                        <th className="eb-bulk-th text-start"><span className="eb-bulk-th-label">Description of Trips</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "center" }}><span className="eb-bulk-th-label">Actual Trip</span></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.map((entry, index) => (
                                                        <tr key={index} className="eb-bulk-row">
                                                            <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                                {index + 1}.
                                                            </td>

                                                            <td className="eb-bulk-td">
                                                                <span style={{ fontWeight: 500 }}>{entry.boq_trips}</span>
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                                <input
                                                                    type="number"
                                                                    step="any"
                                                                    inputMode="decimal"
                                                                    id={`actual_trip_${index}`}
                                                                    name="actual_trip"
                                                                    placeholder="Actual Trip"
                                                                    value={entry.actual_trip ?? ""}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_trip`] ? "eb-bulk-input-error" : ""}`}
                                                                    style={{ width: "100px", textAlign: "center" }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};

const UpdateDutyTravelInvoices = ({ i, p_id, invoice_id, getDutyTravelinvoice }) => {
    const [show, setShow] = useState(false);
    const [dutyTravel, setDutyTravel] = useState([]);

    const handleShow = () => {
        setFormData(i);
        getDutyTravel();
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }

    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        month: "",
        current_invoice_amount: "",
        dutytravel: "",

    });
    const getDutyTravel = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqtravelbyproject/${p_id}`
            );
            setDutyTravel(res.data);
        } catch (err) { }
    };

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "invoice",
            "month",
            "current_invoice_amount",
            "dutytravel",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoiceduty/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getDutyTravelinvoice();
                    setShow(false);
                    toast.dismiss(loadingToastId);
                    toast.success("Data Updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button className="model-edit-button" title="Update Duty and Travel" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Duty & Travels for Invoice</Modal.Title> </h1>

                            <div title="Duty & Travels" className="flex-column form-group-selectt">
                                <label htmlFor="dutytravel" className="form-labels  font-weight500    font-size-subheading">
                                    Duty & Travels<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="dutytravel"
                                    name="dutytravel"
                                    placeholder="Duty & Travels"
                                    value={formData.dutytravel}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.dutytravel ? "error" : inputState.dutytravel ? "success" : ""}`}
                                >
                                    <option value="">Select Duty & Travel</option>
                                    {dutyTravel?.sort((a, b) => a.trips.localeCompare(b.trips, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.trips}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.dutytravel && <span className="error-message font-size-text ">{errors.dutytravel}</span>}
                            </div>

                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    CurrentCurrent Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>
                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}

                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}

const DeleteDutyTravelInvoice = ({ i, getDutyTravelinvoice }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }
    const [loading, setLoading] = useState(false);


    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoicedutytravel/${i.id}/`);
            if (response.status === 200) {
                getDutyTravelinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success(" Data Deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Duty and Travel Invoice" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.duty_travel_details.trips}</Modal.Title> </h1>

                        Are You Sure You Want to Delete {i.duty_travel_details.trips}
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )
}
const DeleteDutyTravelInvoiceDeduction = ({ i, getDutyTravelinvoice }) => {
    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }
    const handleClose = () => {
        setShow(false);
    }
    const [loading, setLoading] = useState(false);


    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceduty/${i.id}/`);
            if (response.status === 200) {
                getDutyTravelinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success(" Data Deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Duty and Travel Invoice" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.duty_travel_details.trips}</Modal.Title> </h1>

                        Are You Sure You Want to Delete {i.duty_travel_details.trips}
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )
}

// const OfficeRentInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getOfficeRentinvoice, month, year, logData }) => {
//     const [show, setShow] = useState(false);
//     const [logid, setLogId] = useState("null");
//     const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
//     const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
//     const [invoiceIds, setInvoiceIds] = useState([]);
//     const [months, setMonths] = useState([]);
//     const [years, setyears] = useState([]);
//     const [getResults, setGetResults] = useState([]);
//     const [getSheetData, setGetSheetData] = useState([])
//     const [getAllResults, setGetAllResults] = useState([]);

//     const [getTotalWithId, setGetTotalWithid] = useState([])

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         getOfficeRent();
//         setShow(true);
//     };

//     const [formData, setFormData] = useState([]);

//     const [officeRent, setOfficeRent] = useState([]);



//     const [rentList, setrentList] = useState([]);
//     useEffect(() => {
//         if (show === true) {


//             if (!month || !year) {
//                 console.error("Both month and year are required to fetch progress data.");
//                 return;
//             }

//             const getData = async () => {
//                 try {
//                     let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
//                     let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
//                     let dataFound = false; // Flag to check if data is found


//                     while (!dataFound) {
//                         const response = await axios.get(
//                             `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//                         );
//                         const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//                         // ✅ Store raw data in local variable
//                         const releaseRawData = releaseResponse.data;
//                         setWithHeldReleaseData(releaseRawData);

//                         const monthInt = parseInt(month, 10);
//                         const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//                         const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//                         const filterReleaseData = releaseRawData.filter(i =>
//                             (i.month === monthCalculation && i.year === calculatedYear) &&
//                             i?.deduction_data?.project === p_id
//                         );
//                         setfilterwithHeldReleaseData(filterReleaseData);

//                         const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
//                         setInvoiceIds(invoiceIds);

//                         let localAllResults = [];
//                         let localSheetData = [];

//                         if (invoiceIds.length > 0) {
//                             const res = await axios.get(
//                                 `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//                             );

//                             const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

//                             if (filteredData.length > 0) {
//                                 const months = [...new Set(filteredData.map(i => i.month))];
//                                 const years = [...new Set(filteredData.map(i => i.year))];

//                                 setMonths(months);
//                                 setyears(years);

//                                 for (const m of months) {
//                                     for (const y of years) {
//                                         try {
//                                             const filterRes = await axios.get(
//                                                 `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${m}/${y}/`
//                                             );
//                                             localAllResults.push(...filterRes.data);
//                                         } catch (err) {
//                                             console.error(`Failed for month: ${m}, year: ${y}`, err);
//                                         }
//                                     }
//                                 }

//                                 const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
//                                 console.log("All IDs:", allIds);

//                                 for (const id of allIds) {
//                                     try {
//                                         const secondRes = await axios.get(
//                                             `${BASE_URL}/siteproject/newinvoiceofficerentfilter/${id}/`
//                                         );
//                                         localSheetData.push(...secondRes.data);
//                                     } catch (err) {
//                                         console.error(`Failed for id: ${id}`, err);
//                                     }
//                                 }

//                                 console.log("Secondary Results:", localSheetData);
//                                 setGetSheetData(localSheetData);

//                                 const getboqIds = localAllResults.map(i => i?.officerent_details?.id);
//                                 setGetResults(getboqIds);
//                                 setGetAllResults(localAllResults);

//                                 console.log(localAllResults, "allresults");
//                                 console.log(getboqIds, "getboqIds");
//                             }
//                         }
//                         const data = response.data;

//                         let selectedData = [];

//                         if (data.length > 0) {
//                             const uids = data.map(item => item.id).filter(Boolean);

//                             let uidResults = [];

//                             for (const uid of uids) {
//                                 const res = await axios.get(
//                                     `${BASE_URL}/siteproject/newinvoiceofficerentfilter/${uid}/`
//                                 );

//                                 if (!res.data || res.data.length === 0) {
//                                     console.error(`No data found for UID ${uid}. Breaking loop.`);
//                                     dataFound = false;
//                                     break; // stop everything
//                                 }

//                                 uidResults = [...uidResults, ...res.data];
//                             }

//                             if (!dataFound && uidResults.length === 0) {
//                                 break; // if any uid fails, exit while loop
//                             }

//                             selectedData = uidResults;
//                         } else {
//                             // ❌ No data -> skip calling second API
//                             console.warn(
//                                 `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
//                             );

//                             currentMonth -= 1;
//                             if (currentMonth === 0) {
//                                 currentMonth = 12;
//                                 currentYear -= 1;
//                             }

//                             if (currentYear < year - 1) {
//                                 console.error("No data found for the past 1 year.");
//                                 break;
//                             }

//                             continue; // retry loop with new month/year
//                         }

//                         if (selectedData.length > 0) {

//                             const updatedGetAllResults = localSheetData.map((resultItem) => {

//                                 const matchingReleases = filterReleaseData.filter(
//                                     (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
//                                 );

//                                 const totalReleaseAmount = matchingReleases.reduce(
//                                     (sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0),
//                                     0
//                                 );

//                                 const totalDeductionAmount = matchingReleases.reduce(
//                                     (sum, r) => sum + (Number(r.deduction_amount) || 0),
//                                     0
//                                 );

//                                 const totalMonthRelease = matchingReleases.reduce(
//                                     (sum, r) => sum + (r.release_month || 0),
//                                     0
//                                 );

//                                 const total = totalReleaseAmount + totalDeductionAmount;

//                                 return {
//                                     id: resultItem?.employee_details?.id,
//                                     total_AMOUNT: total,
//                                     total_month_release: totalMonthRelease,
//                                 };
//                             });
//                             setGetTotalWithid(updatedGetAllResults);
//                             const updatedRentData = selectedData.map((item) => {
//                                 const boqId = item?.officerent_details?.id;
//                                 const getTotalWithid = getTotalWithId.filter(i => i.id === boqId);
//                                 const totalReleaseAmount = getTotalWithid.reduce(
//                                     (sum, i) => sum + (Number(i.total_AMOUNT) || 0),
//                                     0
//                                 );

//                                 const totalMonthRelease = getTotalWithid.reduce(
//                                     (sum, i) => sum + (Number(i.total_month_release) || 0),
//                                     0
//                                 );
//                                 const prevAmount = parseFloat(item.previous_invoice_total || 0);
//                                 const currentAmount = item.invoice_amount === null
//                                     ? parseFloat(item.current_invoice_amount)
//                                     : parseFloat(item.invoice_amount || 0);
//                                 const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

//                                 const prev = parseFloat(item.actual_month_total_previous || 0);
//                                 const current = parseFloat(item.actual_month || 0);
//                                 const newPrevious = prev + current + totalMonthRelease;

//                                 return {
//                                     ...item,
//                                     updated_previous_invoice_total: newPreviousAmount,
//                                     updated_actual_month_total_previous: newPrevious,
//                                 };
//                             });





//                             console.log("Updated Progress Data:", updatedRentData);

//                             // You can set it in state or pass to other components
//                             setrentList(updatedRentData);
//                             dataFound = true;
//                         }
//                     }
//                 } catch (error) {
//                     console.error("Error fetching progress data:", error);
//                 }
//             };




//             getData();
//         }
//     }, [month, year, show]);

//     const rentID = officeRent.map(e => e.id);
//     const rentData = logData.filter(item =>
//         rentID.includes(item.object_id)
//     );
//     const rentChangeReason = officeRent[0]?.reason_of_change || "";

//     const groupedByRandomChange = Object.entries(
//         rentData.reduce((acc, item) => {
//             const groupKey = item.data?.random_value_of_changes;
//             if (!acc[groupKey]) acc[groupKey] = [];
//             acc[groupKey].push(item);
//             return acc;
//         }, {})
//     ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

//     const selectedGroup = logid === "null"
//         ? officeRent
//         : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

//     const getOfficeRent = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/boqofficerentbyproject/${p_id}/`);
//             if (Array.isArray(res.data)) {
//                 setOfficeRent(res.data);
//             } else {
//                 console.error("Error: Expected a list of office rent items");
//             }
//         } catch (err) {
//             console.error("Error fetching office rent data", err);
//         }
//     };


//     // Fetch Office Rent data
//     // const getOfficeRent = async () => {
//     //     try {
//     //         const res = await axios.get(`${BASE_URL}/siteproject/boqofficerentbyproject/${p_id}/`);
//     //         if (Array.isArray(res.data)) {
//     //             setOfficeRent(res.data);

//     //             const initialData = res.data.map(item => ({
//     //                 project: p_id,
//     //                 invoice: invoice_id,
//     //                 officerent: item.id,
//     //                 actual_month: "",
//     //                 month: month,
//     //                 year: year,
//     //             }));
//     //             setFormData(initialData);
//     //         } else {
//     //             console.error("Error: Expected a list of office rent items");
//     //         }
//     //     } catch (err) {
//     //         console.error("Error fetching office rent data", err);
//     //     }
//     // };


//     useEffect(() => {
//         if (officeRent.length === 0) return;

//         const initialData = selectedGroup.map((item) => {
//             const rentId = item.object_id ?? item.id;

//             // Find matching progress entry from previousProgressData
//             const matchedProgress = rentList.find(
//                 (progress) => progress.officerent === rentId
//             );

//             let eot_details;
//             if (logid === "null") {
//                 eot_details = item.eot_details?.map((item) => (
//                     item
//                 ));
//             }
//             else {
//                 eot_details = item?.data?.eot_details?.map((item) => (
//                     item
//                 ));
//             }

//             return {
//                 project: p_id,
//                 invoice: invoice_id,
//                 officerent: rentId,
//                 actual_month: "",
//                 month: month,
//                 year: year,
//                 actual_month_cumulative_total: "",
//                 cumulative_invoice_total: "",
//                 contract_amount: "",
//                 remaining_amount: "",
//                 actual_month_remaining: "",
//                 invoice_amount: "",
//                 previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
//                 actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
//                 boq_rate_per_month: item.rate_per_month ?? item.data?.rate_per_month,
//                 boq_num_of_months: item.num_of_months ?? item.data?.num_of_months,
//                 boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,
//                 boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,
//                 eot_details: eot_details,

//             };
//         });

//         setFormData(initialData);
//     }, [logid, officeRent, rentList]);

//     console.log("formData");
//     console.log(formData);
//     const [finalFormData, setFinalFormData] = useState([]);


//     useEffect(() => {
//         if (formData?.length > 0) {
//             setFinalFormData(formData);
//         }
//     }, [formData])


//     // Validation logic
//     const [errors, setErrors] = useState({});

//     const validateForm = () => {
//         const newErrors = {};
//         formData.forEach((entry, index) => {
//             const requiredFields = [];
//             requiredFields.forEach(field => {
//                 if (!entry[field]) {
//                     newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//                 }
//             });
//         });

//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     // Loading state
//     const [loading, setLoading] = useState(false);

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true);
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             if (usedfor === "InvoiceandDeduction") {
//                 try {
//                     const res = await axios.post(
//                         `${BASE_URL}/siteproject/bulkinvoiceofficerentapi1/`,
//                         formData
//                     );

//                     if (res.status === 201) {
//                         const createdData = res.data;

//                         const mappedFinalData = finalFormData.map((item, index) => ({
//                             ...item,
//                             invoiceofficerent: createdData[index]?.id,
//                         }));

//                         const res2 = await axios.post(
//                             `${BASE_URL}/siteproject/newinvoiceofficerentlistcreate/`,
//                             mappedFinalData
//                         );

//                         if (res2.status === 201) {
//                             await getOfficeRentinvoice();
//                             setShow(false);
//                             toast.dismiss(loadingToastId);
//                             toast.success("Office rent Data added Successfully");
//                         } else {
//                             alert("Second API failed");
//                         }

//                     } else {
//                         alert("First API failed");
//                     }
//                 }
//                 catch (err) {
//                     handleErrorToast(err, loadingToastId);
//                 } finally {
//                     setLoading(false);
//                     toast.dismiss(loadingToastId);
//                 }
//             }
//         }
//         else if (usedfor === "OnlyDeduction") {
//             const loadingToastId = toast.loading("Loading: Please wait...");

//             try {

//                 const createdData = invoiceData;

//                 const mappedFinalData = finalFormData.map((item, index) => ({
//                     ...item,
//                     invoiceofficerent: createdData[index]?.id,
//                 }));

//                 const res2 = await axios.post(
//                     `${BASE_URL}/siteproject/newinvoiceofficerentlistcreate/`,
//                     mappedFinalData
//                 );

//                 if (res2.status === 201) {
//                     await getOfficeRentinvoice();
//                     setShow(false);
//                     toast.dismiss(loadingToastId);
//                     toast.success("Office rent Data added Successfully");
//                 } else {
//                     alert("Second API failed");
//                 }


//             } catch (error) {
//                 handleErrorToast(error, loadingToastId);
//             }
//         }
//     };

//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;

//         const updatedFormData = formData.map((entry, i) => {
//             if (i !== index) return entry;

//             const updatedEntry = { ...entry, [name]: value };

//             let rate;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 rate = Number(lastEOT.rate || 0);
//             } else {
//                 rate = Number(entry.boq_rate_per_month || 0);
//             }
//             const cp = entry.boq_during_construction_period
//             const dlp = entry.boq_during_dlp_OM_period
//             let month;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 month = Number(lastEOT.t_month || 0);
//             } else {
//                 month = Number(cp) + Number(dlp);
//             }
//             let total;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 total = Number(lastEOT.total_amount || 0);
//             } else {
//                 total = Number(rate) * Number(month)
//             }

//             const previous = entry.actual_month_total_previous;
//             const previousAmount = entry.previous_invoice_total;
//             const actualMonth = name === "actual_month"
//                 ? parseFloat(value) || 0
//                 : parseFloat(entry.actual_month) || 0;

//             updatedEntry.invoice_amount = Number(Number(rate) * Number(actualMonth)).toFixed(2);

//             updatedEntry.actual_month_cumulative_total = Number(previous) + Number(actualMonth);
//             updatedEntry.cumulative_invoice_total = Number(previousAmount) + Number(updatedEntry.invoice_amount);


//             updatedEntry.actual_month_remaining = Number(month) - Number(updatedEntry.actual_month_cumulative_total);
//             updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

//             return updatedEntry;
//         });

//         setFormData(updatedFormData);
//     };

//     return (
//         <>
//             <button title="Add Office Rent" className="upload-svg flex-row" onClick={handleShow}>
//                 <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
//                     <g clipPath="url(#clip0_1415_3177)">
//                         <path
//                             d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
//                             fill="white"
//                         />
//                     </g>
//                     <defs>
//                         <clipPath id="clip0_1415_3177">
//                             <rect width="24" height="24" fill="white" />
//                         </clipPath>
//                     </defs>
//                 </svg>
//                 {" "} Office Rent{usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="three-fourth-modal">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div flex-column">
//                             <div>
//                                 {(officeRent.length > 0 && groupedByRandomChange.length > 0) && (
//                                     <select
//                                         value={logid}
//                                         onChange={(e) => setLogId(e.target.value)}
//                                         className="dropdown font-size-subheading navbar-inputt"
//                                     >
//                                         <option value="null">
//                                             BOQ {groupedByRandomChange.length + 1} - {rentChangeReason}
//                                         </option>
//                                         {groupedByRandomChange.map(([groupKey, items], index) => {
//                                             const reasons = [...new Set(
//                                                 items.map(i => i.data?.reason_of_change).filter(reason =>
//                                                     reason !== null && reason !== "null" && reason?.trim() !== ""
//                                                 )
//                                             )];
//                                             return (
//                                                 <option key={groupKey} value={groupKey}>
//                                                     BOQ {groupedByRandomChange.length - index}
//                                                     {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                                 </option>
//                                             );
//                                         })}
//                                     </select>
//                                 )}
//                             </div>
//                             <div className="flex-row justify-center">
//                                 <table className="nested-table-lightblue width-90vw payment">

//                                     <thead>
//                                         <tr className="custom-table-head-td width-10vw">
//                                             <th className="width-10vw">S no.</th>
//                                             <th className="width-10vw">Office Rent</th>
//                                             <th className="align-center width-10vw">Actual Month</th>
//                                             {/* <th className="align-center width-10vw">Current Invoice Amount</th> */}
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {formData.map((entry, index) => (
//                                             <tr className="custom-table-head-td" key={index}>
//                                                 <td className="align-left width-5vw">{index + 1}.</td>
//                                                 <td>
//                                                     <div title="Office Rent" className="flex-column form-group-selectt">
//                                                         <p className="">{entry.boq_num_of_months}</p>
//                                                     </div>
//                                                 </td>
//                                                 <td>
//                                                     <div title="Actual Month" className="flex-column align-items-center">
//                                                         <input
//                                                             type="number"
//                                                             id={`actual_month_${index}`}
//                                                             name="actual_month"
//                                                             placeholder="Actual Month"
//                                                             value={entry.actual_month}
//                                                             onChange={(e) => handleInputChange(e, index)}
//                                                             className={`form-input-date width-5vw ${errors[`${index}_actual_month`] ? "error" : ""}`}
//                                                         />
//                                                     </div>
//                                                 </td>
//                                                 {/* <td>
//                                                     <div title="Invoice Amount" className="flex-column form-group-selectt">
//                                                         <input
//                                                             id={`current_invoice_amount_${index}`}
//                                                             name="current_invoice_amount"
//                                                             type="number"
//                                                             value={entry.current_invoice_amount}
//                                                             placeholder="Current Invoice Amount"
//                                                             onChange={(e) => handleInputChange(e, index)}
//                                                             className={`form-input-date width-5vw ${errors[`${index}_current_invoice_amount`] ? "error" : ""}`}
//                                                         />
//                                                     </div>
//                                                 </td> */}
//                                             </tr>
//                                         ))}
//                                     </tbody>
//                                 </table>
//                             </div>
//                             <div className="button-models">
//                                 <button className="model-button-cancel model-button font-weight500" onClick={handleClose}>
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button font-weight500 model-button-submit font-weight500 font-size-heading"
//                                     disabled={loading}
//                                     onClick={handleSubmit}

//                                 >
//                                     Add
//                                 </button>
//                             </div>

//                         </div>
//                     </div>
//                     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//                 </Modal.Body>
//             </Modal >

//         </>
//     );
// };


// const OfficeRentInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getOfficeRentinvoice, month, year, logData }) => {
//     const [show, setShow] = useState(false);
//     const [logid, setLogId] = useState("null");
//     const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
//     const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
//     const [invoiceIds, setInvoiceIds] = useState([]);
//     const [months, setMonths] = useState([]);
//     const [years, setyears] = useState([]);
//     const [getResults, setGetResults] = useState([]);
//     const [getSheetData, setGetSheetData] = useState([]);
//     const [getAllResults, setGetAllResults] = useState([]);
//     const [getTotalWithId, setGetTotalWithid] = useState([]);
//     const [modalLoading, setModalLoading] = useState(false);
//     const [listLoaded, setListLoaded] = useState(false);
//     const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });

//     const handleClose = () => {
//         setShow(false);
//         setModalLoading(false);
//         setListLoaded(false);
//         setFetchProgress({ percent: 0, label: "" });
//     };

//     const handleShow = () => {
//         getOfficeRent();
//         setShow(true);
//     };

//     useEffect(() => {
//         if (!show) return;
//         if (listLoaded) {
//             setModalLoading(false);
//         } else {
//             setModalLoading(true);
//         }
//     }, [listLoaded, show]);

//     const [formData, setFormData] = useState([]);
//     const [officeRent, setOfficeRent] = useState([]);
//     const [rentList, setrentList] = useState([]);

//     useEffect(() => {
//         if (show === true) {
//             if (!month || !year) {
//                 console.error("Both month and year are required to fetch progress data.");
//                 return;
//             }

//             const getData = async () => {
//                 try {
//                     let currentMonth = month - 1 === 0 ? 12 : month - 1;
//                     let currentYear = month - 1 === 0 ? year - 1 : year;
//                     let dataFound = false;
//                     let currentPercent = 0;

//                     const updateProgress = (percent, label) => {
//                         currentPercent = Math.max(currentPercent, percent);
//                         setFetchProgress({ percent: currentPercent, label });
//                     };

//                     updateProgress(5, "Connecting to server...");

//                     while (!dataFound) {
//                         updateProgress(10, "Fetching previous office rent data...");
//                         const response = await axios.get(
//                             `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
//                         );

//                         updateProgress(20, "Fetching withheld release data...");
//                         const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
//                         const releaseRawData = releaseResponse.data;
//                         setWithHeldReleaseData(releaseRawData);

//                         const monthInt = parseInt(month, 10);
//                         const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
//                         const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

//                         const filterReleaseData = releaseRawData.filter(i =>
//                             (i.month === monthCalculation && i.year === calculatedYear) &&
//                             i?.deduction_data?.project === p_id
//                         );
//                         setfilterwithHeldReleaseData(filterReleaseData);

//                         const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
//                         setInvoiceIds(invoiceIds);

//                         let localAllResults = [];
//                         let localSheetData = [];

//                         if (invoiceIds.length > 0) {
//                             updateProgress(35, "Fetching consultant invoices...");
//                             const res = await axios.get(
//                                 `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
//                             );

//                             const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

//                             if (filteredData.length > 0) {
//                                 const months = [...new Set(filteredData.map(i => i.month))];
//                                 const years = [...new Set(filteredData.map(i => i.year))];
//                                 setMonths(months);
//                                 setyears(years);

//                                 const totalMonthYearCalls = months.length * years.length;
//                                 let completedMonthYearCalls = 0;

//                                 for (const m of months) {
//                                     for (const y of years) {
//                                         try {
//                                             const filterRes = await axios.get(
//                                                 `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${m}/${y}/`
//                                             );
//                                             localAllResults.push(...filterRes.data);
//                                         } catch (err) {
//                                             console.error(`Failed for month: ${m}, year: ${y}`, err);
//                                         }
//                                         completedMonthYearCalls++;
//                                         const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
//                                         updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
//                                     }
//                                 }

//                                 const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
//                                 const totalIdCalls = allIds.length;
//                                 let completedIdCalls = 0;

//                                 for (const id of allIds) {
//                                     try {
//                                         const secondRes = await axios.get(
//                                             `${BASE_URL}/siteproject/newinvoiceofficerentfilter/${id}/`
//                                         );
//                                         localSheetData.push(...secondRes.data);
//                                     } catch (err) {
//                                         console.error(`Failed for id: ${id}`, err);
//                                     }
//                                     completedIdCalls++;
//                                     const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
//                                     updateProgress(50 + idPercent, `Loading rent sheet ${completedIdCalls} of ${totalIdCalls}...`);
//                                 }

//                                 setGetSheetData(localSheetData);
//                                 const getboqIds = localAllResults.map(i => i?.officerent_details?.id);
//                                 setGetResults(getboqIds);
//                                 setGetAllResults(localAllResults);
//                             }
//                         }

//                         updateProgress(70, "Processing office rent records...");
//                         const data = response.data;
//                         let selectedData = [];

//                         if (data.length > 0) {
//                             const uids = data.map(item => item.id).filter(Boolean);
//                             let uidResults = [];
//                             const totalUids = uids.length;
//                             let completedUids = 0;

//                             for (const uid of uids) {
//                                 const res = await axios.get(
//                                     `${BASE_URL}/siteproject/newinvoiceofficerentfilter/${uid}/`
//                                 );

//                                 if (!res.data || res.data.length === 0) {
//                                     console.error(`No data found for UID ${uid}. Breaking loop.`);
//                                     dataFound = false;
//                                     break;
//                                 }

//                                 uidResults = [...uidResults, ...res.data];
//                                 completedUids++;
//                                 const uidPercent = Math.round((completedUids / totalUids) * 15);
//                                 updateProgress(70 + uidPercent, `Loading rent ${completedUids} of ${totalUids}...`);
//                             }

//                             if (!dataFound && uidResults.length === 0) break;
//                             selectedData = uidResults;

//                         } else {
//                             updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);
//                             currentMonth -= 1;
//                             if (currentMonth === 0) {
//                                 currentMonth = 12;
//                                 currentYear -= 1;
//                             }
//                             if (currentYear < year - 1) {
//                                 console.error("No data found for the past 1 year.");
//                                 break;
//                             }
//                             continue;
//                         }

//                         if (selectedData.length > 0) {
//                             updateProgress(90, "Calculating cumulative totals...");

//                             const updatedGetAllResults = localSheetData.map((resultItem) => {
//                                 const matchingReleases = filterReleaseData.filter(
//                                     (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
//                                 );
//                                 const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
//                                 const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
//                                 const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
//                                 const total = totalReleaseAmount + totalDeductionAmount;
//                                 return { id: resultItem?.officerent_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
//                             });
//                             setGetTotalWithid(updatedGetAllResults);

//                             const updatedRentData = selectedData.map((item) => {
//                                 const boqId = item?.officerent_details?.id;
//                                 const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);
//                                 const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
//                                 const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

//                                 const prevAmount = parseFloat(item.previous_invoice_total || 0);
//                                 const currentAmount = item.invoice_amount === null
//                                     ? parseFloat(item.current_invoice_amount)
//                                     : parseFloat(item.invoice_amount || 0);
//                                 const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

//                                 const prev = parseFloat(item.actual_month_total_previous || 0);
//                                 const current = parseFloat(item.actual_month || 0);
//                                 const newPrevious = prev + current + totalMonthRelease;

//                                 return {
//                                     ...item,
//                                     updated_previous_invoice_total: newPreviousAmount,
//                                     updated_actual_month_total_previous: newPrevious,
//                                 };
//                             });

//                             updateProgress(100, "Done!");
//                             setrentList(updatedRentData);
//                             setListLoaded(true);
//                             dataFound = true;
//                         }
//                     }

//                     if (!dataFound) {
//                         updateProgress(100, "No previous data found.");
//                         setListLoaded(true);
//                     }

//                 } catch (error) {
//                     console.error("Error fetching progress data:", error);
//                     setFetchProgress({ percent: 100, label: "Error loading data." });
//                     setListLoaded(true);
//                 }
//             };

//             getData();
//         }
//     }, [month, year, show]);

//     const rentID = officeRent.map(e => e.id);
//     const rentData = logData.filter(item => rentID.includes(item.object_id));
//     const rentChangeReason = officeRent[0]?.reason_of_change || "";

//     const groupedByRandomChange = Object.entries(
//         rentData.reduce((acc, item) => {
//             const groupKey = item.data?.random_value_of_changes;
//             if (!acc[groupKey]) acc[groupKey] = [];
//             acc[groupKey].push(item);
//             return acc;
//         }, {})
//     ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

//     const selectedGroup = logid === "null"
//         ? officeRent
//         : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

//     const getOfficeRent = async () => {
//         try {
//             const res = await axios.get(`${BASE_URL}/siteproject/boqofficerentbyproject/${p_id}/`);
//             if (Array.isArray(res.data)) {
//                 setOfficeRent(res.data);
//             } else {
//                 console.error("Error: Expected a list of office rent items");
//             }
//         } catch (err) {
//             console.error("Error fetching office rent data", err);
//         }
//     };

//     useEffect(() => {
//         if (officeRent.length === 0) return;

//         const initialData = selectedGroup.map((item) => {
//             const rentId = item.object_id ?? item.id;
//             const matchedProgress = rentList.find((progress) => progress.officerent === rentId);

//             let eot_details;
//             if (logid === "null") {
//                 eot_details = item.eot_details?.map((item) => item);
//             } else {
//                 eot_details = item?.data?.eot_details?.map((item) => item);
//             }

//             return {
//                 project: p_id,
//                 invoice: invoice_id,
//                 officerent: rentId,
//                 actual_month: "",
//                 month: month,
//                 year: year,
//                 actual_month_cumulative_total: "",
//                 cumulative_invoice_total: "",
//                 contract_amount: "",
//                 remaining_amount: "",
//                 actual_month_remaining: "",
//                 invoice_amount: "",
//                 previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
//                 actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
//                 boq_rate_per_month: item.rate_per_month ?? item.data?.rate_per_month,
//                 boq_num_of_months: item.num_of_months ?? item.data?.num_of_months,
//                 boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,
//                 boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,
//                 eot_details: eot_details,
//             };
//         });

//         setFormData(initialData);
//     }, [logid, officeRent, rentList]);

//     const [finalFormData, setFinalFormData] = useState([]);

//     useEffect(() => {
//         if (formData?.length > 0) {
//             setFinalFormData(formData);
//         }
//     }, [formData]);

//     const [errors, setErrors] = useState({});

//     const validateForm = () => {
//         const newErrors = {};
//         formData.forEach((entry, index) => {
//             const requiredFields = [];
//             requiredFields.forEach(field => {
//                 if (!entry[field]) {
//                     newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//                 }
//             });
//         });
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const [loading, setLoading] = useState(false);

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true);
//             const loadingToastId = toast.loading("Loading: Please wait...");

//             if (usedfor === "InvoiceandDeduction") {
//                 try {
//                     const res = await axios.post(`${BASE_URL}/siteproject/bulkinvoiceofficerentapi1/`, formData);

//                     if (res.status === 201) {
//                         const createdData = res.data;
//                         const mappedFinalData = finalFormData.map((item, index) => ({
//                             ...item,
//                             invoiceofficerent: createdData[index]?.id,
//                         }));

//                         const res2 = await axios.post(`${BASE_URL}/siteproject/newinvoiceofficerentlistcreate/`, mappedFinalData);

//                         if (res2.status === 201) {
//                             await getOfficeRentinvoice();
//                             setShow(false);
//                             toast.dismiss(loadingToastId);
//                             toast.success("Office rent Data added Successfully");
//                         } else {
//                             alert("Second API failed");
//                         }
//                     } else {
//                         alert("First API failed");
//                     }
//                 } catch (err) {
//                     handleErrorToast(err, loadingToastId);
//                 } finally {
//                     setLoading(false);
//                     toast.dismiss(loadingToastId);
//                 }
//             }
//         } else if (usedfor === "OnlyDeduction") {
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             try {
//                 const createdData = invoiceData;
//                 const mappedFinalData = finalFormData.map((item, index) => ({
//                     ...item,
//                     invoiceofficerent: createdData[index]?.id,
//                 }));

//                 const res2 = await axios.post(`${BASE_URL}/siteproject/newinvoiceofficerentlistcreate/`, mappedFinalData);

//                 if (res2.status === 201) {
//                     await getOfficeRentinvoice();
//                     setShow(false);
//                     toast.dismiss(loadingToastId);
//                     toast.success("Office rent Data added Successfully");
//                 } else {
//                     alert("Second API failed");
//                 }
//             } catch (error) {
//                 handleErrorToast(error, loadingToastId);
//             } finally {
//                 setLoading(false);
//             }
//         }
//     };

//     const handleInputChange = (e, index) => {
//         const { name, value } = e.target;

//         const updatedFormData = formData.map((entry, i) => {
//             if (i !== index) return entry;

//             const updatedEntry = { ...entry, [name]: value };

//             let rate;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 rate = Number(lastEOT.rate || 0);
//             } else {
//                 rate = Number(entry.boq_rate_per_month || 0);
//             }
//             const cp = entry.boq_during_construction_period;
//             const dlp = entry.boq_during_dlp_OM_period;
//             let month;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 month = Number(lastEOT.t_month || 0);
//             } else {
//                 month = Number(cp) + Number(dlp);
//             }
//             let total;
//             if (entry.eot_details && entry.eot_details.length > 0) {
//                 const lastEOT = entry.eot_details[entry.eot_details.length - 1];
//                 total = Number(lastEOT.total_amount || 0);
//             } else {
//                 total = Number(rate) * Number(month);
//             }

//             const previous = entry.actual_month_total_previous;
//             const previousAmount = entry.previous_invoice_total;
//             const actualMonth = name === "actual_month"
//                 ? parseFloat(value) || 0
//                 : parseFloat(entry.actual_month) || 0;

//             updatedEntry.invoice_amount = Number(Number(rate) * Number(actualMonth)).toFixed(2);
//             updatedEntry.actual_month_cumulative_total = Number(previous) + Number(actualMonth);
//             updatedEntry.cumulative_invoice_total = Number(previousAmount) + Number(updatedEntry.invoice_amount);
//             updatedEntry.actual_month_remaining = Number(month) - Number(updatedEntry.actual_month_cumulative_total);
//             updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

//             return updatedEntry;
//         });

//         setFormData(updatedFormData);
//     };

//     return (
//         <>
//             <button title="Add Office Rent" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
//                 <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                     <circle cx="12" cy="12" r="10" />
//                     <line x1="12" y1="8" x2="12" y2="16" />
//                     <line x1="8" y1="12" x2="16" y2="12" />
//                 </svg>
//                 Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
//                 <Modal.Header className="eb-bulk-modal-header">
//                     <Modal.Title className="eb-bulk-modal-title">
//                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                             <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
//                             <polyline points="9 22 9 12 15 12 15 22" />
//                         </svg>
//                         Add Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
//                     </Modal.Title>

//                     <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                         {(officeRent.length > 0 && groupedByRandomChange.length > 0) && (
//                             <select
//                                 value={logid}
//                                 onChange={(e) => setLogId(e.target.value)}
//                                 style={{
//                                     fontSize: "13px",
//                                     background: "var(--surface-2, #fff)",
//                                     border: "0.5px solid var(--border-strong, #ccc)",
//                                     borderRadius: "var(--radius, 8px)",
//                                     padding: "4px 10px",
//                                     cursor: "pointer",
//                                     color: "var(--text-primary)",
//                                 }}
//                             >
//                                 <option value="null">
//                                     BOQ {groupedByRandomChange.length + 1} - {rentChangeReason}
//                                 </option>
//                                 {groupedByRandomChange.map(([groupKey, items], index) => {
//                                     const reasons = [...new Set(
//                                         items.map(i => i.data?.reason_of_change).filter(reason =>
//                                             reason !== null && reason !== "null" && reason?.trim() !== ""
//                                         )
//                                     )];
//                                     return (
//                                         <option key={groupKey} value={groupKey}>
//                                             BOQ {groupedByRandomChange.length - index}
//                                             {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
//                                         </option>
//                                     );
//                                 })}
//                             </select>
//                         )}
//                         <button className="close-btn" onClick={handleClose}>
//                             <X size={20} />
//                         </button>
//                     </div>
//                 </Modal.Header>

//                 <Modal.Body className="eb-bulk-modal-body">
//                     {modalLoading ? (
//                         <div style={{
//                             display: "flex",
//                             flexDirection: "column",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             minHeight: "50vh",
//                             gap: "20px",
//                             padding: "40px",
//                         }}>
//                             <div style={{
//                                 width: "44px",
//                                 height: "44px",
//                                 border: "3px solid #e0e0e0",
//                                 borderTop: "3px solid #000",
//                                 borderRadius: "50%",
//                                 animation: "eb-spin 0.8s linear infinite",
//                             }} />
//                             <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
//                                 {fetchProgress.label || "Loading data..."}
//                             </p>
//                             <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
//                                 <div style={{
//                                     height: "100%",
//                                     width: `${fetchProgress.percent}%`,
//                                     background: "#111",
//                                     borderRadius: "999px",
//                                     transition: "width 0.3s ease",
//                                 }} />
//                             </div>
//                             <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
//                                 {fetchProgress.percent}%
//                             </p>
//                             <style>{`
//                                 @keyframes eb-spin {
//                                     0% { transform: rotate(0deg); }
//                                     100% { transform: rotate(360deg); }
//                                 }
//                             `}</style>
//                         </div>
//                     ) : (
//                         <div className="eb-bulk-container">
//                             <div className="eb-bulk-content">
//                                 <div className="eb-bulk-table-wrapper">
//                                     <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"
//                                         style={{ maxHeight: "50vh", minHeight: "50vh" }}>
//                                         <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
//                                             <thead className="eb-bulk-table-head">
//                                                 <tr className="eb-bulk-table-header-row">
//                                                     <th className="eb-bulk-th" style={{ width: "48px" }}>
//                                                         <span className="eb-bulk-th-label">#</span>
//                                                     </th>
//                                                     <th className="eb-bulk-th" style={{ textAlign: "start" }}>
//                                                         <span className="eb-bulk-th-label">Office Rent</span>
//                                                     </th>
//                                                     <th className="eb-bulk-th" style={{ textAlign: "center" }}>
//                                                         <span className="eb-bulk-th-label">Actual Month</span>
//                                                     </th>
//                                                 </tr>
//                                             </thead>
//                                             <tbody>
//                                                 {formData.map((entry, index) => (
//                                                     <tr key={index} className="eb-bulk-row">
//                                                         <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
//                                                             {index + 1}.
//                                                         </td>
//                                                         <td className="eb-bulk-td">
//                                                             <span style={{ fontWeight: 500 }}>{entry.boq_num_of_months}</span>
//                                                         </td>
//                                                         <td className="eb-bulk-td" style={{ textAlign: "center" }}>
//                                                             <input
//                                                                 type="number"
//                                                                 id={`actual_month_${index}`}
//                                                                 name="actual_month"
//                                                                 placeholder="Actual Month"
//                                                                 value={entry.actual_month}
//                                                                 onChange={(e) => handleInputChange(e, index)}
//                                                                 className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
//                                                                 style={{ width: "100px", textAlign: "center" }}
//                                                             />
//                                                         </td>
//                                                     </tr>
//                                                 ))}
//                                             </tbody>
//                                         </table>
//                                     </div>
//                                 </div>

//                                 <div className="eb-bulk-footer-actions">
//                                     <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
//                                         Cancel
//                                     </button>
//                                     <button
//                                         type="submit"
//                                         className="eb-bulk-btn eb-bulk-btn-submit"
//                                         disabled={loading}
//                                         onClick={handleSubmit}
//                                         style={{ background: "black" }}
//                                     >
//                                         {loading ? (
//                                             <span className="eb-bulk-btn-loader">
//                                                 <span className="eb-bulk-spinner"></span>
//                                                 Submitting...
//                                             </span>
//                                         ) : (
//                                             <>
//                                                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//                                                     <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
//                                                     <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
//                                                 </svg>
//                                                 Add
//                                             </>
//                                         )}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     )}
//                     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const OfficeRentInvoice = ({ invoiceData, usedfor, p_id, invoice_id, getOfficeRentinvoice, month, year, logData }) => {

    const [show, setShow] = useState(false);

    const [logid, setLogId] = useState("null");

    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);

    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);

    const [invoiceIds, setInvoiceIds] = useState([]);

    const [months, setMonths] = useState([]);

    const [years, setyears] = useState([]);

    const [getResults, setGetResults] = useState([]);

    const [getSheetData, setGetSheetData] = useState([]);

    const [getAllResults, setGetAllResults] = useState([]);

    const [getTotalWithId, setGetTotalWithid] = useState([]);

    const [modalLoading, setModalLoading] = useState(false);

    const [listLoaded, setListLoaded] = useState(false);

    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });



    const handleClose = () => {

        setShow(false);

        setModalLoading(false);

        setListLoaded(false);

        setFetchProgress({ percent: 0, label: "" });

    };



    const handleShow = () => {

        getOfficeRent();

        setShow(true);

    };



    useEffect(() => {

        if (!show) return;

        if (listLoaded) {

            setModalLoading(false);

        } else {

            setModalLoading(true);

        }

    }, [listLoaded, show]);



    const [formData, setFormData] = useState([]);

    const [officeRent, setOfficeRent] = useState([]);

    const [rentList, setrentList] = useState([]);



    useEffect(() => {

        if (show === true) {

            if (!month || !year) {

                console.error("Both month and year are required to fetch progress data.");

                return;

            }



            const getData = async () => {

                try {

                    let currentMonth = month - 1 === 0 ? 12 : month - 1;

                    let currentYear = month - 1 === 0 ? year - 1 : year;

                    let dataFound = false;

                    let currentPercent = 0;



                    const updateProgress = (percent, label) => {

                        currentPercent = Math.max(currentPercent, percent);

                        setFetchProgress({ percent: currentPercent, label });

                    };



                    updateProgress(5, "Connecting to server...");



                    while (!dataFound) {

                        updateProgress(10, "Fetching previous office rent data...");

                        const response = await axios.get(

                            `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`

                        );



                        updateProgress(20, "Fetching withheld release data...");

                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);

                        const releaseRawData = releaseResponse.data;

                        setWithHeldReleaseData(releaseRawData);



                        const monthInt = parseInt(month, 10);

                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');

                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;



                        const filterReleaseData = releaseRawData.filter(i =>

                            (i.month === monthCalculation && i.year === calculatedYear) &&

                            i?.deduction_data?.project === p_id

                        );

                        setfilterwithHeldReleaseData(filterReleaseData);



                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];

                        setInvoiceIds(invoiceIds);



                        let localAllResults = [];

                        let localSheetData = [];



                        if (invoiceIds.length > 0) {

                            updateProgress(35, "Fetching consultant invoices...");

                            const res = await axios.get(

                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`

                            );



                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));



                            if (filteredData.length > 0) {

                                const months = [...new Set(filteredData.map(i => i.month))];

                                const years = [...new Set(filteredData.map(i => i.year))];

                                setMonths(months);

                                setyears(years);



                                const totalMonthYearCalls = months.length * years.length;

                                let completedMonthYearCalls = 0;



                                for (const m of months) {

                                    for (const y of years) {

                                        try {

                                            const filterRes = await axios.get(

                                                `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${m}/${y}/`

                                            );

                                            localAllResults.push(...filterRes.data);

                                        } catch (err) {

                                            console.error(`Failed for month: ${m}, year: ${y}`, err);

                                        }

                                        completedMonthYearCalls++;

                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);

                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);

                                    }

                                }



                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];

                                const totalIdCalls = allIds.length;

                                let completedIdCalls = 0;



                                for (const id of allIds) {

                                    try {

                                        const secondRes = await axios.get(

                                            `${BASE_URL}/siteproject/newinvoiceofficerentfilter/${id}/`

                                        );

                                        localSheetData.push(...secondRes.data);

                                    } catch (err) {

                                        console.error(`Failed for id: ${id}`, err);

                                    }

                                    completedIdCalls++;

                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);

                                    updateProgress(50 + idPercent, `Loading rent sheet ${completedIdCalls} of ${totalIdCalls}...`);

                                }



                                setGetSheetData(localSheetData);

                                const getboqIds = localAllResults.map(i => i?.officerent_details?.id);

                                setGetResults(getboqIds);

                                setGetAllResults(localAllResults);

                            }

                        }



                        updateProgress(70, "Processing office rent records...");

                        const data = response.data;

                        let selectedData = [];



                        if (data.length > 0) {

                            const uids = data.map(item => item.id).filter(Boolean);

                            let uidResults = [];

                            const totalUids = uids.length;

                            let completedUids = 0;



                            for (const uid of uids) {

                                const res = await axios.get(

                                    `${BASE_URL}/siteproject/newinvoiceofficerentfilter/${uid}/`

                                );



                                if (!res.data || res.data.length === 0) {

                                    console.error(`No data found for UID ${uid}. Breaking loop.`);

                                    dataFound = false;

                                    break;

                                }



                                uidResults = [...uidResults, ...res.data];

                                completedUids++;

                                const uidPercent = Math.round((completedUids / totalUids) * 15);

                                updateProgress(70 + uidPercent, `Loading rent ${completedUids} of ${totalUids}...`);

                            }



                            if (!dataFound && uidResults.length === 0) break;

                            selectedData = uidResults;



                        } else {

                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                            currentMonth -= 1;

                            if (currentMonth === 0) {

                                currentMonth = 12;

                                currentYear -= 1;

                            }

                            if (currentYear < year - 1) {

                                console.error("No data found for the past 1 year.");

                                break;

                            }

                            continue;

                        }



                        if (selectedData.length > 0) {

                            updateProgress(90, "Calculating cumulative totals...");



                            const updatedGetAllResults = localSheetData.map((resultItem) => {

                                const matchingReleases = filterReleaseData.filter(

                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)

                                );

                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);

                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);

                                // API may return release_month as a string (e.g. "0.20").
                                // Always coerce to Number before addition; otherwise JS concatenates.
                                const totalMonthRelease = matchingReleases.reduce(
                                    (sum, r) => sum + (Number(r.release_month) || 0),
                                    0
                                );

                                const total = totalReleaseAmount + totalDeductionAmount;

                                return { id: resultItem?.officerent_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };

                            });

                            setGetTotalWithid(updatedGetAllResults);



                            const updatedRentData = selectedData.map((item) => {

                                const boqId = item?.officerent_details?.id;

                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);

                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);

                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);



                                const prevAmount = Number(item.previous_invoice_total) || 0;

                                const currentAmount = Number(
                                    item.invoice_amount ?? item.current_invoice_amount ?? 0
                                ) || 0;

                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;



                                const prev = Number(item.actual_month_total_previous) || 0;
                                const current = Number(item.actual_month) || 0;
                                const newPrevious = prev + current + totalMonthRelease;



                                return {

                                    ...item,

                                    updated_previous_invoice_total: newPreviousAmount,

                                    updated_actual_month_total_previous: newPrevious,

                                };

                            });



                            updateProgress(100, "Done!");

                            setrentList(updatedRentData);

                            setListLoaded(true);

                            dataFound = true;

                        }

                    }



                    if (!dataFound) {

                        updateProgress(100, "No previous data found.");

                        setListLoaded(true);

                    }



                } catch (error) {

                    console.error("Error fetching progress data:", error);

                    setFetchProgress({ percent: 100, label: "Error loading data." });

                    setListLoaded(true);

                }

            };



            getData();

        }

    }, [month, year, show]);



    const rentID = officeRent.map(e => e.id);

    const rentData = (Array.isArray(logData) ? logData : []).filter(
        item => rentID.includes(item.object_id)
    );

    const rentChangeReason = officeRent[0]?.reason_of_change || "";



    const groupedByRandomChange = Object.entries(

        rentData.reduce((acc, item) => {

            const groupKey = item.data?.random_value_of_changes;

            if (!acc[groupKey]) acc[groupKey] = [];

            acc[groupKey].push(item);

            return acc;

        }, {})

    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));



    const selectedGroup = logid === "null"

        ? officeRent

        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];



    const getOfficeRent = async () => {

        try {

            const res = await axios.get(`${BASE_URL}/siteproject/boqofficerentbyproject/${p_id}/`);

            if (Array.isArray(res.data)) {

                setOfficeRent(res.data);

            } else {

                console.error("Error: Expected a list of office rent items");

            }

        } catch (err) {

            console.error("Error fetching office rent data", err);

        }

    };



    useEffect(() => {

        if (officeRent.length === 0) return;



        const initialData = selectedGroup.map((item) => {

            const rentId = item.object_id ?? item.id;

            const matchedProgress = rentList.find((progress) => progress.officerent === rentId);



            let eot_details;

            if (logid === "null") {

                eot_details = item.eot_details?.map((item) => item);

            } else {

                eot_details = item?.data?.eot_details?.map((item) => item);

            }



            return {

                project: p_id,

                invoice: invoice_id,

                officerent: rentId,

                actual_month: "",

                month: month,

                year: year,

                actual_month_cumulative_total: "",

                cumulative_invoice_total: "",

                contract_amount: "",

                remaining_amount: "",

                actual_month_remaining: "",

                invoice_amount: "",

                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",

                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",

                boq_rate_per_month: item.rate_per_month ?? item.data?.rate_per_month,

                boq_num_of_months: item.num_of_months ?? item.data?.num_of_months,

                boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,

                boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,

                eot_details: eot_details,

            };

        });



        setFormData(initialData);

    }, [logid, officeRent, rentList]);



    // Keep full-precision user input and calculations in formData.
    // Only the outgoing request payload is rounded (see roundOfficeRentForPost).



    const [errors, setErrors] = useState({});



    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            // Empty values remain backward-compatible with the existing workflow.
            // Reject invalid non-empty numeric entries instead of posting NaN.
            if (entry.actual_month !== "" && entry.actual_month != null &&
                !Number.isFinite(Number(entry.actual_month))) {
                newErrors[`${index}_actual_month`] = "Enter a valid actual month";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };



    const [loading, setLoading] = useState(false);



    // These are the calculated numeric fields, not identifiers or calendar month/year.
    // Preserve original precision in formData; round only in outgoing POST payload.
    const POST_TWO_DECIMAL_FIELDS = [
        "actual_month",
        "invoice_amount",
        "actual_month_cumulative_total",
        "cumulative_invoice_total",
        "contract_amount",
        "remaining_amount",
        "actual_month_remaining",
        "previous_invoice_total",
        "actual_month_total_previous",
    ];

    const roundOfficeRentForPost = (entry) => {
        const payload = { ...entry };
        POST_TWO_DECIMAL_FIELDS.forEach((field) => {
            const val = payload[field];
            // Leave empty fields empty; don't turn an unentered amount into zero.
            if (val === "" || val === null || val === undefined) return;
            const numeric = Number(val);
            if (!Number.isFinite(numeric)) {
                throw new Error(`Invalid numeric value for ${field}`);
            }
            payload[field] = Number(numeric.toFixed(2));
        });
        return payload;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm() || loading) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            // Round the SNAPSHOT once, immediately before POST; React state stays untouched.
            const roundedPostData = formData.map(roundOfficeRentForPost);
            if (usedfor === "InvoiceandDeduction") {
                const res = await axios.post(
                    `${BASE_URL}/siteproject/bulkinvoiceofficerentapi1/`,
                    roundedPostData
                );

                if (res.status !== 201) {
                    throw new Error("First Office Rent API failed");
                }

                const createdData = Array.isArray(res.data)
                    ? res.data
                    : Array.isArray(res.data?.data)
                        ? res.data.data
                        : Array.isArray(res.data?.results)
                            ? res.data.results
                            : roundedPostData.length === 1 && res.data?.id
                                ? [res.data]
                                : [];

                if (createdData.length !== roundedPostData.length ||
                    createdData.some(record => !record?.id)) {
                    throw new Error(
                        "First Office Rent API did not return an ID for every created invoice. " +
                        "Check the first API response in Network before retrying."
                    );
                }
                const mappedFinalData = roundedPostData.map((item, index) => ({
                    ...item,
                    invoiceofficerent: createdData[index].id,
                }));

                const res2 = await axios.post(
                    `${BASE_URL}/siteproject/newinvoiceofficerentlistcreate/`,
                    mappedFinalData
                );
                if (res2.status !== 201) {
                    throw new Error("Second Office Rent API failed");
                }
            } else if (usedfor === "OnlyDeduction") {
                const createdData = Array.isArray(invoiceData) ? invoiceData : [];
                if (createdData.length < roundedPostData.length ||
                    roundedPostData.some((_, index) => !createdData[index]?.id)) {
                    throw new Error("Missing Office Rent invoice IDs for deduction data");
                }
                const mappedFinalData = roundedPostData.map((item, index) => ({
                    ...item,
                    invoiceofficerent: createdData[index].id,
                }));

                const res2 = await axios.post(
                    `${BASE_URL}/siteproject/newinvoiceofficerentlistcreate/`,
                    mappedFinalData
                );
                if (res2.status !== 201) {
                    throw new Error("Office Rent deduction API failed");
                }
            } else {
                throw new Error(`Unsupported submission mode: ${usedfor}`);
            }

            await getOfficeRentinvoice();
            setShow(false);
            toast.success("Office rent Data added Successfully");
        } catch (err) {
            // This exposes the actual API error instead of only a generic toast.
            console.error("Office Rent invoice POST failed", {
                status: err?.response?.status,
                response: err?.response?.data,
                message: err?.message,
            });
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e, index) => {

        const { name, value } = e.target;



        const updatedFormData = formData.map((entry, i) => {

            if (i !== index) return entry;



            const updatedEntry = { ...entry, [name]: value };



            let rate;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                rate = Number(lastEOT.rate || 0);

            } else {

                rate = Number(entry.boq_rate_per_month || 0);

            }

            const cp = entry.boq_during_construction_period;

            const dlp = entry.boq_during_dlp_OM_period;

            let month;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                month = Number(lastEOT.t_month || 0);

            } else {

                month = Number(cp) + Number(dlp);

            }

            let total;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                total = Number(lastEOT.total_amount || 0);

            } else {

                total = Number(rate) * Number(month);

            }



            const previous = entry.actual_month_total_previous;

            const previousAmount = entry.previous_invoice_total;

            const actualMonth = Number(
                name === "actual_month" ? value : entry.actual_month
            ) || 0;



            // Calculate with the exact entered decimal value; do NOT round here.
            // Calculate all totals from ORIGINAL decimals in the form, without rounding.
            updatedEntry.invoice_amount = rate * actualMonth;
            updatedEntry.actual_month_cumulative_total = (Number(previous) || 0) + actualMonth;
            updatedEntry.cumulative_invoice_total = (Number(previousAmount) || 0) + updatedEntry.invoice_amount;
            updatedEntry.actual_month_remaining = month - updatedEntry.actual_month_cumulative_total;
            updatedEntry.remaining_amount = total - updatedEntry.cumulative_invoice_total;



            return updatedEntry;

        });



        setFormData(updatedFormData);

    };



    return (

        <>

            <button title="Add Office Rent" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>

                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                    <circle cx="12" cy="12" r="10" />

                    <line x1="12" y1="8" x2="12" y2="16" />

                    <line x1="8" y1="12" x2="16" y2="12" />

                </svg>

                Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

            </button>



            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">

                <Modal.Header className="eb-bulk-modal-header">

                    <Modal.Title className="eb-bulk-modal-title">

                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />

                            <polyline points="9 22 9 12 15 12 15 22" />

                        </svg>

                        Add Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

                    </Modal.Title>



                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                        {(officeRent.length > 0 && groupedByRandomChange.length > 0) && (

                            <select

                                value={logid}

                                onChange={(e) => setLogId(e.target.value)}

                                style={{

                                    fontSize: "13px",

                                    background: "var(--surface-2, #fff)",

                                    border: "0.5px solid var(--border-strong, #ccc)",

                                    borderRadius: "var(--radius, 8px)",

                                    padding: "4px 10px",

                                    cursor: "pointer",

                                    color: "var(--text-primary)",

                                }}

                            >

                                <option value="null">

                                    BOQ {groupedByRandomChange.length + 1} - {rentChangeReason}

                                </option>

                                {groupedByRandomChange.map(([groupKey, items], index) => {

                                    const reasons = [...new Set(

                                        items.map(i => i.data?.reason_of_change).filter(reason =>

                                            reason !== null && reason !== "null" && reason?.trim() !== ""

                                        )

                                    )];

                                    return (

                                        <option key={groupKey} value={groupKey}>

                                            BOQ {groupedByRandomChange.length - index}

                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}

                                        </option>

                                    );

                                })}

                            </select>

                        )}

                        <button className="close-btn" onClick={handleClose}>

                            <X size={20} />

                        </button>

                    </div>

                </Modal.Header>



                <Modal.Body className="eb-bulk-modal-body">

                    {modalLoading ? (

                        <div style={{

                            display: "flex",

                            flexDirection: "column",

                            alignItems: "center",

                            justifyContent: "center",

                            minHeight: "50vh",

                            gap: "20px",

                            padding: "40px",

                        }}>

                            <div style={{

                                width: "44px",

                                height: "44px",

                                border: "3px solid #e0e0e0",

                                borderTop: "3px solid #000",

                                borderRadius: "50%",

                                animation: "eb-spin 0.8s linear infinite",

                            }} />

                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>

                                {fetchProgress.label || "Loading data..."}

                            </p>

                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>

                                <div style={{

                                    height: "100%",

                                    width: `${fetchProgress.percent}%`,

                                    background: "#111",

                                    borderRadius: "999px",

                                    transition: "width 0.3s ease",

                                }} />

                            </div>

                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>

                                {fetchProgress.percent}%

                            </p>

                            <style>{`

                                @keyframes eb-spin {

                                    0% { transform: rotate(0deg); }

                                    100% { transform: rotate(360deg); }

                                }

                            `}</style>

                        </div>

                    ) : (

                        <div className="eb-bulk-container">

                            <div className="eb-bulk-content">

                                <div className="eb-bulk-table-wrapper">

                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"

                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}>

                                        <table className="eb-bulk-table" style={{ minWidth: "100%" }}>

                                            <thead className="eb-bulk-table-head">

                                                <tr className="eb-bulk-table-header-row">

                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>

                                                        <span className="eb-bulk-th-label">#</span>

                                                    </th>

                                                    <th className="eb-bulk-th" style={{ textAlign: "start" }}>

                                                        <span className="eb-bulk-th-label">Office Rent</span>

                                                    </th>

                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>

                                                        <span className="eb-bulk-th-label">Actual Month</span>

                                                    </th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {formData.map((entry, index) => (

                                                    <tr key={index} className="eb-bulk-row">

                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>

                                                            {index + 1}.

                                                        </td>

                                                        <td className="eb-bulk-td">

                                                            <span style={{ fontWeight: 500 }}>{entry.boq_num_of_months}</span>

                                                        </td>

                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>

                                                            <input

                                                                type="number"

                                                                step="any"

                                                                id={`actual_month_${index}`}

                                                                name="actual_month"

                                                                placeholder="Actual Month"

                                                                value={entry.actual_month}

                                                                onChange={(e) => handleInputChange(e, index)}

                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}

                                                                style={{ width: "100px", textAlign: "center" }}

                                                            />

                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>



                                <div className="eb-bulk-footer-actions">

                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>

                                        Cancel

                                    </button>

                                    <button

                                        type="submit"

                                        className="eb-bulk-btn eb-bulk-btn-submit"

                                        disabled={loading}

                                        onClick={handleSubmit}

                                        style={{ background: "black" }}

                                    >

                                        {loading ? (

                                            <span className="eb-bulk-btn-loader">

                                                <span className="eb-bulk-spinner"></span>

                                                Submitting...

                                            </span>

                                        ) : (

                                            <>

                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />

                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />

                                                </svg>

                                                Add

                                            </>

                                        )}

                                    </button>

                                </div>

                            </div>

                        </div>

                    )}

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>

            </Modal>

        </>

    );

};

const UpdateOfficeRentInvoice = ({ invoiceData, p_id, invoice_id, getOfficeRentinvoice, month, year, logData = [], usedfor }) => {
    const [show, setShow] = useState(false);
    const [officeRent, setOfficeRent] = useState([]);
    const [logid, setLogId] = useState("null");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [listLoaded, setListLoaded] = useState(false);
    const [rentList, setRentList] = useState([]);
    const [existingRows, setExistingRows] = useState([]);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setListLoaded(false);
        setRentList([]);
        setExistingRows([]);
        setFormData([]);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        setShow(true);
        await getExistingRows();
        await getOfficeRent();
    };

    // ******************* Current month ki already saved rows *******************
    const fetchExistingRows = async () => {
        const res = await axios.get(
            `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${String(month).padStart(2, "0")}/${year}/`
        );
        return Array.isArray(res.data) ? res.data : [];
    };

    const getExistingRows = async () => {
        try {
            const rows = await fetchExistingRows();
            setExistingRows(rows);
            return rows;
        } catch (err) {
            handleErrorToast(err);
            return [];
        }
    };

    const getRowRentId = (row) => row?.officerent ?? row?.officerent_details?.id;

    // ******************* Previous data fetch *******************
    useEffect(() => {
        if (show !== true) return;
        if (!month || !year) {
            console.error("Both month and year are required to fetch progress data.");
            return;
        }

        const getData = async () => {
            try {
                let currentMonth = month - 1 === 0 ? 12 : month - 1;
                let currentYear = month - 1 === 0 ? year - 1 : year;
                let dataFound = false;
                let currentPercent = 0;

                const updateProgress = (percent, label) => {
                    currentPercent = Math.max(currentPercent, percent);
                    setFetchProgress({ percent: currentPercent, label });
                };

                updateProgress(5, "Connecting to server...");

                while (!dataFound) {
                    updateProgress(10, "Fetching previous office rent data...");
                    const response = await axios.get(
                        `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, "0")}/${currentYear}/`
                    );

                    updateProgress(20, "Fetching withheld release data...");
                    const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                    const releaseRawData = releaseResponse.data;

                    const monthInt = parseInt(month, 10);
                    const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, "0");
                    const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                    const filterReleaseData = releaseRawData.filter(
                        (i) =>
                            i.month === monthCalculation &&
                            i.year === calculatedYear &&
                            i?.deduction_data?.project === p_id
                    );

                    const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

                    let localAllResults = [];
                    let localSheetData = [];

                    if (invoiceIds.length > 0) {
                        updateProgress(35, "Fetching consultant invoices...");
                        const res = await axios.get(
                            `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                        );
                        const filteredData = res.data.filter((item) => invoiceIds.includes(item.id));

                        if (filteredData.length > 0) {
                            const months = [...new Set(filteredData.map((i) => i.month))];
                            const years = [...new Set(filteredData.map((i) => i.year))];

                            const totalMonthYearCalls = months.length * years.length;
                            let completedMonthYearCalls = 0;

                            for (const m of months) {
                                for (const y of years) {
                                    try {
                                        const filterRes = await axios.get(
                                            `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id}/${m}/${y}/`
                                        );
                                        localAllResults.push(...filterRes.data);
                                    } catch (err) {
                                        console.error(`Failed for month: ${m}, year: ${y}`, err);
                                    }
                                    completedMonthYearCalls++;
                                    const pct = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                    updateProgress(35 + pct, `Fetching BOQ data for ${m}/${y}...`);
                                }
                            }

                            const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                            const totalIdCalls = allIds.length;
                            let completedIdCalls = 0;

                            for (const id of allIds) {
                                try {
                                    const secondRes = await axios.get(`${BASE_URL}/siteproject/newinvoiceofficerentfilter/${id}/`);
                                    localSheetData.push(...secondRes.data);
                                } catch (err) {
                                    console.error(`Failed for id: ${id}`, err);
                                }
                                completedIdCalls++;
                                const pct = Math.round((completedIdCalls / totalIdCalls) * 15);
                                updateProgress(50 + pct, `Loading rent sheet ${completedIdCalls} of ${totalIdCalls}...`);
                            }
                        }
                    }

                    updateProgress(70, "Processing office rent records...");
                    const data = response.data;
                    let selectedData = [];

                    if (data.length > 0) {
                        const uids = data.map((item) => item.id).filter(Boolean);
                        let uidResults = [];
                        const totalUids = uids.length;
                        let completedUids = 0;

                        for (const uid of uids) {
                            const res = await axios.get(`${BASE_URL}/siteproject/newinvoiceofficerentfilter/${uid}/`);

                            if (!res.data || res.data.length === 0) {
                                console.error(`No data found for UID ${uid}. Breaking loop.`);
                                dataFound = false;
                                break;
                            }

                            uidResults = [...uidResults, ...res.data];
                            completedUids++;
                            const pct = Math.round((completedUids / totalUids) * 15);
                            updateProgress(70 + pct, `Loading rent ${completedUids} of ${totalUids}...`);
                        }

                        if (!dataFound && uidResults.length === 0) break;
                        selectedData = uidResults;
                    } else {
                        updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                        currentMonth -= 1;
                        if (currentMonth === 0) {
                            currentMonth = 12;
                            currentYear -= 1;
                        }
                        if (currentYear < year - 1) {
                            console.error("No data found for the past 1 year.");
                            break;
                        }
                        continue;
                    }

                    if (selectedData.length > 0) {
                        updateProgress(90, "Calculating cumulative totals...");

                        const updatedGetAllResults = localSheetData.map((resultItem) => {
                            const matchingReleases = filterReleaseData.filter(
                                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                            );
                            const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                            const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                            // release_month string aa sakta hai (e.g. "0.20"), isliye Number() zaroori hai
                            const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (Number(r.release_month) || 0), 0);
                            return {
                                id: resultItem?.officerent_details?.id,
                                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                                total_month_release: totalMonthRelease,
                            };
                        });

                        const updatedRentData = selectedData.map((item) => {
                            const boqId = item?.officerent_details?.id;
                            const matchedData = updatedGetAllResults.filter((i) => i.id === boqId);
                            const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                            const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                            const prevAmount = Number(item.previous_invoice_total) || 0;
                            const currentAmount = Number(item.invoice_amount ?? item.current_invoice_amount ?? 0) || 0;
                            const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

                            const prev = Number(item.actual_month_total_previous) || 0;
                            const current = Number(item.actual_month) || 0;
                            const newPrevious = prev + current + totalMonthRelease;

                            return {
                                ...item,
                                updated_previous_invoice_total: newPreviousAmount,
                                updated_actual_month_total_previous: newPrevious,
                            };
                        });

                        updateProgress(100, "Done!");
                        setRentList(updatedRentData);
                        setListLoaded(true);
                        dataFound = true;
                    }
                }

                if (!dataFound) {
                    updateProgress(100, "No previous data found.");
                    setListLoaded(true);
                }
            } catch (error) {
                console.error("Error fetching progress data:", error);
                setFetchProgress({ percent: 100, label: "Error loading data." });
                setListLoaded(true);
            }
        };
        getData();
    }, [month, year, show]);

    // ******************* Revised (BOQ change log) data *******************
    const rentID = officeRent.map((e) => e.id);
    const rentData = (Array.isArray(logData) ? logData : []).filter((item) => rentID.includes(item.object_id));
    const rentChangeReason = officeRent[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        rentData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? officeRent
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ******************* BOQ fetch *******************
    const getOfficeRent = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqofficerentbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setOfficeRent(res.data);
            } else {
                console.error("Error: Expected a list of office rent items");
            }
        } catch (err) {
            console.error("Error fetching office rent data", err);
        }
    };

    // actual_month se invoice / cumulative / remaining nikalta hai (original precision, koi rounding nahi)
    const calcEntry = (entry, actualMonthValue) => {
        const hasEot = entry.eot_details && entry.eot_details.length > 0;
        const lastEOT = hasEot ? entry.eot_details[entry.eot_details.length - 1] : null;

        const rate = hasEot ? Number(lastEOT.rate || 0) : Number(entry.boq_rate_per_month || 0);
        const boqMonths = hasEot
            ? Number(lastEOT.t_month || 0)
            : Number(entry.boq_during_construction_period) + Number(entry.boq_during_dlp_OM_period);
        const total = hasEot ? Number(lastEOT.total_amount || 0) : rate * boqMonths;

        const actualMonth = Number(actualMonthValue) || 0;
        const previous = Number(entry.actual_month_total_previous) || 0;
        const previousAmount = Number(entry.previous_invoice_total) || 0;

        const invoiceAmount = rate * actualMonth;
        const cumulativeMonth = previous + actualMonth;
        const cumulativeAmount = previousAmount + invoiceAmount;

        return {
            ...entry,
            actual_month: actualMonthValue,
            invoice_amount: invoiceAmount,
            actual_month_cumulative_total: cumulativeMonth,
            cumulative_invoice_total: cumulativeAmount,
            actual_month_remaining: boqMonths - cumulativeMonth,
            remaining_amount: total - cumulativeAmount,
        };
    };

    // ******************* Initial form (BOQ + previous data + saved values) *******************
    useEffect(() => {
        if (!listLoaded || officeRent.length === 0) return;

        const usedCount = {};

        const initialData = selectedGroup.map((item) => {
            const rentId = item.object_id ?? item.id;
            const d = logid === "null" ? item : item.data || {};

            const matchedProgress = rentList.find(
                (progress) => (progress.officerent ?? progress.officerent_details?.id) === rentId
            );

            // Saved (current invoice) row, same office rent ke multiple rows ho to order se
            const savedRows = existingRows.filter((r) => String(getRowRentId(r)) === String(rentId));
            const k = usedCount[rentId] || 0;
            usedCount[rentId] = k + 1;
            const saved = savedRows[k];
            const savedMonth = saved?.actual_month ?? "";

            const baseEntry = {
                project: p_id,
                invoice: invoice_id,
                officerent: rentId,
                month: month,
                year: year,
                contract_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_rate_per_month: d.rate_per_month,
                boq_num_of_months: d.num_of_months,
                boq_during_construction_period: d.during_construction_period,
                boq_during_dlp_OM_period: d.during_dlp_OM_period,
                eot_details: d.eot_details?.map((e) => e),
            };

            return calcEntry(baseEntry, savedMonth);
        });

        setFormData(initialData);
    }, [logid, officeRent, rentList, listLoaded, existingRows]);

    useEffect(() => {
        if (!show) return;
        setModalLoading(!listLoaded);
    }, [listLoaded, show]);

    // ******************* Validation *******************
    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            if (entry.actual_month !== "" && entry.actual_month != null && !Number.isFinite(Number(entry.actual_month))) {
                newErrors[`${index}_actual_month`] = "Enter a valid actual month";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Sirf outgoing payload 2 decimal me round hota hai; state original precision me rehti hai
    const POST_TWO_DECIMAL_FIELDS = [
        "actual_month",
        "invoice_amount",
        "actual_month_cumulative_total",
        "cumulative_invoice_total",
        "contract_amount",
        "remaining_amount",
        "actual_month_remaining",
        "previous_invoice_total",
        "actual_month_total_previous",
    ];

    const roundOfficeRentForPost = (entry) => {
        const payload = { ...entry };
        POST_TWO_DECIMAL_FIELDS.forEach((field) => {
            const val = payload[field];
            if (val === "" || val === null || val === undefined) return;
            const numeric = Number(val);
            if (!Number.isFinite(numeric)) {
                throw new Error(`Invalid numeric value for ${field}`);
            }
            payload[field] = Number(numeric.toFixed(2));
        });
        return payload;
    };

    // // ******************* Submit: UPDATE *******************
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (!validateForm() || loading) return;

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing invoiceofficerent rows -> unki id attach karni hai
    //         const freshRows = await fetchExistingRows();

    //         // officerent -> [ids...] (same office rent multiple rows ho to order ke hisaab se)
    //         const idQueue = {};
    //         freshRows.forEach((row) => {
    //             const key = String(getRowRentId(row));
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = formData
    //             .map(roundOfficeRentForPost)
    //             .map((item) => {
    //                 const queue = idQueue[String(item.officerent)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("No existing office rent rows found to update");
    //             return;
    //         }

    //         const res = await axios.put(
    //             `${BASE_URL}/siteproject/invoiceofficerent/bulk-update/`,
    //             payload,
    //             {
    //                 onUploadProgress: (progressEvent) => {
    //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //                     setUploadProgress(percentCompleted);
    //                 },
    //             }
    //         );

    //         if (res.status === 200 || res.status === 201) {
    //             await getOfficeRentinvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Office Rent Invoice Updated Successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         console.error("Office Rent invoice UPDATE failed", {
    //             status: err?.response?.status,
    //             response: err?.response?.data,
    //             message: err?.message,
    //         });
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };


    // ******************* Submit: UPDATE *******************
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm() || loading) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing invoiceofficerent rows -> unki id attach karni hai
            const freshRows = await fetchExistingRows();

            // officerent -> [ids...] (same office rent multiple rows ho to order ke hisaab se)
            const idQueue = {};
            freshRows.forEach((row) => {
                const key = String(getRowRentId(row));
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = formData
                .map(roundOfficeRentForPost)
                .map((item) => {
                    const queue = idQueue[String(item.officerent)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("No existing office rent rows found to update");
                return;
            }

            // 1st API: invoiceofficerent bulk update
            const res = await axios.put(
                `${BASE_URL}/siteproject/invoiceofficerent/bulk-update/`,
                payload,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(Math.min(Math.round(percentCompleted * 0.5), 50));
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: claim (new invoice office rent) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoiceofficerentfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoiceofficerent.id == claim.invoiceofficerent
                const claimPayload = payload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoiceofficerent) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                        // claim ke baaki fields bache rahein
                        ...item,                       // updated invoice data replicate
                        id: row.id,                    // claim row ki apni id
                        invoiceofficerent: item.id,    // link wapas invoiceofficerent se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoiceofficerentupdatedelete/null/`,
                        claimPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("Claim me koi matching invoiceofficerent nahi mili");
                }

                setUploadProgress(100);

                await getOfficeRentinvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Office Rent Invoice Updated Successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            console.error("Office Rent invoice UPDATE failed", {
                status: err?.response?.status,
                response: err?.response?.data,
                message: err?.message,
            });
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    // ******************* Input handler *******************
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;

            if (name === "actual_month") {
                // typed text as-is (e.g. "0.", "0.3222") taaki decimals na ud jaayein
                return calcEntry(entry, value);
            }
            return { ...entry, [name]: value };
        });

        setFormData(updatedFormData);
    };

    return (
        <>
            <button
                title="Update Office Rent"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width50vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                                <polyline points="9 22 9 12 15 12 15 22" />
                            </svg>
                            Update Office Rent {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {officeRent.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {rentChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />

                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>

                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>

                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>

                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}><span className="eb-bulk-th-label">#</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "start" }}><span className="eb-bulk-th-label">Office Rent</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "center" }}><span className="eb-bulk-th-label">Actual Month</span></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.map((entry, index) => (
                                                        <tr key={index} className="eb-bulk-row">
                                                            <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                                {index + 1}.
                                                            </td>

                                                            <td className="eb-bulk-td">
                                                                <span style={{ fontWeight: 500 }}>{entry.boq_num_of_months}</span>
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                                <input
                                                                    type="number"
                                                                    step="any"
                                                                    id={`actual_month_${index}`}
                                                                    name="actual_month"
                                                                    placeholder="Actual Month"
                                                                    value={entry.actual_month ?? ""}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
                                                                    style={{ width: "100px", textAlign: "center" }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};


const UpdateOfficeRentInvoices = ({ i, p_id, invoice_id, getOfficeRentinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
        getOfficeRent();
        setFormData(i);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        month: "",
        current_invoice_amount: "",
        officerent: "",
    });

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "invoice",
            "month",
            "current_invoice_amount",
            "officerent",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [officeRent, setOfficeRent] = useState([]);

    const getOfficeRent = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqofficerentbyproject/${p_id}/`
            );
            setOfficeRent(res.data);
        } catch (err) { }
    };

    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoiceofficerent/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeRentinvoice();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Data updated successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button className="model-edit-button" title="Update Officerent" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Office Rent for Invoice</Modal.Title> </h1>

                            <div title="Office Rent" className="flex-column form-group-selectt">
                                <label htmlFor="officerent" className="form-labels  font-weight500    font-size-subheading">
                                    Office Rent<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="officerent"
                                    name="officerent"
                                    placeholder="Office Rent"
                                    value={formData.officerent}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.officerent ? "error" : inputState.officerent ? "success" : ""}`}
                                >
                                    <option value="">Select Office Rent</option>
                                    {officeRent?.map((i, index) => (
                                        <option key={index} value={i.id}>Months : {i.num_of_months}, Rent : {i.rate_per_month}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.officerent && <span className="error-message font-size-text ">{errors.officerent}</span>}
                            </div>

                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    Current Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>
                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}

                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );

};


const DeleteOfficeRent = ({ i, getOfficeRentinvoice }) => {

    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceofficerent/${i.id}/`);
            if (response.status === 200) {
                getOfficeRentinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Office Rent" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )


}
const DeleteOfficeRentDeduction = ({ i, getOfficeRentinvoice }) => {

    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceofficerent/${i.id}/`);
            if (response.status === 200) {
                getOfficeRentinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Office Rent" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )


}
const DeleteEmployee = ({ i, getData }) => {

    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceemployee/${i.id}/`);
            if (response.status === 200) {
                getData();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Employee" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )


}
const DeleteEmployeeDeduction = ({ i, getData, deductionData, }) => {

    const [show, setShow] = useState(false);

    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);
    const getid = i.id;

    const filterDeductionData = deductionData.filter(i => i.item_id === getid);
    const getDeductionIds = filterDeductionData.map(i => i.id);

    console.log("id to delete :", i.id); // Debugging log
    console.log("Deduction Ids to delete:", getDeductionIds); // Debugging log
    console.log("Deduction Ids to FILTER:", filterDeductionData); // Debugging log
    console.log("Deduction Ids to FILTER:", deductionData); // Debugging log

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/newinvoiceemployeeupdatedelete/${i.id}/`);
            if (response.status === 200) {
                if (getDeductionIds && getDeductionIds.length > 0) {
                    try {
                        for (const deductionId of getDeductionIds) {
                            await axios.delete(
                                `${BASE_URL}/siteproject/invoice-deduction/${deductionId}/`
                            );
                        }
                    } catch (error) {
                        handleErrorToast(error, loadingToastId)

                    }

                }

                getData();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");


            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Employee" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )


}


const OfficeSuppliesInvoice = ({ p_id, invoice_id, usedfor, invoiceData, getOfficeSuppliesinvoice, month, year, logData }) => {
    const [show, setShow] = useState(false);

    // Calculations use the full entered precision. Only API payloads use 2 decimals.
    const asNumber = (value) => {
        const numeric = Number(value);
        return Number.isFinite(numeric) ? numeric : 0;
    };

    const toPostInvoiceRow = (entry) => {
        // Never round BOQ/master rates, EOT, identifiers, or calendar month/year.
        const decimalFields = [
            "actual_month",
            "invoice_amount",
            "actual_month_cumulative_total",
            "cumulative_invoice_total",
            "actual_month_remaining",
            "remaining_amount",
            "previous_invoice_total",
            "actual_month_total_previous",
            "contract_amount",
        ];
        const payload = { ...entry };
        for (const field of decimalFields) {
            if (payload[field] === "" || payload[field] == null) continue;
            const numeric = Number(payload[field]);
            if (!Number.isFinite(numeric)) {
                throw new Error(`Invalid numeric value for ${field}: ${payload[field]}`);
            }
            payload[field] = Number(numeric.toFixed(2));
        }
        return payload;
    };

    const [logid, setLogId] = useState("null");
    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
    const [invoiceIds, setInvoiceIds] = useState([]);
    const [months, setMonths] = useState([]);
    const [years, setyears] = useState([]);
    const [getResults, setGetResults] = useState([]);
    const [getSheetData, setGetSheetData] = useState([]);
    const [getAllResults, setGetAllResults] = useState([]);
    const [getTotalWithId, setGetTotalWithid] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [listLoaded, setListLoaded] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setListLoaded(false);
        setFetchProgress({ percent: 0, label: "" });
    };
    const handleShow = () => {
        getOfficeSupplies();
        setShow(true);
    };
    useEffect(() => {
        if (!show) return;
        if (listLoaded) {
            setModalLoading(false);
        } else {
            setModalLoading(true);
        }
    }, [listLoaded, show]);
    const [formData, setFormData] = useState([]);
    const [officeSupplies, setOfficeSupplies] = useState([]);
    const [officeSuppliesList, setOfficeSuppliesList] = useState([]);
    useEffect(() => {
        if (show === true) {
            if (!month || !year) {
                console.error("Both month and year are required to fetch progress data.");
                return;
            }
            const getData = async () => {
                try {
                    let currentMonth = month - 1 === 0 ? 12 : month - 1;
                    let currentYear = month - 1 === 0 ? year - 1 : year;
                    let dataFound = false;
                    let currentPercent = 0;
                    const updateProgress = (percent, label) => {
                        currentPercent = Math.max(currentPercent, percent);
                        setFetchProgress({ percent: currentPercent, label });
                    };
                    updateProgress(5, "Connecting to server...");
                    while (!dataFound) {
                        updateProgress(10, "Fetching previous office supplies data...");
                        const response = await axios.get(
                            `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
                        );
                        updateProgress(20, "Fetching withheld release data...");
                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                        const releaseRawData = releaseResponse.data;
                        setWithHeldReleaseData(releaseRawData);
                        const monthInt = parseInt(month, 10);
                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;
                        const filterReleaseData = releaseRawData.filter(i =>
                            (i.month === monthCalculation && i.year === calculatedYear) &&
                            i?.deduction_data?.project === p_id
                        );
                        setfilterwithHeldReleaseData(filterReleaseData);
                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
                        setInvoiceIds(invoiceIds);
                        let localAllResults = [];
                        let localSheetData = [];
                        if (invoiceIds.length > 0) {
                            updateProgress(35, "Fetching consultant invoices...");
                            const res = await axios.get(
                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                            );
                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));
                            if (filteredData.length > 0) {
                                const months = [...new Set(filteredData.map(i => i.month))];
                                const years = [...new Set(filteredData.map(i => i.year))];
                                setMonths(months);
                                setyears(years);
                                const totalMonthYearCalls = months.length * years.length;
                                let completedMonthYearCalls = 0;
                                for (const m of months) {
                                    for (const y of years) {
                                        try {
                                            const filterRes = await axios.get(
                                                `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id}/${m}/${y}/`
                                            );
                                            localAllResults.push(...filterRes.data);
                                        } catch (err) {
                                            console.error(`Failed for month: ${m}, year: ${y}`, err);
                                        }
                                        completedMonthYearCalls++;
                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
                                    }
                                }
                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
                                const totalIdCalls = allIds.length;
                                let completedIdCalls = 0;
                                for (const id of allIds) {
                                    try {
                                        const secondRes = await axios.get(
                                            `${BASE_URL}/siteproject/newinvoiceofficesupplies/${id}/`
                                        );
                                        localSheetData.push(...secondRes.data);
                                    } catch (err) {
                                        console.error(`Failed for id: ${id}`, err);
                                    }
                                    completedIdCalls++;
                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
                                    updateProgress(50 + idPercent, `Loading supplies sheet ${completedIdCalls} of ${totalIdCalls}...`);
                                }
                                setGetSheetData(localSheetData);
                                const getboqIds = localAllResults.map(i => i?.officesupplies_details?.id);
                                setGetResults(getboqIds);
                                setGetAllResults(localAllResults);
                            }
                        }
                        updateProgress(70, "Processing office supplies records...");
                        const data = response.data;
                        let selectedData = [];
                        if (data.length > 0) {
                            const uids = data.map(item => item.id).filter(Boolean);
                            let uidResults = [];
                            const totalUids = uids.length;
                            let completedUids = 0;
                            for (const uid of uids) {
                                const res = await axios.get(
                                    `${BASE_URL}/siteproject/newinvoiceofficesupplies/${uid}/`
                                );
                                if (!res.data || res.data.length === 0) {
                                    console.error(`No data found for UID ${uid}. Breaking loop.`);
                                    dataFound = false;
                                    break;
                                }
                                uidResults = [...uidResults, ...res.data];
                                completedUids++;
                                const uidPercent = Math.round((completedUids / totalUids) * 15);
                                updateProgress(70 + uidPercent, `Loading supplies ${completedUids} of ${totalUids}...`);
                            }
                            if (!dataFound && uidResults.length === 0) break;
                            selectedData = uidResults;
                        } else {
                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);
                            currentMonth -= 1;
                            if (currentMonth === 0) {
                                currentMonth = 12;
                                currentYear -= 1;
                            }
                            if (currentYear < year - 1) {
                                console.error("No data found for the past 1 year.");
                                break;
                            }
                            continue;
                        }
                        if (selectedData.length > 0) {
                            updateProgress(90, "Calculating cumulative totals...");
                            const updatedGetAllResults = localSheetData.map((resultItem) => {
                                const matchingReleases = filterReleaseData.filter(
                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                                );
                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + asNumber(r.release_month), 0);
                                const total = totalReleaseAmount + totalDeductionAmount;
                                return { id: resultItem?.officesupplies_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
                            });
                            setGetTotalWithid(updatedGetAllResults);
                            const updatedData = selectedData.map((item) => {
                                const boqId = item?.officesupplies_details?.id;
                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);
                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);
                                const prevAmount = parseFloat(item.previous_invoice_total || 0);
                                const currentAmount = asNumber(item.invoice_amount ?? item.current_invoice_amount);
                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;
                                const prev = parseFloat(item.actual_month_total_previous || 0);
                                const current = parseFloat(item.actual_month || 0);
                                const newPrevious = prev + current + totalMonthRelease;
                                return {
                                    ...item,
                                    updated_previous_invoice_total: newPreviousAmount,
                                    updated_actual_month_total_previous: newPrevious,
                                };
                            });
                            updateProgress(100, "Done!");
                            setOfficeSuppliesList(updatedData);
                            setListLoaded(true);
                            dataFound = true;
                        }
                    }
                    if (!dataFound) {
                        updateProgress(100, "No previous data found.");
                        setListLoaded(true);
                    }
                } catch (error) {
                    console.error("Error fetching progress data:", error);
                    setFetchProgress({ percent: 100, label: "Error loading data." });
                    setListLoaded(true);
                }
            };
            getData();
        }
    }, [month, year, show]);
    const officeSuppliesID = officeSupplies.map(e => e.id);
    const officeSuppliesData = logData.filter(item => officeSuppliesID.includes(item.object_id));
    const officeSuppliesChangeReason = officeSupplies[0]?.reason_of_change || "";
    const groupedByRandomChange = Object.entries(
        officeSuppliesData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));
    const selectedGroup = logid === "null"
        ? officeSupplies
        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];
    const getOfficeSupplies = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqofficesuppliesbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setOfficeSupplies(res.data);
            } else {
                console.error("Error: Expected a list of office supplies items");
            }
        } catch (err) {
            console.error("Error fetching office supplies data", err);
        }
    };
    useEffect(() => {
        if (officeSupplies.length === 0) return;
        const initialData = selectedGroup.map((item) => {
            const suppliesId = item.object_id ?? item.id;
            const matchedProgress = officeSuppliesList.find((progress) => progress.officesupplies === suppliesId);
            let eot_details;
            if (logid === "null") {
                eot_details = item.eot_details?.map((item) => item);
            } else {
                eot_details = item?.data?.eot_details?.map((item) => item);
            }
            return {
                project: p_id,
                invoice: invoice_id,
                officesupplies: suppliesId,
                actual_month: "",
                month: month,
                year: year,
                actual_month_cumulative_total: "",
                cumulative_invoice_total: "",
                contract_amount: "",
                remaining_amount: "",
                actual_month_remaining: "",
                invoice_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_monthly_rate: item.monthly_rate ?? item.data?.monthly_rate,
                boq_months: item.months ?? item.data?.months,
                boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,
                eot_details: eot_details,
                boq_item: item.item ?? item?.data?.item,
                boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,
            };
        });
        setFormData(initialData);
    }, [logid, officeSupplies, officeSuppliesList]);
    const [errors, setErrors] = useState({});
    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            const requiredFields = [];
            requiredFields.forEach(field => {
                if (!entry[field]) {
                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const [loading, setLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || !validateForm()) return;

        let postRows;
        try {
            // Make a copy: formData keeps the original full-precision values.
            postRows = formData.map(toPostInvoiceRow);
        } catch (error) {
            toast.error(error.message);
            return;
        }

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            let createdData;
            if (usedfor === "InvoiceandDeduction") {
                const response = await axios.post(
                    `${BASE_URL}/siteproject/bulkinvoiceofficesupplies/`,
                    postRows
                );
                if (response.status !== 201) {
                    throw new Error("First Office Supplies API failed");
                }
                createdData = response.data;
            } else if (usedfor === "OnlyInvoice" || usedfor === "OnlyDeduction") {
                createdData = invoiceData;
            } else {
                throw new Error(`Unsupported submission mode: ${usedfor}`);
            }

            if (!Array.isArray(createdData) || createdData.length < postRows.length) {
                throw new Error("Missing Office Supplies invoice records/IDs from first API");
            }

            // Use the already-rounded POST rows, not a stale derived state array.
            const mappedFinalData = postRows.map((item, index) => ({
                ...item,
                invoiceofficesupplies: createdData[index]?.id,
            }));
            if (mappedFinalData.some(row => row.invoiceofficesupplies == null)) {
                throw new Error("Missing invoiceofficesupplies ID from the first API response");
            }

            const res2 = await axios.post(
                `${BASE_URL}/siteproject/newinvoiceofficesupplieslistcreate/`,
                mappedFinalData
            );
            if (res2.status !== 201) {
                throw new Error("Second Office Supplies API failed");
            }

            await getOfficeSuppliesinvoice();
            setShow(false);
            toast.dismiss(loadingToastId);
            toast.success("Office Supplies data added successfully");
        } catch (error) {
            console.error("Office Supplies POST failed:", {
                status: error?.response?.status,
                response: error?.response?.data,
                message: error?.message,
            });
            handleErrorToast(error, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;
            const updatedEntry = { ...entry, [name]: value };
            let rate;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                rate = Number(lastEOT.rate || 0);
            } else {
                rate = Number(entry.boq_monthly_rate || 0);
            }
            const cp = entry.boq_during_construction_period;
            const dlp = entry.boq_during_dlp_OM_period;
            let month;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                month = Number(lastEOT.t_month || 0);
            } else {
                month = Number(cp) + Number(dlp);
            }
            let total;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                total = Number(lastEOT.total_amount || 0);
            } else {
                total = Number(rate) * Number(month);
            }
            // Preserve the exact input string while typing. Never round intermediates.
            const previous = asNumber(entry.actual_month_total_previous);
            const previousAmount = asNumber(entry.previous_invoice_total);
            const actualMonth = asNumber(updatedEntry.actual_month);

            updatedEntry.invoice_amount = rate * actualMonth;
            updatedEntry.actual_month_cumulative_total = previous + actualMonth;
            updatedEntry.cumulative_invoice_total = previousAmount + updatedEntry.invoice_amount;
            updatedEntry.actual_month_remaining = month - updatedEntry.actual_month_cumulative_total;
            updatedEntry.remaining_amount = total - updatedEntry.cumulative_invoice_total;
            return updatedEntry;
        });
        setFormData(updatedFormData);
    };
    return (
        <>
            <button title="Add Office Supplies" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Office Supplies {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
                <Modal.Header className="eb-bulk-modal-header">
                    <Modal.Title className="eb-bulk-modal-title">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M9 17H5a2 2 0 00-2 2" />
                            <path d="M15 17h4a2 2 0 012 2" />
                            <path d="M12 3v14" />
                            <path d="M8 7l4-4 4 4" />
                        </svg>
                        Add Office Supplies {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                    </Modal.Title>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {(officeSupplies.length > 0 && groupedByRandomChange.length > 0) && (
                            <select
                                value={logid}
                                onChange={(e) => setLogId(e.target.value)}
                                style={{
                                    fontSize: "13px",
                                    background: "var(--surface-2, #fff)",
                                    border: "0.5px solid var(--border-strong, #ccc)",
                                    borderRadius: "var(--radius, 8px)",
                                    padding: "4px 10px",
                                    cursor: "pointer",
                                    color: "var(--text-primary)",
                                }}
                            >
                                <option value="null">
                                    BOQ {groupedByRandomChange.length + 1} - {officeSuppliesChangeReason}
                                </option>
                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                    const reasons = [...new Set(
                                        items.map(i => i.data?.reason_of_change).filter(reason =>
                                            reason !== null && reason !== "null" && reason?.trim() !== ""
                                        )
                                    )];
                                    return (
                                        <option key={groupKey} value={groupKey}>
                                            BOQ {groupedByRandomChange.length - index}
                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                        </option>
                                    );
                                })}
                            </select>
                        )}
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </div>
                </Modal.Header>
                <Modal.Body className="eb-bulk-modal-body">
                    {modalLoading ? (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "50vh",
                            gap: "20px",
                            padding: "40px",
                        }}>
                            <div style={{
                                width: "44px",
                                height: "44px",
                                border: "3px solid #e0e0e0",
                                borderTop: "3px solid #000",
                                borderRadius: "50%",
                                animation: "eb-spin 0.8s linear infinite",
                            }} />
                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                {fetchProgress.label || "Loading data..."}
                            </p>
                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                <div style={{
                                    height: "100%",
                                    width: `${fetchProgress.percent}%`,
                                    background: "#111",
                                    borderRadius: "999px",
                                    transition: "width 0.3s ease",
                                }} />
                            </div>
                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                {fetchProgress.percent}%
                            </p>
                            <style>{`
                                @keyframes eb-spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    ) : (
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                                        <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                            <thead className="eb-bulk-table-head">
                                                <tr className="eb-bulk-table-header-row">
                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                        <span className="eb-bulk-th-label">#</span>
                                                    </th>
                                                    <th className="eb-bulk-th text-start">
                                                        <span className="eb-bulk-th-label ">Office Supplies</span>
                                                    </th>
                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>
                                                        <span className="eb-bulk-th-label">Actual Month</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.map((entry, index) => (
                                                    <tr key={index} className="eb-bulk-row">
                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                            {index + 1}.
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <span style={{ fontWeight: 500 }}>{entry.boq_months}</span>
                                                        </td>
                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                            <input
                                                                type="number"
                                                                step="any"
                                                                id={`actual_month_${index}`}
                                                                name="actual_month"
                                                                placeholder="Actual Month"
                                                                value={entry.actual_month}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
                                                                style={{ width: "100px", textAlign: "center" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="eb-bulk-footer-actions">
                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateOfficeSuppliesInvoice = ({ invoiceData, p_id, invoice_id, getOfficeSuppliesinvoice, month, year, logData = [], usedfor }) => {
    const [show, setShow] = useState(false);
    const [officeSupplies, setOfficeSupplies] = useState([]);
    const [logid, setLogId] = useState("null");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [formData, setFormData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const [listLoaded, setListLoaded] = useState(false);
    const [officeSuppliesList, setOfficeSuppliesList] = useState([]);
    const [existingRows, setExistingRows] = useState([]);

    // Calculations full precision me hote hain. Sirf API payload 2 decimal me round hota hai.
    const asNumber = (value) => {
        const numeric = Number(value);
        return Number.isFinite(numeric) ? numeric : 0;
    };

    const toPostInvoiceRow = (entry) => {
        // BOQ rates, EOT, ids, calendar month/year kabhi round nahi hote.
        const decimalFields = [
            "actual_month",
            "invoice_amount",
            "actual_month_cumulative_total",
            "cumulative_invoice_total",
            "actual_month_remaining",
            "remaining_amount",
            "previous_invoice_total",
            "actual_month_total_previous",
            "contract_amount",
        ];
        const payload = { ...entry };
        for (const field of decimalFields) {
            if (payload[field] === "" || payload[field] == null) continue;
            const numeric = Number(payload[field]);
            if (!Number.isFinite(numeric)) {
                throw new Error(`Invalid numeric value for ${field}: ${payload[field]}`);
            }
            payload[field] = Number(numeric.toFixed(2));
        }
        return payload;
    };

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setListLoaded(false);
        setOfficeSuppliesList([]);
        setExistingRows([]);
        setFormData([]);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        setShow(true);
        await getExistingRows();
        await getOfficeSupplies();
    };

    // ******************* Current month ki already saved rows *******************
    const fetchExistingRows = async () => {
        const res = await axios.get(
            `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id}/${String(month).padStart(2, "0")}/${year}/`
        );
        return Array.isArray(res.data) ? res.data : [];
    };

    const getExistingRows = async () => {
        try {
            const rows = await fetchExistingRows();
            setExistingRows(rows);
            return rows;
        } catch (err) {
            handleErrorToast(err);
            return [];
        }
    };

    const getRowSuppliesId = (row) => row?.officesupplies ?? row?.officesupplies_details?.id;

    // ******************* Previous data fetch *******************
    useEffect(() => {
        if (show !== true) return;
        if (!month || !year) {
            console.error("Both month and year are required to fetch progress data.");
            return;
        }

        const getData = async () => {
            try {
                let currentMonth = month - 1 === 0 ? 12 : month - 1;
                let currentYear = month - 1 === 0 ? year - 1 : year;
                let dataFound = false;
                let currentPercent = 0;

                const updateProgress = (percent, label) => {
                    currentPercent = Math.max(currentPercent, percent);
                    setFetchProgress({ percent: currentPercent, label });
                };

                updateProgress(5, "Connecting to server...");

                while (!dataFound) {
                    updateProgress(10, "Fetching previous office supplies data...");
                    const response = await axios.get(
                        `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id}/${String(currentMonth).padStart(2, "0")}/${currentYear}/`
                    );

                    updateProgress(20, "Fetching withheld release data...");
                    const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                    const releaseRawData = releaseResponse.data;

                    const monthInt = parseInt(month, 10);
                    const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, "0");
                    const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                    const filterReleaseData = releaseRawData.filter(
                        (i) =>
                            i.month === monthCalculation &&
                            i.year === calculatedYear &&
                            i?.deduction_data?.project === p_id
                    );

                    const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

                    let localAllResults = [];
                    let localSheetData = [];

                    if (invoiceIds.length > 0) {
                        updateProgress(35, "Fetching consultant invoices...");
                        const res = await axios.get(
                            `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                        );
                        const filteredData = res.data.filter((item) => invoiceIds.includes(item.id));

                        if (filteredData.length > 0) {
                            const months = [...new Set(filteredData.map((i) => i.month))];
                            const years = [...new Set(filteredData.map((i) => i.year))];

                            const totalMonthYearCalls = months.length * years.length;
                            let completedMonthYearCalls = 0;

                            for (const m of months) {
                                for (const y of years) {
                                    try {
                                        const filterRes = await axios.get(
                                            `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id}/${m}/${y}/`
                                        );
                                        localAllResults.push(...filterRes.data);
                                    } catch (err) {
                                        console.error(`Failed for month: ${m}, year: ${y}`, err);
                                    }
                                    completedMonthYearCalls++;
                                    const pct = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                    updateProgress(35 + pct, `Fetching BOQ data for ${m}/${y}...`);
                                }
                            }

                            const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                            const totalIdCalls = allIds.length;
                            let completedIdCalls = 0;

                            for (const id of allIds) {
                                try {
                                    const secondRes = await axios.get(`${BASE_URL}/siteproject/newinvoiceofficesupplies/${id}/`);
                                    localSheetData.push(...secondRes.data);
                                } catch (err) {
                                    console.error(`Failed for id: ${id}`, err);
                                }
                                completedIdCalls++;
                                const pct = Math.round((completedIdCalls / totalIdCalls) * 15);
                                updateProgress(50 + pct, `Loading supplies sheet ${completedIdCalls} of ${totalIdCalls}...`);
                            }
                        }
                    }

                    updateProgress(70, "Processing office supplies records...");
                    const data = response.data;
                    let selectedData = [];

                    if (data.length > 0) {
                        const uids = data.map((item) => item.id).filter(Boolean);
                        let uidResults = [];
                        const totalUids = uids.length;
                        let completedUids = 0;

                        for (const uid of uids) {
                            const res = await axios.get(`${BASE_URL}/siteproject/newinvoiceofficesupplies/${uid}/`);

                            if (!res.data || res.data.length === 0) {
                                console.error(`No data found for UID ${uid}. Breaking loop.`);
                                dataFound = false;
                                break;
                            }

                            uidResults = [...uidResults, ...res.data];
                            completedUids++;
                            const pct = Math.round((completedUids / totalUids) * 15);
                            updateProgress(70 + pct, `Loading supplies ${completedUids} of ${totalUids}...`);
                        }

                        if (!dataFound && uidResults.length === 0) break;
                        selectedData = uidResults;
                    } else {
                        updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                        currentMonth -= 1;
                        if (currentMonth === 0) {
                            currentMonth = 12;
                            currentYear -= 1;
                        }
                        if (currentYear < year - 1) {
                            console.error("No data found for the past 1 year.");
                            break;
                        }
                        continue;
                    }

                    if (selectedData.length > 0) {
                        updateProgress(90, "Calculating cumulative totals...");

                        const updatedGetAllResults = localSheetData.map((resultItem) => {
                            const matchingReleases = filterReleaseData.filter(
                                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                            );
                            const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                            const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                            const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + asNumber(r.release_month), 0);
                            return {
                                id: resultItem?.officesupplies_details?.id,
                                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                                total_month_release: totalMonthRelease,
                            };
                        });

                        const updatedData = selectedData.map((item) => {
                            const boqId = item?.officesupplies_details?.id;
                            const matchedData = updatedGetAllResults.filter((i) => i.id === boqId);
                            const totalReleaseAmount = matchedData.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                            const totalMonthRelease = matchedData.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                            const prevAmount = parseFloat(item.previous_invoice_total || 0);
                            const currentAmount = asNumber(item.invoice_amount ?? item.current_invoice_amount);
                            const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

                            const prev = parseFloat(item.actual_month_total_previous || 0);
                            const current = parseFloat(item.actual_month || 0);
                            const newPrevious = prev + current + totalMonthRelease;

                            return {
                                ...item,
                                updated_previous_invoice_total: newPreviousAmount,
                                updated_actual_month_total_previous: newPrevious,
                            };
                        });

                        updateProgress(100, "Done!");
                        setOfficeSuppliesList(updatedData);
                        setListLoaded(true);
                        dataFound = true;
                    }
                }

                if (!dataFound) {
                    updateProgress(100, "No previous data found.");
                    setListLoaded(true);
                }
            } catch (error) {
                console.error("Error fetching progress data:", error);
                setFetchProgress({ percent: 100, label: "Error loading data." });
                setListLoaded(true);
            }
        };
        getData();
    }, [month, year, show]);

    // ******************* Revised (BOQ change log) data *******************
    const officeSuppliesID = officeSupplies.map((e) => e.id);
    const officeSuppliesData = (Array.isArray(logData) ? logData : []).filter((item) => officeSuppliesID.includes(item.object_id));
    const officeSuppliesChangeReason = officeSupplies[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        officeSuppliesData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? officeSupplies
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ******************* BOQ fetch *******************
    const getOfficeSupplies = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqofficesuppliesbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setOfficeSupplies(res.data);
            } else {
                console.error("Error: Expected a list of office supplies items");
            }
        } catch (err) {
            console.error("Error fetching office supplies data", err);
        }
    };

    // actual_month se invoice / cumulative / remaining nikalta hai (original precision, koi rounding nahi)
    const calcEntry = (entry, actualMonthValue) => {
        const hasEot = entry.eot_details && entry.eot_details.length > 0;
        const lastEOT = hasEot ? entry.eot_details[entry.eot_details.length - 1] : null;

        const rate = hasEot ? Number(lastEOT.rate || 0) : Number(entry.boq_monthly_rate || 0);
        const boqMonths = hasEot
            ? Number(lastEOT.t_month || 0)
            : Number(entry.boq_during_construction_period) + Number(entry.boq_during_dlp_OM_period);
        const total = hasEot ? Number(lastEOT.total_amount || 0) : rate * boqMonths;

        const actualMonth = asNumber(actualMonthValue);
        const previous = asNumber(entry.actual_month_total_previous);
        const previousAmount = asNumber(entry.previous_invoice_total);

        const invoiceAmount = rate * actualMonth;
        const cumulativeMonth = previous + actualMonth;
        const cumulativeAmount = previousAmount + invoiceAmount;

        return {
            ...entry,
            actual_month: actualMonthValue,
            invoice_amount: invoiceAmount,
            actual_month_cumulative_total: cumulativeMonth,
            cumulative_invoice_total: cumulativeAmount,
            actual_month_remaining: boqMonths - cumulativeMonth,
            remaining_amount: total - cumulativeAmount,
        };
    };

    // ******************* Initial form (BOQ + previous data + saved values) *******************
    useEffect(() => {
        if (!listLoaded || officeSupplies.length === 0) return;

        const usedCount = {};

        const initialData = selectedGroup.map((item) => {
            const suppliesId = item.object_id ?? item.id;
            const d = logid === "null" ? item : item.data || {};

            const matchedProgress = officeSuppliesList.find(
                (progress) => (progress.officesupplies ?? progress.officesupplies_details?.id) === suppliesId
            );

            // Saved (current invoice) row, same item ke multiple rows ho to order se
            const savedRows = existingRows.filter((r) => String(getRowSuppliesId(r)) === String(suppliesId));
            const k = usedCount[suppliesId] || 0;
            usedCount[suppliesId] = k + 1;
            const saved = savedRows[k];
            const savedMonth = saved?.actual_month ?? "";

            const baseEntry = {
                project: p_id,
                invoice: invoice_id,
                officesupplies: suppliesId,
                month: month,
                year: year,
                contract_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_monthly_rate: d.monthly_rate,
                boq_months: d.months,
                boq_during_construction_period: d.during_construction_period,
                boq_during_dlp_OM_period: d.during_dlp_OM_period,
                boq_item: d.item,
                eot_details: d.eot_details?.map((e) => e),
            };

            return calcEntry(baseEntry, savedMonth);
        });

        setFormData(initialData);
    }, [logid, officeSupplies, officeSuppliesList, listLoaded, existingRows]);

    useEffect(() => {
        if (!show) return;
        setModalLoading(!listLoaded);
    }, [listLoaded, show]);

    // ******************* Validation *******************
    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            if (entry.actual_month !== "" && entry.actual_month != null && !Number.isFinite(Number(entry.actual_month))) {
                newErrors[`${index}_actual_month`] = "Enter a valid actual month";
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // // ******************* Submit: UPDATE *******************
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (loading || !validateForm()) return;

    //     let postRows;
    //     try {
    //         // formData original precision me rehta hai, sirf copy round hoti hai
    //         postRows = formData.map(toPostInvoiceRow);
    //     } catch (error) {
    //         toast.error(error.message);
    //         return;
    //     }

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing invoiceofficesupplies rows -> unki id attach karni hai
    //         const freshRows = await fetchExistingRows();

    //         // officesupplies -> [ids...] (same item multiple rows ho to order ke hisaab se)
    //         const idQueue = {};
    //         freshRows.forEach((row) => {
    //             const key = String(getRowSuppliesId(row));
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = postRows
    //             .map((item) => {
    //                 const queue = idQueue[String(item.officesupplies)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("No existing office supplies rows found to update");
    //             return;
    //         }

    //         const res = await axios.put(
    //             `${BASE_URL}/siteproject/invoiceofficesupplies/bulk-update/`,
    //             payload,
    //             {
    //                 onUploadProgress: (progressEvent) => {
    //                     const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    //                     setUploadProgress(percentCompleted);
    //                 },
    //             }
    //         );

    //         if (res.status === 200 || res.status === 201) {
    //             await getOfficeSuppliesinvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Office Supplies Invoice Updated Successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         console.error("Office Supplies UPDATE failed:", {
    //             status: err?.response?.status,
    //             response: err?.response?.data,
    //             message: err?.message,
    //         });
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };

    // ******************* Submit: UPDATE *******************
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || !validateForm()) return;

        let postRows;
        try {
            // formData original precision me rehta hai, sirf copy round hoti hai
            postRows = formData.map(toPostInvoiceRow);
        } catch (error) {
            toast.error(error.message);
            return;
        }

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing invoiceofficesupplies rows -> unki id attach karni hai
            const freshRows = await fetchExistingRows();

            // officesupplies -> [ids...] (same item multiple rows ho to order ke hisaab se)
            const idQueue = {};
            freshRows.forEach((row) => {
                const key = String(getRowSuppliesId(row));
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = postRows
                .map((item) => {
                    const queue = idQueue[String(item.officesupplies)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("No existing office supplies rows found to update");
                return;
            }

            // 1st API: invoiceofficesupplies bulk update
            const res = await axios.put(
                `${BASE_URL}/siteproject/invoiceofficesupplies/bulk-update/`,
                payload,
                {
                    onUploadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        setUploadProgress(Math.min(Math.round(percentCompleted * 0.5), 50));
                    },
                }
            );

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: claim (new invoice office supplies) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoiceofficesuppliesfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoiceofficesupplies.id == claim.invoiceofficesupplies
                const claimPayload = payload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoiceofficesupplies) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                            // claim ke baaki fields bache rahein
                        ...item,                           // updated invoice data replicate
                        id: row.id,                        // claim row ki apni id
                        invoiceofficesupplies: item.id,    // link wapas invoiceofficesupplies se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoiceofficesuppliesupdatedelete/null/`,
                        claimPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("Claim me koi matching invoiceofficesupplies nahi mili");
                }

                setUploadProgress(100);

                await getOfficeSuppliesinvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Office Supplies Invoice Updated Successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            console.error("Office Supplies UPDATE failed:", {
                status: err?.response?.status,
                response: err?.response?.data,
                message: err?.message,
            });
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };
    // ******************* Input handler *******************
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;

            if (name === "actual_month") {
                // typed text as-is (e.g. "0.", "0.3222") taaki decimals na ud jaayein
                return calcEntry(entry, value);
            }
            return { ...entry, [name]: value };
        });

        setFormData(updatedFormData);
    };

    return (
        <>
            <button
                title="Update Office Supplies"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Office Supplies {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal
                    show={show}
                    onHide={handleClose}
                    dialogClassName="eb-bulk-modal model-width50vw max-heightModal"
                >
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 17H5a2 2 0 00-2 2" />
                                <path d="M15 17h4a2 2 0 012 2" />
                                <path d="M12 3v14" />
                                <path d="M8 7l4-4 4 4" />
                            </svg>
                            Update Office Supplies {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {officeSupplies.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {officeSuppliesChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />

                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>

                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>

                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>

                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}><span className="eb-bulk-th-label">#</span></th>
                                                        <th className="eb-bulk-th text-start"><span className="eb-bulk-th-label">Office Supplies</span></th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "center" }}><span className="eb-bulk-th-label">Actual Month</span></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.map((entry, index) => (
                                                        <tr key={index} className="eb-bulk-row">
                                                            <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                                {index + 1}.
                                                            </td>

                                                            <td className="eb-bulk-td">
                                                                <span style={{ fontWeight: 500 }}>{entry.boq_months}</span>
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                                <input
                                                                    type="number"
                                                                    step="any"
                                                                    id={`actual_month_${index}`}
                                                                    name="actual_month"
                                                                    placeholder="Actual Month"
                                                                    value={entry.actual_month ?? ""}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
                                                                    style={{ width: "100px", textAlign: "center" }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};
const UpdateOfficeSuppliesInvoices = ({ i, p_id, invoice_id, getOfficeSuppliesinvoice }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false);
    }

    const handleShow = () => {
        setShow(true);
        getOfficeSupplies();
        setFormData(i);
    }

    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        month: "",
        current_invoice_amount: "",
        officesupplies: "",
    });

    const [officeSupplies, setOfficeSupplies] = useState([]);

    const getOfficeSupplies = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqofficesuppliesbyproject/${p_id}/`);
            setOfficeSupplies(res.data);
        } catch (err) { }
    };

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "invoice",
            "month",
            "current_invoice_amount",
            "officesupplies",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoiceofficesupplies/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getOfficeSuppliesinvoice();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Data updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };


    return (
        <>
            <button className="model-edit-button" title="Update Office Supplies" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Office Supplies for Invoice</Modal.Title> </h1>

                            <div title="Office Supplies" className="flex-column form-group-selectt">
                                <label htmlFor="officesupplies" className="form-labels  font-weight500    font-size-subheading">
                                    Office Supplies<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="officesupplies"
                                    name="officesupplies"
                                    placeholder="Office Supplies"
                                    value={formData.officesupplies}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.officesupplies ? "error" : inputState.officesupplies ? "success" : ""}`}
                                >
                                    <option value="">Select Office Supplies</option>
                                    {officeSupplies?.sort((a, b) => a.item.localeCompare(b.item, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.item}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.officesupplies && <span className="error-message font-size-text ">{errors.officesupplies}</span>}
                            </div>

                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    Current Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>
                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}

                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}


const DeleteOfficeSuppliesInvoice = ({ i, getOfficeSuppliesinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceofficesupplies/${i.id}/`);
            if (response.status === 200) {
                getOfficeSuppliesinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Office Supplies" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.officesupplies_details.item}</Modal.Title> </h1>
                        Are You Sure You Want to Delete {i.officesupplies_details.item}
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )
}
const DeleteOfficeSuppliesInvoiceDeduction = ({ i, getOfficeSuppliesinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceofficesupplies/${i.id}/`);
            if (response.status === 200) {
                getOfficeSuppliesinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Office Supplies" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete </Modal.Title> </h1>
                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )
}




const OfficeFurnitureInvoice = ({ p_id, invoice_id, usedfor, invoiceData, getOfficeFurnitureinvoice, month, year, logData }) => {

    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState([]);

    const [officeFurniture, setOfficeFurniture] = useState([]);

    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(false);

    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);

    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);

    const [invoiceIds, setInvoiceIds] = useState([]);

    const [months, setMonths] = useState([]);

    const [years, setyears] = useState([]);

    const [getResults, setGetResults] = useState([]);

    const [getSheetData, setGetSheetData] = useState([]);

    const [getAllResults, setGetAllResults] = useState([]);

    const [getTotalWithId, setGetTotalWithid] = useState([]);

    const [modalLoading, setModalLoading] = useState(false);

    const [listLoaded, setListLoaded] = useState(false);

    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });

    const handleClose = () => {

        setShow(false);

        setModalLoading(false);

        setListLoaded(false);

        setFetchProgress({ percent: 0, label: "" });

    };

    const handleShow = async () => {

        await getOfficeFurniture();

        setShow(true);

    };

    useEffect(() => {

        if (!show) return;

        if (listLoaded) {

            setModalLoading(false);

        } else {

            setModalLoading(true);

        }

    }, [listLoaded, show]);

    const [officeFurnitureList, setOfficeFurnitureList] = useState([]);

    useEffect(() => {

        if (show === true) {

            if (!month || !year) {

                console.error("Both month and year are required to fetch progress data.");

                return;

            }

            const getData = async () => {

                try {

                    let currentMonth = month - 1 === 0 ? 12 : month - 1;

                    let currentYear = month - 1 === 0 ? year - 1 : year;

                    let dataFound = false;

                    let currentPercent = 0;

                    const updateProgress = (percent, label) => {

                        currentPercent = Math.max(currentPercent, percent);

                        setFetchProgress({ percent: currentPercent, label });

                    };

                    updateProgress(5, "Connecting to server...");

                    while (!dataFound) {

                        updateProgress(10, "Fetching previous furniture data...");

                        const response = await axios.get(

                            `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`

                        );

                        updateProgress(20, "Fetching withheld release data...");

                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);

                        const releaseRawData = releaseResponse.data;

                        setWithHeldReleaseData(releaseRawData);

                        const monthInt = parseInt(month, 10);

                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');

                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                        const filterReleaseData = releaseRawData.filter(i =>

                            (i.month === monthCalculation && i.year === calculatedYear) &&

                            i?.deduction_data?.project === p_id

                        );

                        setfilterwithHeldReleaseData(filterReleaseData);

                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];

                        setInvoiceIds(invoiceIds);

                        let localAllResults = [];

                        let localSheetData = [];

                        if (invoiceIds.length > 0) {

                            updateProgress(35, "Fetching consultant invoices...");

                            const res = await axios.get(

                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`

                            );

                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

                            if (filteredData.length > 0) {

                                const months = [...new Set(filteredData.map(i => i.month))];

                                const years = [...new Set(filteredData.map(i => i.year))];

                                setMonths(months);

                                setyears(years);

                                const totalMonthYearCalls = months.length * years.length;

                                let completedMonthYearCalls = 0;

                                for (const m of months) {

                                    for (const y of years) {

                                        try {

                                            const filterRes = await axios.get(

                                                `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id}/${m}/${y}/`

                                            );

                                            localAllResults.push(...filterRes.data);

                                        } catch (err) {

                                            console.error(`Failed for month: ${m}, year: ${y}`, err);

                                        }

                                        completedMonthYearCalls++;

                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);

                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);

                                    }

                                }

                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];

                                const totalIdCalls = allIds.length;

                                let completedIdCalls = 0;

                                for (const id of allIds) {

                                    try {

                                        const secondRes = await axios.get(

                                            `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfilter/${id}/`

                                        );

                                        localSheetData.push(...secondRes.data);

                                    } catch (err) {

                                        console.error(`Failed for id: ${id}`, err);

                                    }

                                    completedIdCalls++;

                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);

                                    updateProgress(50 + idPercent, `Loading furniture sheet ${completedIdCalls} of ${totalIdCalls}...`);

                                }

                                setGetSheetData(localSheetData);

                                const getboqIds = localAllResults.map(i => i?.officefurniture_details?.id);

                                setGetResults(getboqIds);

                                setGetAllResults(localAllResults);

                            }

                        }

                        updateProgress(70, "Processing furniture records...");

                        const data = response.data;

                        let selectedData = [];

                        if (data.length > 0) {

                            const uids = data.map(item => item.id).filter(Boolean);

                            let uidResults = [];

                            const totalUids = uids.length;

                            let completedUids = 0;

                            for (const uid of uids) {

                                const res = await axios.get(

                                    `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfilter/${uid}/`

                                );

                                if (!res.data || res.data.length === 0) {

                                    console.error(`No data found for UID ${uid}. Breaking loop.`);

                                    dataFound = false;

                                    break;

                                }

                                uidResults = [...uidResults, ...res.data];

                                completedUids++;

                                const uidPercent = Math.round((completedUids / totalUids) * 15);

                                updateProgress(70 + uidPercent, `Loading furniture ${completedUids} of ${totalUids}...`);

                            }

                            if (!dataFound && uidResults.length === 0) break;

                            selectedData = uidResults;

                        } else {

                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                            currentMonth -= 1;

                            if (currentMonth === 0) {

                                currentMonth = 12;

                                currentYear -= 1;

                            }

                            if (currentYear < year - 1) {

                                console.error("No data found for the past 1 year.");

                                break;

                            }

                            continue;

                        }

                        if (selectedData.length > 0) {

                            updateProgress(90, "Calculating cumulative totals...");

                            const updatedGetAllResults = localSheetData.map((resultItem) => {

                                const matchingReleases = filterReleaseData.filter(

                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)

                                );

                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);

                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);

                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (Number(r.release_month) || 0), 0);

                                const total = totalReleaseAmount + totalDeductionAmount;

                                return { id: resultItem?.officefurniture_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };

                            });

                            setGetTotalWithid(updatedGetAllResults);

                            const updatedData = selectedData.map((item) => {

                                const boqId = item?.officefurniture_details?.id;

                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);

                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);

                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                                const prevAmount = parseFloat(item.previous_invoice_total || 0);

                                const currentAmount = item.invoice_amount === null

                                    ? parseFloat(item.current_invoice_amount)

                                    : parseFloat(item.invoice_amount || 0);

                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

                                const prev = parseFloat(item.actual_month_total_previous || 0);

                                const current = parseFloat(item.actual_month || 0);

                                const newPrevious = prev + current + totalMonthRelease;

                                return {

                                    ...item,

                                    updated_previous_invoice_total: newPreviousAmount,

                                    updated_actual_month_total_previous: newPrevious,

                                };

                            });

                            updateProgress(100, "Done!");

                            setOfficeFurnitureList(updatedData);

                            setListLoaded(true);

                            dataFound = true;

                        }

                    }

                    if (!dataFound) {

                        updateProgress(100, "No previous data found.");

                        setListLoaded(true);

                    }

                } catch (error) {

                    console.error("Error fetching progress data:", error);

                    setFetchProgress({ percent: 100, label: "Error loading data." });

                    setListLoaded(true);

                }

            };

            getData();

        }

    }, [month, year, show]);

    const [logid, setLogId] = useState("null");

    const officeFurnitureID = officeFurniture.map(e => e.id);

    const officeFurnitureData = logData.filter(item => officeFurnitureID.includes(item.object_id));

    const officeFurnitureChangeReason = officeFurniture[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(

        officeFurnitureData.reduce((acc, item) => {

            const groupKey = item.data?.random_value_of_changes;

            if (!acc[groupKey]) acc[groupKey] = [];

            acc[groupKey].push(item);

            return acc;

        }, {})

    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null"

        ? officeFurniture

        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    const getOfficeFurniture = async () => {

        try {

            const res = await axios.get(`${BASE_URL}/siteproject/boqofficefurnitureandequipmentbyproject/${p_id}/`);

            if (Array.isArray(res.data)) {

                setOfficeFurniture(res.data);

            } else {

                console.error("Error: Expected a list of office furniture items");

            }

        } catch (err) {

            console.error("Error fetching office rent data", err);

        }

    };

    useEffect(() => {

        if (officeFurniture.length === 0) return;

        const initialData = selectedGroup.map((item) => {

            const id = item.object_id ?? item.id;

            const matchedProgress = officeFurnitureList.find((progress) => progress.officefurniture === id);

            let eot_details;

            if (logid === "null") {

                eot_details = item.eot_details?.map((item) => item);

            } else {

                eot_details = item?.data?.eot_details?.map((item) => item);

            }

            return {

                project: p_id,

                invoice: invoice_id,

                officefurniture: id,

                actual_month: "",

                month: month,

                year: year,

                actual_month_cumulative_total: "",

                cumulative_invoice_total: "",

                contract_amount: "",

                remaining_amount: "",

                actual_month_remaining: "",

                invoice_amount: "",

                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",

                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",

                boq_rate_per_month: item.rate_per_month ?? item.data?.rate_per_month,

                boq_num_of_months: item.num_of_months ?? item.data?.num_of_months,

                boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,

                boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,

                eot_details: eot_details,

            };

        });

        setFormData(initialData);

    }, [logid, officeFurniture, officeFurnitureList]);


    const validateForm = () => {

        const newErrors = {};

        formData.forEach((entry, index) => {

            const requiredFields = [];

            requiredFields.forEach(field => {

                if (!entry[field]) {

                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;

                }

            });

        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;

    };

    // Keep the user-entered precision in React state and all calculations.
    // Only apply 2-decimal rounding to values being sent to the APIs.
    const toFiniteNumber = (value) => {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    };

    const toPostDecimal = (value) => {
        if (value === null || value === undefined || value === "") return value;
        const number = Number(value);
        if (!Number.isFinite(number)) return value;
        return Number(number.toFixed(2));
    };

    const preparePostPayload = (entries) => {
        const roundOnPost = [
            "actual_month",
            "invoice_amount",
            "actual_month_total_previous",
            "previous_invoice_total",
            "actual_month_cumulative_total",
            "cumulative_invoice_total",
            "actual_month_remaining",
            "remaining_amount",
            "contract_amount",
        ];

        return entries.map((entry) => {
            const payloadItem = { ...entry };
            roundOnPost.forEach((field) => {
                if (Object.prototype.hasOwnProperty.call(payloadItem, field)) {
                    payloadItem[field] = toPostDecimal(payloadItem[field]);
                }
            });
            return payloadItem;
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || !validateForm()) return;

        if (usedfor !== "InvoiceandDeduction" && usedfor !== "OnlyDeduction") {
            toast.error("Unsupported Office Furniture invoice mode");
            return;
        }

        // This is a fresh COPY. formData still retains the full input precision.
        const postPayload = preparePostPayload(formData);
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            let createdData;

            if (usedfor === "InvoiceandDeduction") {
                const res = await axios.post(
                    `${BASE_URL}/siteproject/bulkinvoiceofficefurnitureandequipment/`,
                    postPayload
                );
                if (res.status !== 201) throw new Error("First Office Furniture API failed");
                createdData = res.data;
            } else {
                createdData = invoiceData;
            }

            if (!Array.isArray(createdData) || createdData.length < postPayload.length) {
                throw new Error("Office Furniture invoice response has missing records");
            }

            const mappedFinalData = postPayload.map((item, index) => ({
                ...item,
                invoiceofficefurniture: createdData[index]?.id,
            }));

            if (mappedFinalData.some(item => item.invoiceofficefurniture == null)) {
                throw new Error("Office Furniture invoice response has missing IDs");
            }

            const res2 = await axios.post(
                `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentlistcreate/`,
                mappedFinalData
            );
            if (res2.status !== 201) throw new Error("Second Office Furniture API failed");

            await getOfficeFurnitureinvoice();
            setShow(false);
            toast.success("Office Furniture data added successfully");
        } catch (err) {
            console.error("OfficeFurnitureInvoice submit error", {
                status: err?.response?.status,
                response: err?.response?.data,
                message: err?.message,
            });
            if (err?.response) {
                handleErrorToast(err, loadingToastId);
            } else {
                toast.error(err?.message || "Office Furniture submission failed");
            }
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;

            // Retain the original input text (including all decimal digits).
            const updatedEntry = { ...entry, [name]: value };
            const eotDetails = entry.eot_details || [];
            const lastEOT = eotDetails.length > 0 ? eotDetails[eotDetails.length - 1] : null;

            const rate = toFiniteNumber(lastEOT ? lastEOT.rate : entry.boq_rate_per_month);
            const totalMonths = lastEOT
                ? toFiniteNumber(lastEOT.t_month)
                : toFiniteNumber(entry.boq_during_construction_period) +
                toFiniteNumber(entry.boq_during_dlp_OM_period);
            const contractTotal = lastEOT
                ? toFiniteNumber(lastEOT.total_amount)
                : rate * totalMonths;

            const actualMonth = toFiniteNumber(updatedEntry.actual_month);
            const previousMonth = toFiniteNumber(entry.actual_month_total_previous);
            const previousAmount = toFiniteNumber(entry.previous_invoice_total);

            // No .toFixed(2) anywhere in these calculations.
            updatedEntry.invoice_amount = rate * actualMonth;
            updatedEntry.actual_month_cumulative_total = previousMonth + actualMonth;
            updatedEntry.cumulative_invoice_total = previousAmount + updatedEntry.invoice_amount;
            updatedEntry.actual_month_remaining = totalMonths - updatedEntry.actual_month_cumulative_total;
            updatedEntry.remaining_amount = contractTotal - updatedEntry.cumulative_invoice_total;

            return updatedEntry;
        });

        setFormData(updatedFormData);
    };

    return (

        <>

            <button title="Add Office Furniture" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>

                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                    <circle cx="12" cy="12" r="10" />

                    <line x1="12" y1="8" x2="12" y2="16" />

                    <line x1="8" y1="12" x2="16" y2="12" />

                </svg>

                Office Furniture {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">

                <Modal.Header className="eb-bulk-modal-header">

                    <Modal.Title className="eb-bulk-modal-title">

                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />

                            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />

                            <line x1="12" y1="12" x2="12" y2="16" />

                            <line x1="10" y1="14" x2="14" y2="14" />

                        </svg>

                        Add Office Furniture {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

                    </Modal.Title>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                        {(officeFurniture.length > 0 && groupedByRandomChange.length > 0) && (

                            <select

                                value={logid}

                                onChange={(e) => setLogId(e.target.value)}

                                style={{

                                    fontSize: "13px",

                                    background: "var(--surface-2, #fff)",

                                    border: "0.5px solid var(--border-strong, #ccc)",

                                    borderRadius: "var(--radius, 8px)",

                                    padding: "4px 10px",

                                    cursor: "pointer",

                                    color: "var(--text-primary)",

                                }}

                            >

                                <option value="null">

                                    BOQ {groupedByRandomChange.length + 1} - {officeFurnitureChangeReason}

                                </option>

                                {groupedByRandomChange.map(([groupKey, items], index) => {

                                    const reasons = [...new Set(

                                        items.map(i => i.data?.reason_of_change).filter(reason =>

                                            reason !== null && reason !== "null" && reason?.trim() !== ""

                                        )

                                    )];

                                    return (

                                        <option key={groupKey} value={groupKey}>

                                            BOQ {groupedByRandomChange.length - index}

                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}

                                        </option>

                                    );

                                })}

                            </select>

                        )}

                        <button className="close-btn" onClick={handleClose}>

                            <X size={20} />

                        </button>

                    </div>

                </Modal.Header>

                <Modal.Body className="eb-bulk-modal-body">

                    {modalLoading ? (

                        <div style={{

                            display: "flex",

                            flexDirection: "column",

                            alignItems: "center",

                            justifyContent: "center",

                            minHeight: "50vh",

                            gap: "20px",

                            padding: "40px",

                        }}>

                            <div style={{

                                width: "44px",

                                height: "44px",

                                border: "3px solid #e0e0e0",

                                borderTop: "3px solid #000",

                                borderRadius: "50%",

                                animation: "eb-spin 0.8s linear infinite",

                            }} />

                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>

                                {fetchProgress.label || "Loading data..."}

                            </p>

                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>

                                <div style={{

                                    height: "100%",

                                    width: `${fetchProgress.percent}%`,

                                    background: "#111",

                                    borderRadius: "999px",

                                    transition: "width 0.3s ease",

                                }} />

                            </div>

                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>

                                {fetchProgress.percent}%

                            </p>

                            <style>{`

                                @keyframes eb-spin {

                                    0% { transform: rotate(0deg); }

                                    100% { transform: rotate(360deg); }

                                }

                            `}</style>

                        </div>

                    ) : (

                        <div className="eb-bulk-container">

                            <div className="eb-bulk-content">

                                <div className="eb-bulk-table-wrapper">

                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"

                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}>

                                        <table className="eb-bulk-table" style={{

                                            minWidth: "100%"

                                        }}>

                                            <thead className="eb-bulk-table-head">

                                                <tr className="eb-bulk-table-header-row">

                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>

                                                        <span className="eb-bulk-th-label">#</span>

                                                    </th>

                                                    <th className="eb-bulk-th">

                                                        <span className="eb-bulk-th-label">Office Furniture</span>

                                                    </th>

                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>

                                                        <span className="eb-bulk-th-label">Actual Month</span>

                                                    </th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {formData.map((entry, index) => (

                                                    <tr key={index} className="eb-bulk-row">

                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>

                                                            {index + 1}.

                                                        </td>

                                                        <td className="eb-bulk-td">

                                                            <span style={{ fontWeight: 500 }}>

                                                                Months: {entry.boq_num_of_months} &nbsp; Rate: ₹.{entry.boq_rate_per_month}

                                                            </span>

                                                        </td>

                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>

                                                            <input

                                                                type="number"

                                                                id={`actual_month_${index}`}

                                                                name="actual_month"
                                                                step="any"

                                                                placeholder="Actual Month"

                                                                value={entry.actual_month}

                                                                onChange={(e) => handleInputChange(e, index)}

                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}

                                                                style={{ width: "100px", textAlign: "center" }}

                                                            />

                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>

                                <div className="eb-bulk-footer-actions">

                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>

                                        Cancel

                                    </button>

                                    <button

                                        type="submit"

                                        className="eb-bulk-btn eb-bulk-btn-submit"

                                        disabled={loading}

                                        onClick={handleSubmit}

                                        style={{ background: "black" }}

                                    >

                                        {loading ? (

                                            <span className="eb-bulk-btn-loader">

                                                <span className="eb-bulk-spinner"></span>

                                                Submitting...

                                            </span>

                                        ) : (

                                            <>

                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />

                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />

                                                </svg>

                                                Add

                                            </>

                                        )}

                                    </button>

                                </div>

                            </div>

                        </div>

                    )}

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>

            </Modal>

        </>

    );

};

// NOTE: imports same rahenge (useState, useEffect, axios, Modal, X, toast, ToastContainer,
// BASE_URL, handleErrorToast, ProgressModal).

const UpdateOfficeFurnitureInvoice = ({ p_id, invoice_id, usedfor, invoiceData, getOfficeFurnitureinvoice, month, year, logData = [] }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [logid, setLogId] = useState("null");
    const [officeFurniture, setOfficeFurniture] = useState([]); // BOQ
    const [currentRows, setCurrentRows] = useState([]); // is month ki existing invoice rows
    const [officeFurnitureList, setOfficeFurnitureList] = useState([]); // previous month data (+ withheld release)
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setDataLoaded(false);
        setFormData([]);
        setCurrentRows([]);
        setOfficeFurnitureList([]);
        setLogId("null");
        setFetchProgress({ percent: 0, label: "" });
    };

    const FURNITURE_BULK_UPDATE_URL = `${BASE_URL}/siteproject/invoiceofficefurnitureequipment/bulk-update/`;

    // Add flow 2 tables mai likhta hai:
    //   (1) invoiceofficefurnitureandequipment (main)
    //   (2) newinvoiceofficefurnitureandequipment (detail, FK = invoiceofficefurniture)
    // Next month ka "previous" detail table se (newinvoiceofficefurnitureandequipmentfilter) padhta hai.
    // Agar detail bulk-update endpoint hai to yaha URL daalo. Empty = skip (backend cascade karta ho to).
    const FURNITURE_DETAIL_BULK_UPDATE_URL = ""; // <-- apna detail bulk-update endpoint

    // ======================= CALCULATION (Add ke handleInputChange jaisi, same formulas) =======================
    const toFiniteNumber = (value) => {
        const number = Number(value);
        return Number.isFinite(number) ? number : 0;
    };

    const toPostDecimal = (value) => {
        if (value === null || value === undefined || value === "") return value;
        const number = Number(value);
        if (!Number.isFinite(number)) return value;
        return Number(number.toFixed(2));
    };

    const preparePostPayload = (entries) => {
        const roundOnPost = [
            "actual_month",
            "invoice_amount",
            "actual_month_total_previous",
            "previous_invoice_total",
            "actual_month_cumulative_total",
            "cumulative_invoice_total",
            "actual_month_remaining",
            "remaining_amount",
            "contract_amount",
        ];

        return entries.map((entry) => {
            const payloadItem = { ...entry };
            roundOnPost.forEach((field) => {
                if (Object.prototype.hasOwnProperty.call(payloadItem, field)) {
                    payloadItem[field] = toPostDecimal(payloadItem[field]);
                }
            });
            return payloadItem;
        });
    };

    const recalcEntry = (entry) => {
        const updatedEntry = { ...entry };
        const eotDetails = entry.eot_details || [];
        const lastEOT = eotDetails.length > 0 ? eotDetails[eotDetails.length - 1] : null;

        const rate = toFiniteNumber(lastEOT ? lastEOT.rate : entry.boq_rate_per_month);
        const totalMonths = lastEOT
            ? toFiniteNumber(lastEOT.t_month)
            : toFiniteNumber(entry.boq_during_construction_period) +
            toFiniteNumber(entry.boq_during_dlp_OM_period);
        const contractTotal = lastEOT ? toFiniteNumber(lastEOT.total_amount) : rate * totalMonths;

        const actualMonth = toFiniteNumber(updatedEntry.actual_month);
        const previousMonth = toFiniteNumber(entry.actual_month_total_previous);
        const previousAmount = toFiniteNumber(entry.previous_invoice_total);

        // Koi .toFixed(2) nahi: original precision pe calculation
        updatedEntry.invoice_amount = rate * actualMonth;
        updatedEntry.actual_month_cumulative_total = previousMonth + actualMonth;
        updatedEntry.cumulative_invoice_total = previousAmount + updatedEntry.invoice_amount;
        updatedEntry.actual_month_remaining = totalMonths - updatedEntry.actual_month_cumulative_total;
        updatedEntry.remaining_amount = contractTotal - updatedEntry.cumulative_invoice_total;

        return updatedEntry;
    };

    // ======================= FETCHERS =======================
    const fetchBoq = async () => {
        const res = await axios.get(`${BASE_URL}/siteproject/boqofficefurnitureandequipmentbyproject/${p_id}/`);
        return Array.isArray(res.data) ? res.data : [];
    };

    // ---------- Current month ki existing rows ----------
    const fetchCurrentRows = async () => {
        const mm = String(month).padStart(2, "0");
        const res = await axios.get(
            `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id}/${mm}/${year}/`
        );
        return Array.isArray(res.data) ? res.data : [];
    };

    // ---------- Previous month invoice + withheld release (Add ka same logic) ----------
    const fetchPreviousData = async (updateProgress) => {
        const monthInt = parseInt(month, 10);
        const yearInt = parseInt(year, 10);

        let currentMonth = monthInt - 1 === 0 ? 12 : monthInt - 1;
        let currentYear = monthInt - 1 === 0 ? yearInt - 1 : yearInt;

        // Withheld release hamesha immediate previous month ka lagta hai (Add jaisa)
        const releaseMonth = String(currentMonth).padStart(2, "0");
        const releaseYear = currentYear;

        // 1) Previous month ka invoice dhundo (max 1 saal peeche)
        let selectedData = [];
        while (true) {
            const mm = String(currentMonth).padStart(2, "0");
            updateProgress(30, `Checking invoice for ${mm}/${currentYear}...`);

            const response = await axios.get(
                `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id}/${mm}/${currentYear}/`
            );
            const data = response.data || [];

            if (data.length > 0) {
                const uids = data.map((item) => item.id).filter(Boolean);
                let uidResults = [];
                let done = 0;
                for (const uid of uids) {
                    const res = await axios.get(
                        `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfilter/${uid}/`
                    );

                    // Add jaisa: empty data aaye to loop rok do
                    if (!res.data || res.data.length === 0) {
                        console.error(`No data found for UID ${uid}. Breaking loop.`);
                        break;
                    }

                    uidResults = [...uidResults, ...res.data];
                    done++;
                    updateProgress(
                        30 + Math.round((done / uids.length) * 30),
                        `Loading furniture ${done} of ${uids.length}...`
                    );
                }
                selectedData = uidResults;
                break;
            }

            currentMonth -= 1;
            if (currentMonth === 0) {
                currentMonth = 12;
                currentYear -= 1;
            }
            if (currentYear < yearInt - 1) {
                console.error("No data found for the past 1 year.");
                break;
            }
        }

        if (selectedData.length === 0) return [];

        // 2) Withheld release data
        let filterReleaseData = [];
        let localSheetData = [];
        try {
            updateProgress(65, "Fetching withheld release data...");
            const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
            const releaseRawData = releaseResponse.data || [];

            filterReleaseData = releaseRawData.filter(
                (i) =>
                    String(i.month).padStart(2, "0") === releaseMonth &&
                    Number(i.year) === Number(releaseYear) &&
                    String(i?.deduction_data?.project) === String(p_id)
            );

            const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

            if (invoiceIds.length > 0) {
                updateProgress(72, "Fetching consultant invoices...");
                const res = await axios.get(
                    `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                );
                const filteredData = (res.data || []).filter((item) => invoiceIds.includes(item.id));

                if (filteredData.length > 0) {
                    const months = [...new Set(filteredData.map((i) => i.month))];
                    const years = [...new Set(filteredData.map((i) => i.year))];

                    let localAllResults = [];
                    for (const m of months) {
                        for (const y of years) {
                            try {
                                const filterRes = await axios.get(
                                    `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id}/${m}/${y}/`
                                );
                                localAllResults.push(...(filterRes.data || []));
                            } catch (err) {
                                console.error(`Failed for month: ${m}, year: ${y}`, err);
                            }
                        }
                    }

                    const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                    let idDone = 0;
                    for (const id of allIds) {
                        try {
                            const secondRes = await axios.get(
                                `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfilter/${id}/`
                            );
                            localSheetData.push(...(secondRes.data || []));
                        } catch (err) {
                            console.error(`Failed for id: ${id}`, err);
                        }
                        idDone++;
                        updateProgress(
                            72 + Math.round((idDone / allIds.length) * 15),
                            `Loading furniture sheet ${idDone} of ${allIds.length}...`
                        );
                    }
                }
            }
        } catch (err) {
            console.error("Release data fetch failed, continuing without it", err);
            handleErrorToast(err); // user ko pata chale ki deduction include nahi hua
        }

        // 3) Cumulative totals (release + deduction, release_month)
        updateProgress(90, "Calculating cumulative totals...");

        const releaseTotals = localSheetData.map((resultItem) => {
            const matchingReleases = filterReleaseData.filter(
                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
            );
            const totalReleaseAmount = matchingReleases.reduce(
                (s, r) => s + (parseFloat(r.withheld_release_amount) || 0), 0
            );
            const totalDeductionAmount = matchingReleases.reduce(
                (s, r) => s + (Number(r.deduction_amount) || 0), 0
            );
            const totalMonthRelease = matchingReleases.reduce(
                (s, r) => s + (Number(r.release_month) || 0), 0
            );
            return {
                id: resultItem?.officefurniture_details?.id,
                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                total_month_release: totalMonthRelease,
            };
        });

        return selectedData.map((item) => {
            const boqId = item?.officefurniture_details?.id;
            // String compare: number vs string mismatch se deduction miss nahi hoga
            const matched = releaseTotals.filter((i) => String(i.id) === String(boqId));
            const totalReleaseAmount = matched.reduce((s, i) => s + (Number(i.total_AMOUNT) || 0), 0);
            const totalMonthRelease = matched.reduce((s, i) => s + (Number(i.total_month_release) || 0), 0);

            const prevAmount = parseFloat(item.previous_invoice_total || 0) || 0;
            const currentAmount =
                item.invoice_amount === null
                    ? parseFloat(item.current_invoice_amount) || 0
                    : parseFloat(item.invoice_amount || 0) || 0;
            const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

            const prev = parseFloat(item.actual_month_total_previous || 0) || 0;
            const current = parseFloat(item.actual_month || 0) || 0;
            const newPrevious = prev + current + totalMonthRelease;

            return {
                ...item,
                updated_previous_invoice_total: newPreviousAmount,
                updated_actual_month_total_previous: newPrevious,
            };
        });
    };

    // ---------- Modal open: sab data load ----------
    const handleShow = async () => {
        setShow(true);
        setModalLoading(true);
        setDataLoaded(false);

        let currentPercent = 0;
        const updateProgress = (percent, label) => {
            currentPercent = Math.max(currentPercent, percent);
            setFetchProgress({ percent: currentPercent, label });
        };

        try {
            updateProgress(5, "Connecting to server...");
            const boq = await fetchBoq();
            setOfficeFurniture(boq);

            updateProgress(15, "Fetching current invoice data...");
            const rows = await fetchCurrentRows();
            setCurrentRows(rows);

            try {
                const prev = await fetchPreviousData(updateProgress);
                setOfficeFurnitureList(prev);
            } catch (err) {
                console.error("Error fetching previous data", err);
                handleErrorToast(err);
            }

            updateProgress(100, "Done!");
        } catch (err) {
            console.error("Error loading data", err);
            handleErrorToast(err);
        } finally {
            setDataLoaded(true);
            setModalLoading(false);
        }
    };

    // ======================= BOQ revision dropdown data =======================
    const officeFurnitureID = officeFurniture.map((e) => e.id);
    const officeFurnitureData = (logData || []).filter((item) => officeFurnitureID.includes(item.object_id));
    const officeFurnitureChangeReason = officeFurniture[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        officeFurnitureData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? officeFurniture
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ======================= formData build: BOQ + existing current values + previous =======================
    useEffect(() => {
        if (!dataLoaded || officeFurniture.length === 0) return;

        // furniture -> [rows...] (same BOQ item ki multiple rows ho to order se)
        const currentQueue = {};
        currentRows.forEach((r) => {
            const key = String(r.officefurniture_details?.id ?? r.officefurniture);
            if (!currentQueue[key]) currentQueue[key] = [];
            currentQueue[key].push(r);
        });

        const initialData = selectedGroup.map((item) => {
            const id = item.object_id ?? item.id;

            const eot_details =
                logid === "null"
                    ? item.eot_details?.map((e) => e)
                    : item?.data?.eot_details?.map((e) => e);

            // Previous month data (string-safe match)
            const matchedProgress = officeFurnitureList.find(
                (p) => String(p.officefurniture ?? p.officefurniture_details?.id) === String(id)
            );

            // Is month ki existing row (id + saved actual month)
            const existing = currentQueue[String(id)]?.shift();
            const existingActual =
                existing?.actual_month !== undefined && existing?.actual_month !== null
                    ? String(existing.actual_month)
                    : "";

            const base = {
                id: existing?.id,
                project: p_id,
                invoice: invoice_id,
                officefurniture: id,
                actual_month: existingActual,
                month: month,
                year: year,
                actual_month_cumulative_total: "",
                cumulative_invoice_total: "",
                contract_amount: "",
                remaining_amount: "",
                actual_month_remaining: "",
                invoice_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_rate_per_month: item.rate_per_month ?? item.data?.rate_per_month,
                boq_num_of_months: item.num_of_months ?? item.data?.num_of_months,
                boq_during_construction_period: item.during_construction_period ?? item.data?.during_construction_period,
                boq_during_dlp_OM_period: item.during_dlp_OM_period ?? item.data?.during_dlp_OM_period,
                eot_details: eot_details,
            };

            return recalcEntry(base);
        });

        setFormData(initialData);
    }, [logid, officeFurniture, officeFurnitureList, currentRows, dataLoaded]);

    // ======================= Input change =======================
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;
            // Typed text (saari decimals) preserve
            return recalcEntry({ ...entry, [name]: value });
        });

        setFormData(updatedFormData);
    };

    const validateForm = () => {
        const newErrors = {};
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ======================= Detail table sync (optional, URL set ho tabhi) =======================
    const syncDetailRows = async (postPayload) => {
        if (!FURNITURE_DETAIL_BULK_UPDATE_URL) return;

        const detailPayload = [];
        for (const item of postPayload) {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfilter/${item.id}/`
            );
            const rows = Array.isArray(res.data) ? res.data : [];
            const match =
                rows.find((r) => String(r.officefurniture_details?.id) === String(item.officefurniture)) || rows[0];
            if (match?.id) {
                detailPayload.push({ ...item, id: match.id, invoiceofficefurniture: item.id });
            }
        }

        if (detailPayload.length > 0) {
            await axios.put(FURNITURE_DETAIL_BULK_UPDATE_URL, detailPayload);
        }
    };

    // // ======================= Submit: bulk-update =======================
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (loading || !validateForm()) return;

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing rows fresh fetch (id attach karne ke liye)
    //         const existingRows = await fetchCurrentRows();

    //         // furniture -> [ids...] (same BOQ item ki multiple rows ho to order se)
    //         const idQueue = {};
    //         existingRows.forEach((row) => {
    //             const key = String(row.officefurniture_details?.id ?? row.officefurniture);
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = formData
    //             .map((item) => {
    //                 const queue = idQueue[String(item.officefurniture)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("Koi existing office furniture invoice row nahi mili update karne ke liye");
    //             return;
    //         }

    //         // Fresh COPY: formData mai full precision rehti hai, sirf upload pe 2 decimals
    //         const postPayload = preparePostPayload(payload);

    //         const res = await axios.put(FURNITURE_BULK_UPDATE_URL, postPayload, {
    //             onUploadProgress: (progressEvent) => {
    //                 if (!progressEvent.total) return;
    //                 setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
    //             },
    //         });

    //         if (res.status === 200 || res.status === 201) {
    //             await syncDetailRows(postPayload);
    //             await getOfficeFurnitureinvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Office Furniture data updated successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         console.error("UpdateOfficeFurnitureInvoice submit error", {
    //             status: err?.response?.status,
    //             response: err?.response?.data,
    //             message: err?.message,
    //         });
    //         if (err?.response) {
    //             handleErrorToast(err, loadingToastId);
    //         } else {
    //             toast.error(err?.message || "Office Furniture update failed");
    //         }
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };

    // ======================= Submit: bulk-update =======================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || !validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing rows fresh fetch (id attach karne ke liye)
            const existingRows = await fetchCurrentRows();

            // furniture -> [ids...] (same BOQ item ki multiple rows ho to order se)
            const idQueue = {};
            existingRows.forEach((row) => {
                const key = String(row.officefurniture_details?.id ?? row.officefurniture);
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = formData
                .map((item) => {
                    const queue = idQueue[String(item.officefurniture)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("No existing office furniture invoice rows found to update");
                return;
            }

            // Fresh COPY: formData mai full precision rehti hai, sirf upload pe 2 decimals
            const postPayload = preparePostPayload(payload);

            // 1st API: invoiceofficefurnitureequipment bulk update
            const res = await axios.put(FURNITURE_BULK_UPDATE_URL, postPayload, {
                onUploadProgress: (progressEvent) => {
                    if (!progressEvent.total) return;
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(Math.min(Math.round(percentCompleted * 0.5), 50));
                },
            });

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: claim (new invoice office furniture) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoiceofficefurniture.id == claim.invoiceofficefurniture
                const claimPayload = postPayload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoiceofficefurniture) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                              // claim ke baaki fields bache rahein
                        ...item,                             // updated invoice data replicate
                        id: row.id,                          // claim row ki apni id
                        invoiceofficefurniture: item.id,     // link wapas invoice row se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentupdatedelete/null/`,
                        claimPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                if (!progressEvent.total) return;
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("Claim me koi matching invoiceofficefurniture nahi mili");
                }

                setUploadProgress(100);

                await getOfficeFurnitureinvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Office Furniture data updated successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            console.error("UpdateOfficeFurnitureInvoice submit error", {
                status: err?.response?.status,
                response: err?.response?.data,
                message: err?.message,
            });
            if (err?.response) {
                handleErrorToast(err, loadingToastId);
            } else {
                toast.error(err?.message || "Office Furniture update failed");
            }
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    return (
        <>
            <button title="Update Office Furniture" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Office Furniture {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                                <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
                                <line x1="12" y1="12" x2="12" y2="16" />
                                <line x1="10" y1="14" x2="14" y2="14" />
                            </svg>
                            Update Office Furniture {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {officeFurniture.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {officeFurnitureChangeReason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />
                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>
                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>
                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>
                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                            <span className="eb-bulk-th-label">#</span>
                                                        </th>
                                                        <th className="eb-bulk-th">
                                                            <span className="eb-bulk-th-label">Office Furniture</span>
                                                        </th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "center" }}>
                                                            <span className="eb-bulk-th-label">Actual Month</span>
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.length === 0 && (
                                                        <tr>
                                                            <td colSpan={3} style={{ textAlign: "center", padding: "24px" }}>
                                                                No office furniture data found for {month}/{year}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {formData.map((entry, index) => (
                                                        <tr key={index} className="eb-bulk-row">
                                                            <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                                {index + 1}.
                                                            </td>

                                                            <td className="eb-bulk-td">
                                                                <span style={{ fontWeight: 500 }}>
                                                                    Months: {entry.boq_num_of_months} &nbsp; Rate: ₹.{entry.boq_rate_per_month}
                                                                </span>
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                                <input
                                                                    type="number"
                                                                    id={`actual_month_${index}`}
                                                                    name="actual_month"
                                                                    step="any"
                                                                    placeholder="Actual Month"
                                                                    value={entry.actual_month ?? ""}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
                                                                    style={{ width: "100px", textAlign: "center" }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading || formData.length === 0}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};
const UpdateFurnitureInvoice = ({ p_id, i, invoice_id, getOfficeFurnitureinvoice }) => {

    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        month: "",
        current_invoice_amount: "",
        officefurniture: "",
    });

    const handleShow = () => {
        setShow(true);
        getOfficeFurniture();
        setFormData(i);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [officeFurniture, setOfficeFurniture] = useState([]);

    const getOfficeFurniture = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqofficefurnitureandequipmentbyproject/${p_id}/`);
            setOfficeFurniture(res.data);
        } catch (err) { }
    };
    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "invoice",
            "month",
            "current_invoice_amount",
            "officefurniture",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoiceofficefurniture/${i.id}/`,
                    formData
                );
                if (res.status === 200) {
                    await getOfficeFurnitureinvoice();
                    setShow(false);
                    toast.dismiss(loadingToastId);
                    toast.success("Data updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button className="model-edit-button" title="Update Office Furniture" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Office Furniture for Invoice</Modal.Title> </h1>



                            <div title="Office Furniture" className="flex-column form-group-selectt">
                                <label htmlFor="officefurniture" className="form-labels  font-weight500    font-size-subheading">
                                    Office Furniture<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="officefurniture"
                                    name="officefurniture"
                                    placeholder="Office Furniture"
                                    value={formData.officefurniture}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.officefurniture ? "error" : inputState.officefurniture ? "success" : ""}`}
                                >
                                    <option value="">Select Office Furniture</option>
                                    {officeFurniture?.map((i, index) => (
                                        <option key={index} value={i.id}>Months : {i.num_of_months}, Rent : {i.rate_per_month}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.officefurniture && <span className="error-message font-size-text ">{errors.officefurniture}</span>}
                            </div>


                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    Current Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>
                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}


                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
}

const DeleteFurnitureInvoice = ({ i, getOfficeFurnitureinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceofficefurnitureequipment/${i.id}/`);
            if (response.status === 200) {
                getOfficeFurnitureinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Furniture" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}
const DeleteFurnitureInvoiceDeduction = ({ i, getOfficeFurnitureinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceofficefurniture/${i.id}/`);
            if (response.status === 200) {
                getOfficeFurnitureinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Furniture" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}


const ReportsPrinttInvoice = ({ p_id, invoice_id, usedfor, invoiceData, getReportsPrinttinvoice, month, year, logData }) => {

    // Keep the typed value and every intermediate calculation at full JS numeric precision.
    const numberOrZero = (value) => {
        const n = Number(value);
        return Number.isFinite(n) ? n : 0;
    };

    // Serialize only numeric quantity/amount fields to two decimals at POST time.
    // IDs, calendar month/year, BOQ inputs, EOT objects and other metadata stay untouched.
    const postDecimalFields = [
        "actual_month", "actual_month_cumulative_total", "actual_month_remaining",
        "actual_month_total_previous", "invoice_amount", "cumulative_invoice_total",
        "previous_invoice_total", "remaining_amount", "contract_amount",
    ];
    const toPost2Decimals = (item) => {
        const payload = { ...item };
        postDecimalFields.forEach((key) => {
            if (payload[key] === undefined || payload[key] === null || payload[key] === "") return;
            const n = Number(payload[key]);
            if (!Number.isFinite(n)) {
                throw new Error(`Invalid numeric value for ${key}: ${payload[key]}`);
            }
            payload[key] = Number(n.toFixed(2));
        });
        return payload;
    };

    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState([]);

    const [reportsPrinting, setReportsPrinting] = useState([]);

    const [errors, setErrors] = useState({});

    const [loading, setLoading] = useState(false);

    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);

    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);

    const [invoiceIds, setInvoiceIds] = useState([]);

    const [months, setMonths] = useState([]);

    const [years, setyears] = useState([]);

    const [getResults, setGetResults] = useState([]);

    const [getSheetData, setGetSheetData] = useState([]);

    const [getAllResults, setGetAllResults] = useState([]);

    const [getTotalWithId, setGetTotalWithid] = useState([]);

    const [modalLoading, setModalLoading] = useState(false);

    const [listLoaded, setListLoaded] = useState(false);

    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });



    const handleClose = () => {

        setShow(false);

        setModalLoading(false);

        setListLoaded(false);

        setFetchProgress({ percent: 0, label: "" });

    };



    const handleShow = async () => {

        await getReportsPrinting();

        setShow(true);

    };



    useEffect(() => {

        if (!show) return;

        if (listLoaded) {

            setModalLoading(false);

        } else {

            setModalLoading(true);

        }

    }, [listLoaded, show]);



    const [logid, setLogId] = useState("null");

    const [reportsPrintingList, setReportsList] = useState([]);



    useEffect(() => {

        if (show === true) {

            if (!month || !year) {

                console.error("Both month and year are required to fetch progress data.");

                return;

            }



            const getData = async () => {

                try {

                    let currentMonth = month - 1 === 0 ? 12 : month - 1;

                    let currentYear = month - 1 === 0 ? year - 1 : year;

                    let dataFound = false;

                    let currentPercent = 0;



                    const updateProgress = (percent, label) => {

                        currentPercent = Math.max(currentPercent, percent);

                        setFetchProgress({ percent: currentPercent, label });

                    };



                    updateProgress(5, "Connecting to server...");



                    while (!dataFound) {

                        updateProgress(10, "Fetching previous reports data...");

                        const response = await axios.get(

                            `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`

                        );



                        updateProgress(20, "Fetching withheld release data...");

                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);

                        const releaseRawData = releaseResponse.data;

                        setWithHeldReleaseData(releaseRawData);



                        const monthInt = parseInt(month, 10);

                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');

                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;



                        const filterReleaseData = releaseRawData.filter(i =>

                            (i.month === monthCalculation && i.year === calculatedYear) &&

                            i?.deduction_data?.project === p_id

                        );

                        setfilterwithHeldReleaseData(filterReleaseData);



                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];

                        setInvoiceIds(invoiceIds);



                        let localAllResults = [];

                        let localSheetData = [];



                        if (invoiceIds.length > 0) {

                            updateProgress(35, "Fetching consultant invoices...");

                            const res = await axios.get(

                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`

                            );



                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));



                            if (filteredData.length > 0) {

                                const months = [...new Set(filteredData.map(i => i.month))];

                                const years = [...new Set(filteredData.map(i => i.year))];

                                setMonths(months);

                                setyears(years);



                                const totalMonthYearCalls = months.length * years.length;

                                let completedMonthYearCalls = 0;



                                for (const m of months) {

                                    for (const y of years) {

                                        try {

                                            const filterRes = await axios.get(

                                                `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id}/${m}/${y}/`

                                            );

                                            localAllResults.push(...filterRes.data);

                                        } catch (err) {

                                            console.error(`Failed for month: ${m}, year: ${y}`, err);

                                        }

                                        completedMonthYearCalls++;

                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);

                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);

                                    }

                                }



                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];

                                const totalIdCalls = allIds.length;

                                let completedIdCalls = 0;



                                for (const id of allIds) {

                                    try {

                                        const secondRes = await axios.get(

                                            `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfilter/${id}/`

                                        );

                                        localSheetData.push(...secondRes.data);

                                    } catch (err) {

                                        console.error(`Failed for id: ${id}`, err);

                                    }

                                    completedIdCalls++;

                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);

                                    updateProgress(50 + idPercent, `Loading reports sheet ${completedIdCalls} of ${totalIdCalls}...`);

                                }



                                setGetSheetData(localSheetData);

                                const getboqIds = localAllResults.map(i => i?.reportanddoc_details?.id);

                                setGetResults(getboqIds);

                                setGetAllResults(localAllResults);

                            }

                        }



                        updateProgress(70, "Processing report records...");

                        const data = response.data;

                        let selectedData = [];



                        if (data.length > 0) {

                            const uids = data.map(item => item.id).filter(Boolean);

                            let uidResults = [];

                            const totalUids = uids.length;

                            let completedUids = 0;



                            for (const uid of uids) {

                                const res = await axios.get(

                                    `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfilter/${uid}/`

                                );



                                if (!res.data || res.data.length === 0) {

                                    console.error(`No data found for UID ${uid}. Breaking loop.`);

                                    dataFound = false;

                                    break;

                                }



                                uidResults = [...uidResults, ...res.data];

                                completedUids++;

                                const uidPercent = Math.round((completedUids / totalUids) * 15);

                                updateProgress(70 + uidPercent, `Loading report ${completedUids} of ${totalUids}...`);

                            }



                            if (!dataFound && uidResults.length === 0) break;

                            selectedData = uidResults;



                        } else {

                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);

                            currentMonth -= 1;

                            if (currentMonth === 0) {

                                currentMonth = 12;

                                currentYear -= 1;

                            }

                            if (currentYear < year - 1) {

                                console.error("No data found for the past 1 year.");

                                break;

                            }

                            continue;

                        }



                        if (selectedData.length > 0) {

                            updateProgress(90, "Calculating cumulative totals...");



                            const updatedGetAllResults = localSheetData.map((resultItem) => {

                                const matchingReleases = filterReleaseData.filter(

                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)

                                );

                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);

                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);

                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + numberOrZero(r.release_month), 0);

                                const total = totalReleaseAmount + totalDeductionAmount;

                                return { id: resultItem?.reportanddoc_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };

                            });

                            setGetTotalWithid(updatedGetAllResults);



                            const updatedData = selectedData.map((item) => {

                                const boqId = item?.reportanddoc_details?.id;

                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);

                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);

                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);



                                const prevAmount = numberOrZero(item.previous_invoice_total);

                                const currentAmount = item.invoice_amount === null

                                    ? numberOrZero(item.current_invoice_amount)

                                    : numberOrZero(item.invoice_amount);

                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;



                                const prev = numberOrZero(item.actual_month_total_previous);

                                const current = numberOrZero(item.actual_month);

                                const newPrevious = prev + current + totalMonthRelease;



                                return {

                                    ...item,

                                    updated_previous_invoice_total: newPreviousAmount,

                                    updated_actual_month_total_previous: newPrevious,

                                };

                            });



                            updateProgress(100, "Done!");

                            setReportsList(updatedData);

                            setListLoaded(true);

                            dataFound = true;

                        }

                    }



                    if (!dataFound) {

                        updateProgress(100, "No previous data found.");

                        setListLoaded(true);

                    }



                } catch (error) {

                    console.error("Error fetching progress data:", error);

                    setFetchProgress({ percent: 100, label: "Error loading data." });

                    setListLoaded(true);

                }

            };



            getData();

        }

    }, [month, year, show]);



    const reportID = reportsPrinting.map(e => e.id);

    const reportsData = logData.filter(item => reportID.includes(item.object_id));

    const Changereason = reportsPrinting[0]?.reason_of_change || "";



    const groupedByRandomChange = Object.entries(

        reportsData.reduce((acc, item) => {

            const groupKey = item.data?.random_value_of_changes;

            if (!acc[groupKey]) acc[groupKey] = [];

            acc[groupKey].push(item);

            return acc;

        }, {})

    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));



    const selectedGroup = logid === "null"

        ? reportsPrinting

        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];



    const getReportsPrinting = async () => {

        try {

            const res = await axios.get(`${BASE_URL}/siteproject/boqreportsanddocprintbyproject/${p_id}/`);

            if (Array.isArray(res.data)) {

                setReportsPrinting(res.data);

            } else {

                console.error("Error: Expected a list of reports");

            }

        } catch (err) {

            console.error("Error fetching reports data", err);

        }

    };



    useEffect(() => {

        if (reportsPrinting.length === 0) return;



        const initialData = selectedGroup.map((item) => {

            const ID = item.object_id ?? item.id;

            const matchedProgress = reportsPrintingList.find((progress) => progress.reportanddoc === ID);



            let eot_details;

            if (logid === "null") {

                eot_details = item.revised?.map((item) => item);

            } else {

                eot_details = item?.data?.revised?.map((item) => item);

            }



            return {

                project: p_id,

                invoice: invoice_id,

                reportanddoc: ID,

                actual_month: "",

                month: month,

                year: year,

                actual_month_cumulative_total: "",

                cumulative_invoice_total: "",

                contract_amount: "",

                remaining_amount: "",

                actual_month_remaining: "",

                invoice_amount: "",

                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",

                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",

                boq_rate_per_copy: item.rate_per_copy ?? item.data?.rate_per_copy,

                boq_num_of_copies_per_report: item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report,

                boq_description: item.description ?? item.data?.description,

                boq_num_of_reports: item.num_of_reports ?? item.data?.num_of_reports,

                eot_details: eot_details,

            };

        });



        setFormData(initialData);

    }, [logid, reportsPrinting, reportsPrintingList]);



    // POST payload is derived from the latest formData at the moment of submission.



    const validateForm = () => {

        const newErrors = {};

        formData.forEach((entry, index) => {

            const requiredFields = [];

            requiredFields.forEach(field => {

                if (!entry[field]) {

                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;

                }

            });

        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;

    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm() || loading) return;

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        try {
            // Snapshot remains full-precision in React state; each POST gets its own rounded copy.
            const postPayload = formData.map(toPost2Decimals);
            let createdData;

            if (usedfor === "InvoiceandDeduction") {
                const res = await axios.post(
                    `${BASE_URL}/siteproject/bulkinvoicereportsanddocumentprinting/`,
                    postPayload
                );
                if (res.status !== 201 || !Array.isArray(res.data)) {
                    throw new Error("First API did not return a list of created report invoice records.");
                }
                createdData = res.data;
            } else if (usedfor === "OnlyInvoice" || usedfor === "OnlyDeduction") {
                createdData = invoiceData;
            } else {
                throw new Error(`Unsupported invoice mode: ${usedfor}`);
            }

            if (!Array.isArray(createdData) || createdData.length < postPayload.length) {
                throw new Error("Missing created invoice records for one or more report rows.");
            }

            const mappedFinalData = postPayload.map((item, index) => {
                const invoiceRecordId = createdData[index]?.id;
                if (invoiceRecordId === undefined || invoiceRecordId === null || invoiceRecordId === "") {
                    throw new Error(`Missing reports invoice ID for row ${index + 1}`);
                }
                return { ...item, invoicereportsanddoc: invoiceRecordId };
            });

            const res2 = await axios.post(
                `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintinglistcreate/`,
                mappedFinalData
            );

            if (res2.status !== 201) {
                throw new Error("Second API failed to create report invoice details.");
            }

            await getReportsPrinttinvoice();
            setShow(false);
            toast.success("Data added Successfully");
        } catch (err) {
            console.error("Reports & Document Printing POST failed:", {
                message: err?.message,
                status: err?.response?.status,
                response: err?.response?.data,
            });
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    const handleInputChange = (e, index) => {

        const { name, value } = e.target;



        const updatedFormData = formData.map((entry, i) => {

            if (i !== index) return entry;



            const updatedEntry = { ...entry, [name]: value };



            const reports = entry.boq_num_of_reports;

            const copies = entry.boq_num_of_copies_per_report;



            let rate;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                rate = Number(lastEOT.rate_per_copy || 0);

            } else {

                rate = Number(entry.boq_rate_per_copy || 0);

            }

            let totalCopies;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                totalCopies = Number(lastEOT.t_reports || 0);

            } else {

                totalCopies = Number(copies) * Number(reports);

            }

            let total;

            if (entry.eot_details && entry.eot_details.length > 0) {

                const lastEOT = entry.eot_details[entry.eot_details.length - 1];

                total = Number(lastEOT.total_amount || 0);

            } else {

                total = Number(rate) * Number(totalCopies);

            }



            const previous = entry.actual_month_total_previous;

            const previousAmount = entry.previous_invoice_total;

            const actualMonth = numberOrZero(updatedEntry.actual_month);



            updatedEntry.invoice_amount = rate * actualMonth;

            updatedEntry.actual_month_cumulative_total = numberOrZero(previous) + actualMonth;

            updatedEntry.cumulative_invoice_total = numberOrZero(previousAmount) + updatedEntry.invoice_amount;

            updatedEntry.actual_month_remaining = Number(totalCopies) - Number(updatedEntry.actual_month_cumulative_total);

            updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);



            return updatedEntry;

        });



        setFormData(updatedFormData);

    };



    return (

        <>

            <button title="Add Reports & Document" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>

                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                    <circle cx="12" cy="12" r="10" />

                    <line x1="12" y1="8" x2="12" y2="16" />

                    <line x1="8" y1="12" x2="16" y2="12" />

                </svg>

                Reports & Document {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

            </button>



            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">

                <Modal.Header className="eb-bulk-modal-header">

                    <Modal.Title className="eb-bulk-modal-title">

                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />

                            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />

                            <line x1="12" y1="12" x2="12" y2="16" />

                            <line x1="10" y1="14" x2="14" y2="14" />

                        </svg>

                        Add Reports & Document {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}

                    </Modal.Title>



                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                        {(reportsPrinting.length > 0 && groupedByRandomChange.length > 0) && (

                            <select

                                value={logid}

                                onChange={(e) => setLogId(e.target.value)}

                                style={{

                                    fontSize: "13px",

                                    background: "var(--surface-2, #fff)",

                                    border: "0.5px solid var(--border-strong, #ccc)",

                                    borderRadius: "var(--radius, 8px)",

                                    padding: "4px 10px",

                                    cursor: "pointer",

                                    color: "var(--text-primary)",

                                }}

                            >

                                <option value="null">

                                    BOQ {groupedByRandomChange.length + 1} - {Changereason}

                                </option>

                                {groupedByRandomChange.map(([groupKey, items], index) => {

                                    const reasons = [...new Set(

                                        items.map(i => i.data?.reason_of_change).filter(reason =>

                                            reason !== null && reason !== "null" && reason?.trim() !== ""

                                        )

                                    )];

                                    return (

                                        <option key={groupKey} value={groupKey}>

                                            BOQ {groupedByRandomChange.length - index}

                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}

                                        </option>

                                    );

                                })}

                            </select>

                        )}

                        <button className="close-btn" onClick={handleClose}>

                            <X size={20} />

                        </button>

                    </div>

                </Modal.Header>



                <Modal.Body className="eb-bulk-modal-body">

                    {modalLoading ? (

                        <div style={{

                            display: "flex",

                            flexDirection: "column",

                            alignItems: "center",

                            justifyContent: "center",

                            minHeight: "50vh",

                            gap: "20px",

                            padding: "40px",

                        }}>

                            <div style={{

                                width: "44px",

                                height: "44px",

                                border: "3px solid #e0e0e0",

                                borderTop: "3px solid #000",

                                borderRadius: "50%",

                                animation: "eb-spin 0.8s linear infinite",

                            }} />

                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>

                                {fetchProgress.label || "Loading data..."}

                            </p>

                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>

                                <div style={{

                                    height: "100%",

                                    width: `${fetchProgress.percent}%`,

                                    background: "#111",

                                    borderRadius: "999px",

                                    transition: "width 0.3s ease",

                                }} />

                            </div>

                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>

                                {fetchProgress.percent}%

                            </p>

                            <style>{`

                                @keyframes eb-spin {

                                    0% { transform: rotate(0deg); }

                                    100% { transform: rotate(360deg); }

                                }

                            `}</style>

                        </div>

                    ) : (

                        <div className="eb-bulk-container">

                            <div className="eb-bulk-content">

                                <div className="eb-bulk-table-wrapper">

                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"

                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}>

                                        <table className="eb-bulk-table" style={{ minWidth: "100%" }}>

                                            <thead className="eb-bulk-table-head">

                                                <tr className="eb-bulk-table-header-row">

                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>

                                                        <span className="eb-bulk-th-label">#</span>

                                                    </th>

                                                    <th className="eb-bulk-th">

                                                        <span className="eb-bulk-th-label">Reports & Document</span>

                                                    </th>

                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>

                                                        <span className="eb-bulk-th-label">Total number of Copies</span>

                                                    </th>

                                                </tr>

                                            </thead>

                                            <tbody>

                                                {formData.map((entry, index) => (

                                                    <tr key={index} className="eb-bulk-row">

                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>

                                                            {index + 1}.

                                                        </td>

                                                        <td className="eb-bulk-td">

                                                            <span style={{ fontWeight: 500 }}>

                                                                {entry.boq_description || "TBN"}

                                                            </span>

                                                        </td>

                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>

                                                            <input

                                                                type="number"

                                                                step="any"

                                                                min={0}

                                                                id={`actual_month_${index}`}

                                                                name="actual_month"

                                                                placeholder="Total Copies"

                                                                value={entry.actual_month}

                                                                onChange={(e) => handleInputChange(e, index)}

                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}

                                                                style={{ width: "100px", textAlign: "center" }}

                                                            />

                                                        </td>

                                                    </tr>

                                                ))}

                                            </tbody>

                                        </table>

                                    </div>

                                </div>



                                <div className="eb-bulk-footer-actions">

                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>

                                        Cancel

                                    </button>

                                    <button

                                        type="submit"

                                        className="eb-bulk-btn eb-bulk-btn-submit"

                                        disabled={loading}

                                        onClick={handleSubmit}

                                        style={{ background: "black" }}

                                    >

                                        {loading ? (

                                            <span className="eb-bulk-btn-loader">

                                                <span className="eb-bulk-spinner"></span>

                                                Submitting...

                                            </span>

                                        ) : (

                                            <>

                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">

                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />

                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />

                                                </svg>

                                                Add

                                            </>

                                        )}

                                    </button>

                                </div>

                            </div>

                        </div>

                    )}

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

                </Modal.Body>

            </Modal>

        </>

    );

};


// NOTE: imports same rahenge (useState, useEffect, axios, Modal, X, toast, ToastContainer,
// BASE_URL, handleErrorToast, ProgressModal).

const UpdateReportsPrinttInvoice = ({ p_id, invoice_id, usedfor, invoiceData, getReportsPrinttinvoice, month, year, logData = [] }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [logid, setLogId] = useState("null");
    const [reportsPrinting, setReportsPrinting] = useState([]); // BOQ
    const [currentRows, setCurrentRows] = useState([]); // is month ki existing invoice rows
    const [reportsPrintingList, setReportsList] = useState([]); // previous month data (+ withheld release)
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [modalLoading, setModalLoading] = useState(false);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });
    const [uploadProgress, setUploadProgress] = useState(0);
    const [showProgressModal, setShowProgressModal] = useState(false);

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setDataLoaded(false);
        setFormData([]);
        setCurrentRows([]);
        setReportsList([]);
        setLogId("null");
        setFetchProgress({ percent: 0, label: "" });
    };

    const REPORTS_BULK_UPDATE_URL = `${BASE_URL}/siteproject/invoicereportsdocumentsprinting/bulk-update/`;

    // Add flow 2 tables mai likhta hai:
    //   (1) invoicereportsanddocumentprinting (main)
    //   (2) newinvoicereportsanddocumentprinting (detail, FK = invoicereportsanddoc)
    // Next month ka "previous" detail table se (newinvoicereportsanddocumentprintingfilter) padhta hai.
    // Agar detail bulk-update endpoint hai to yaha URL daalo. Empty = skip (backend cascade karta ho to).
    const REPORTS_DETAIL_BULK_UPDATE_URL = ""; // <-- apna detail bulk-update endpoint

    // ======================= CALCULATION (Add ke handleInputChange jaisi, same formulas) =======================
    const numberOrZero = (value) => {
        const n = Number(value);
        return Number.isFinite(n) ? n : 0;
    };

    // Sirf upload pe numeric quantity/amount fields 2 decimals
    const postDecimalFields = [
        "actual_month", "actual_month_cumulative_total", "actual_month_remaining",
        "actual_month_total_previous", "invoice_amount", "cumulative_invoice_total",
        "previous_invoice_total", "remaining_amount", "contract_amount",
    ];
    const toPost2Decimals = (item) => {
        const payload = { ...item };
        postDecimalFields.forEach((key) => {
            if (payload[key] === undefined || payload[key] === null || payload[key] === "") return;
            const n = Number(payload[key]);
            if (!Number.isFinite(n)) {
                throw new Error(`Invalid numeric value for ${key}: ${payload[key]}`);
            }
            payload[key] = Number(n.toFixed(2));
        });
        return payload;
    };

    const recalcEntry = (entry) => {
        const updatedEntry = { ...entry };

        const reports = entry.boq_num_of_reports;
        const copies = entry.boq_num_of_copies_per_report;
        const hasEOT = entry.eot_details && entry.eot_details.length > 0;
        const lastEOT = hasEOT ? entry.eot_details[entry.eot_details.length - 1] : null;

        const rate = hasEOT ? Number(lastEOT.rate_per_copy || 0) : Number(entry.boq_rate_per_copy || 0);
        const totalCopies = hasEOT ? Number(lastEOT.t_reports || 0) : Number(copies) * Number(reports);
        const total = hasEOT ? Number(lastEOT.total_amount || 0) : Number(rate) * Number(totalCopies);

        const previous = entry.actual_month_total_previous;
        const previousAmount = entry.previous_invoice_total;
        const actualMonth = numberOrZero(updatedEntry.actual_month);

        // Koi .toFixed nahi: original precision pe calculation
        updatedEntry.invoice_amount = rate * actualMonth;
        updatedEntry.actual_month_cumulative_total = numberOrZero(previous) + actualMonth;
        updatedEntry.cumulative_invoice_total = numberOrZero(previousAmount) + updatedEntry.invoice_amount;
        updatedEntry.actual_month_remaining = Number(totalCopies) - Number(updatedEntry.actual_month_cumulative_total);
        updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

        return updatedEntry;
    };

    // ======================= FETCHERS =======================
    const fetchBoq = async () => {
        const res = await axios.get(`${BASE_URL}/siteproject/boqreportsanddocprintbyproject/${p_id}/`);
        return Array.isArray(res.data) ? res.data : [];
    };

    // ---------- Current month ki existing rows ----------
    const fetchCurrentRows = async () => {
        const mm = String(month).padStart(2, "0");
        const res = await axios.get(
            `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id}/${mm}/${year}/`
        );
        return Array.isArray(res.data) ? res.data : [];
    };

    // ---------- Previous month invoice + withheld release (Add ka same logic) ----------
    const fetchPreviousData = async (updateProgress) => {
        const monthInt = parseInt(month, 10);
        const yearInt = parseInt(year, 10);

        let currentMonth = monthInt - 1 === 0 ? 12 : monthInt - 1;
        let currentYear = monthInt - 1 === 0 ? yearInt - 1 : yearInt;

        // Withheld release hamesha immediate previous month ka lagta hai (Add jaisa)
        const releaseMonth = String(currentMonth).padStart(2, "0");
        const releaseYear = currentYear;

        // 1) Previous month ka invoice dhundo (max 1 saal peeche)
        let selectedData = [];
        while (true) {
            const mm = String(currentMonth).padStart(2, "0");
            updateProgress(30, `Checking invoice for ${mm}/${currentYear}...`);

            const response = await axios.get(
                `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id}/${mm}/${currentYear}/`
            );
            const data = response.data || [];

            if (data.length > 0) {
                const uids = data.map((item) => item.id).filter(Boolean);
                let uidResults = [];
                let done = 0;
                for (const uid of uids) {
                    const res = await axios.get(
                        `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfilter/${uid}/`
                    );

                    // Add jaisa: empty data aaye to loop rok do
                    if (!res.data || res.data.length === 0) {
                        console.error(`No data found for UID ${uid}. Breaking loop.`);
                        break;
                    }

                    uidResults = [...uidResults, ...res.data];
                    done++;
                    updateProgress(
                        30 + Math.round((done / uids.length) * 30),
                        `Loading report ${done} of ${uids.length}...`
                    );
                }
                selectedData = uidResults;
                break;
            }

            currentMonth -= 1;
            if (currentMonth === 0) {
                currentMonth = 12;
                currentYear -= 1;
            }
            if (currentYear < yearInt - 1) {
                console.error("No data found for the past 1 year.");
                break;
            }
        }

        if (selectedData.length === 0) return [];

        // 2) Withheld release data
        let filterReleaseData = [];
        let localSheetData = [];
        try {
            updateProgress(65, "Fetching withheld release data...");
            const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
            const releaseRawData = releaseResponse.data || [];

            filterReleaseData = releaseRawData.filter(
                (i) =>
                    String(i.month).padStart(2, "0") === releaseMonth &&
                    Number(i.year) === Number(releaseYear) &&
                    String(i?.deduction_data?.project) === String(p_id)
            );

            const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];

            if (invoiceIds.length > 0) {
                updateProgress(72, "Fetching consultant invoices...");
                const res = await axios.get(
                    `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                );
                const filteredData = (res.data || []).filter((item) => invoiceIds.includes(item.id));

                if (filteredData.length > 0) {
                    const months = [...new Set(filteredData.map((i) => i.month))];
                    const years = [...new Set(filteredData.map((i) => i.year))];

                    let localAllResults = [];
                    for (const m of months) {
                        for (const y of years) {
                            try {
                                const filterRes = await axios.get(
                                    `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id}/${m}/${y}/`
                                );
                                localAllResults.push(...(filterRes.data || []));
                            } catch (err) {
                                console.error(`Failed for month: ${m}, year: ${y}`, err);
                            }
                        }
                    }

                    const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                    let idDone = 0;
                    for (const id of allIds) {
                        try {
                            const secondRes = await axios.get(
                                `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfilter/${id}/`
                            );
                            localSheetData.push(...(secondRes.data || []));
                        } catch (err) {
                            console.error(`Failed for id: ${id}`, err);
                        }
                        idDone++;
                        updateProgress(
                            72 + Math.round((idDone / allIds.length) * 15),
                            `Loading reports sheet ${idDone} of ${allIds.length}...`
                        );
                    }
                }
            }
        } catch (err) {
            console.error("Release data fetch failed, continuing without it", err);
            handleErrorToast(err); // user ko pata chale ki deduction include nahi hua
        }

        // 3) Cumulative totals (release + deduction, release_month)
        updateProgress(90, "Calculating cumulative totals...");

        const releaseTotals = localSheetData.map((resultItem) => {
            const matchingReleases = filterReleaseData.filter(
                (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
            );
            const totalReleaseAmount = matchingReleases.reduce(
                (s, r) => s + (parseFloat(r.withheld_release_amount) || 0), 0
            );
            const totalDeductionAmount = matchingReleases.reduce(
                (s, r) => s + (Number(r.deduction_amount) || 0), 0
            );
            const totalMonthRelease = matchingReleases.reduce(
                (s, r) => s + numberOrZero(r.release_month), 0
            );
            return {
                id: resultItem?.reportanddoc_details?.id,
                total_AMOUNT: totalReleaseAmount + totalDeductionAmount,
                total_month_release: totalMonthRelease,
            };
        });

        return selectedData.map((item) => {
            const boqId = item?.reportanddoc_details?.id;
            // String compare: number vs string mismatch se deduction miss nahi hoga
            const matched = releaseTotals.filter((i) => String(i.id) === String(boqId));
            const totalReleaseAmount = matched.reduce((s, i) => s + (Number(i.total_AMOUNT) || 0), 0);
            const totalMonthRelease = matched.reduce((s, i) => s + (Number(i.total_month_release) || 0), 0);

            const prevAmount = numberOrZero(item.previous_invoice_total);
            const currentAmount =
                item.invoice_amount === null
                    ? numberOrZero(item.current_invoice_amount)
                    : numberOrZero(item.invoice_amount);
            const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

            const prev = numberOrZero(item.actual_month_total_previous);
            const current = numberOrZero(item.actual_month);
            const newPrevious = prev + current + totalMonthRelease;

            return {
                ...item,
                updated_previous_invoice_total: newPreviousAmount,
                updated_actual_month_total_previous: newPrevious,
            };
        });
    };

    // ---------- Modal open: sab data load ----------
    const handleShow = async () => {
        setShow(true);
        setModalLoading(true);
        setDataLoaded(false);

        let currentPercent = 0;
        const updateProgress = (percent, label) => {
            currentPercent = Math.max(currentPercent, percent);
            setFetchProgress({ percent: currentPercent, label });
        };

        try {
            updateProgress(5, "Connecting to server...");
            const boq = await fetchBoq();
            setReportsPrinting(boq);

            updateProgress(15, "Fetching current invoice data...");
            const rows = await fetchCurrentRows();
            setCurrentRows(rows);

            try {
                const prev = await fetchPreviousData(updateProgress);
                setReportsList(prev);
            } catch (err) {
                console.error("Error fetching previous data", err);
                handleErrorToast(err);
            }

            updateProgress(100, "Done!");
        } catch (err) {
            console.error("Error loading data", err);
            handleErrorToast(err);
        } finally {
            setDataLoaded(true);
            setModalLoading(false);
        }
    };

    // ======================= BOQ revision dropdown data =======================
    const reportID = reportsPrinting.map((e) => e.id);
    const reportsData = (logData || []).filter((item) => reportID.includes(item.object_id));
    const Changereason = reportsPrinting[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        reportsData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null"
            ? reportsPrinting
            : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    // ======================= formData build: BOQ + existing current values + previous =======================
    useEffect(() => {
        if (!dataLoaded || reportsPrinting.length === 0) return;

        // report -> [rows...] (same BOQ item ki multiple rows ho to order se)
        const currentQueue = {};
        currentRows.forEach((r) => {
            const key = String(r.reportanddoc_details?.id ?? r.reportanddoc);
            if (!currentQueue[key]) currentQueue[key] = [];
            currentQueue[key].push(r);
        });

        const initialData = selectedGroup.map((item) => {
            const ID = item.object_id ?? item.id;

            const eot_details =
                logid === "null"
                    ? item.revised?.map((e) => e)
                    : item?.data?.revised?.map((e) => e);

            // Previous month data (string-safe match)
            const matchedProgress = reportsPrintingList.find(
                (p) => String(p.reportanddoc ?? p.reportanddoc_details?.id) === String(ID)
            );

            // Is month ki existing row (id + saved actual month)
            const existing = currentQueue[String(ID)]?.shift();
            const existingActual =
                existing?.actual_month !== undefined && existing?.actual_month !== null
                    ? String(existing.actual_month)
                    : "";

            const base = {
                id: existing?.id,
                project: p_id,
                invoice: invoice_id,
                reportanddoc: ID,
                actual_month: existingActual,
                month: month,
                year: year,
                actual_month_cumulative_total: "",
                cumulative_invoice_total: "",
                contract_amount: "",
                remaining_amount: "",
                actual_month_remaining: "",
                invoice_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_rate_per_copy: item.rate_per_copy ?? item.data?.rate_per_copy,
                boq_num_of_copies_per_report: item.num_of_copies_per_report ?? item.data?.num_of_copies_per_report,
                boq_description: item.description ?? item.data?.description,
                boq_num_of_reports: item.num_of_reports ?? item.data?.num_of_reports,
                eot_details: eot_details,
            };

            return recalcEntry(base);
        });

        setFormData(initialData);
    }, [logid, reportsPrinting, reportsPrintingList, currentRows, dataLoaded]);

    // ======================= Input change =======================
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;
            // Typed text (saari decimals) preserve
            return recalcEntry({ ...entry, [name]: value });
        });

        setFormData(updatedFormData);
    };

    const validateForm = () => {
        const newErrors = {};
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ======================= Detail table sync (optional, URL set ho tabhi) =======================
    const syncDetailRows = async (postPayload) => {
        if (!REPORTS_DETAIL_BULK_UPDATE_URL) return;

        const detailPayload = [];
        for (const item of postPayload) {
            const res = await axios.get(
                `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfilter/${item.id}/`
            );
            const rows = Array.isArray(res.data) ? res.data : [];
            const match =
                rows.find((r) => String(r.reportanddoc_details?.id) === String(item.reportanddoc)) || rows[0];
            if (match?.id) {
                detailPayload.push({ ...item, id: match.id, invoicereportsanddoc: item.id });
            }
        }

        if (detailPayload.length > 0) {
            await axios.put(REPORTS_DETAIL_BULK_UPDATE_URL, detailPayload);
        }
    };

    // // ======================= Submit: bulk-update =======================
    // const handleSubmit = async (e) => {
    //     e.preventDefault();
    //     if (loading || !validateForm()) return;

    //     setLoading(true);
    //     setShowProgressModal(true);
    //     setUploadProgress(0);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Current month ke existing rows fresh fetch (id attach karne ke liye)
    //         const existingRows = await fetchCurrentRows();

    //         // report -> [ids...] (same BOQ item ki multiple rows ho to order se)
    //         const idQueue = {};
    //         existingRows.forEach((row) => {
    //             const key = String(row.reportanddoc_details?.id ?? row.reportanddoc);
    //             if (!idQueue[key]) idQueue[key] = [];
    //             idQueue[key].push(row.id);
    //         });

    //         const payload = formData
    //             .map((item) => {
    //                 const queue = idQueue[String(item.reportanddoc)];
    //                 const id = queue && queue.length > 0 ? queue.shift() : undefined;
    //                 return { ...item, id };
    //             })
    //             .filter((item) => item.id !== undefined);

    //         if (payload.length === 0) {
    //             toast.dismiss(loadingToastId);
    //             toast.error("Koi existing reports invoice row nahi mili update karne ke liye");
    //             return;
    //         }

    //         // Fresh COPY: formData mai full precision rehti hai, sirf upload pe 2 decimals
    //         const postPayload = payload.map(toPost2Decimals);

    //         const res = await axios.put(REPORTS_BULK_UPDATE_URL, postPayload, {
    //             onUploadProgress: (progressEvent) => {
    //                 if (!progressEvent.total) return;
    //                 setUploadProgress(Math.round((progressEvent.loaded * 100) / progressEvent.total));
    //             },
    //         });

    //         if (res.status === 200 || res.status === 201) {
    //             await syncDetailRows(postPayload);
    //             await getReportsPrinttinvoice();
    //             handleClose();
    //             setTimeout(() => {
    //                 toast.dismiss(loadingToastId);
    //                 toast.success("Reports & Document data updated successfully");
    //             }, 4000);
    //         } else {
    //             alert("Update failed");
    //         }
    //     } catch (err) {
    //         console.error("Reports & Document Printing update failed:", {
    //             message: err?.message,
    //             status: err?.response?.status,
    //             response: err?.response?.data,
    //         });
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setTimeout(() => setShowProgressModal(false), 2000);
    //         setTimeout(() => {
    //             setLoading(false);
    //             toast.dismiss(loadingToastId);
    //         }, 4000);
    //     }
    // };

    // ======================= Submit: bulk-update =======================
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading || !validateForm()) return;

        setLoading(true);
        setShowProgressModal(true);
        setUploadProgress(0);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // Current month ke existing rows fresh fetch (id attach karne ke liye)
            const existingRows = await fetchCurrentRows();

            // report -> [ids...] (same BOQ item ki multiple rows ho to order se)
            const idQueue = {};
            existingRows.forEach((row) => {
                const key = String(row.reportanddoc_details?.id ?? row.reportanddoc);
                if (!idQueue[key]) idQueue[key] = [];
                idQueue[key].push(row.id);
            });

            const payload = formData
                .map((item) => {
                    const queue = idQueue[String(item.reportanddoc)];
                    const id = queue && queue.length > 0 ? queue.shift() : undefined;
                    return { ...item, id };
                })
                .filter((item) => item.id !== undefined);

            if (payload.length === 0) {
                toast.dismiss(loadingToastId);
                toast.error("No existing reports invoice rows found to update");
                return;
            }

            // Fresh COPY: formData mai full precision rehti hai, sirf upload pe 2 decimals
            const postPayload = payload.map(toPost2Decimals);

            // 1st API: invoicereportsdocumentsprinting bulk update
            const res = await axios.put(REPORTS_BULK_UPDATE_URL, postPayload, {
                onUploadProgress: (progressEvent) => {
                    if (!progressEvent.total) return;
                    const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(Math.min(Math.round(percentCompleted * 0.5), 50));
                },
            });

            if (res.status === 200 || res.status === 201) {
                setUploadProgress(60);

                // 2nd API: claim (new invoice reports & document printing) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoicereportsanddocumentprinting.id == claim.invoicereportsanddoc
                const claimPayload = postPayload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoicereportsanddoc) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                              // claim ke baaki fields bache rahein
                        ...item,                             // updated invoice data replicate
                        id: row.id,                          // claim row ki apni id
                        invoicereportsanddoc: item.id,       // link wapas invoice row se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingupdatedelete/null/`,
                        claimPayload,
                        {
                            onUploadProgress: (progressEvent) => {
                                if (!progressEvent.total) return;
                                const pct = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(60 + Math.round(pct * 0.4));
                            },
                        }
                    );
                } else {
                    console.warn("Claim me koi matching invoicereportsanddoc nahi mili");
                }

                setUploadProgress(100);

                await getReportsPrinttinvoice();
                handleClose();
                setTimeout(() => {
                    toast.dismiss(loadingToastId);
                    toast.success("Reports & Document data updated successfully");
                }, 4000);
            } else {
                alert("Update failed");
            }
        } catch (err) {
            console.error("Reports & Document Printing update failed:", {
                message: err?.message,
                status: err?.response?.status,
                response: err?.response?.data,
            });
            handleErrorToast(err, loadingToastId);
        } finally {
            setTimeout(() => setShowProgressModal(false), 2000);
            setTimeout(() => {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }, 4000);
        }
    };

    return (
        <>
            <button title="Update Reports & Document" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
                    <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
                </svg>
                Update Reports & Document {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            {showProgressModal ? (
                <ProgressModal usedFor="Update" show={showProgressModal} progress={uploadProgress} />
            ) : (
                <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
                    <Modal.Header className="eb-bulk-modal-header">
                        <Modal.Title className="eb-bulk-modal-title">
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                                <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
                                <line x1="12" y1="12" x2="12" y2="16" />
                                <line x1="10" y1="14" x2="14" y2="14" />
                            </svg>
                            Update Reports & Document {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                        </Modal.Title>

                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            {reportsPrinting.length > 0 && groupedByRandomChange.length > 0 && (
                                <select
                                    value={logid}
                                    onChange={(e) => setLogId(e.target.value)}
                                    style={{
                                        fontSize: "13px",
                                        background: "var(--surface-2, #fff)",
                                        border: "0.5px solid var(--border-strong, #ccc)",
                                        borderRadius: "var(--radius, 8px)",
                                        padding: "4px 10px",
                                        cursor: "pointer",
                                        color: "var(--text-primary)",
                                    }}
                                >
                                    <option value="null">
                                        BOQ {groupedByRandomChange.length + 1} - {Changereason}
                                    </option>
                                    {groupedByRandomChange.map(([groupKey, items], index) => {
                                        const reasons = [
                                            ...new Set(
                                                items
                                                    .map((i) => i.data?.reason_of_change)
                                                    .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                            ),
                                        ];
                                        return (
                                            <option key={groupKey} value={groupKey}>
                                                BOQ {groupedByRandomChange.length - index}
                                                {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                            </option>
                                        );
                                    })}
                                </select>
                            )}
                            <button className="close-btn" onClick={handleClose}>
                                <X size={20} />
                            </button>
                        </div>
                    </Modal.Header>

                    <Modal.Body className="eb-bulk-modal-body">
                        {modalLoading ? (
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "50vh", gap: "20px", padding: "40px" }}>
                                <div style={{ width: "44px", height: "44px", border: "3px solid #e0e0e0", borderTop: "3px solid #000", borderRadius: "50%", animation: "eb-spin 0.8s linear infinite" }} />
                                <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                    {fetchProgress.label || "Loading data..."}
                                </p>
                                <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                    <div style={{ height: "100%", width: `${fetchProgress.percent}%`, background: "#111", borderRadius: "999px", transition: "width 0.3s ease" }} />
                                </div>
                                <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                    {fetchProgress.percent}%
                                </p>
                                <style>{`@keyframes eb-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
                            </div>
                        ) : (
                            <div className="eb-bulk-container">
                                <div className="eb-bulk-content">
                                    <div className="eb-bulk-table-wrapper">
                                        <div
                                            className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                            style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                        >
                                            <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                                <thead className="eb-bulk-table-head">
                                                    <tr className="eb-bulk-table-header-row">
                                                        <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                            <span className="eb-bulk-th-label">#</span>
                                                        </th>
                                                        <th className="eb-bulk-th">
                                                            <span className="eb-bulk-th-label">Reports & Document</span>
                                                        </th>
                                                        <th className="eb-bulk-th" style={{ textAlign: "center" }}>
                                                            <span className="eb-bulk-th-label">Total number of Copies</span>
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    {formData.length === 0 && (
                                                        <tr>
                                                            <td colSpan={3} style={{ textAlign: "center", padding: "24px" }}>
                                                                No reports & document data found for {month}/{year}
                                                            </td>
                                                        </tr>
                                                    )}

                                                    {formData.map((entry, index) => (
                                                        <tr key={index} className="eb-bulk-row">
                                                            <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                                {index + 1}.
                                                            </td>

                                                            <td className="eb-bulk-td">
                                                                <span style={{ fontWeight: 500 }}>
                                                                    {entry.boq_description || "TBN"}
                                                                </span>
                                                            </td>

                                                            <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                                <input
                                                                    type="number"
                                                                    step="any"
                                                                    min={0}
                                                                    id={`actual_month_${index}`}
                                                                    name="actual_month"
                                                                    placeholder="Total Copies"
                                                                    value={entry.actual_month ?? ""}
                                                                    onChange={(e) => handleInputChange(e, index)}
                                                                    className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
                                                                    style={{ width: "100px", textAlign: "center" }}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>

                                    <div className="eb-bulk-footer-actions">
                                        <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="eb-bulk-btn eb-bulk-btn-submit"
                                            disabled={loading || formData.length === 0}
                                            onClick={handleSubmit}
                                            style={{ background: "black" }}
                                        >
                                            {loading ? (
                                                <span className="eb-bulk-btn-loader">
                                                    <span className="eb-bulk-spinner"></span>
                                                    Updating...
                                                </span>
                                            ) : (
                                                <>
                                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                        <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                        <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                    </svg>
                                                    Update
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}

                        <ToastContainer
                            position="top-center"
                            autoClose={1000}
                            hideProgressBar={false}
                            newestOnTop={true}
                            closeOnClick
                            rtl={false}
                            pauseOnFocusLoss
                            draggable
                            pauseOnHover
                        />
                    </Modal.Body>
                </Modal>
            )}
        </>
    );
};
const UpdateReportsPrinttInvoicee = ({ i, p_id, invoice_id, getReportsPrinttinvoice }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        getReportsPrinting()
        setShow(true);
        setFormData(i);

    };

    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        month: "",
        current_invoice_amount: "",
        reportanddoc: "",
    });


    const [reportsPrinting, setReportsPrinting] = useState([]);

    const getReportsPrinting = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqreportsanddocprintbyproject/${p_id}/`);
            setReportsPrinting(res.data);
        } catch (err) { }
    };

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "invoice",
            "month",
            "current_invoice_amount",
            "reportanddoc",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoicereportsanddocument/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getReportsPrinttinvoice();
                    setShow(false);
                    toast.dismiss(loadingToastId);
                    toast.success("Data Updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button className="model-edit-button" title="Update Reports" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Reports & Document for Invoice</Modal.Title> </h1>

                            <div title="Reports & Document" className="flex-column form-group-selectt">
                                <label htmlFor="reportanddoc" className="form-labels  font-weight500    font-size-subheading">
                                    Reports & Document<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="reportanddoc"
                                    name="reportanddoc"
                                    placeholder="reportanddoc"
                                    value={formData.reportanddoc}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.reportanddoc ? "error" : inputState.reportanddoc ? "success" : ""}`}
                                >
                                    <option value="">Select Reports & Document*</option>
                                    {reportsPrinting?.sort((a, b) => a.description.localeCompare(b.description, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.description}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.reportanddoc && <span className="error-message font-size-text ">{errors.reportanddoc}</span>}
                            </div>

                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    Current Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>
                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}

                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteReportsPrinttInvoice = ({ i, getReportsPrinttinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoicereportsdocumentsprinting/${i.id}/`);
            if (response.status === 200) {
                getReportsPrinttinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Reports" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.item}</Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}
const DeleteReportsPrinttInvoiceDeduction = ({ i, getReportsPrinttinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoicereportsanddocument/${i.id}/`);
            if (response.status === 200) {
                getReportsPrinttinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Reports" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record of {i.item}</Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}

const RoadSurveyEquipmentInvoice = ({ p_id, invoice_id, usedfor, invoiceData, getRoadSurveyinvoice, month, year, logData }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [roadsurvey, setRoadsurvey] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
    const [invoiceIds, setInvoiceIds] = useState([]);
    const [months, setMonths] = useState([]);
    const [years, setyears] = useState([]);
    const [getResults, setGetResults] = useState([]);
    const [getSheetData, setGetSheetData] = useState([]);
    const [getAllResults, setGetAllResults] = useState([]);
    const [getTotalWithId, setGetTotalWithid] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [listLoaded, setListLoaded] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setListLoaded(false);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        await getRoadSurveyEquipment();
        setShow(true);
    };

    useEffect(() => {
        if (!show) return;
        if (listLoaded) {
            setModalLoading(false);
        } else {
            setModalLoading(true);
        }
    }, [listLoaded, show]);

    const [roadSureveyList, setroadSureveyList] = useState([]);

    useEffect(() => {
        if (show === true) {
            if (!month || !year) {
                console.error("Both month and year are required to fetch progress data.");
                return;
            }

            const getData = async () => {
                try {
                    let currentMonth = month - 1 === 0 ? 12 : month - 1;
                    let currentYear = month - 1 === 0 ? year - 1 : year;
                    let dataFound = false;
                    let currentPercent = 0;

                    const updateProgress = (percent, label) => {
                        currentPercent = Math.max(currentPercent, percent);
                        setFetchProgress({ percent: currentPercent, label });
                    };

                    updateProgress(5, "Connecting to server...");

                    while (!dataFound) {
                        updateProgress(10, "Fetching previous survey data...");
                        const response = await axios.get(
                            `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id}/${String(currentMonth).padStart(2, '0')}/${currentYear}/`
                        );

                        updateProgress(20, "Fetching withheld release data...");
                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                        const releaseRawData = releaseResponse.data;
                        setWithHeldReleaseData(releaseRawData);

                        const monthInt = parseInt(month, 10);
                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, '0');
                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                        const filterReleaseData = releaseRawData.filter(i =>
                            (i.month === monthCalculation && i.year === calculatedYear) &&
                            i?.deduction_data?.project === p_id
                        );
                        setfilterwithHeldReleaseData(filterReleaseData);

                        const invoiceIds = [...new Set(filterReleaseData.map(i => i?.deduction_data?.invoice_id))];
                        setInvoiceIds(invoiceIds);

                        let localAllResults = [];
                        let localSheetData = [];

                        if (invoiceIds.length > 0) {
                            updateProgress(35, "Fetching consultant invoices...");
                            const res = await axios.get(
                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                            );

                            const filteredData = res.data.filter(item => invoiceIds.includes(item.id));

                            if (filteredData.length > 0) {
                                const months = [...new Set(filteredData.map(i => i.month))];
                                const years = [...new Set(filteredData.map(i => i.year))];
                                setMonths(months);
                                setyears(years);

                                const totalMonthYearCalls = months.length * years.length;
                                let completedMonthYearCalls = 0;

                                for (const m of months) {
                                    for (const y of years) {
                                        try {
                                            const filterRes = await axios.get(
                                                `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id}/${m}/${y}/`
                                            );
                                            localAllResults.push(...filterRes.data);
                                        } catch (err) {
                                            console.error(`Failed for month: ${m}, year: ${y}`, err);
                                        }
                                        completedMonthYearCalls++;
                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
                                    }
                                }

                                const allIds = [...new Set(localAllResults.map(i => i.id).filter(Boolean))];
                                const totalIdCalls = allIds.length;
                                let completedIdCalls = 0;

                                for (const id of allIds) {
                                    try {
                                        const secondRes = await axios.get(
                                            `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfilter/${id}/`
                                        );
                                        localSheetData.push(...secondRes.data);
                                    } catch (err) {
                                        console.error(`Failed for id: ${id}`, err);
                                    }
                                    completedIdCalls++;
                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
                                    updateProgress(50 + idPercent, `Loading survey sheet ${completedIdCalls} of ${totalIdCalls}...`);
                                }

                                setGetSheetData(localSheetData);
                                const getboqIds = localAllResults.map(i => i?.roadsurvey_details?.id);
                                setGetResults(getboqIds);
                                setGetAllResults(localAllResults);
                            }
                        }

                        updateProgress(70, "Processing survey records...");
                        const data = response.data;
                        let selectedData = [];

                        if (data.length > 0) {
                            const uids = data.map(item => item.id).filter(Boolean);
                            let uidResults = [];
                            const totalUids = uids.length;
                            let completedUids = 0;

                            for (const uid of uids) {
                                const res = await axios.get(
                                    `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfilter/${uid}/`
                                );

                                if (!res.data || res.data.length === 0) {
                                    console.error(`No data found for UID ${uid}. Breaking loop.`);
                                    dataFound = false;
                                    break;
                                }

                                uidResults = [...uidResults, ...res.data];
                                completedUids++;
                                const uidPercent = Math.round((completedUids / totalUids) * 15);
                                updateProgress(70 + uidPercent, `Loading survey ${completedUids} of ${totalUids}...`);
                            }

                            if (!dataFound && uidResults.length === 0) break;
                            selectedData = uidResults;

                        } else {
                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);
                            currentMonth -= 1;
                            if (currentMonth === 0) {
                                currentMonth = 12;
                                currentYear -= 1;
                            }
                            if (currentYear < year - 1) {
                                console.error("No data found for the past 1 year.");
                                break;
                            }
                            continue;
                        }

                        if (selectedData.length > 0) {
                            updateProgress(90, "Calculating cumulative totals...");

                            const updatedGetAllResults = localSheetData.map((resultItem) => {
                                const matchingReleases = filterReleaseData.filter(
                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                                );
                                const totalReleaseAmount = matchingReleases.reduce((sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0), 0);
                                const totalDeductionAmount = matchingReleases.reduce((sum, r) => sum + (Number(r.deduction_amount) || 0), 0);
                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
                                const total = totalReleaseAmount + totalDeductionAmount;
                                return { id: resultItem?.roadsurvey_details?.id, total_AMOUNT: total, total_month_release: totalMonthRelease };
                            });
                            setGetTotalWithid(updatedGetAllResults);

                            const updatedData = selectedData.map((item) => {
                                const boqId = item?.roadsurvey_details?.id;
                                const getTotalWithid = updatedGetAllResults.filter(i => i.id === boqId);
                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                                const totalMonthRelease = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_month_release) || 0), 0);

                                const prevAmount = parseFloat(item.previous_invoice_total || 0);
                                const currentAmount = item.invoice_amount === null
                                    ? parseFloat(item.current_invoice_amount)
                                    : parseFloat(item.invoice_amount || 0);
                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

                                const prev = parseFloat(item.actual_month_total_previous || 0);
                                const current = parseFloat(item.actual_month || 0);
                                const newPrevious = prev + current + totalMonthRelease;

                                return {
                                    ...item,
                                    updated_previous_invoice_total: newPreviousAmount,
                                    updated_actual_month_total_previous: newPrevious,
                                };
                            });

                            updateProgress(100, "Done!");
                            setroadSureveyList(updatedData);
                            setListLoaded(true);
                            dataFound = true;
                        }
                    }

                    if (!dataFound) {
                        updateProgress(100, "No previous data found.");
                        setListLoaded(true);
                    }

                } catch (error) {
                    console.error("Error fetching progress data:", error);
                    setFetchProgress({ percent: 100, label: "Error loading data." });
                    setListLoaded(true);
                }
            };

            getData();
        }
    }, [month, year, show]);

    const [logid, setLogId] = useState("null");

    const roadSurveyID = roadsurvey.map(e => e.id);
    const roadSurveydataData = logData.filter(item => roadSurveyID.includes(item.object_id));
    const roadSurveyChangeReason = roadsurvey[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        roadSurveydataData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup = logid === "null"
        ? roadsurvey
        : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    const getRoadSurveyEquipment = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqroadsurveyequipmentbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setRoadsurvey(res.data);
            } else {
                console.error("Error: Expected a list of roadsurvey items");
            }
        } catch (err) {
            console.error("Error fetching road survey data", err);
        }
    };

    useEffect(() => {
        if (roadsurvey.length === 0) return;

        const initialData = selectedGroup.map((item) => {
            const id = item.object_id ?? item.id;
            const matchedProgress = roadSureveyList.find((progress) => progress.roadsurvey === id);

            let eot_details;
            if (logid === "null") {
                eot_details = item.eot_details?.map((item) => item);
            } else {
                eot_details = item?.data?.eot_details?.map((item) => item);
            }

            return {
                project: p_id,
                invoice: invoice_id,
                roadsurvey: id,
                actual_month: "",
                month: month,
                year: year,
                actual_month_cumulative_total: "",
                cumulative_invoice_total: "",
                contract_amount: "",
                remaining_amount: "",
                actual_month_remaining: "",
                invoice_amount: "",
                previous_invoice_total: matchedProgress?.updated_previous_invoice_total?.toString() ?? "0",
                actual_month_total_previous: matchedProgress?.updated_actual_month_total_previous?.toString() ?? "0",
                boq_rate_per_km_times: item.rate_per_km_times ?? item.data?.rate_per_km_times,
                boq_num_of_times_survey_concluded: item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded,
                boq_KM: item.KM ?? item.data?.KM,
                boq_description: item.description ?? item.data?.description,
                eot_details: eot_details,
            };
        });

        setFormData(initialData);
    }, [logid, roadsurvey, roadSureveyList]);

    const [finalFormData, setFinalFormData] = useState([]);

    useEffect(() => {
        if (formData?.length > 0) {
            setFinalFormData(formData);
        }
    }, [formData]);

    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            const requiredFields = [];
            requiredFields.forEach(field => {
                if (!entry[field]) {
                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");

            if (usedfor === "InvoiceandDeduction") {
                try {
                    const res = await axios.post(
                        `${BASE_URL}/siteproject/bulkinvoiceroadsurveyequipment/`,
                        formData
                    );

                    if (res.status === 201) {
                        const createdData = res.data;
                        const mappedFinalData = finalFormData.map((item, index) => ({
                            ...item,
                            invoiceroadsurvey: createdData[index]?.id,
                        }));

                        const res2 = await axios.post(
                            `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentlistcreate/`,
                            mappedFinalData
                        );

                        if (res2.status === 201) {
                            await getRoadSurveyinvoice();
                            setShow(false);
                            toast.dismiss(loadingToastId);
                            toast.success("Data added Successfully");
                        } else {
                            alert("Second API failed");
                        }
                    } else {
                        alert("First API failed");
                    }
                } catch (err) {
                    handleErrorToast(err, loadingToastId);
                } finally {
                    setLoading(false);
                    toast.dismiss(loadingToastId);
                }
            } else if (usedfor === "OnlyDeduction") {
                try {
                    const createdData = invoiceData;
                    const mappedFinalData = finalFormData.map((item, index) => ({
                        ...item,
                        invoiceroadsurvey: createdData[index]?.id,
                    }));

                    const res2 = await axios.post(
                        `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentlistcreate/`,
                        mappedFinalData
                    );

                    if (res2.status === 201) {
                        await getRoadSurveyinvoice();
                        setShow(false);
                        toast.dismiss(loadingToastId);
                        toast.success("Data added Successfully");
                    } else {
                        alert("Second API failed");
                    }
                } catch (error) {
                    handleErrorToast(error, loadingToastId);
                } finally {
                    setLoading(false);
                    toast.dismiss(loadingToastId);
                }
            }
        }
    };

    const handleInputChange = (e, index) => {
        const { name, value } = e.target;

        const updatedFormData = formData.map((entry, i) => {
            if (i !== index) return entry;

            const updatedEntry = { ...entry, [name]: value };

            const cp = entry.boq_num_of_times_survey_concluded;
            const dlp = entry.boq_KM;

            let rate;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                rate = Number(lastEOT.rate_per_km_times || 0);
            } else {
                rate = Number(entry.boq_rate_per_km_times || 0);
            }
            let month;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                month = Number(lastEOT.num_of_times_survey_concluded || 0) * Number(lastEOT.KM || 0);
            } else {
                month = Number(cp) * Number(dlp);
            }
            let total;
            if (entry.eot_details && entry.eot_details.length > 0) {
                const lastEOT = entry.eot_details[entry.eot_details.length - 1];
                total = Number(lastEOT.total_amount || 0);
            } else {
                total = Number(rate) * Number(month);
            }

            const previous = entry.actual_month_total_previous;
            const previousAmount = entry.previous_invoice_total;
            const actualMonth = name === "actual_month"
                ? parseFloat(value) || 0
                : parseFloat(entry.actual_month) || 0;

            const invoiceAmount = Number(rate) * Number(actualMonth) * Number(dlp);
            updatedEntry.invoice_amount = invoiceAmount.toFixed(2);
            updatedEntry.actual_month_cumulative_total = Number(previous) + Number(actualMonth);
            updatedEntry.cumulative_invoice_total = Number(previousAmount) + Number(updatedEntry.invoice_amount);
            updatedEntry.actual_month_remaining = Number(cp) - Number(updatedEntry.actual_month_cumulative_total);
            updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

            return updatedEntry;
        });

        setFormData(updatedFormData);
    };

    return (
        <>
            <button title="Add Road Survey Equipment" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Road Survey Equipment {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
                <Modal.Header className="eb-bulk-modal-header">
                    <Modal.Title className="eb-bulk-modal-title">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
                            <line x1="12" y1="12" x2="12" y2="16" />
                            <line x1="10" y1="14" x2="14" y2="14" />
                        </svg>
                        Add Road Survey Equipment {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                    </Modal.Title>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {(roadsurvey.length > 0 && groupedByRandomChange.length > 0) && (
                            <select
                                value={logid}
                                onChange={(e) => setLogId(e.target.value)}
                                style={{
                                    fontSize: "13px",
                                    background: "var(--surface-2, #fff)",
                                    border: "0.5px solid var(--border-strong, #ccc)",
                                    borderRadius: "var(--radius, 8px)",
                                    padding: "4px 10px",
                                    cursor: "pointer",
                                    color: "var(--text-primary)",
                                }}
                            >
                                <option value="null">
                                    BOQ {groupedByRandomChange.length + 1} - {roadSurveyChangeReason}
                                </option>
                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                    const reasons = [...new Set(
                                        items.map(i => i.data?.reason_of_change).filter(reason =>
                                            reason !== null && reason !== "null" && reason?.trim() !== ""
                                        )
                                    )];
                                    return (
                                        <option key={groupKey} value={groupKey}>
                                            BOQ {groupedByRandomChange.length - index}
                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                        </option>
                                    );
                                })}
                            </select>
                        )}
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body className="eb-bulk-modal-body">
                    {modalLoading ? (
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            minHeight: "50vh",
                            gap: "20px",
                            padding: "40px",
                        }}>
                            <div style={{
                                width: "44px",
                                height: "44px",
                                border: "3px solid #e0e0e0",
                                borderTop: "3px solid #000",
                                borderRadius: "50%",
                                animation: "eb-spin 0.8s linear infinite",
                            }} />
                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                {fetchProgress.label || "Loading data..."}
                            </p>
                            <div style={{ width: "100%", maxWidth: "360px", background: "#e0e0e0", borderRadius: "999px", height: "6px", overflow: "hidden" }}>
                                <div style={{
                                    height: "100%",
                                    width: `${fetchProgress.percent}%`,
                                    background: "#111",
                                    borderRadius: "999px",
                                    transition: "width 0.3s ease",
                                }} />
                            </div>
                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>
                                {fetchProgress.percent}%
                            </p>
                            <style>{`
                                @keyframes eb-spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    ) : (
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}>
                                        <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                            <thead className="eb-bulk-table-head">
                                                <tr className="eb-bulk-table-header-row">
                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                        <span className="eb-bulk-th-label">#</span>
                                                    </th>
                                                    <th className="eb-bulk-th">
                                                        <span className="eb-bulk-th-label">Road Survey Equipment</span>
                                                    </th>
                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>
                                                        <span className="eb-bulk-th-label">Actual Month</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.map((entry, index) => (
                                                    <tr key={index} className="eb-bulk-row">
                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                            {index + 1}.
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <span style={{ fontWeight: 500 }}>
                                                                {entry.boq_description || "—"}
                                                            </span>
                                                        </td>
                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                            <input
                                                                type="number"
                                                                id={`actual_month_${index}`}
                                                                name="actual_month"
                                                                placeholder="Actual Month"
                                                                value={entry.actual_month}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""}`}
                                                                style={{ width: "100px", textAlign: "center" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Submitting...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Add
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


const RoadSurveyEquipmentInvoiceUpdate = ({ p_id, invoice_id, usedfor, invoiceData, getRoadSurveyinvoice, month, year, logData }) => {
    const [show, setShow] = useState(false);
    const [formData, setFormData] = useState([]);
    const [roadsurvey, setRoadsurvey] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [withHeldReleaseData, setWithHeldReleaseData] = useState([]);
    const [filterwithHeldReleaseData, setfilterwithHeldReleaseData] = useState([]);
    const [invoiceIds, setInvoiceIds] = useState([]);
    const [months, setMonths] = useState([]);
    const [years, setyears] = useState([]);
    const [getResults, setGetResults] = useState([]);
    const [getSheetData, setGetSheetData] = useState([]);
    const [getAllResults, setGetAllResults] = useState([]);
    const [getTotalWithId, setGetTotalWithid] = useState([]);
    const [modalLoading, setModalLoading] = useState(false);
    const [listLoaded, setListLoaded] = useState(false);
    const [fetchProgress, setFetchProgress] = useState({ percent: 0, label: "" });

    const handleClose = () => {
        setShow(false);
        setModalLoading(false);
        setListLoaded(false);
        setFetchProgress({ percent: 0, label: "" });
    };

    const handleShow = async () => {
        await getRoadSurveyEquipment();
        setShow(true);
    };

    useEffect(() => {
        if (!show) return;
        if (listLoaded) {
            setModalLoading(false);
        } else {
            setModalLoading(true);
        }
    }, [listLoaded, show]);

    const [roadSureveyList, setroadSureveyList] = useState([]);

    // ---------------------------------------------------------------
    // Previous month / withheld release data (create component jaisa hi)
    // ---------------------------------------------------------------
    useEffect(() => {
        if (show === true) {
            if (!month || !year) {
                console.error("Both month and year are required to fetch progress data.");
                return;
            }

            const getData = async () => {
                try {
                    let currentMonth = month - 1 === 0 ? 12 : month - 1;
                    let currentYear = month - 1 === 0 ? year - 1 : year;
                    let dataFound = false;
                    let currentPercent = 0;

                    const updateProgress = (percent, label) => {
                        currentPercent = Math.max(currentPercent, percent);
                        setFetchProgress({ percent: currentPercent, label });
                    };

                    updateProgress(5, "Connecting to server...");

                    while (!dataFound) {
                        updateProgress(10, "Fetching previous survey data...");
                        const response = await axios.get(
                            `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id}/${String(currentMonth).padStart(2, "0")}/${currentYear}/`
                        );

                        updateProgress(20, "Fetching withheld release data...");
                        const releaseResponse = await axios.get(`${BASE_URL}/siteproject/invoice-deduction-release/`);
                        const releaseRawData = releaseResponse.data;
                        setWithHeldReleaseData(releaseRawData);

                        const monthInt = parseInt(month, 10);
                        const monthCalculation = String(monthInt - 1 === 0 ? 12 : monthInt - 1).padStart(2, "0");
                        const calculatedYear = monthInt - 1 === 0 ? year - 1 : year;

                        const filterReleaseData = releaseRawData.filter(
                            (i) =>
                                i.month === monthCalculation &&
                                i.year === calculatedYear &&
                                i?.deduction_data?.project === p_id
                        );
                        setfilterwithHeldReleaseData(filterReleaseData);

                        const invoiceIds = [...new Set(filterReleaseData.map((i) => i?.deduction_data?.invoice_id))];
                        setInvoiceIds(invoiceIds);

                        let localAllResults = [];
                        let localSheetData = [];

                        if (invoiceIds.length > 0) {
                            updateProgress(35, "Fetching consultant invoices...");
                            const res = await axios.get(
                                `${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${p_id}/null/null/`
                            );

                            const filteredData = res.data.filter((item) => invoiceIds.includes(item.id));

                            if (filteredData.length > 0) {
                                const months = [...new Set(filteredData.map((i) => i.month))];
                                const years = [...new Set(filteredData.map((i) => i.year))];
                                setMonths(months);
                                setyears(years);

                                const totalMonthYearCalls = months.length * years.length;
                                let completedMonthYearCalls = 0;

                                for (const m of months) {
                                    for (const y of years) {
                                        try {
                                            const filterRes = await axios.get(
                                                `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id}/${m}/${y}/`
                                            );
                                            localAllResults.push(...filterRes.data);
                                        } catch (err) {
                                            console.error(`Failed for month: ${m}, year: ${y}`, err);
                                        }
                                        completedMonthYearCalls++;
                                        const monthYearPercent = Math.round((completedMonthYearCalls / totalMonthYearCalls) * 15);
                                        updateProgress(35 + monthYearPercent, `Fetching BOQ data for ${m}/${y}...`);
                                    }
                                }

                                const allIds = [...new Set(localAllResults.map((i) => i.id).filter(Boolean))];
                                const totalIdCalls = allIds.length;
                                let completedIdCalls = 0;

                                for (const id of allIds) {
                                    try {
                                        const secondRes = await axios.get(
                                            `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfilter/${id}/`
                                        );
                                        localSheetData.push(...secondRes.data);
                                    } catch (err) {
                                        console.error(`Failed for id: ${id}`, err);
                                    }
                                    completedIdCalls++;
                                    const idPercent = Math.round((completedIdCalls / totalIdCalls) * 15);
                                    updateProgress(50 + idPercent, `Loading survey sheet ${completedIdCalls} of ${totalIdCalls}...`);
                                }

                                setGetSheetData(localSheetData);
                                const getboqIds = localAllResults.map((i) => i?.roadsurvey_details?.id);
                                setGetResults(getboqIds);
                                setGetAllResults(localAllResults);
                            }
                        }

                        updateProgress(70, "Processing survey records...");
                        const data = response.data;
                        let selectedData = [];

                        if (data.length > 0) {
                            const uids = data.map((item) => item.id).filter(Boolean);
                            let uidResults = [];
                            const totalUids = uids.length;
                            let completedUids = 0;

                            for (const uid of uids) {
                                const res = await axios.get(
                                    `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfilter/${uid}/`
                                );

                                if (!res.data || res.data.length === 0) {
                                    console.error(`No data found for UID ${uid}. Breaking loop.`);
                                    dataFound = false;
                                    break;
                                }

                                uidResults = [...uidResults, ...res.data];
                                completedUids++;
                                const uidPercent = Math.round((completedUids / totalUids) * 15);
                                updateProgress(70 + uidPercent, `Loading survey ${completedUids} of ${totalUids}...`);
                            }

                            if (!dataFound && uidResults.length === 0) break;
                            selectedData = uidResults;
                        } else {
                            updateProgress(currentPercent, `No data for ${currentMonth}/${currentYear}, checking previous month...`);
                            currentMonth -= 1;
                            if (currentMonth === 0) {
                                currentMonth = 12;
                                currentYear -= 1;
                            }
                            if (currentYear < year - 1) {
                                console.error("No data found for the past 1 year.");
                                break;
                            }
                            continue;
                        }

                        if (selectedData.length > 0) {
                            updateProgress(90, "Calculating cumulative totals...");

                            const updatedGetAllResults = localSheetData.map((resultItem) => {
                                const matchingReleases = filterReleaseData.filter(
                                    (r) => String(r?.deduction_data?.item_id) === String(resultItem.id)
                                );
                                const totalReleaseAmount = matchingReleases.reduce(
                                    (sum, r) => sum + (parseFloat(r.withheld_release_amount) || 0),
                                    0
                                );
                                const totalDeductionAmount = matchingReleases.reduce(
                                    (sum, r) => sum + (Number(r.deduction_amount) || 0),
                                    0
                                );
                                const totalMonthRelease = matchingReleases.reduce((sum, r) => sum + (r.release_month || 0), 0);
                                const total = totalReleaseAmount + totalDeductionAmount;
                                return {
                                    id: resultItem?.roadsurvey_details?.id,
                                    total_AMOUNT: total,
                                    total_month_release: totalMonthRelease,
                                };
                            });
                            setGetTotalWithid(updatedGetAllResults);

                            const updatedData = selectedData.map((item) => {
                                const boqId = item?.roadsurvey_details?.id;
                                const getTotalWithid = updatedGetAllResults.filter((i) => i.id === boqId);
                                const totalReleaseAmount = getTotalWithid.reduce((sum, i) => sum + (Number(i.total_AMOUNT) || 0), 0);
                                const totalMonthRelease = getTotalWithid.reduce(
                                    (sum, i) => sum + (Number(i.total_month_release) || 0),
                                    0
                                );

                                const prevAmount = parseFloat(item.previous_invoice_total || 0);
                                const currentAmount =
                                    item.invoice_amount === null
                                        ? parseFloat(item.current_invoice_amount)
                                        : parseFloat(item.invoice_amount || 0);
                                const newPreviousAmount = prevAmount + currentAmount + totalReleaseAmount;

                                const prev = parseFloat(item.actual_month_total_previous || 0);
                                const current = parseFloat(item.actual_month || 0);
                                const newPrevious = prev + current + totalMonthRelease;

                                return {
                                    ...item,
                                    updated_previous_invoice_total: newPreviousAmount,
                                    updated_actual_month_total_previous: newPrevious,
                                };
                            });

                            updateProgress(100, "Done!");
                            setroadSureveyList(updatedData);
                            setListLoaded(true);
                            dataFound = true;
                        }
                    }

                    if (!dataFound) {
                        updateProgress(100, "No previous data found.");
                        setListLoaded(true);
                    }
                } catch (error) {
                    console.error("Error fetching progress data:", error);
                    setFetchProgress({ percent: 100, label: "Error loading data." });
                    setListLoaded(true);
                }
            };

            getData();
        }
    }, [month, year, show]);

    // ---------------------------------------------------------------
    // BOQ log / version selection
    // ---------------------------------------------------------------
    const [logid, setLogId] = useState("null");

    const roadSurveyID = roadsurvey.map((e) => e.id);
    const roadSurveydataData = logData.filter((item) => roadSurveyID.includes(item.object_id));
    const roadSurveyChangeReason = roadsurvey[0]?.reason_of_change || "";

    const groupedByRandomChange = Object.entries(
        roadSurveydataData.reduce((acc, item) => {
            const groupKey = item.data?.random_value_of_changes;
            if (!acc[groupKey]) acc[groupKey] = [];
            acc[groupKey].push(item);
            return acc;
        }, {})
    ).sort((a, b) => new Date(b[0]) - new Date(a[0]));

    const selectedGroup =
        logid === "null" ? roadsurvey : groupedByRandomChange.find(([key]) => key === logid)?.[1] || [];

    const getRoadSurveyEquipment = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/boqroadsurveyequipmentbyproject/${p_id}/`);
            if (Array.isArray(res.data)) {
                setRoadsurvey(res.data);
            } else {
                console.error("Error: Expected a list of roadsurvey items");
            }
        } catch (err) {
            console.error("Error fetching road survey data", err);
        }
    };

    // ---------------------------------------------------------------
    // Calculation helper (create wale handleInputChange ka same logic)
    // ---------------------------------------------------------------
    const calculateEntry = (entry, actualMonthValue) => {
        const updatedEntry = { ...entry, actual_month: actualMonthValue };

        const cp = entry.boq_num_of_times_survey_concluded;
        const dlp = entry.boq_KM;

        let rate;
        if (entry.eot_details && entry.eot_details.length > 0) {
            const lastEOT = entry.eot_details[entry.eot_details.length - 1];
            rate = Number(lastEOT.rate_per_km_times || 0);
        } else {
            rate = Number(entry.boq_rate_per_km_times || 0);
        }

        let monthVal;
        if (entry.eot_details && entry.eot_details.length > 0) {
            const lastEOT = entry.eot_details[entry.eot_details.length - 1];
            monthVal = Number(lastEOT.num_of_times_survey_concluded || 0) * Number(lastEOT.KM || 0);
        } else {
            monthVal = Number(cp) * Number(dlp);
        }

        let total;
        if (entry.eot_details && entry.eot_details.length > 0) {
            const lastEOT = entry.eot_details[entry.eot_details.length - 1];
            total = Number(lastEOT.total_amount || 0);
        } else {
            total = Number(rate) * Number(monthVal);
        }

        const previous = entry.actual_month_total_previous;
        const previousAmount = entry.previous_invoice_total;
        const actualMonth = parseFloat(actualMonthValue) || 0;

        const invoiceAmount = Number(rate) * Number(actualMonth) * Number(dlp);
        updatedEntry.invoice_amount = invoiceAmount.toFixed(2);
        updatedEntry.actual_month_cumulative_total = Number(previous) + Number(actualMonth);
        updatedEntry.cumulative_invoice_total = Number(previousAmount) + Number(updatedEntry.invoice_amount);
        updatedEntry.actual_month_remaining = Number(cp) - Number(updatedEntry.actual_month_cumulative_total);
        updatedEntry.remaining_amount = Number(total) - Number(updatedEntry.cumulative_invoice_total);

        return updatedEntry;
    };

    // ---------------------------------------------------------------
    // Initial form data: BOQ + existing invoice record (prefill)
    // ---------------------------------------------------------------
    useEffect(() => {
        if (roadsurvey.length === 0) return;

        const initialData = selectedGroup.map((item) => {
            const id = item.object_id ?? item.id;
            const matchedProgress = roadSureveyList.find((progress) => progress.roadsurvey === id);

            // Already saved invoice record (isi ko update karna hai)
            const existing = Array.isArray(invoiceData)
                ? invoiceData.find((inv) => String(inv.roadsurvey) === String(id))
                : null;

            let eot_details;
            if (logid === "null") {
                eot_details = item.eot_details?.map((item) => item);
            } else {
                eot_details = item?.data?.eot_details?.map((item) => item);
            }

            const base = {
                id: existing?.id, // <-- bulk-update ke liye zaroori
                project: p_id,
                invoice: invoice_id,
                roadsurvey: id,
                actual_month: "",
                month: month,
                year: year,
                actual_month_cumulative_total: "",
                cumulative_invoice_total: "",
                contract_amount: "",
                remaining_amount: "",
                actual_month_remaining: "",
                invoice_amount: "",
                previous_invoice_total:
                    matchedProgress?.updated_previous_invoice_total?.toString() ??
                    existing?.previous_invoice_total?.toString() ??
                    "0",
                actual_month_total_previous:
                    matchedProgress?.updated_actual_month_total_previous?.toString() ??
                    existing?.actual_month_total_previous?.toString() ??
                    "0",
                boq_rate_per_km_times: item.rate_per_km_times ?? item.data?.rate_per_km_times,
                boq_num_of_times_survey_concluded:
                    item.num_of_times_survey_concluded ?? item.data?.num_of_times_survey_concluded,
                boq_KM: item.KM ?? item.data?.KM,
                boq_description: item.description ?? item.data?.description,
                eot_details: eot_details,
            };

            // Existing actual_month ke saath saare derived fields dobara calculate
            const existingActual = existing?.actual_month ?? "";
            return existingActual !== "" && existingActual !== null
                ? calculateEntry(base, existingActual)
                : base;
        });

        setFormData(initialData);
    }, [logid, roadsurvey, roadSureveyList, invoiceData]);

    const validateForm = () => {
        const newErrors = {};
        formData.forEach((entry, index) => {
            const requiredFields = [];
            requiredFields.forEach((field) => {
                if (!entry[field]) {
                    newErrors[`${index}_${field}`] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
                }
            });
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // // ---------------------------------------------------------------
    // // Submit -> invoiceroadsurveyequipment/bulk-update/
    // // ---------------------------------------------------------------
    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (!validateForm()) return;

    //     // sirf wahi rows bhejo jinka existing record (id) hai
    //     const payload = formData.filter((item) => item.id);

    //     if (payload.length === 0) {
    //         toast.error("No existing records found to update");
    //         return;
    //     }

    //     setLoading(true);
    //     const loadingToastId = toast.loading("Updating: Please wait...");

    //     try {
    //         // Agar backend PATCH leta hai to axios.patch kar dein
    //         const res = await axios.put(
    //             `${BASE_URL}/siteproject/invoiceroadsurveyequipment/bulk-update/`,
    //             payload
    //         );

    //         if (res.status === 200 || res.status === 201) {
    //             await getRoadSurveyinvoice();
    //             setShow(false);
    //             toast.dismiss(loadingToastId);
    //             toast.success("Data updated Successfully");
    //         } else {
    //             alert("Update API failed");
    //         }
    //     } catch (err) {
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setLoading(false);
    //         toast.dismiss(loadingToastId);
    //     }
    // };

    // ---------------------------------------------------------------
    // Submit -> invoiceroadsurveyequipment/bulk-update/ + claim update
    // ---------------------------------------------------------------
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        // sirf wahi rows bhejo jinka existing record (id) hai
        const payload = formData.filter((item) => item.id);

        if (payload.length === 0) {
            toast.error("No existing records found to update");
            return;
        }

        setLoading(true);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            // 1st API: invoice road survey bulk update
            const res = await axios.put(
                `${BASE_URL}/siteproject/invoiceroadsurveyequipment/bulk-update/`,
                payload
            );

            if (res.status === 200 || res.status === 201) {
                // 2nd API: claim (new invoice road survey) rows fetch
                const claimRes = await axios.get(
                    `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfiltermonthyear/${invoice_id}/${String(month).padStart(2, "0")}/${year}/`
                );
                const claimRows = Array.isArray(claimRes.data) ? claimRes.data : [];

                // invoiceroadsurveyequipment.id == claim.invoiceroadsurvey
                const claimPayload = payload.flatMap((item) => {
                    const matches = claimRows.filter(
                        (row) => String(row.invoiceroadsurvey) === String(item.id)
                    );

                    return matches.map((row) => ({
                        ...row,                        // claim ke baaki fields bache rahein
                        ...item,                       // updated invoice data replicate
                        id: row.id,                    // claim row ki apni id
                        invoiceroadsurvey: item.id,    // link wapas invoice row se
                    }));
                });

                if (claimPayload.length > 0) {
                    // 3rd API: claim update
                    await axios.put(
                        `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentupdatedelete/null/`,
                        claimPayload
                    );
                } else {
                    console.warn("Claim me koi matching invoiceroadsurvey nahi mili");
                }

                await getRoadSurveyinvoice();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Data updated Successfully");
            } else {
                alert("Update API failed");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };
    const handleInputChange = (e, index) => {
        const { value } = e.target;
        const updatedFormData = formData.map((entry, i) => (i !== index ? entry : calculateEntry(entry, value)));
        setFormData(updatedFormData);
    };

    return (
        <>
            <button
                title="Update Road Survey Equipment"
                className="eb-bulk-trigger-btn"
                onClick={handleShow}
                style={{ background: "black" }}
            >
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M12 20h9" />
                    <path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z" />
                </svg>
                Update Road Survey Equipment {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
                <Modal.Header className="eb-bulk-modal-header">
                    <Modal.Title className="eb-bulk-modal-title">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
                            <line x1="12" y1="12" x2="12" y2="16" />
                            <line x1="10" y1="14" x2="14" y2="14" />
                        </svg>
                        Update Road Survey Equipment {usedfor === "OnlyDeduction" ? "Deduction Invoice" : "Invoice"}
                    </Modal.Title>

                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {roadsurvey.length > 0 && groupedByRandomChange.length > 0 && (
                            <select
                                value={logid}
                                onChange={(e) => setLogId(e.target.value)}
                                style={{
                                    fontSize: "13px",
                                    background: "var(--surface-2, #fff)",
                                    border: "0.5px solid var(--border-strong, #ccc)",
                                    borderRadius: "var(--radius, 8px)",
                                    padding: "4px 10px",
                                    cursor: "pointer",
                                    color: "var(--text-primary)",
                                }}
                            >
                                <option value="null">
                                    BOQ {groupedByRandomChange.length + 1} - {roadSurveyChangeReason}
                                </option>
                                {groupedByRandomChange.map(([groupKey, items], index) => {
                                    const reasons = [
                                        ...new Set(
                                            items
                                                .map((i) => i.data?.reason_of_change)
                                                .filter((reason) => reason !== null && reason !== "null" && reason?.trim() !== "")
                                        ),
                                    ];
                                    return (
                                        <option key={groupKey} value={groupKey}>
                                            BOQ {groupedByRandomChange.length - index}
                                            {reasons.length > 0 ? ` - ${reasons.join(", ")}` : ""}
                                        </option>
                                    );
                                })}
                            </select>
                        )}
                        <button className="close-btn" onClick={handleClose}>
                            <X size={20} />
                        </button>
                    </div>
                </Modal.Header>

                <Modal.Body className="eb-bulk-modal-body">
                    {modalLoading ? (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                minHeight: "50vh",
                                gap: "20px",
                                padding: "40px",
                            }}
                        >
                            <div
                                style={{
                                    width: "44px",
                                    height: "44px",
                                    border: "3px solid #e0e0e0",
                                    borderTop: "3px solid #000",
                                    borderRadius: "50%",
                                    animation: "eb-spin 0.8s linear infinite",
                                }}
                            />
                            <p style={{ color: "var(--text-secondary)", fontSize: "14px", margin: 0, textAlign: "center" }}>
                                {fetchProgress.label || "Loading data..."}
                            </p>
                            <div
                                style={{
                                    width: "100%",
                                    maxWidth: "360px",
                                    background: "#e0e0e0",
                                    borderRadius: "999px",
                                    height: "6px",
                                    overflow: "hidden",
                                }}
                            >
                                <div
                                    style={{
                                        height: "100%",
                                        width: `${fetchProgress.percent}%`,
                                        background: "#111",
                                        borderRadius: "999px",
                                        transition: "width 0.3s ease",
                                    }}
                                />
                            </div>
                            <p style={{ color: "var(--text-muted)", fontSize: "12px", margin: 0 }}>{fetchProgress.percent}%</p>
                            <style>{`
                                @keyframes eb-spin {
                                    0% { transform: rotate(0deg); }
                                    100% { transform: rotate(360deg); }
                                }
                            `}</style>
                        </div>
                    ) : (
                        <div className="eb-bulk-container">
                            <div className="eb-bulk-content">
                                <div className="eb-bulk-table-wrapper">
                                    <div
                                        className="eb-bulk-table-scroll table-box scroll-container-tablesss"
                                        style={{ maxHeight: "50vh", minHeight: "50vh" }}
                                    >
                                        <table className="eb-bulk-table" style={{ minWidth: "100%" }}>
                                            <thead className="eb-bulk-table-head">
                                                <tr className="eb-bulk-table-header-row">
                                                    <th className="eb-bulk-th" style={{ width: "48px" }}>
                                                        <span className="eb-bulk-th-label">#</span>
                                                    </th>
                                                    <th className="eb-bulk-th">
                                                        <span className="eb-bulk-th-label">Road Survey Equipment</span>
                                                    </th>
                                                    <th className="eb-bulk-th" style={{ textAlign: "center" }}>
                                                        <span className="eb-bulk-th-label">Actual Month</span>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {formData.map((entry, index) => (
                                                    <tr key={entry.id ?? index} className="eb-bulk-row">
                                                        <td className="eb-bulk-td" style={{ color: "var(--text-muted)", fontSize: "12px" }}>
                                                            {index + 1}.
                                                        </td>
                                                        <td className="eb-bulk-td">
                                                            <span style={{ fontWeight: 500 }}>{entry.boq_description || "—"}</span>
                                                        </td>
                                                        <td className="eb-bulk-td" style={{ textAlign: "center" }}>
                                                            <input
                                                                type="number"
                                                                id={`actual_month_${index}`}
                                                                name="actual_month"
                                                                placeholder="Actual Month"
                                                                value={entry.actual_month}
                                                                onChange={(e) => handleInputChange(e, index)}
                                                                className={`eb-bulk-input eb-bulk-input-number ${errors[`${index}_actual_month`] ? "eb-bulk-input-error" : ""
                                                                    }`}
                                                                style={{ width: "100px", textAlign: "center" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                                <div className="eb-bulk-footer-actions">
                                    <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="eb-bulk-btn eb-bulk-btn-submit"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                        style={{ background: "black" }}
                                    >
                                        {loading ? (
                                            <span className="eb-bulk-btn-loader">
                                                <span className="eb-bulk-spinner"></span>
                                                Updating...
                                            </span>
                                        ) : (
                                            <>
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                    <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                    <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                                </svg>
                                                Update
                                            </>
                                        )}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateRoadSurveyEquipmentInvoice = ({ i, p_id, invoice_id, getRoadSurveyinvoice }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        getRoadSurveyEquipment()
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        project: p_id,
        invoice: invoice_id,
        month: "",
        current_invoice_amount: "",
        roadsurvey: "",
    });


    const [reportsPrinting, setReportsPrinting] = useState([]);

    const getRoadSurveyEquipment = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqroadsurveyequipmentbyproject/${p_id}/`);
            setReportsPrinting(res.data);
        } catch (err) { }
    };

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "project",
            "invoice",
            "month",
            "current_invoice_amount",
            "roadsurvey",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/invoiceroadsurveyequipment/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getRoadSurveyinvoice();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Data updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//



    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button className="model-edit-button" title="Update Road Survey" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.9834 5.1589L12.8412 2.01734C12.7367 1.91285 12.6127 1.82996 12.4762 1.7734C12.3397 1.71685 12.1933 1.68774 12.0456 1.68774C11.8978 1.68774 11.7515 1.71685 11.615 1.7734C11.4785 1.82996 11.3545 1.91285 11.25 2.01734L2.57977 10.6876C2.47485 10.7917 2.39167 10.9156 2.33506 11.0521C2.27844 11.1886 2.24953 11.335 2.25001 11.4828V14.6251C2.25001 14.9234 2.36853 15.2096 2.57951 15.4206C2.79049 15.6315 3.07664 15.7501 3.37501 15.7501H15.1875C15.3367 15.7501 15.4798 15.6908 15.5853 15.5853C15.6907 15.4798 15.75 15.3368 15.75 15.1876C15.75 15.0384 15.6907 14.8953 15.5853 14.7898C15.4798 14.6843 15.3367 14.6251 15.1875 14.6251H8.10844L15.9834 6.75007C16.0879 6.6456 16.1708 6.52157 16.2274 6.38507C16.2839 6.24856 16.313 6.10225 16.313 5.95449C16.313 5.80673 16.2839 5.66042 16.2274 5.52391C16.1708 5.3874 16.0879 5.26337 15.9834 5.1589ZM6.51727 14.6251H3.37501V11.4828L9.56251 5.29531L12.7048 8.43757L6.51727 14.6251ZM13.5 7.64234L10.3584 4.50007L12.0459 2.81257L15.1875 5.95484L13.5 7.64234Z"
                        fill="#145650"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Update Road Survey Equipment for Invoice</Modal.Title> </h1>

                            <div title="Road Survey Equipment" className="flex-column form-group-selectt">
                                <label htmlFor="roadsurvey" className="form-labels  font-weight500    font-size-subheading">
                                    Road Survey Equipment<span className="required">*</span>
                                </label>
                                <br />
                                <select
                                    id="roadsurvey"
                                    name="roadsurvey"
                                    placeholder="Road Survey Equipment"
                                    value={formData.roadsurvey}
                                    onChange={handleInputChange}
                                    className={`form-input form-group-selection ${errors.roadsurvey ? "error" : inputState.roadsurvey ? "success" : ""}`}
                                >
                                    <option value="">Select Road Survey Equipment</option>
                                    {reportsPrinting?.sort((a, b) => a.description.localeCompare(b.description, 'en', { ignorePunctuation: true })).map((i, index) => (
                                        <option key={index} value={i.id}>{i.description}</option>
                                    ))}
                                </select>
                                <div className="form-group-selection-arrow">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="20"
                                        height="25"
                                        fill="currentColor"
                                        className="bi bi-caret-down-fill"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                    </svg>
                                </div>
                                {errors.roadsurvey && <span className="error-message font-size-text ">{errors.roadsurvey}</span>}
                            </div>

                            <div title="Month" className="flex-column">
                                <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                    Month<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    min={0}
                                    step={0.01}
                                    onWheel={(e) => e.target.blur()}
                                    id="month"
                                    name="month"
                                    placeholder="Month"
                                    onChange={handleInputChange}
                                    value={formData.month}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                />
                                {errors.month && (
                                    <span className="error-message font-size-text ">{errors.month}</span>
                                )}
                            </div>

                            <div title="Invoice Amount" className="flex-column form-group-selectt">
                                <label htmlFor="current_invoice_amount" className="form-labels  font-weight500    font-size-subheading">
                                    Current Invoice Amount<span className="required">*</span>
                                </label>
                                <br />
                                <input
                                    id="current_invoice_amount"
                                    name="current_invoice_amount"
                                    type="number"
                                    min={0}
                                    onWheel={(e) => e.target.blur()}
                                    placeholder="Current Invoice Amount"
                                    onChange={handleInputChange}
                                    value={formData.current_invoice_amount}
                                    className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
                                        }`}
                                />
                                {errors.current_invoice_amount && <span className="error-message font-size-text ">{errors.current_invoice_amount}</span>}
                            </div>
                            {errors.project && <span className="error-message font-size-text ">{errors.project}</span>}
                            {errors.invoice && <span className="error-message font-size-text ">{errors.invoice}</span>}

                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};


const DeleteRoadSurveyEquipmentInvoice = ({ i, getRoadSurveyinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceroadsurveyequipment/${i.id}/`);
            if (response.status === 200) {
                getRoadSurveyinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Road Survey" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}
const DeleteRoadSurveyEquipmentInvoiceDeduction = ({ i, getRoadSurveyinvoice }) => {

    const [show, setShow] = useState(false);
    const handleShow = () => {
        setShow(true);
    }

    const handleClose = () => {
        setShow(false);
    }

    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            const response = await axios.delete(`${BASE_URL}/siteproject/invoiceroadsurveyequipment/${i.id}/`);
            if (response.status === 200) {
                getRoadSurveyinvoice();
                handleClose();
                toast.dismiss(loadingToastId);
                toast.success("Data deleted Successfully");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    }
    return (
        <>
            <button title="Delete Road Survey" className="model-delete-button" onClick={handleShow}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
                        fill="#F72B50"
                    />
                </svg>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Body>
                    <div className="parent-div">
                        <h1 className="task-Tab-heading align-center  font-weight500    font-size-heading"><Modal.Title>Delete Record </Modal.Title> </h1>

                        Are You Sure You Want to Delete
                        <div className="button-models">
                            <button className="model-button-cancel model-button   font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    )

}

// const AddContingenciesinvoice = ({ p_id, invoice_id, getContingencies, dataInvoice, month, year }) => {
//     const [show, setShow] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => setShow(true);

//     const [formData, setFormData] = useState({
//         unit: "",
//         actual_month: "",
//         current_invoice_amount: "",
//         month: month,
//         year: year,
//         project: p_id,
//         invoice: invoice_id,
//         created_at: new Date().toISOString(),

//         // sub_company: sessionStorage.getItem('company_id')
//     });

//     // !  ************** Validation start **************  ! //

//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});

//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = ["unit", "actual_month", "current_invoice_amount"];
//         requiredFields.forEach((field) => {
//             if (!formData[field]) {
//                 newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
//                     } is required !`;
//             }
//         });

//         setErrors(newErrors);

//         return Object.keys(newErrors).length === 0;
//     };

//     // ?  ************** Validation End **************  ! //

//     //! **************************** post API ***********************!//
//     const [loading, setLoading] = useState(false); //loading logic

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true); //loading logic
//             const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//             try {
//                 let res = await axios.post(
//                     `${BASE_URL}/siteproject/invoice-contingencies/`,
//                     formData
//                 );

//                 if (res.status === 200) {
//                     await getContingencies();
//                     setShow(false);
//                     toast.dismiss(loadingToastId);
//                     toast.success("Data added Successfully");
//                 } else {
//                     alert(res);
//                 }
//             } catch (err) {
//                 //toast Logic
//                 handleErrorToast(err);
//             } finally {
//                 setLoading(false); //loading logic
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };

//     //! **************************** post API End ***********************!//

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;

//         setInputState({
//             ...inputState,
//             [name]: value.trim() ? "green" : "",
//         });

//         setFormData({
//             ...formData,
//             [name]: value,
//         });
//     };

//     return (
//         <>
//             <button title="Contingencies" className="upload-svg flex-row" onClick={handleShow}>
//                 <AddwithWhiteCircle />
//                 {" "} Contingencies
//             </button>

//             <Modal
//                 show={show}
//                 onHide={handleClose}
//                 dialogClassName="request-leave width-40vw"
//             >
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Contingencies</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

//                             <form>
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="actual_month"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         Actual Months<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="actual_month"
//                                         type="number"
//                                         maxLength={1}
//                                         max={9}
//                                         min={0}
//                                         name="actual_month"
//                                         onWheel={(e) => e.target.blur()}
//                                         placeholder="Actual Month"
//                                         onChange={handleInputChange}
//                                         value={formData.actual_month}
//                                         className={`form-input ${errors.actual_month ? "error" : inputState.actual_month ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.actual_month && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.actual_month}
//                                         </span>
//                                     )}
//                                 </div>
//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="unit"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         Units<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="unit"
//                                         type="text"
//                                         name="unit"

//                                         placeholder="Units"
//                                         onChange={handleInputChange}
//                                         value={formData.unit}
//                                         className={`form-input ${errors.unit ? "error" : inputState.unit ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.unit && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.unit}
//                                         </span>
//                                     )}
//                                 </div>

//                                 <div className="flex-column">
//                                     <label
//                                         htmlFor="current_invoice_amount"
//                                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                                     >
//                                         Current Invoice Amount<span className="required">*</span>
//                                     </label>
//                                     <input
//                                         id="current_invoice_amount"
//                                         type="number"
//                                         min={0}
//                                         name="current_invoice_amount"
//                                         onWheel={(e) => e.target.blur()}

//                                         placeholder="Amount"
//                                         onChange={handleInputChange}
//                                         value={formData.current_invoice_amount}
//                                         className={`form-input ${errors.current_invoice_amount ? "error" : inputState.current_invoice_amount ? "success" : ""
//                                             }`}
//                                     />
//                                     {errors.current_invoice_amount && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.current_invoice_amount}
//                                         </span>
//                                     )}
//                                 </div>
//                                 <div title="Transportation" className="flex-column form-group-selectt">
//                                     <label htmlFor="contingencies" className="form-labels  font-weight500    font-size-subheading">
//                                         Contingencies<span className="required">*</span>
//                                     </label>
//                                     <br />
//                                     <select
//                                         id="contingencies"
//                                         name="contingencies"
//                                         placeholder="contingencies"
//                                         value={formData.contingencies}
//                                         onChange={handleInputChange}
//                                         className={`form-input form-group-selection ${errors.contingencies ? "error" : inputState.contingencies ? "success" : ""}`}
//                                     >
//                                         <option value="">Select Contingencies</option>
//                                         {dataInvoice?.sort((a, b) => a.description.localeCompare(b.description, 'en', { ignorePunctuation: true })).map((i, index) => (
//                                             <option key={index} value={i.id}>{i.description}</option>
//                                         ))}
//                                     </select>

//                                     {errors.contingencies && <span className="error-message font-size-text ">{errors.contingencies}</span>}
//                                 </div>
//                             </form>
//                             <div className="button-models">
//                                 <button
//                                     className="model-button-cancel model-button   font-weight500   "
//                                     onClick={handleClose}
//                                 >
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
//                                     onClick={handleSubmit}
//                                     disabled={loading}
//                                 >
//                                     Add
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <ToastContainer
//                         position="top-center"
//                         autoClose={1000}
//                         hideProgressBar={false}
//                         newestOnTop={true}
//                         closeOnClick
//                         rtl={false}
//                         pauseOnFocusLoss
//                         draggable
//                         pauseOnHover
//                     />
//                 </Modal.Body>
//             </Modal>
//         </>
//     );
// };

const AddContingenciesinvoice = ({ p_id, invoice_id, getContingencies, dataInvoice, month, year }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        unit: "",
        actual_month: "",
        current_invoice_amount: "",
        month: month,
        year: year,
        project: p_id,
        invoice: invoice_id,
        created_at: new Date().toISOString(),
    });

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["unit", "actual_month", "current_invoice_amount"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                let res = await axios.post(
                    `${BASE_URL}/siteproject/invoice-contingencies/`,
                    formData
                );

                if (res.status === 200) {
                    await getContingencies();
                    setShow(false);
                    toast.dismiss(loadingToastId);
                    toast.success("Data added Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                handleErrorToast(err);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    return (
        <>
            <button title="Contingencies" className="eb-bulk-trigger-btn" onClick={handleShow} style={{ background: "black" }}>
                <svg className="eb-bulk-btn-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="16" />
                    <line x1="8" y1="12" x2="16" y2="12" />
                </svg>
                Contingencies
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="eb-bulk-modal model-width50vw max-heightModal">
                <Modal.Header className="eb-bulk-modal-header">
                    <Modal.Title className="eb-bulk-modal-title">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
                            <path d="M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2" />
                            <line x1="12" y1="12" x2="12" y2="16" />
                            <line x1="10" y1="14" x2="14" y2="14" />
                        </svg>
                        Add Contingencies
                    </Modal.Title>
                    <button className="close-btn" onClick={handleClose}>
                        <X size={20} />
                    </button>
                </Modal.Header>

                <Modal.Body className="eb-bulk-modal-body">
                    <div className="eb-bulk-container">
                        <div className="eb-bulk-content">
                            <div className="eb-bulk-table-wrapper">
                                <div style={{ padding: "8px 4px", display: "flex", flexDirection: "column", gap: "16px" }}>

                                    {/* Actual Months */}
                                    <div className="flex-column">
                                        <label htmlFor="actual_month" className="eb-bulk-th-label" style={{ marginBottom: "6px", display: "block" }}>
                                            Actual Months <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            id="actual_month"
                                            type="number"
                                            name="actual_month"
                                            maxLength={1}
                                            max={9}
                                            min={0}
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="Actual Month"
                                            onChange={handleInputChange}
                                            value={formData.actual_month}
                                            className={`eb-bulk-input text-start eb-bulk-input-number ${errors.actual_month ? "eb-bulk-input-error" : ""}`}
                                            style={{ width: "95%" }}
                                        />
                                        {errors.actual_month && (
                                            <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.actual_month}</span>
                                        )}
                                    </div>

                                    {/* Units */}
                                    <div className="flex-column">
                                        <label htmlFor="unit" className="eb-bulk-th-label" style={{ marginBottom: "6px", display: "block" }}>
                                            Units <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            id="unit"
                                            type="text"
                                            name="unit"
                                            placeholder="Units"
                                            onChange={handleInputChange}
                                            value={formData.unit}
                                            className={`eb-bulk-input text-start ${errors.unit ? "eb-bulk-input-error" : ""}`}
                                            style={{ width: "95%" }}
                                        />
                                        {errors.unit && (
                                            <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.unit}</span>
                                        )}
                                    </div>

                                    {/* Current Invoice Amount */}
                                    <div className="flex-column">
                                        <label htmlFor="current_invoice_amount" className="eb-bulk-th-label" style={{ marginBottom: "6px", display: "block" }}>
                                            Current Invoice Amount <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            id="current_invoice_amount"
                                            type="number"
                                            min={0}
                                            name="current_invoice_amount"
                                            onWheel={(e) => e.target.blur()}
                                            placeholder="Amount"
                                            onChange={handleInputChange}
                                            value={formData.current_invoice_amount}
                                            className={`eb-bulk-input text-start eb-bulk-input-number ${errors.current_invoice_amount ? "eb-bulk-input-error" : ""}`}
                                            style={{ width: "95%" }}
                                        />
                                        {errors.current_invoice_amount && (
                                            <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.current_invoice_amount}</span>
                                        )}
                                    </div>

                                    {/* Contingencies Select */}
                                    <div className="flex-column">
                                        <label htmlFor="contingencies" className="eb-bulk-th-label" style={{ marginBottom: "6px", display: "block" }}>
                                            Contingencies <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <select
                                            id="contingencies"
                                            name="contingencies"
                                            value={formData.contingencies}
                                            onChange={handleInputChange}
                                            className={`eb-bulk-input text-start ${errors.contingencies ? "eb-bulk-input-error" : ""}`}
                                            style={{ width: "95%", cursor: "pointer" }}
                                        >
                                            <option value="">Select Contingencies</option>
                                            {dataInvoice?.sort((a, b) =>
                                                a.description.localeCompare(b.description, 'en', { ignorePunctuation: true })
                                            ).map((i, index) => (
                                                <option key={index} value={i.id}>{i.description}</option>
                                            ))}
                                        </select>
                                        {errors.contingencies && (
                                            <span style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors.contingencies}</span>
                                        )}
                                    </div>

                                </div>
                            </div>

                            <div className="eb-bulk-footer-actions">
                                <button className="eb-bulk-btn eb-bulk-btn-cancel" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="eb-bulk-btn eb-bulk-btn-submit"
                                    disabled={loading}
                                    onClick={handleSubmit}
                                    style={{ background: "black" }}
                                >
                                    {loading ? (
                                        <span className="eb-bulk-btn-loader">
                                            <span className="eb-bulk-spinner"></span>
                                            Submitting...
                                        </span>
                                    ) : (
                                        <>
                                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                                <path d="M20 14.66V20a2 2 0 01-2 2H4a2 2 0 01-2-2V6a2 2 0 012-2h5.34" />
                                                <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                                            </svg>
                                            Add
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const UpdateContingenciestinvoice = ({ i, getContingencies }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true)
        setFormData(i);
    };

    const [formData, setFormData] = useState({
        description: "",
        unit: "",
        ammount: "",
        project: ""

        // sub_company: sessionStorage.getItem('company_id')
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["description", "unit", "ammount"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    //! **************************** post API ***********************!//
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                let res = await axios.put(
                    `${BASE_URL}/siteproject/boqcontingenciesupdate/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getContingencies();
                    setShow(false);
                    toast.dismiss(loadingToastId);
                    toast.success("Data Updated Successfully");
                } else {
                    alert(res);
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    //! **************************** post API End ***********************!//

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    return (
        <>
            <button
                title="Update Contingencies"
                className="model-edit-button"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>


            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update Contingencies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Add Item</h6> */}

                            <form>
                                <div className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description
                                    </label>
                                    <input
                                        id="description"
                                        type="text"
                                        name="description"
                                        maxLength={300}
                                        placeholder="Description"
                                        onChange={handleInputChange}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text ">
                                            {errors.description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="unit"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Units
                                    </label>
                                    <input
                                        id="unit"
                                        type="text"
                                        name="unit"

                                        placeholder="Units"
                                        onChange={handleInputChange}
                                        value={formData.unit}
                                        className={`form-input ${errors.unit ? "error" : inputState.unit ? "success" : ""
                                            }`}
                                    />
                                    {errors.unit && (
                                        <span className="error-message font-size-text ">
                                            {errors.unit}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="ammount"
                                        className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Amount
                                    </label>
                                    <input
                                        id="ammount"
                                        type="number"
                                        min={0}
                                        name="ammount"
                                        onWheel={(e) => e.target.blur()}

                                        placeholder="Amount"
                                        onChange={handleInputChange}
                                        value={formData.ammount}
                                        className={`form-input ${errors.ammount ? "error" : inputState.ammount ? "success" : ""
                                            }`}
                                    />
                                    {errors.ammount && (
                                        <span className="error-message font-size-text ">
                                            {errors.ammount}
                                        </span>
                                    )}
                                </div>
                            </form>
                            <div className="button-models">
                                <button
                                    className="model-button-cancel model-button   font-weight500   "
                                    onClick={handleClose}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-submit  font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteUpdateContingenciestinvoice = ({ i, getContingencies }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/siteproject/invoicecontingencies/${i.id}/`
            );

            if (res.status === 200) {
                await getContingencies();
                setShow(false);
            } else {
                alert(res);
            }
        } catch (err) {

            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button title="Delete Contingencies" className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Contingencies</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="del-button">
                        <div>
                            <h1 className="task-Tab-heading font-weight500    font-size-heading">Are You Sure You Want to Delete </h1>
                        </div>
                    </div>
                    <br />
                    <div className="button-models">
                        <button className="model-button-cancel model-button   font-weight500" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            onClick={handleFormSubmitDelete}
                            className="model-button   font-weight500    model-button-delete"
                        >
                            Delete
                        </button>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

export {

    AddEmployeeInvoice,
    UpdateEmployeeInvoice,
    UpdateNewEmployeeInvoice,

    AddContingenciesinvoice,
    UpdateContingenciestinvoice,
    DeleteUpdateContingenciestinvoice,
    AddTransportationInvoice,
    DutyTravelInvoice,
    OfficeRentInvoice,

    OfficeSuppliesInvoice,
    OfficeFurnitureInvoice,
    ReportsPrinttInvoice,
    RoadSurveyEquipmentInvoice,
    RoadSurveyEquipmentInvoiceUpdate,


    UpdateDutyTravelInvoice,
    UpdateTransportationInvoice,
    UpdateTransportationInvoices,
    UpdateOfficeRentInvoice,
    UpdateOfficeSuppliesInvoice,
    UpdateFurnitureInvoice,
    UpdateOfficeFurnitureInvoice,
    UpdateReportsPrinttInvoice,
    UpdateRoadSurveyEquipmentInvoice,

    DeleteDutyTravelInvoice,
    DeleteDutyTravelInvoiceDeduction,
    DeleteTransportationInvoice,
    DeleteTransportationInvoiceDeduction,
    DeleteOfficeRent,
    DeleteOfficeRentDeduction,
    DeleteOfficeSuppliesInvoice,
    DeleteOfficeSuppliesInvoiceDeduction,
    DeleteFurnitureInvoice,
    DeleteFurnitureInvoiceDeduction,
    DeleteReportsPrinttInvoice,
    DeleteReportsPrinttInvoiceDeduction,
    DeleteRoadSurveyEquipmentInvoice,
    DeleteRoadSurveyEquipmentInvoiceDeduction,
    DeleteEmployee,
    DeleteEmployeeDeduction


}